
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("bXGQx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c5f41f67157b262$export$2e2bcd8739ae039);

var $3yzOx = parcelRequire("3yzOx");

var $ctXx8 = parcelRequire("ctXx8");

var $ihEDU = parcelRequire("ihEDU");

var $dHa0b = parcelRequire("dHa0b");

var $fnihK = parcelRequire("fnihK");

var $i860n = parcelRequire("i860n");

var $gA92M = parcelRequire("gA92M");

var $3GN2r = parcelRequire("3GN2r");

var $kt86l = parcelRequire("kt86l");

var $cxpqA = parcelRequire("cxpqA");

var $6Phv4 = parcelRequire("6Phv4");

var $7jBdz = parcelRequire("7jBdz");

var $7IK6V = parcelRequire("7IK6V");

var $fZL4f = parcelRequire("fZL4f");

var $bmXzb = parcelRequire("bmXzb");

var $f6qor = parcelRequire("f6qor");

var $fAVtN = parcelRequire("fAVtN");

var $5fpxV = parcelRequire("5fpxV");

var $9Oo0T = parcelRequire("9Oo0T");

var $ldZHG = parcelRequire("ldZHG");

var $7RI9J = parcelRequire("7RI9J");
var $93ner = parcelRequire("93ner");

var $2b39L = parcelRequire("2b39L");

var $6ZLJT = parcelRequire("6ZLJT");

var $dC2mi = parcelRequire("dC2mi");


var $6NPUA = parcelRequire("6NPUA");

var $c0zmz = parcelRequire("c0zmz");

var $3e4X9 = parcelRequire("3e4X9");

var $cMz6U = parcelRequire("cMz6U");

var $fHaVI = parcelRequire("fHaVI");
const $5c5f41f67157b262$var$create = (0, $7RI9J.defineMessage)({
    defaultMessage: "Create",
    id: "atlassian-navigation.universal-create.create"
});
const $5c5f41f67157b262$var$noopPreload = ()=>{
// No-op: hover preload is disabled when the on-hover gate is off.
};
const $5c5f41f67157b262$var$emptyGlobalIssueCreateModernisedModalEntryPointParams = {};
const $5c5f41f67157b262$var$gateOffIssueCreateState = [
    (0, $9Oo0T.initialState),
    (0, $9Oo0T.noopActions)
];
const $5c5f41f67157b262$var$shouldPreloadModernisedGlobalCreate = (projectContext, shouldUseLegacyCreateExperience)=>!shouldUseLegacyCreateExperience && (!projectContext?.projectType || (0, $7IK6V.SUPPORTED_MODERNISED_PROJECT_TYPES).includes(projectContext.projectType));
const $5c5f41f67157b262$var$useGicHoverApiPreload = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('nike_united_gic_on_hover_') && !(0, $i860n.fg)('relay-migration-gic-phase-1'), ()=>{
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const storageVariables = (0, $f6qor.useStorageVariables)();
    const { withMachineLearning: withMachineLearning } = (0, $fZL4f.useSmartFieldsMachineLearning)();
    return (0, $3yzOx.useCallback)(()=>{
        (0, $bmXzb.preloadModalLoadQuery)({
            projectContext: projectContext,
            storageVariables: storageVariables,
            withMachineLearning: withMachineLearning
        });
    }, [
        projectContext,
        storageVariables,
        withMachineLearning
    ]);
}, ()=>$5c5f41f67157b262$var$noopPreload);
const $5c5f41f67157b262$var$useUniversalCreateIssueCreateState = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('relay-migration-gic-phase-1'), (0, $9Oo0T.useTriggerIssueCreateModal), ()=>$5c5f41f67157b262$var$gateOffIssueCreateState);
const $5c5f41f67157b262$var$useGlobalIssueCreateModernisedModalEntryPointPreload = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('relay-migration-gic-phase-1'), ()=>{
    const relayEnvironmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const loadGlobalIssueCreateModernisedModalEntryPoint = (0, $3yzOx.useCallback)(()=>(0, $ctXx8.loadEntryPoint)(relayEnvironmentProvider, (0, $5fpxV.globalIssueCreateModernisedModalEntryPoint), $5c5f41f67157b262$var$emptyGlobalIssueCreateModernisedModalEntryPointParams), [
        relayEnvironmentProvider
    ]);
    const { preloadReference: preloadReference } = (0, $dHa0b.useEntryPointPreload)(loadGlobalIssueCreateModernisedModalEntryPoint);
    return preloadReference;
}, ()=>$5c5f41f67157b262$var$noopPreload);
function $5c5f41f67157b262$var$UniversalCreateInner({ CreateComponent: CreateComponent }) {
    const { formatMessage: formatMessage } = (0, $93ner.default)();
    const triggerAnalytics = (0, $cMz6U.useUniversalCreateAnalytics)();
    const aiPlannerEnabled = (0, $7jBdz.useAiPlannerUniversalCreateEnabled)();
    // oxlint-disable-next-line react-hooks/rules-of-hooks
    const sharedPlannerIframe = aiPlannerEnabled ? (0, $6Phv4.useAiPlannerIframe)() : undefined;
    const warmPlanner = sharedPlannerIframe?.warm;
    (0, $fHaVI.useUniversalCreateLoadExperience)();
    (0, $fHaVI.useUniversalCreateButtonInteractiveExperienceStart)();
    const createIssueItem = (0, $6NPUA.useCreateIssueItem)({});
    const createWithPlannerItem = aiPlannerEnabled ? // oxlint-disable-next-line react-hooks/rules-of-hooks
    (0, $c0zmz.useCreateWithPlannerItem)() : undefined;
    const plannerCreateEnabled = aiPlannerEnabled && createWithPlannerItem !== undefined;
    const shouldShowDefaultCreateButton = (0, $3e4X9.useShouldShowDefaultCreateButton)();
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const [{ shouldUseLegacyCreateExperience: shouldUseLegacyCreateExperience }] = $5c5f41f67157b262$var$useUniversalCreateIssueCreateState();
    const preloadGlobalIssueCreateModernisedModalEntryPoint = $5c5f41f67157b262$var$useGlobalIssueCreateModernisedModalEntryPointPreload();
    const menuSection = (0, $3yzOx.useMemo)(()=>{
        if (plannerCreateEnabled && createWithPlannerItem) return {
            items: [
                createWithPlannerItem,
                ...!(0, $i860n.fg)('jira_uc_split_button_enabled') ? [
                    createIssueItem
                ] : []
            ]
        };
        return {
            items: [
                createIssueItem
            ]
        };
    }, [
        plannerCreateEnabled,
        createIssueItem,
        createWithPlannerItem
    ]);
    const sections = (0, $3yzOx.useMemo)(()=>[
            {
                type: 'appDefinedSection',
                items: menuSection.items
            }
        ], [
        menuSection.items
    ]);
    // Primary button needs its own onClick that fires analytics with isPrimary: true
    const primaryActionItem = (0, $3yzOx.useMemo)(()=>({
            ...createIssueItem,
            onClick: (event)=>{
                triggerAnalytics({
                    isPrimary: true
                });
                createIssueItem.onClick?.(event);
            }
        }), [
        createIssueItem,
        triggerAnalytics
    ]);
    // Mark interactive experience as complete (items are loaded)
    (0, $fHaVI.useUniversalCreateButtonInteractiveExperienceComplete)();
    const onDropdownMenuOpen = (0, $3yzOx.useCallback)(()=>{
        if (aiPlannerEnabled) warmPlanner?.();
        triggerAnalytics();
    }, [
        aiPlannerEnabled,
        triggerAnalytics,
        warmPlanner
    ]);
    const onDefaultCreateClick = (0, $3yzOx.useCallback)(()=>{
        // oxlint-disable-next-line typescript/consistent-type-assertions
        createIssueItem?.onClick?.({
            timeStamp: performance.now()
        });
    }, [
        createIssueItem
    ]);
    const preloadGicApiOnHover = $5c5f41f67157b262$var$useGicHoverApiPreload();
    const hasPreloadedModernisedModalRef = (0, $3yzOx.useRef)(false);
    const hasPreloadedGicApiRef = (0, $3yzOx.useRef)(false);
    const handlePreloadTrigger = (0, $3yzOx.useCallback)(()=>{
        if (!hasPreloadedGicApiRef.current && !(0, $i860n.fg)('relay-migration-gic-phase-1') && (0, $i860n.fg)('nike_united_gic_on_hover_')) {
            hasPreloadedGicApiRef.current = true;
            preloadGicApiOnHover();
        }
        if (!$5c5f41f67157b262$var$shouldPreloadModernisedGlobalCreate(projectContext, shouldUseLegacyCreateExperience ?? false) && (0, $i860n.fg)('relay-migration-gic-phase-1')) return;
        if (hasPreloadedModernisedModalRef.current) return;
        hasPreloadedModernisedModalRef.current = true;
        if ((0, $i860n.fg)('relay-migration-gic-phase-1')) {
            preloadGlobalIssueCreateModernisedModalEntryPoint();
            return;
        }
        (0, $fAVtN.preloadIssueCreateModernisedModal)();
    }, [
        preloadGicApiOnHover,
        preloadGlobalIssueCreateModernisedModalEntryPoint,
        projectContext,
        shouldUseLegacyCreateExperience
    ]);
    const conditionalProps = ()=>{
        if (shouldShowDefaultCreateButton) return {
            buttonOnly: true,
            onClick: onDefaultCreateClick
        };
        const menuSections = {
            sections: sections
        };
        // UC split button variant
        if ((0, $i860n.fg)('jira_uc_split_button_enabled')) return {
            primaryActionItem: primaryActionItem,
            onClick: onDropdownMenuOpen,
            ...menuSections
        };
        // UC single button variant
        return {
            onClick: onDropdownMenuOpen,
            ...menuSections
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $ihEDU.Box), {
        testId: `${(0, $aec4a9b10933d5e3$export$d28a4ed98505cc58)}`,
        onMouseEnter: handlePreloadTrigger,
        onFocus: handlePreloadTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $dC2mi.NavigationCreateIssueButtonWrapperNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($5c5f41f67157b262$var$CreateButtonSpotlightTarget, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(CreateComponent, {
        product: "jira",
        testId: (0, $aec4a9b10933d5e3$export$bac9f330cf4670e8),
        ...conditionalProps()
    }, formatMessage($5c5f41f67157b262$var$create)))));
}
$5c5f41f67157b262$var$UniversalCreateInner.displayName = "UniversalCreateInner";
const $5c5f41f67157b262$var$CreateButtonSpotlightTarget = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $gA92M.SpotlightTarget), {
        name: "global-create-spotlight"
    }, children);
};
$5c5f41f67157b262$var$CreateButtonSpotlightTarget.displayName = "CreateButtonSpotlightTarget";
const $5c5f41f67157b262$var$UniversalCreateWithPlannerProviders = ({ CreateComponent: CreateComponent })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const accountId = (0, $3GN2r.useAccountId)() || '';
    const embedContext = (0, $3yzOx.useMemo)(()=>({
            cloudId: cloudId,
            accountId: accountId
        }), [
        cloudId,
        accountId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $6Phv4.AiPlannerIframeProvider), {
        embedContext: embedContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $fnihK.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($5c5f41f67157b262$var$UniversalCreateInner, {
        CreateComponent: CreateComponent
    })));
};
$5c5f41f67157b262$var$UniversalCreateWithPlannerProviders.displayName = "UniversalCreateWithPlannerProviders";
function $5c5f41f67157b262$export$2e2bcd8739ae039({ CreateComponent: CreateComponent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $ldZHG.TopLevelErrorBoundary), {
        id: (0, $aec4a9b10933d5e3$export$91e69945d7373dba)
    }, (0, $i860n.fg)('jira_planner_uc_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($5c5f41f67157b262$var$UniversalCreateWithPlannerProviders, {
        CreateComponent: CreateComponent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($5c5f41f67157b262$var$UniversalCreateInner, {
        CreateComponent: CreateComponent
    }));
}
$5c5f41f67157b262$export$2e2bcd8739ae039.displayName = "UniversalCreate";

});
parcelRegister("gA92M", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $78c69aedca2c77ed$export$e29577842f211e22);
/* SpotlightTarget.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5ggCc = parcelRequire("5ggCc");

var $3yzOx = parcelRequire("3yzOx");

var $8maDC = parcelRequire("8maDC");
const $78c69aedca2c77ed$var$styles = {
    root: "_39xV02E6Kk",
    fullWidth: "_39xV02N91d"
};
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $78c69aedca2c77ed$export$e29577842f211e22 = ({ children: children, name: name, isFullWidth: isFullWidth = false })=>{
    const id = (0, $8maDC.targetTranslation)(name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement("div", {
        id: id,
        className: (0, $5ggCc.default)([
            $78c69aedca2c77ed$var$styles.root,
            isFullWidth && $78c69aedca2c77ed$var$styles.fullWidth
        ])
    }, children);
};
$78c69aedca2c77ed$export$e29577842f211e22.displayName = "SpotlightTarget";
$78c69aedca2c77ed$export$e29577842f211e22.displayName = 'SpotlightTarget';

});
parcelRegister("8maDC", function(module, exports) {
$parcel$export(module.exports, "targetTranslation", () => $955264891535364f$export$1d49f6eff744367d);
const $955264891535364f$export$1d49f6eff744367d = (value)=>{
    if (!value || value.length === 0) return '';
    /**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */ return value.replace(/[ /.]/g, '-');
};

});


parcelRegister("6Phv4", function(module, exports) {
$parcel$export(module.exports, "AiPlannerIframeProvider", () => $eb68f8b07d77ef78$export$3a5bf2d6543be75);
$parcel$export(module.exports, "useAiPlannerIframe", () => $eb68f8b07d77ef78$export$5c4e77d5744d1603);
/* AiPlannerIframeProvider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5ggCc = parcelRequire("5ggCc");

var $3yzOx = parcelRequire("3yzOx");

var $5E14l = parcelRequire("5E14l");

var $kU3j1 = parcelRequire("kU3j1");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $cztJ0 = parcelRequire("cztJ0");

var $3w83P = parcelRequire("3w83P");


var $52rYh = parcelRequire("52rYh");

var $kZ3gK = parcelRequire("kZ3gK");

var $1t7ix = parcelRequire("1t7ix");

var $cPYhH = parcelRequire("cPYhH");

var $hRTng = parcelRequire("hRTng");
// If the iframe has not signalled that its document is ready within this
// window, we treat the load as failed and surface the error fallback.
const $eb68f8b07d77ef78$var$LOAD_TIMEOUT_MS = 15000;
const $eb68f8b07d77ef78$var$noop = ()=>undefined;
const $eb68f8b07d77ef78$var$FAILED_CLAIM = {
    ok: false,
    release: $eb68f8b07d77ef78$var$noop
};
const $eb68f8b07d77ef78$var$AiPlannerIframeContext = /*#__PURE__*/ (0, $3yzOx.createContext)(null);
const $eb68f8b07d77ef78$export$3a5bf2d6543be75 = ({ embedContext: embedContext, defaultJiraSpaceKey: defaultJiraSpaceKey, defaultConfluenceSpaceKey: defaultConfluenceSpaceKey, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { push: push } = (0, $cztJ0.useRouterActions)();
    const parkingRef = (0, $3yzOx.useRef)(null);
    const hostRef = (0, $3yzOx.useRef)(null);
    const iframeRef = (0, $3yzOx.useRef)(null);
    // Stable per-mount id giving this iframe a private Rovo bridge channel, so it
    // never collides with another planner iframe on the shared bridge.
    // oxlint-disable-next-line react/refs
    const bridgeInstanceId = (0, $3yzOx.useRef)(globalThis.crypto.randomUUID()).current;
    const [status, setStatus] = (0, $3yzOx.useState)('idle');
    // Set once the iframe should exist in the DOM (after first warm/claim).
    const [isMounted, setIsMounted] = (0, $3yzOx.useState)(false);
    // True while the iframe is revealed in a modal. Background warming is silent
    // (no overlay, no timeout); only a claimed/visible iframe drives status and
    // the load timeout so a slow background boot never poisons the warm.
    const [isClaimed, setIsClaimed] = (0, $3yzOx.useState)(false);
    // True once the parking wrapper (and inner host) have mounted on the client.
    const [isHostReady, setIsHostReady] = (0, $3yzOx.useState)(false);
    // Bumping this forces a remount of the iframe for a clean retry.
    const [loadKey, setLoadKey] = (0, $3yzOx.useState)(0);
    const settledRef = (0, $3yzOx.useRef)(false);
    // Bumped on each successful claim so a stale release cannot steal the host
    // from a newer claim (rapid close/reopen).
    const claimGenerationRef = (0, $3yzOx.useRef)(0);
    const releaseActiveClaimRef = (0, $3yzOx.useRef)($eb68f8b07d77ef78$var$noop);
    // Jira's live theme, never the OS preference (see useAiPlannerColorMode).
    const colorMode = (0, $hRTng.useAiPlannerColorMode)();
    // Root URL — stable across plan navigation (never changes `src` for a plan
    // switch; that happens over the bridge via `sendLoadPlan`) but recomputed
    // when `colorMode` changes, since Planner only reads colorMode once per
    // iframe load. The effect below detects that recompute and forces the
    // already-booted iframe to reload so the new value actually takes effect.
    const src = (0, $3yzOx.useMemo)(// A planner Bifrost build can be pinned via the page URL's
    // `ai-planner-bifrost-override` query param (see getBifrostOverrideFromLocation).
    ()=>(0, $52rYh.getAiPlannerUrl)(embedContext, undefined, (0, $52rYh.getBifrostOverrideFromLocation)() ?? undefined, undefined, bridgeInstanceId, colorMode), [
        embedContext,
        bridgeInstanceId,
        colorMode
    ]);
    // Tracks the requestId of the most recent loadPlan so we only react to the
    // planner's matching `ready` transition (ignoring stale/echoed ones).
    const pendingRequestIdRef = (0, $3yzOx.useRef)(null);
    // The most recent plan id requested (via warm/claim); undefined means the
    // planner root. Replayed after a colorMode-triggered reload so the fresh
    // iframe resumes wherever the user (or a warm) had navigated to.
    const activePlanIdRef = (0, $3yzOx.useRef)(undefined);
    // The plan id the planner last confirmed via a matching `ready` transition,
    // or null once it has been asked for something else or lost its document.
    // A loadPlan for the plan already on screen is a planner-side no-op, so
    // without this a repeat request would wait for a `ready` that never comes.
    const loadedPlanIdRef = (0, $3yzOx.useRef)(null);
    // Set right before a colorMode-triggered reload and consumed by handleLoad,
    // so the freshly-reloaded iframe is re-pointed at the plan it lost when its
    // document was discarded (plan navigation normally never reloads the
    // iframe — see the `src` comment above — so this only fires for a theme
    // change, never for an ordinary plan switch).
    const reloadPendingRef = (0, $3yzOx.useRef)(false);
    // True once the iframe's root document (the SPA shell) has loaded at least
    // once. After that, the same persistent iframe is reused and won't fire
    // `onLoad` again, so claims rely on this + bridge transitions.
    const shellLoadedRef = (0, $3yzOx.useRef)(false);
    // Back/close/view intents are owned by whoever currently has the iframe claimed
    // (the open modal). We hold the active claim's handlers in a ref so the bridge
    // client is created once and always calls the latest handlers.
    const claimIntentsRef = (0, $3yzOx.useRef)({});
    const markVisibleLoadSucceeded = (0, $3yzOx.useCallback)((fromWarmShell = false)=>{
        if (settledRef.current) return false;
        settledRef.current = true;
        setStatus((currentStatus)=>currentStatus === 'idle' ? currentStatus : 'loaded');
        claimIntentsRef.current.onLoad?.({
            fromWarmShell: fromWarmShell
        });
        return true;
    }, []);
    const markVisibleLoadFailed = (0, $3yzOx.useCallback)((reason)=>{
        if (settledRef.current) return false;
        settledRef.current = true;
        // A failed load must never be short-circuited as "already showing".
        loadedPlanIdRef.current = null;
        setStatus((currentStatus)=>currentStatus === 'idle' ? currentStatus : 'error');
        claimIntentsRef.current.onError?.(reason);
        return true;
    }, []);
    const handleNavigate = (0, $3yzOx.useCallback)((url)=>{
        if (typeof globalThis.window === 'undefined') return;
        const path = (0, $kZ3gK.getValidatedPlannerNavigationPath)(url, globalThis.window.location.origin);
        if (path != null) push(path);
    }, [
        push
    ]);
    // oxlint-disable-next-line react/refs
    const { sendLoadPlan: sendLoadPlan, sendPrewarmPlans: sendPrewarmPlans, sendVisibility: sendVisibility } = (0, $cPYhH.useAiPlannerBridge)({
        bridgeInstanceId: bridgeInstanceId,
        defaultJiraSpaceKey: defaultJiraSpaceKey,
        defaultConfluenceSpaceKey: defaultConfluenceSpaceKey,
        onTransition: (0, $3yzOx.useCallback)((transition)=>{
            if (transition.requestId !== pendingRequestIdRef.current) return;
            if (transition.state === 'ready') {
                loadedPlanIdRef.current = activePlanIdRef.current ?? null;
                markVisibleLoadSucceeded();
            }
        }, [
            markVisibleLoadSucceeded
        ]),
        onBack: (0, $3yzOx.useCallback)(()=>{
            claimIntentsRef.current.onBack?.();
        }, []),
        onClose: (0, $3yzOx.useCallback)(()=>{
            claimIntentsRef.current.onClose?.();
        }, []),
        onViewChange: (0, $3yzOx.useCallback)((isHomeView)=>{
            claimIntentsRef.current.onViewChange?.(isHomeView);
        }, []),
        onNavigate: handleNavigate
    });
    // Preconnect to the planner origin (only when cross-origin) so the TLS/DNS
    // connection is warm before the iframe loads. No-op when same-origin.
    (0, $3yzOx.useEffect)(()=>{
        const origin = (0, $52rYh.getAiPlannerOrigin)();
        if (origin == null || typeof globalThis.document === 'undefined') return undefined;
        const link = globalThis.document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        link.crossOrigin = '';
        globalThis.document.head.appendChild(link);
        return ()=>{
            globalThis.document.head.removeChild(link);
        };
    }, []);
    // Mount the persistent iframe once (boots the planner SPA at the root URL).
    // Stable identity: reads live state via refs, so it never re-creates and
    // never triggers claim/release churn.
    const bootRef = (0, $3yzOx.useRef)(false);
    // Boot the persistent iframe once. This is SILENT — it never sets a visible
    // status or arms the timeout, so a slow background boot cannot error the
    // warm. The claimed/visible path owns status + timeout.
    const boot = (0, $3yzOx.useCallback)(()=>{
        if (bootRef.current) return;
        if (!(0, $1t7ix.isMoveBeforeSupported)()) return;
        bootRef.current = true;
        setIsMounted(true);
    }, []);
    // Ask the planner to navigate (no reload). Records the requestId so we can
    // match the planner's `ready` transition. `visible` is true for a claim
    // (drives the overlay/timeout); false for background warming (stays silent).
    // The same boolean is sent over the bridge so the planner can pause
    // placeholder animations while hidden.
    const requestPlan = (0, $3yzOx.useCallback)((nextPlanId, visible)=>{
        sendVisibility(visible);
        // Re-requesting the confirmed plan leaves the planner silent; anything
        // else makes it navigate and re-confirm with a fresh `ready`.
        const isAlreadyShowing = shellLoadedRef.current && nextPlanId != null && nextPlanId === loadedPlanIdRef.current;
        if (!isAlreadyShowing) loadedPlanIdRef.current = null;
        activePlanIdRef.current = nextPlanId;
        const requestId = sendLoadPlan(nextPlanId);
        pendingRequestIdRef.current = requestId;
        if (!visible) return;
        settledRef.current = false;
        // For a visible claim, show loading until ready — unless there is
        // nothing for the planner to navigate to, in which case it is already
        // showing the right content: the root of an already-booted shell, or a
        // plan it has confirmed and not left since.
        const isRoot = nextPlanId == null;
        if (shellLoadedRef.current && (isRoot || isAlreadyShowing)) {
            // Set the status explicitly: a silent warm may have settled the shell
            // while the status was still 'idle', and `markVisibleLoadSucceeded`
            // leaves 'idle' alone so background boots stay silent. Claimers render
            // 'idle' as loading and the timeout only arms for 'loading', so without
            // this the claim shows a spinner nothing can clear.
            setStatus('loaded');
            markVisibleLoadSucceeded(true);
            return;
        }
        setStatus('loading');
    }, [
        markVisibleLoadSucceeded,
        sendLoadPlan,
        sendVisibility
    ]);
    const warm = (0, $3yzOx.useCallback)((nextPlanId)=>{
        if (!(0, $1t7ix.isMoveBeforeSupported)()) return;
        boot();
        requestPlan(nextPlanId, false);
    }, [
        boot,
        requestPlan
    ]);
    const prewarm = (0, $3yzOx.useCallback)((planIds)=>{
        if (!(0, $1t7ix.isMoveBeforeSupported)()) return;
        // Boot the (hidden) iframe so the planner is alive to receive and act on
        // the prewarm; the warming itself is silent and never blocks.
        boot();
        sendPrewarmPlans(planIds);
    }, [
        boot,
        sendPrewarmPlans
    ]);
    const parkHost = (0, $3yzOx.useCallback)(()=>{
        (0, $1t7ix.moveNodeBefore)(hostRef.current, parkingRef.current);
    }, []);
    const bindRelease = (0, $3yzOx.useCallback)((release)=>{
        releaseActiveClaimRef.current = release;
        return release;
    }, []);
    const claim = (0, $3yzOx.useCallback)(({ target: target, onAbort: onAbort, onBack: onBack, onClose: onClose, onError: onError, onLoad: onLoad, onViewChange: onViewChange }, nextPlanId)=>{
        if (!(0, $1t7ix.isMoveBeforeSupported)()) return $eb68f8b07d77ef78$var$FAILED_CLAIM;
        const host = hostRef.current;
        if (!(0, $1t7ix.moveNodeBefore)(host, target)) return $eb68f8b07d77ef78$var$FAILED_CLAIM;
        boot();
        const generation = claimGenerationRef.current + 1;
        claimGenerationRef.current = generation;
        setIsClaimed(true);
        // Route the planner's back/close/view intents to this claimer (the open
        // modal) for as long as it holds the iframe.
        claimIntentsRef.current = {
            onAbort: onAbort,
            onBack: onBack,
            onClose: onClose,
            onError: onError,
            onLoad: onLoad,
            onViewChange: onViewChange
        };
        requestPlan(nextPlanId, true);
        const release = bindRelease(()=>{
            if (generation !== claimGenerationRef.current) return;
            if (!settledRef.current) claimIntentsRef.current.onAbort?.();
            parkHost();
            sendVisibility(false);
            setIsClaimed(false);
            claimIntentsRef.current = {};
            releaseActiveClaimRef.current = $eb68f8b07d77ef78$var$noop;
        });
        return {
            ok: true,
            release: release
        };
    }, [
        bindRelease,
        boot,
        parkHost,
        requestPlan,
        sendVisibility
    ]);
    const releaseActiveClaim = (0, $3yzOx.useCallback)(()=>{
        releaseActiveClaimRef.current();
    }, []);
    // Why the document currently loading exists, reported on the load event so a
    // theme reload or a retry is not counted as a cold boot.
    const loadTriggerRef = (0, $3yzOx.useRef)('boot');
    const retry = (0, $3yzOx.useCallback)(()=>{
        loadTriggerRef.current = 'retry';
        settledRef.current = false;
        // Recreating the iframe discards the document, and with it whatever the
        // planner had confirmed.
        loadedPlanIdRef.current = null;
        setStatus('loading');
        setLoadKey((key)=>key + 1);
    }, []);
    // `src` only changes when Jira's theme does, and Planner reads colorMode once
    // per document (see getAiPlannerUrl), so the new value can only be applied by
    // reloading: bump `loadKey` to recreate the iframe, and `handleLoad` replays
    // the active plan into the fresh document. Adjusted during render rather than
    // in an effect because the reload belongs to the render that delivers the new
    // `src`.
    const prevSrcRef = (0, $3yzOx.useRef)(src);
    // oxlint-disable-next-line react/refs
    if (prevSrcRef.current !== src) {
        // oxlint-disable-next-line react/refs
        prevSrcRef.current = src;
        // oxlint-disable-next-line react/refs
        if (bootRef.current) {
            // oxlint-disable-next-line react/refs
            shellLoadedRef.current = false;
            // oxlint-disable-next-line react/refs
            reloadPendingRef.current = true;
            setLoadKey((key)=>key + 1);
            if (isClaimed) {
                // oxlint-disable-next-line react/refs
                settledRef.current = false;
                setStatus('loading');
            }
        }
    }
    const handleLoad = (0, $3yzOx.useCallback)(()=>{
        // The SPA shell has loaded — record it so later claims know the iframe is
        // already booted (it won't fire onLoad again once reused).
        shellLoadedRef.current = true;
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'aiPlannerIframe loaded', {
            path: 'shared',
            // A background warm loads with nobody watching. Without this, silent
            // boots and real opens land in the same bucket and no reliability rate
            // computed from these events means anything.
            visible: isClaimed,
            trigger: reloadPendingRef.current ? 'colorMode' : loadTriggerRef.current
        });
        loadTriggerRef.current = 'boot';
        if (reloadPendingRef.current) {
            // A theme reload, not the initial boot: the fresh document discarded
            // whatever the planner was showing, so forget the confirmed plan and
            // re-request it. Nothing can act on the stale id before this point —
            // every short-circuit that reads it also requires `shellLoadedRef`,
            // which stays false until the reload lands.
            reloadPendingRef.current = false;
            loadedPlanIdRef.current = null;
            requestPlan(activePlanIdRef.current, isClaimed);
            return;
        }
        // Only lift the overlay when the iframe is actually visible in a modal;
        // background warming stays silent. (A specific-plan claim still waits for
        // the bridge `ready` transition — but the shell load is a safe fallback.)
        markVisibleLoadSucceeded();
    }, [
        createAnalyticsEvent,
        isClaimed,
        markVisibleLoadSucceeded,
        requestPlan
    ]);
    const handleError = (0, $3yzOx.useCallback)(()=>{
        // Only surface the error when visible; a failed background warm is silent
        // and will be retried/handled when the user actually opens the modal.
        if (!markVisibleLoadFailed('error')) return;
        (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'aiPlannerIframe failed', {
            reason: 'error',
            path: 'shared',
            visible: isClaimed
        });
    }, [
        createAnalyticsEvent,
        isClaimed,
        markVisibleLoadFailed
    ]);
    // Treat a stalled load as a failure — but ONLY while the iframe is visible in
    // a modal. Background warming never times out, so a slow cold boot can't
    // poison the warm before the user even opens it.
    (0, $3yzOx.useEffect)(()=>{
        if (!isClaimed || status !== 'loading') return undefined;
        const timeoutId = setTimeout(()=>{
            if (!markVisibleLoadFailed('timeout')) return;
            (0, $aJ81Y.fireOperationalAnalytics)(createAnalyticsEvent({}), 'aiPlannerIframe failed', {
                reason: 'timeout',
                path: 'shared',
                // The timeout only arms for a claimed iframe, so this is always a
                // user-visible failure.
                visible: true
            });
        }, $eb68f8b07d77ef78$var$LOAD_TIMEOUT_MS);
        return ()=>{
            clearTimeout(timeoutId);
        };
    // oxlint-disable-next-line react/exhaustive-effect-dependencies
    }, [
        isClaimed,
        status,
        loadKey,
        createAnalyticsEvent,
        markVisibleLoadFailed
    ]);
    // Once the host is in the slot and the document is ready, send keyboard
    // focus into the iframe so Tab is not required after a click.
    const didFocusRef = (0, $3yzOx.useRef)(false);
    (0, $3yzOx.useEffect)(()=>{
        if (!isClaimed || status !== 'loaded') {
            if (!isClaimed) didFocusRef.current = false;
            return undefined;
        }
        if (didFocusRef.current) return undefined;
        didFocusRef.current = true;
        try {
            iframeRef.current?.focus();
        } catch  {
        // jsdom implements HTMLElement.focus but not window.focus.
        }
        return undefined;
    }, [
        isClaimed,
        status
    ]);
    const value = (0, $3yzOx.useMemo)(()=>({
            defaultConfluenceSpaceKey: defaultConfluenceSpaceKey,
            status: status,
            isHostReady: isHostReady,
            warm: warm,
            prewarm: prewarm,
            claim: claim,
            releaseActiveClaim: releaseActiveClaim,
            retry: retry
        }), [
        defaultConfluenceSpaceKey,
        status,
        isHostReady,
        warm,
        prewarm,
        claim,
        releaseActiveClaim,
        retry
    ]);
    const hostRefCallback = (0, $3yzOx.useCallback)((node)=>{
        hostRef.current = node;
        setIsHostReady(node != null);
    }, []);
    /*
   * Parking wrapper is the stable React portal target and is never moved.
   * The inner host is the node `moveBefore` relocates into the modal slot.
   */ const host = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement("div", {
        ref: parkingRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement("div", {
        ref: hostRefCallback,
        "aria-hidden": isClaimed ? undefined : 'true',
        className: (0, $5ggCc.default)([
            isClaimed ? $eb68f8b07d77ef78$var$styles.hostInSlot : $eb68f8b07d77ef78$var$styles.host,
            isClaimed ? $eb68f8b07d77ef78$var$styles.hostVisible : $eb68f8b07d77ef78$var$styles.hostHidden
        ])
    }, isMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement("iframe", {
        key: loadKey,
        ref: iframeRef,
        src: src,
        title: "Planner",
        [(0, $36299dcc0b1a7512$export$111797c9d1b433fd)]: (0, $kU3j1.getAiPlannerEmbedReceiverId)(bridgeInstanceId),
        onLoad: handleLoad,
        onError: handleError,
        className: (0, $5ggCc.default)([
            $eb68f8b07d77ef78$var$styles.iframe
        ])
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($eb68f8b07d77ef78$var$AiPlannerIframeContext.Provider, {
        value: value
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $3w83P.RenderOnClient), null, globalThis.document?.body != null ? /*#__PURE__*/ (0, $5E14l.createPortal)(host, globalThis.document.body) : null));
};
$eb68f8b07d77ef78$export$3a5bf2d6543be75.displayName = "AiPlannerIframeProvider";
const $eb68f8b07d77ef78$export$5c4e77d5744d1603 = ()=>(0, $3yzOx.useContext)($eb68f8b07d77ef78$var$AiPlannerIframeContext);
const $eb68f8b07d77ef78$var$styles = {
    host: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdy1CL",
    hostInSlot: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ",
    hostHidden: "_3iDTPbYbGa",
    hostVisible: "_1YKVNs7dHp _1pp6NdIZbP",
    iframe: "_30huDKYbGa _0bjKvDyzSk _39xV02N91d _0jFU0VN91d _0KLXrulfZc"
};

});
parcelRegister("kU3j1", function(module, exports) {
$parcel$export(module.exports, "AI_PLANNER_BRIDGE_INSTANCE_PARAM", () => $f37b9a10cf400c5c$export$5ba0b8703379af6d);
$parcel$export(module.exports, "getAiPlannerEmbedClientId", () => $f37b9a10cf400c5c$export$84fb98351c55df94);
$parcel$export(module.exports, "getAiPlannerEmbedHostClientId", () => $f37b9a10cf400c5c$export$ada09acbcd33ba77);
$parcel$export(module.exports, "AiPlannerLoadPlanCommand", () => $f37b9a10cf400c5c$export$92a23a7bd6adc98e);
$parcel$export(module.exports, "AiPlannerPrewarmPlansCommand", () => $f37b9a10cf400c5c$export$37f7a180f3455542);
$parcel$export(module.exports, "AiPlannerSetVisibilityCommand", () => $f37b9a10cf400c5c$export$f5a5563344f3c9c0);
$parcel$export(module.exports, "AiPlannerTransitionCommand", () => $f37b9a10cf400c5c$export$8de8de8946850bb2);
$parcel$export(module.exports, "AiPlannerViewChangedCommand", () => $f37b9a10cf400c5c$export$a4989d7ffa9e129b);
$parcel$export(module.exports, "AiPlannerBackCommand", () => $f37b9a10cf400c5c$export$2e17051711be66fb);
$parcel$export(module.exports, "AiPlannerCloseCommand", () => $f37b9a10cf400c5c$export$96b34b258bc0d035);
$parcel$export(module.exports, "AiPlannerNavigateCommand", () => $f37b9a10cf400c5c$export$85b0834d0e0cf5b3);
$parcel$export(module.exports, "getAiPlannerEmbedReceiverId", () => $f37b9a10cf400c5c$export$ebb28ab2fa8ad98f);
parcelRequire("dSkUb");
var $lCPrG = parcelRequire("lCPrG");
var $7xUUt = parcelRequire("7xUUt");
const $f37b9a10cf400c5c$export$c03c05b30acabeb5 = (0, $lCPrG.client)('ai-planner-embed');
const $f37b9a10cf400c5c$export$7dcc2389a5e767df = (0, $lCPrG.client)('ai-planner-embed-host');
const $f37b9a10cf400c5c$export$5ba0b8703379af6d = 'bridgeInstanceId';
function $f37b9a10cf400c5c$export$84fb98351c55df94(instanceId) {
    return instanceId ? (0, $lCPrG.client)(`ai-planner-embed:${instanceId}`) : $f37b9a10cf400c5c$export$c03c05b30acabeb5;
}
function $f37b9a10cf400c5c$export$ada09acbcd33ba77(instanceId) {
    return instanceId ? (0, $lCPrG.client)(`ai-planner-embed-host:${instanceId}`) : $f37b9a10cf400c5c$export$7dcc2389a5e767df;
}
const $f37b9a10cf400c5c$export$1cd00d6f2618cb6b = 'aiPlanner/loadPlan';
const $f37b9a10cf400c5c$export$eda7ffad5e568090 = 'aiPlanner/transition';
const $f37b9a10cf400c5c$export$cb1a368bc1226e2c = 'aiPlanner/viewChanged';
const $f37b9a10cf400c5c$export$e08cea685c90847d = 'aiPlanner/prewarmPlans';
const $f37b9a10cf400c5c$export$2da609ccb4c4acad = 'aiPlanner/setVisibility';
const $f37b9a10cf400c5c$export$5e29152f7a53efe1 = 'aiPlanner/back';
const $f37b9a10cf400c5c$export$2da3ff86e0902163 = 'aiPlanner/close';
const $f37b9a10cf400c5c$export$7096cf6009f9b31 = 'aiPlanner/navigateToIssue';
const $f37b9a10cf400c5c$export$3f5f763b7051a10a = 'aiPlanner/navigate';
const $f37b9a10cf400c5c$export$92a23a7bd6adc98e = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$1cd00d6f2618cb6b);
const $f37b9a10cf400c5c$export$37f7a180f3455542 = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$e08cea685c90847d);
const $f37b9a10cf400c5c$export$f5a5563344f3c9c0 = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$2da609ccb4c4acad);
const $f37b9a10cf400c5c$export$8de8de8946850bb2 = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$eda7ffad5e568090);
const $f37b9a10cf400c5c$export$a4989d7ffa9e129b = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$cb1a368bc1226e2c);
const $f37b9a10cf400c5c$export$2e17051711be66fb = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$5e29152f7a53efe1);
const $f37b9a10cf400c5c$export$96b34b258bc0d035 = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$2da3ff86e0902163);
const $f37b9a10cf400c5c$export$afc5a3320414dc37 = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$7096cf6009f9b31);
const $f37b9a10cf400c5c$export$85b0834d0e0cf5b3 = (0, $7xUUt.createCommand)($f37b9a10cf400c5c$export$3f5f763b7051a10a);
const $f37b9a10cf400c5c$export$6b25d6643d9903e8 = 'initial';
function $f37b9a10cf400c5c$export$ebb28ab2fa8ad98f(instanceId) {
    return $f37b9a10cf400c5c$export$84fb98351c55df94(instanceId);
}

});
parcelRegister("dSkUb", function(module, exports) {
$parcel$export(module.exports, "client", () => (parcelRequire("lCPrG")).client);
$parcel$export(module.exports, "createCommand", () => (parcelRequire("7xUUt")).createCommand);
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $61Nbv = parcelRequire("61Nbv");

var $hnZqe = parcelRequire("hnZqe");

var $lCPrG = parcelRequire("lCPrG");

var $bAlcE = parcelRequire("bAlcE");

var $7xUUt = parcelRequire("7xUUt");

var $jDdBA = parcelRequire("jDdBA");

});
parcelRegister("61Nbv", function(module, exports) {

var $hnZqe = parcelRequire("hnZqe");
const $ecdf673584b3bcc6$export$57477d04dca7c540 = (id, setupHandlers, api = (0, $hnZqe.getBrowserBridgeAPI)())=>{
    // setup command handlers before indicating this client is ready
    setupHandlers?.((command, handler)=>api.on(id, command, handler));
    // indicate as ready
    api.ready(id);
    // start using the API
    return api;
};

});
parcelRegister("hnZqe", function(module, exports) {
$parcel$export(module.exports, "getBrowserBridgeAPI", () => $092fe4b28b3c2512$export$948c8d79381235ac);
$parcel$export(module.exports, "destroyBridgeAPI", () => $092fe4b28b3c2512$export$ba1db4e691f11d50);

var $jDdBA = parcelRequire("jDdBA");

var $5s3v4 = parcelRequire("5s3v4");

var $iGQVw = parcelRequire("iGQVw");
/**
 * A singleton instance to the Rovo bridge API, for bidirectional communication between Rovo Chat and fully immersive content
 * representations. Available in the scope of a single JavaScript context.
 *
 * @description For browser use cases, use {@link getBrowserBridgeAPI}.
 *
 * @description Note: A content frame in this context can refer to either (1) preview of content in a 'staging' view (
 * see @atlassian/smart-creation), or (2) the content actually rendered in an application (e.g. a Confluence page).
 *
 * @description Note: Here, a single JavaScript context can mean any of the following scenarios:
 * - a web application and React component mounted inside of it (e.g. Confluence + Confluence Pages)
 * - a web application and same-origin `<iframe>` mounted inside of it (e.g. Confluence + Confluence Whiteboards / Databases)
 *
 * The following cases represent distinct JavaScript contexts:
 * - a web application and a cross-origin `<iframe>` mounted inside of it (e.g. a third-party Smart Link embed)
 * - the main thread and a worker thread in a web application
 * - the main thread and renderer thread in a desktop application
 *
 * In the case that you have a distinct JavaScript context, ensure you use a transport protocol optimised for your use case.
 * @see {@link getBrowserBridgeAPI} for usage in a browser context.
 */ let $092fe4b28b3c2512$var$bridgeApiInstance = null;
const $092fe4b28b3c2512$export$948c8d79381235ac = (options = {})=>{
    // 1) read singleton instance
    if ($092fe4b28b3c2512$var$bridgeApiInstance) return $092fe4b28b3c2512$var$bridgeApiInstance;
    // 2) read singleton instance from window.top
    const api = (0, $5s3v4.readAPI)();
    if (api) return api;
    // 3) create and yield
    const source = window.origin;
    $092fe4b28b3c2512$var$bridgeApiInstance = new (0, $jDdBA.RovoContentBridgeAPI)(source, new (0, $iGQVw.BrowserTransport)(source, {
        resolveTarget: options.resolveTarget,
        allowedOrigins: options.allowedOrigins
    }));
    (0, $5s3v4.mountAPI)($092fe4b28b3c2512$var$bridgeApiInstance);
    return $092fe4b28b3c2512$var$bridgeApiInstance;
};
const $092fe4b28b3c2512$export$ba1db4e691f11d50 = ()=>{
    // Ensure bridge instance is fully destroyed first to clean up all internal state
    if ($092fe4b28b3c2512$var$bridgeApiInstance) $092fe4b28b3c2512$var$bridgeApiInstance.destroy();
    $092fe4b28b3c2512$var$bridgeApiInstance = null;
    (0, $5s3v4.clearAPI)();
};

});
parcelRegister("jDdBA", function(module, exports) {
$parcel$export(module.exports, "RovoContentBridgeAPI", () => $e43b9ecd75d0cbb4$export$d90806e6eab0cb0a);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $21Wjy = parcelRequire("21Wjy");

var $iqfTZ = parcelRequire("iqfTZ");

var $cd27a = parcelRequire("cd27a");

var $lCPrG = parcelRequire("lCPrG");

var $jLW0e = parcelRequire("jLW0e");

var $jbMnm = parcelRequire("jbMnm");

var $7vL1x = parcelRequire("7vL1x");

var $4eBcB = parcelRequire("4eBcB");

var $8LcKM = parcelRequire("8LcKM");

var $6ZZeg = parcelRequire("6ZZeg");

var $3Qdyn = parcelRequire("3Qdyn");

var $b1lgN = parcelRequire("b1lgN");

var $bcqEj = parcelRequire("bcqEj");

var $arHYA = parcelRequire("arHYA");
class $e43b9ecd75d0cbb4$export$d90806e6eab0cb0a {
    constructor(instanceId, transport){
        this.registry = new (0, $cd27a.ClientRegistry)();
        this.queue = new (0, $3Qdyn.BufferedInvocationQueue)();
        this.transport = transport;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.identifier = (0, $lCPrG.client)(instanceId ? instanceId : `bridge-api-${(0, $21Wjy.default)()}`);
        this.rpc = {
            request: new (0, $bcqEj.RequestHandler)(this.transport),
            response: new (0, $arHYA.ResponseHandler)()
        };
        // setup emitter for all events
        (0, $8LcKM.emitter)().setBridgeId(this.identifier);
        // start listening for any incoming messages
        this.transport.onMessage(this.onMessage.bind(this));
        // setup tick handler for sending discovery commands to pending clients
        this.queue.onTick((pendingConnections)=>{
            for (const { senderId: senderId, receiverId: receiverId } of pendingConnections)this.sendCommand((0, $7vL1x.DiscoveryCommand), {
                senderId: senderId,
                receiverId: receiverId
            });
        });
        // setup dropped message handler to cancel orphaned promises
        this.queue.onInvocationDroppped((m)=>{
            this.rpc.response.cancel(m.invocationId);
            (0, $8LcKM.emitter)().emit({
                type: 'message-dropped',
                messageCount: this.queue.messageCount,
                messageId: m.invocationId,
                message: {
                    ...m.params
                },
                clientId: m.senderId,
                reason: 'queue-overflow'
            });
        });
        // setup client added handler to drain commands when clients are ready
        this.registry.onClientAdded((clientId)=>{
            this.drainCommands(clientId);
        });
        // observe readiness of bridge API
        (0, $8LcKM.emitter)().emit({
            type: 'bridge-ready'
        });
    }
    /**
	 * Unique ID for this specific bridge API instance.
	 *
	 * @description Should be the 1 instance in a given JS context.
	 */ get id() {
        return this.identifier;
    }
    /**
	 * Indicates a specific client is ready to start sending and accepting messages.
	 *
	 * @param clientId unique identifier for the client.
	 */ ready(clientId) {
        this.registry.addLocalClient(clientId);
        // client-specific handlers - sent by a remote client -> this bridge API instance,
        // targeting the client which we are setting up in this method
        this.createDiscoveryHandler(clientId);
        this.createReachableHandler(clientId);
        this.createTeardownHandler(clientId);
        // emit client registration event
        (0, $8LcKM.emitter)().emit({
            type: 'client-registered',
            clientId: clientId
        });
    }
    /**
	 * Send a command with strongly-typed parameters to a recipient.
	 *
	 * @description It is possible to wait for the response of a command via the following:
	 * ```typescript
	 * const command = send(MyCommand, {});
	 * await command.result(); // promise with result of the command
	 * // optionally, to cancel:
	 * command.cancel();
	 * ```
	 * Command invocations should be treated similarly in concept to network requests to an upstream system.
	 * The upstream system can time out, disappear, crash, etc. Hence, all command results yield an optional
	 * result, with resiliency baked in for connectivity with a client see {@link BufferedInvocationQueue}.
	 *
	 * Deferrables are used to expose a stable promise API for the result of a command. I.e., if the receiver
	 * of a command is not seen as 'ready' yet, commands will be buffered until a time limit. Once that time
	 * limit is expended, the message will be dropped, and its associated deferrable cancelled.
	 *
	 * @returns {CommandInvocation} api for handling the response of the command.
	 */ send(command, params) {
        // assign a unique ID to this command invocation
        if (!params._invocationId) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        params._invocationId = (0, $21Wjy.default)();
        // unique, stable ID for this command
        const id = (0, $b1lgN.createInvocationId)(command, params);
        const message = (0, $b1lgN.rpcCommand)(id, command, params);
        const senderId = params.senderId;
        const receiverId = params.receiverId;
        // emit command creation event
        (0, $8LcKM.emitter)().emit({
            type: 'command-created',
            commandId: id,
            commandType: command.identifier,
            senderId: senderId,
            receiverId: receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        let promise;
        // not ready to send to a known, communicable client yet - buffer & defer (if allowed)
        if (!this.registry.has(receiverId) || !this.transport.canSend(message) || this.registry.isPendingClient(receiverId)) {
            // default to buffering the sending of all commands
            const buffer = params.buffer ?? true;
            if (buffer) {
                this.queue.enqueue(id, senderId, receiverId, command, params);
                promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
            } else // opted out of buffering - resolve immediately to undefined
            promise = Promise.resolve(undefined);
        } else if (this.registry.isLocalClient(receiverId)) {
            // emit command sent event for local invocation
            (0, $8LcKM.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            const result = this.rpc.request.invoke(command, params);
            const existing = this.rpc.response.get(id);
            // if a local client was not ready yet and we tried to communicate with it,
            // we do not want to instantiate a new promise. Hence, we need to latch onto
            // the same deferrable as before, and yield it with the result of invoking the
            // handler provided by the local client which is ready & we are communicating to
            if (existing) {
                existing.resolve(result);
                promise = existing.promise;
            } else promise = result;
        } else {
            // emit command sent event
            (0, $8LcKM.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            this.transport.send(message);
            promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
        }
        return new (0, $jbMnm.CommandInvocation)(id, promise, (invocationId)=>this.cancel(invocationId), (groupId)=>this.cancelGroup(groupId));
    }
    /**
	 * Broadcasts a command to all registered clients except those that are pending or filtered out.
	 *
	 * @typeParam C - The type of command properties, which must include a `receiverId` of type `ClientId`.
	 * @param command - The constructor for the broadcastable command to be sent.
	 * @param params - The parameters for the command, excluding the `receiverId` which will be set for each recipient.
	 * @param options - Optional broadcast options, including a filter function to select specific clients.
	 *
	 * @remarks
	 * - Only commands that pass `isBroadcastableCommand` are sent.
	 * - The method retrieves all client IDs from the registry, filters out pending clients, and applies any additional filter provided in `options`.
	 * - For each eligible client, the command is sent with the appropriate `receiverId`.
	 * - Errors during broadcasting are caught and logged to the console.
	 */ broadcast(command, params, options) {
        try {
            if (!(0, $jLW0e.isBroadcastableCommand)(command)) return;
            const receiverIds = this.registry.getAllClientIds()?.filter((clientId)=>!this.registry.isPendingClient(clientId) && String(params.senderId) !== clientId)?.filter((clientId)=>options?.filter ? options.filter(clientId) : true) ?? [];
            for (const receiverId of receiverIds)this.send(command, {
                ...params,
                receiverId: receiverId
            });
            if (receiverIds.length) (0, $8LcKM.emitter)().emit({
                type: 'command-broadcast',
                senderId: params.senderId,
                receiverIds: receiverIds,
                commandType: command.identifier
            });
        } catch (err) {
            console.error('broadcast failed', err);
        }
    }
    /**
	 * Register a handler for a specific command type for a specific client.
	 */ on(clientId, Command, handler) {
        this.rpc.request.register(clientId, Command, handler);
        (0, $8LcKM.emitter)().emit({
            type: 'handler-registered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
	 * Unregister a handler for a specific command type for a specific client.
	 */ off(clientId, Command) {
        this.rpc.request.unregister(clientId, Command);
        (0, $8LcKM.emitter)().emit({
            type: 'handler-unregistered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
	 * Tears down a specific client, removing it from the registry and notifying all remote clients.
	 *
	 * @description This method performs the following actions:
	 * 1. Removes the client from the local registry
	 * 2. Sends teardown commands to all known remote clients
	 * 3. Drops all buffered messages for the client
	 * 4. Unregisters all command handlers for the client
	 * 5. Clears any pending response handlers for the client
	 * 6. Removes transport target references for the client
	 *
	 * @param clientId unique identifier for the client to tear down
	 */ teardown(clientId) {
        // 1. remove the client from the registry
        const wasRemoved = this.registry.removeClient(clientId);
        if (!wasRemoved) return;
        // 2. notify all remote clients about the teardown
        const allClientIds = this.registry.getAllClientIds();
        for (const otherClientId of allClientIds)// irrespective of state, we should communicate we are tearing down
        // this handles any potential race conditions with in-flight messages
        // across JS contexts (e.g., actively shaking hands with a pending client)
        if (this.registry.isPendingClient(otherClientId) || this.registry.isRemoteClient(otherClientId)) this.sendCommand((0, $7vL1x.TeardownCommand), {
            senderId: clientId,
            receiverId: otherClientId
        });
        // 3. drop all buffered messages for this client
        this.queue.clear(clientId);
        // 4. unregister all command handlers for this client
        this.rpc.request.unregisterAll(clientId);
        // 5. clear any pending response handlers for this client
        this.rpc.response.teardown(clientId);
        // 6. remove transport target references (Window/WebContents) for this client
        this.transport.teardown(clientId);
        // 7. emit client teardown event
        (0, $8LcKM.emitter)().emit({
            type: 'client-teardown',
            clientId: clientId
        });
    }
    /**
	 * Clear all state prior to the application being destroyed.
	 *
	 * @description NOTE: Ensure all containing state is destroyed to avoid memory leaks during
	 * SPA transitions away from application contexts which use the bridge API.
	 */ destroy() {
        this.queue.destroy();
        this.rpc.request.destroy();
        this.rpc.response.clear();
        this.registry.destroy();
        this.transport.destroy();
        // stop emitting any events & drop memory
        (0, $8LcKM.emitter)().emit({
            type: 'bridge-destroyed'
        });
        // clean up all event emitter state
        (0, $8LcKM.destroyGlobalEventEmitter)();
        (0, $4eBcB.destroyGlobalDebugConsumer)();
        (0, $6ZZeg.destroyGlobalObservabilityConsumer)();
    }
    /**
	 * Registers a message listener for RPC events received over {@link transport}.
	 * @param data RPC message received by this JS context
	 */ async onMessage(data) {
        try {
            if ((0, $b1lgN.isRPCRequest)(data)) return await this.rpc.request.handleRequest(data);
            if ((0, $b1lgN.isRPCResponse)(data)) return this.rpc.response.resolveWithResponse(data);
        } catch (err) {
            console.error('failed to handle message:', err);
        }
    }
    /**
	 * Sets up a reachable handler for a specific client ID
	 * @summary the {@link senderId} is the remote client who sent this command, expressing they are now reachable.
	 * @param senderId
	 */ createReachableHandler(senderId) {
        this.on(senderId, (0, $7vL1x.ReachableCommand), (params)=>{
            this.registry.addRemoteClient(params.senderId);
            (0, $8LcKM.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'reachable-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
	 * Sets up a discoverable handler for a specific client ID
	 * @summary the {@link senderId} is the remote client who sent this command, expressing they are looking for {@link senderId}.
	 * @param senderId
	 */ createDiscoveryHandler(senderId) {
        this.on(senderId, (0, $7vL1x.DiscoveryCommand), (params)=>{
            this.sendCommand((0, $7vL1x.ReachableCommand), {
                senderId: params.receiverId,
                receiverId: params.senderId
            });
            this.registry.addRemoteClient(params.senderId);
            (0, $8LcKM.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'discovery-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
	 * Sets up a teardown handler for a specific client ID
	 * @summary the {@link senderId} is the remote client who sent this command, expressing they are shutting down.
	 * @param receiverId the local client that should handle teardown notifications
	 */ createTeardownHandler(receiverId) {
        this.on(receiverId, (0, $7vL1x.TeardownCommand), (params)=>{
            // remove the client that is tearing down from our registry
            this.registry.removeClient(params.senderId);
            // drop all buffered messages for the client that is tearing down
            this.queue.clear(params.senderId);
            if ((0, $iqfTZ.fg)('rovo_bridge_remote_teardown_cleanup')) this.transport.teardown(params.senderId);
        });
    }
    /**
	 * Immediately send a command over the configured {@link transport}.
	 *
	 * @description Used for handshake between clients, to simplify logic.
	 * @description Re-used to send all commands in the bridge API.
	 *
	 * @param command command to send
	 * @param params command properties to provide
	 */ sendCommand(command, params) {
        const id = (0, $b1lgN.createInvocationId)(command, params);
        const message = (0, $b1lgN.rpcCommand)(id, command, params);
        this.transport.send(message);
    }
    /**
	 * Drain commands for a given client ID from the queue.
	 * @param clientId unique identifier for the client
	 */ drainCommands(clientId) {
        const messages = this.queue.flush(clientId);
        if (!messages) return;
        for (const message of messages)this.send(message.command, message.params);
    }
    /**
	 * Cancel all commands in a specific group.
	 *
	 * @param groupId The group identifier of commands to cancel
	 * @returns number of commands that were cancelled
	 */ cancelGroup(groupId) {
        // remove the buffered commands with this group ID from the queue, if they exist; will also clean up
        // the RPC response handler deferrable for each command
        return this.queue.cancelGroup(groupId);
    }
    /**
	 * Cancel a specific command invocation by its ID.
	 *
	 * @param invocationId The unique identifier of the command invocation to cancel
	 * @returns true if the command was found and cancelled, false otherwise
	 */ cancel(invocationId) {
        // remove the buffered command from the queue, if it exists on it; this will also clean up
        // the RPC response handler deferrable for this command
        return this.queue.cancel(invocationId);
    }
}

});
parcelRegister("cd27a", function(module, exports) {
$parcel$export(module.exports, "ClientRegistry", () => $2344622b59d9e035$export$c7eb95d2cb93befa);
class $2344622b59d9e035$export$c7eb95d2cb93befa {
    /**
	 * Yields the current state of a client.
	 * @param clientId
	 * @returns current state
	 */ get(clientId) {
        return this.registry.get(clientId);
    }
    /**
	 * Yields whether a given client is known or not to the registry.
	 * @param clientId unique identifier for the client
	 */ has(clientId) {
        return this.registry.has(clientId);
    }
    /**
	 * Adds an entry for a new, pending client. It will be marked as `ready` once a successful handshake transpires.
	 *
	 * @description Will early exit with a warning if the client being marked as `pending` is already `ready`. This
	 * is an anomalous state transition which we do not expect.
	 *
	 * @param clientId unique identifier for the client
	 * @returns void
	 */ addPendingClient(clientId) {
        const client = this.get(clientId);
        if (client && client.state === 'ready') {
            console.warn('tried to mark', clientId, 'as `pending` when already in `ready` state');
            return;
        }
        this.registry.set(clientId, {
            id: clientId,
            state: 'pending'
        });
    }
    /**
	 * Adds an entry for a local client. It will be immediately ready for direct communication in the same JS context.
	 *
	 * @description Will early exit with a warning if the client being marked as `local` if already `remote`. This
	 * is an anomalous state transition which we do not expect.
	 *
	 * @param clientId unique identifier for the client
	 * @returns void
	 */ addLocalClient(clientId) {
        if (this.isRemoteClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `local` when already tracked as `remote`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'local',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    /**
	 * Adds an entry for a remote client. It will be ready for asynchronous communication once a handshake transpires.
	 *
	 * @description Will early exit with a warning if the client being marked as `remote` if already `local`. This
	 * is an anomalous state transition which we do not expect.
	 *
	 * @param clientId unique identifier for the client
	 * @returns void
	 */ addRemoteClient(clientId) {
        if (this.isLocalClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `remote` when already tracked as `local`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'remote',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    isPendingClient(clientId) {
        const client = this.get(clientId);
        return client?.state === 'pending';
    }
    isLocalClient(clientId) {
        const client = this.get(clientId);
        return client?.state === 'ready' && client.type === 'local';
    }
    isRemoteClient(clientId) {
        const client = this.get(clientId);
        return client?.state === 'ready' && client.type === 'remote';
    }
    get size() {
        return this.registry.size;
    }
    /**
	 * Removes a client from the registry.
	 *
	 * @param clientId unique identifier for the client to remove
	 * @returns true if the client was removed, false if it wasn't found
	 */ removeClient(clientId) {
        return this.registry.delete(clientId);
    }
    /**
	 * Gets all client IDs currently in the registry.
	 *
	 * @returns array of all client IDs
	 */ getAllClientIds() {
        return Array.from(this.registry.keys());
    }
    /**
	 * Register a handler to be called when a client is added to the registry.
	 *
	 * @param handler Function to call when a client is added
	 */ onClientAdded(handler) {
        this.onClientAddedHandlers.add(handler);
    }
    /**
	 * Emit client added event to all registered handlers.
	 *
	 * @param clientId The client ID that was added
	 */ emitClientAdded(clientId) {
        for (const handler of this.onClientAddedHandlers)try {
            handler(clientId);
        } catch (error) {
            console.error('Error in client added handler:', error);
        }
    }
    /**
	 * Clean up all event handlers.
	 */ destroy() {
        this.onClientAddedHandlers.clear();
        this.registry.clear();
    }
    constructor(){
        /**
	 * A registry of all clients known to the current bridge API instance.
	 *
	 * @description NOTE: Clients undergo state transitions from pending -> ready until the current bridge
	 * API instance is able to communicate with them.
	 */ this.registry = new Map();
        /**
	 * Event handlers for when clients are added to the registry.
	 */ this.onClientAddedHandlers = new Set();
    }
}

});

parcelRegister("lCPrG", function(module, exports) {
$parcel$export(module.exports, "client", () => $6ec7f0126d50e40e$export$388e0302ca0d9a41);
/**
 * A unique ID for referring to a client of the bridge API.
 *
 * @description Can either be a producer or receiver of events.
 */ const $6ec7f0126d50e40e$export$388e0302ca0d9a41 = (s)=>s;

});

parcelRegister("jLW0e", function(module, exports) {
$parcel$export(module.exports, "isBroadcastableCommand", () => $a37c4a89ecae80a4$export$761a9dd8b8d30326);
function $a37c4a89ecae80a4$export$761a9dd8b8d30326(command) {
    return typeof command === 'function' && command.__broadcastable === true;
}

});

parcelRegister("jbMnm", function(module, exports) {
$parcel$export(module.exports, "CommandInvocation", () => $e05903c8840d4b4e$export$aa5e57f9f8c1afec);
class $e05903c8840d4b4e$export$aa5e57f9f8c1afec {
    constructor(invocationId, resultPromise, cancelCallback, cancelGroupCallback){
        this.invocationId = invocationId;
        this.resultPromise = resultPromise;
        this.cancelCallback = cancelCallback;
        this.cancelGroupCallback = cancelGroupCallback;
    }
    /**
	 * Get the result of the command invocation.
	 *
	 * @description Returns a promise that resolves to the command result, or undefined if cancelled.
	 *
	 * @returns Promise that resolves to the command result, or undefined if cancelled
	 */ result() {
        return this.resultPromise;
    }
    /**
	 * Cancel this specific command invocation.
	 *
	 * @description Attempts to cancel the command if it's still buffered or in-flight.
	 * If the command has already completed, this will have no effect.
	 *
	 * @returns true if the command was found and cancelled, false if it was already completed/cancelled
	 */ cancel() {
        return this.cancelCallback(this.invocationId);
    }
    /**
	 * Cancel all commands in a specific group.
	 *
	 * @description Cancels all buffered commands that share the same groupId.
	 * This is useful for cancelling related commands that were sent as part of the same operation.
	 *
	 * @param groupId The group identifier of commands to cancel
	 * @returns number of commands that were cancelled
	 */ cancelGroup(groupId) {
        return this.cancelGroupCallback(groupId);
    }
}

});

parcelRegister("7vL1x", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCommand", () => $cfe99cec2617f731$export$ae5619804e22bb3b);
$parcel$export(module.exports, "ReachableCommand", () => $cfe99cec2617f731$export$bf4ce67fda5f9b9f);
$parcel$export(module.exports, "TeardownCommand", () => $cfe99cec2617f731$export$6884e468caa75174);

var $7xUUt = parcelRequire("7xUUt");
const $cfe99cec2617f731$export$ae5619804e22bb3b = (0, $7xUUt.createCommand)('discovery-command');
const $cfe99cec2617f731$export$bf4ce67fda5f9b9f = (0, $7xUUt.createCommand)('reachable-command');
const $cfe99cec2617f731$export$6884e468caa75174 = (0, $7xUUt.createCommand)('teardown-command');

});
parcelRegister("7xUUt", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $4d273e073f9652b1$export$8d4021544bdece00);
$parcel$export(module.exports, "createBroadcastableCommand", () => $4d273e073f9652b1$export$87c8f2eea65200a8);

var $bAlcE = parcelRequire("bAlcE");
function $4d273e073f9652b1$export$8d4021544bdece00(commandName) {
    return class NamedCommand extends (0, $bAlcE.Command) {
        static{
            /**
		 * @see {@link Command.identifier}
		 */ this.identifier = commandName;
        }
    };
}
function $4d273e073f9652b1$export$87c8f2eea65200a8(commandName) {
    // We create a class and then assert the broadcastable marker.
    return class NamedBroadcastCommand extends (0, $bAlcE.Command) {
        static{
            this.identifier = commandName;
        }
        static{
            this.__broadcastable = true;
        }
    };
}

});
parcelRegister("bAlcE", function(module, exports) {
$parcel$export(module.exports, "Command", () => $6f3d07c3817a69ec$export$cc7e12c76513e857);
class $6f3d07c3817a69ec$export$cc7e12c76513e857 {
    constructor(properties, result){
        this.properties = properties;
        this.result = result;
    }
}

});



parcelRegister("4eBcB", function(module, exports) {
$parcel$export(module.exports, "getDebugConsumer", () => $942003566250607c$export$f646f8b6276e8a5d);
$parcel$export(module.exports, "destroyGlobalDebugConsumer", () => $942003566250607c$export$7e0c663a378d377a);

var $8LcKM = parcelRequire("8LcKM");
/**
 * Default debug configuration.
 */ const $942003566250607c$var$DEFAULT_CONFIG = {
    enabled: false,
    maxHistory: 1000
};
class $942003566250607c$export$6144c928b2a81851 {
    /**
	 * Start consuming and logging bridge API events.
	 */ enable() {
        if (this.subscription) return; // Already enabled
        this.config.enabled = true;
        this.subscription = (0, $8LcKM.emitter)().onAny((event)=>{
            if (this.config.enabled && this.shouldLogEvent(event)) {
                this.logEvent(event);
                this.addToHistory(event);
            }
        });
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Enabled", 'color: #4ECDC4; font-weight: bold; font-size: 14px;');
    }
    /**
	 * Stop consuming bridge API events.
	 */ disable() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        this.config.enabled = false;
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Disabled", 'color: #FF6B6B; font-weight: bold; font-size: 14px;');
    }
    /**
	 * Update debug configuration.
	 */ configure(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
        console.log("%c\uD83D\uDD27 Debug configuration updated", 'color: #96CEB4; font-weight: bold;', this.config);
    }
    /**
	 * Get current configuration.
	 */ getConfig() {
        return {
            ...this.config
        };
    }
    /**
	 * Get event history.
	 */ getHistory() {
        return [
            ...this.eventHistory
        ];
    }
    /**
	 * Clear event history.
	 */ clearHistory() {
        this.eventHistory = [];
        console.log("%c\uD83E\uDDF9 Event history cleared", 'color: #FFEAA7; font-weight: bold;');
    }
    /**
	 * Get debug statistics.
	 */ getStats() {
        const eventCounts = this.eventHistory.reduce((counts, event)=>{
            counts[event.type] = (counts[event.type] || 0) + 1;
            return counts;
        }, {});
        return {
            enabled: this.config.enabled,
            totalEvents: this.eventHistory.length,
            eventCounts: eventCounts,
            uniqueClients: new Set(this.eventHistory.filter((e)=>'clientId' in e).map((e)=>e.clientId)).size,
            uniqueCommands: new Set(this.eventHistory.filter((e)=>'commandType' in e).map((e)=>e.commandType)).size
        };
    }
    /**
	 * Export event history as JSON.
	 */ exportHistory() {
        return JSON.stringify({
            exportedAt: new Date().toISOString(),
            config: this.config,
            events: this.eventHistory,
            stats: this.getStats()
        }, null, 2);
    }
    /**
	 * Log an event to the console with simple formatting.
	 */ logEvent(event) {
        const icon = this.eventIcons[event.type] || "\uD83D\uDCCB";
        const timestamp = this.formatTimestamp(event.timestamp);
        const bridgeId = event.bridgeId;
        // Create collapsible group with basic info
        const groupTitle = `${icon} ${timestamp} ${event.type} [${bridgeId}]`;
        console.groupCollapsed(`%c${groupTitle}`, this.getEventTypeStyle(event.type));
        // Add key details in a simple format
        this.logKeyDetails(event);
        // Log raw event data
        console.log('%cRaw Event:', 'color: #888; font-style: italic;', event);
        console.groupEnd();
    }
    /**
	 * Log key event details in a simple format.
	 */ logKeyDetails(event) {
        // Client ID (if present)
        if ('clientId' in event) {
            const clientEvent = event;
            console.log(`%c\u{1F464} Client: %c${clientEvent.clientId}`, 'font-weight: bold;', this.getClientStyle(clientEvent.clientId));
        }
        // Command details (if present)
        if ('commandType' in event) {
            const cmdEvent = event;
            console.log(`%c\u{26A1} Command: %c${cmdEvent.commandType}`, 'font-weight: bold;', this.getCommandStyle(cmdEvent.commandType));
            if (cmdEvent.senderId && cmdEvent.receiverId) console.log(`%c\u{1F4E4} %c${cmdEvent.senderId} %c\u{2192} %c\u{1F4E5} %c${cmdEvent.receiverId}`, 'font-weight: bold;', this.getClientStyle(cmdEvent.senderId), 'color: #888;', 'font-weight: bold;', this.getClientStyle(cmdEvent.receiverId));
            if (cmdEvent.duration !== undefined) console.log(`%c\u{23F1}\u{FE0F} Duration: %c${this.formatDuration(cmdEvent.duration)}`, 'font-weight: bold;', this.getDurationStyle(cmdEvent.duration));
        }
        // Error (if present)
        if ('error' in event && event.error) {
            const errorEvent = event;
            console.log("%c\u274C Error:", 'color: #FF6B6B; font-weight: bold;', errorEvent.error);
        }
        // Queue size (if present)
        if ('queueSize' in event) {
            const queueEvent = event;
            console.log(`%c\u{1F4CB} Queue Size: %c${queueEvent.queueSize}`, 'font-weight: bold;', this.getQueueSizeStyle(queueEvent.queueSize));
        }
    }
    /**
	 * Check if an event should be logged (with debouncing for transport errors).
	 */ shouldLogEvent(event) {
        // Apply event filter if configured
        if (this.config.eventFilter && this.config.eventFilter.length > 0) {
            const matchesFilter = this.config.eventFilter.some((filter)=>{
                // Support category filters
                if (filter === 'commands') return event.type.startsWith('command-');
                if (filter === 'clients') return event.type.startsWith('client-');
                if (filter === 'transport') return event.type.startsWith('transport-');
                if (filter === 'queue') return event.type.includes('queue') || event.type.includes('message-');
                if (filter === 'handlers') return event.type.startsWith('handler-');
                if (filter === 'bridge') return event.type.startsWith('bridge-');
                if (filter === 'errors') return event.type.includes('error') || event.type.includes('failed') || event.type.includes('dropped');
                // Support exact event type matching
                return event.type === filter;
            });
            if (!matchesFilter) return false;
        }
        // Debounce transport errors to prevent spam during tick loops
        if (event.type === 'transport-error') {
            const transportEvent = event;
            const errorKey = `${event.type}-${transportEvent.messageId || 'unknown'}-${transportEvent.error?.message || 'unknown'}`;
            const lastLogged = this.recentErrors.get(errorKey) || 0;
            const now = Date.now();
            if (now - lastLogged < this.ERROR_DEBOUNCE_MS) return false; // Skip this duplicate error
            this.recentErrors.set(errorKey, now);
        }
        return true;
    }
    /**
	 * Add event to history with size management.
	 */ addToHistory(event) {
        this.eventHistory.push(event);
        // Trim history if it exceeds max size
        if (this.eventHistory.length > this.config.maxHistory) this.eventHistory.shift();
    }
    /**
	 * Get color for a client ID.
	 */ getClientColor(clientId) {
        if (!this.clientColors.has(clientId)) {
            const colorIndex = this.clientColors.size % this.colors.length;
            this.clientColors.set(clientId, this.colors[colorIndex]);
        }
        return this.clientColors.get(clientId);
    }
    /**
	 * Get color for a command type.
	 */ getCommandColor(commandType) {
        if (!this.commandColors.has(commandType)) {
            const colorIndex = this.commandColors.size % this.colors.length;
            this.commandColors.set(commandType, this.colors[colorIndex]);
        }
        return this.commandColors.get(commandType);
    }
    /**
	 * Get CSS style for event type.
	 */ getEventTypeStyle(eventType) {
        const baseStyle = 'font-weight: bold; font-size: 12px;';
        if (eventType.includes('error') || eventType.includes('failed')) return `${baseStyle} color: #FF6B6B;`;
        if (eventType.includes('completed') || eventType.includes('ready')) return `${baseStyle} color: #4ECDC4;`;
        if (eventType.includes('created') || eventType.includes('sent')) return `${baseStyle} color: #45B7D1;`;
        return `${baseStyle} color: #666;`;
    }
    /**
	 * Get CSS style for client ID.
	 */ getClientStyle(clientId) {
        return `color: ${this.getClientColor(clientId)}; font-weight: bold;`;
    }
    /**
	 * Get CSS style for command type.
	 */ getCommandStyle(commandType) {
        return `color: ${this.getCommandColor(commandType)}; font-weight: bold;`;
    }
    /**
	 * Get CSS style for duration based on performance.
	 */ getDurationStyle(duration) {
        if (duration < 10) return 'color: #4ECDC4; font-weight: bold;';
         // Fast
        if (duration < 100) return 'color: #FFEAA7; font-weight: bold;';
         // Medium
        return 'color: #FF6B6B; font-weight: bold;'; // Slow
    }
    /**
	 * Get CSS style for queue size.
	 */ getQueueSizeStyle(size) {
        if (size === 0) return 'color: #4ECDC4; font-weight: bold;';
        if (size < 5) return 'color: #FFEAA7; font-weight: bold;';
        return 'color: #FF6B6B; font-weight: bold;';
    }
    /**
	 * Format timestamp for display.
	 */ formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour12: false
        });
    }
    /**
	 * Format duration in milliseconds.
	 */ formatDuration(ms) {
        if (ms < 1) return `${(ms * 1000).toFixed(0)}\u{3BC}s`;
        if (ms < 1000) return `${ms.toFixed(1)}ms`;
        return `${(ms / 1000).toFixed(2)}s`;
    }
    constructor(){
        this.config = {
            ...$942003566250607c$var$DEFAULT_CONFIG
        };
        this.subscription = null;
        this.eventHistory = [];
        this.clientColors = new Map();
        this.commandColors = new Map();
        this.recentErrors = new Map();
        this.ERROR_DEBOUNCE_MS = 5000; // 5 seconds
        /**
	 * Color palette for consistent coloring.
	 */ this.colors = [
            '#FF6B6B',
            '#4ECDC4',
            '#45B7D1',
            '#96CEB4',
            '#FFEAA7',
            '#DDA0DD',
            '#98D8C8',
            '#F7DC6F',
            '#BB8FCE',
            '#85C1E9'
        ];
        /**
	 * Event type icons for visual distinction.
	 */ this.eventIcons = {
            // Bridge events
            'bridge-ready': "\uD83C\uDF09",
            'bridge-destroyed': "\uD83D\uDCA5",
            // Client events
            'client-registered': "\uD83D\uDCDD",
            'client-ready': "\u2705",
            'client-discovered': "\uD83D\uDD0D",
            'client-teardown': "\uD83D\uDD04",
            // Command events
            'command-created': "\u26A1",
            'command-sent': "\uD83D\uDCE4",
            'command-received': "\uD83D\uDCE5",
            'command-completed': "\u2705",
            'command-failed': "\u274C",
            // Queue events
            'message-queued': "\uD83D\uDCCB",
            'queue-flushed': "\uD83D\uDE80",
            'queue-cleared': "\uD83E\uDDF9",
            'message-dropped': "\uD83D\uDDD1\uFE0F",
            // Transport events
            'transport-ready': "\uD83D\uDE9B",
            'transport-message-sent': "\uD83D\uDCE1",
            'transport-message-received': "\uD83D\uDCFB",
            'transport-error': "\u26A0\uFE0F",
            'transport-destroyed': "\uD83D\uDC80",
            // Handler events
            'handler-registered': "\uD83D\uDD27",
            'handler-unregistered': "\uD83D\uDD13",
            // Broadcast events
            'command-broadcast': "\uD83D\uDCE2"
        };
    }
}
/**
 * Global debug consumer instance.
 */ let $942003566250607c$var$globalDebugConsumer = null;
function $942003566250607c$export$f646f8b6276e8a5d() {
    if (!$942003566250607c$var$globalDebugConsumer) $942003566250607c$var$globalDebugConsumer = new $942003566250607c$export$6144c928b2a81851();
    return $942003566250607c$var$globalDebugConsumer;
}
function $942003566250607c$export$7e0c663a378d377a() {
    if ($942003566250607c$var$globalDebugConsumer) {
        $942003566250607c$var$globalDebugConsumer.disable();
        $942003566250607c$var$globalDebugConsumer = null;
    }
}

});
parcelRegister("8LcKM", function(module, exports) {
$parcel$export(module.exports, "emitter", () => $4d15eb6461284828$export$bad24218ebd77223);
$parcel$export(module.exports, "destroyGlobalEventEmitter", () => $4d15eb6461284828$export$9e5e7c9e5a788cf7);
class $4d15eb6461284828$export$543ba59d3cb254aa {
    constructor(config = {}){
        this.handlers = new Map();
        this.globalHandlers = new Set();
        this.bridgeId = null;
        this.config = {
            enabled: true,
            ...config
        };
    }
    /**
	 * Set the bridge ID for this emitter instance.
	 * Should be called once when the bridge API is initialized.
	 *
	 * @param bridgeId The unique identifier for the bridge API instance
	 */ setBridgeId(bridgeId) {
        this.bridgeId = bridgeId;
    }
    /**
	 * Emit an event to all registered handlers.
	 * Automatically adds timestamp and bridge ID to the event.
	 *
	 * @param event The event to emit (without timestamp and bridgeId)
	 */ emit(event) {
        // Early return if emitter is disabled
        if (!this.config.enabled) return;
        // Automatically add timestamp and bridge ID
        const fullEvent = {
            ...event,
            timestamp: Date.now(),
            bridgeId: this.bridgeId ?? 'unknown-bridge'
        };
        // Emit to type-specific handlers
        const typeHandlers = this.handlers.get(fullEvent.type);
        if (typeHandlers) for (const handler of typeHandlers)this.safeInvoke(handler, fullEvent);
        // Emit to global handlers
        for (const handler of this.globalHandlers)this.safeInvoke(handler, fullEvent);
    }
    /**
	 * Listen for events of a specific type.
	 *
	 * @param eventType The type of event to listen for
	 * @param handler The handler function to call when the event occurs
	 * @returns A subscription handle
	 */ on(eventType, handler) {
        if (!this.handlers.has(eventType)) this.handlers.set(eventType, new Set());
        const handlers = this.handlers.get(eventType);
        handlers.add(handler);
        return this.createSubscription(()=>{
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        });
    }
    /**
	 * Listen for all events regardless of type.
	 *
	 * @param handler The handler function to call for any event
	 * @returns A subscription handle
	 */ onAny(handler) {
        this.globalHandlers.add(handler);
        return this.createSubscription(()=>{
            this.globalHandlers.delete(handler);
        });
    }
    /**
	 * Remove a specific handler for an event type.
	 *
	 * @param eventType The event type to remove the handler from
	 * @param handler The handler to remove
	 */ off(eventType, handler) {
        const handlers = this.handlers.get(eventType);
        if (handlers) {
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        }
    }
    /**
	 * Remove all handlers for a specific event type.
	 *
	 * @param eventType The event type to clear handlers for
	 */ removeAllListeners(eventType) {
        if (eventType) this.handlers.delete(eventType);
        else {
            this.handlers.clear();
            this.globalHandlers.clear();
        }
    }
    /**
	 * Update emitter configuration.
	 *
	 * @param config New configuration options
	 */ configure(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    /**
	 * Enable or disable the emitter.
	 *
	 * @param enabled Whether to enable event emission
	 */ setEnabled(enabled) {
        this.config.enabled = enabled;
    }
    /**
	 * Check if the emitter is currently enabled.
	 */ isEnabled() {
        return this.config.enabled;
    }
    /**
	 * Destroy the emitter and clean up all resources.
	 */ destroy() {
        this.handlers.clear();
        this.globalHandlers.clear();
        this.config.enabled = false;
    }
    /**
	 * Safely invoke a handler, catching any errors.
	 */ safeInvoke(handler, event) {
        try {
            handler(event);
        } catch  {
        // we do not want to produce error logs for the observer
        // if you need to add logs, go for it - just remove them afterwards!
        }
    }
    /**
	 * Create a subscription handle.
	 */ createSubscription(unsubscribeFn) {
        let active = true;
        return {
            unsubscribe: ()=>{
                if (active) {
                    unsubscribeFn();
                    active = false;
                }
            },
            isActive: ()=>active
        };
    }
}
/**
 * Default global event emitter instance.
 *
 * This can be used as a singleton across the bridge API, or individual
 * bridge instances can create their own emitters.
 */ let $4d15eb6461284828$var$globalEmitter = null;
function $4d15eb6461284828$export$bad24218ebd77223() {
    if (!$4d15eb6461284828$var$globalEmitter) $4d15eb6461284828$var$globalEmitter = new $4d15eb6461284828$export$543ba59d3cb254aa();
    return $4d15eb6461284828$var$globalEmitter;
}
function $4d15eb6461284828$export$9e5e7c9e5a788cf7() {
    if ($4d15eb6461284828$var$globalEmitter) {
        $4d15eb6461284828$var$globalEmitter.destroy();
        $4d15eb6461284828$var$globalEmitter = null;
    }
}

});


parcelRegister("6ZZeg", function(module, exports) {
$parcel$export(module.exports, "destroyGlobalObservabilityConsumer", () => $653f1467ab37d304$export$19aa922f09a1d9de);

var $8LcKM = parcelRequire("8LcKM");
const $653f1467ab37d304$var$DEFAULT_CONFIG = {
    registrationGapThresholdMs: 10000,
    queueDepthWarningThreshold: 50,
    registrationGapDebounceMs: 60000
};
class $653f1467ab37d304$export$43f799969b7f8bad {
    enable(sink, config) {
        if (this.subscription) return;
        if (config) this.config = {
            ...$653f1467ab37d304$var$DEFAULT_CONFIG,
            ...config
        };
        this.sink = sink;
        this.subscription = (0, $8LcKM.emitter)().onAny((event)=>this.handle(event));
    }
    disable() {
        this.subscription?.unsubscribe();
        this.subscription = null;
        this.sink = null;
        for (const { timer: timer } of this.pendingReceivers.values())clearTimeout(timer);
        this.pendingReceivers.clear();
        this.registeredClients.clear();
        this.lastGapEmittedAt.clear();
    }
    isEnabled() {
        return this.subscription !== null;
    }
    handle(event) {
        switch(event.type){
            case 'client-registered':
            case 'client-discovered':
                {
                    const { clientId: clientId } = event;
                    this.registeredClients.add(clientId);
                    this.resolvePendingReceiver(clientId, 'registration-succeeded');
                    break;
                }
            case 'client-teardown':
                {
                    const { clientId: clientId } = event;
                    this.registeredClients.delete(clientId);
                    this.resolvePendingReceiver(clientId, 'registration-aborted');
                    break;
                }
            case 'message-queued':
                {
                    const queueEvent = event;
                    const receiverId = queueEvent.clientId;
                    if (receiverId && !this.registeredClients.has(receiverId)) this.trackPendingReceiver(receiverId);
                    if ((queueEvent.messageCount ?? 0) >= this.config.queueDepthWarningThreshold) this.forward('message-queued', event, {
                        clientId: receiverId,
                        reason: queueEvent.reason,
                        queueDepth: queueEvent.messageCount
                    });
                    break;
                }
            case 'queue-flushed':
                {
                    const receiverId = event.clientId;
                    if (receiverId) this.resolvePendingReceiver(receiverId, 'registration-succeeded');
                    break;
                }
            case 'queue-cleared':
                {
                    const receiverId = event.clientId;
                    if (receiverId) this.resolvePendingReceiver(receiverId, 'registration-aborted');
                    break;
                }
            case 'message-dropped':
                {
                    const queueEvent = event;
                    this.forward('message-dropped', event, {
                        clientId: queueEvent.clientId,
                        reason: queueEvent.reason,
                        queueDepth: queueEvent.messageCount
                    });
                    break;
                }
            default:
                break;
        }
    }
    trackPendingReceiver(receiverId) {
        if (this.pendingReceivers.has(receiverId)) return;
        const timer = setTimeout(()=>this.emitRegistrationGap(receiverId), this.config.registrationGapThresholdMs);
        this.pendingReceivers.set(receiverId, {
            firstQueuedAt: Date.now(),
            timer: timer
        });
        this.sink?.({
            signal: 'registration-pending',
            clientId: receiverId,
            timestamp: Date.now()
        });
    }
    resolvePendingReceiver(receiverId, outcome) {
        const pending = this.pendingReceivers.get(receiverId);
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingReceivers.delete(receiverId);
        const now = Date.now();
        this.sink?.({
            signal: outcome,
            clientId: receiverId,
            waitedMs: now - pending.firstQueuedAt,
            timestamp: now
        });
    }
    emitRegistrationGap(receiverId) {
        const pending = this.pendingReceivers.get(receiverId);
        this.pendingReceivers.delete(receiverId);
        if (!pending || this.registeredClients.has(receiverId)) return;
        const now = Date.now();
        const lastEmitted = this.lastGapEmittedAt.get(receiverId);
        if (lastEmitted !== undefined && now - lastEmitted < this.config.registrationGapDebounceMs) return;
        this.lastGapEmittedAt.set(receiverId, now);
        this.sink?.({
            signal: 'registration-gap',
            clientId: receiverId,
            waitedMs: now - pending.firstQueuedAt,
            timestamp: now
        });
    }
    forward(signal, source, fields) {
        this.sink?.({
            signal: signal,
            timestamp: source.timestamp ?? Date.now(),
            bridgeId: source.bridgeId,
            ...fields
        });
    }
    constructor(){
        this.subscription = null;
        this.sink = null;
        this.config = {
            ...$653f1467ab37d304$var$DEFAULT_CONFIG
        };
        this.registeredClients = new Set();
        this.pendingReceivers = new Map();
        this.lastGapEmittedAt = new Map();
    }
}
let $653f1467ab37d304$var$globalObservabilityConsumer = null;
function $653f1467ab37d304$export$4c639b188cc02177() {
    if (!$653f1467ab37d304$var$globalObservabilityConsumer) $653f1467ab37d304$var$globalObservabilityConsumer = new $653f1467ab37d304$export$43f799969b7f8bad();
    return $653f1467ab37d304$var$globalObservabilityConsumer;
}
function $653f1467ab37d304$export$19aa922f09a1d9de() {
    if ($653f1467ab37d304$var$globalObservabilityConsumer) {
        $653f1467ab37d304$var$globalObservabilityConsumer.disable();
        $653f1467ab37d304$var$globalObservabilityConsumer = null;
    }
}

});

parcelRegister("3Qdyn", function(module, exports) {
$parcel$export(module.exports, "BufferedInvocationQueue", () => $e35b024c436fc88e$export$b0fcb10052c4c5ff);

var $8LcKM = parcelRequire("8LcKM");

class $e35b024c436fc88e$export$b0fcb10052c4c5ff {
    /**
	 * Buffers an invocation into a queue tied to the intended {@link receiverId}.
	 *
	 * @description Once the receiver is reachable, this message will be flushed alongside any other messages
	 * which were previously enqueued against the provided {@link receiverId}.
	 *
	 * @param invocationId
	 * @param senderId
	 * @param receiverId
	 * @param command
	 * @param params
	 */ enqueue(invocationId, senderId, receiverId, command, params) {
        const queue = this.queue.get(receiverId) ?? [];
        const now = performance.now();
        const groupId = params.groupId;
        // check the receiver is not overwhelmed with too many pending messages; if it is, drop the oldest message
        if (queue.length >= (0, $193c3b479529650b$export$1552419560d53c41)) {
            console.warn(`Message queue for receiver ${receiverId} is full, dropping oldest message`);
            const expired = queue.shift();
            if (expired) this.onInvocationDropped?.(expired);
        }
        // check if the overall queue isn't overwhelmed; if it is, drop the oldest message from each receiver
        if (this.messageCount >= (0, $193c3b479529650b$export$2805cdefd9b18065)) {
            console.warn('Total message queue is full, dropping oldest messages');
            this.checkAndDropOldestMessage();
        }
        // If this command has a groupId, reset the timer for all commands with the same groupId
        if (groupId) this.resetGroupTimers(groupId, now);
        queue.push({
            invocationId: invocationId,
            senderId: senderId,
            receiverId: receiverId,
            command: command,
            params: params,
            enqueuedAt: now
        });
        this.queue.set(receiverId, queue);
        (0, $8LcKM.emitter)().emit({
            type: 'message-queued',
            messageCount: this.messageCount,
            messageId: invocationId,
            clientId: receiverId,
            reason: 'receiver-not-ready'
        });
        // now that we have >1 message (at least), start a tick which executes every N millis
        // and drop any messages which go beyond the lifetime limit
        this.startTick();
    }
    /**
	 * Flush all messages associated with a speciifc receiver.
	 *
	 * @description Typically called once the receiver is marked as ready.
	 *
	 * @param receiverId unique identifier for the receiver
	 */ flush(receiverId) {
        const messages = this.queue.get(receiverId);
        // no messages found
        if (!messages) return;
        // we know we have a reference in the message list now - remove it
        this.deleteClientFromQueue(receiverId);
        // empty message list
        if (messages.length === 0) return;
        // emit queue flush event
        (0, $8LcKM.emitter)().emit({
            type: 'queue-flushed',
            clientId: receiverId,
            messageCount: messages.length,
            reason: 'client-ready'
        });
        // return no-empty message list
        return messages;
    }
    /**
	 * Returns the total number of messages across all receivers.
	 * @returns count of messages across all buffered receivers
	 */ get messageCount() {
        return Array.from(this.queue.values()).reduce((sum, q)=>sum + q.length, 0);
    }
    /**
	 * Registers a callback to be called on every tick with unique senderId/receiverId pairs
	 * for clients that are still waiting to connect.
	 *
	 * @param callback Function to call with pending connection pairs
	 */ onTick(callback) {
        this.onTickCallback = callback;
    }
    /**
	 * Registers a callback to be called when a message is dropped due to expiration or queue overflow.
	 *
	 * @param callback Callback to invoke with the dropped message
	 */ onInvocationDroppped(callback) {
        this.onInvocationDropped = callback;
    }
    /**
	 * Drops all buffered messages for a specific client (both as sender and receiver).
	 *
	 * @param clientId unique identifier for the client whose messages should be dropped
	 * @returns number of messages that were dropped
	 */ clear(clientId) {
        let droppedCount = 0;
        const toDelete = new Set();
        // remove all messages where this client is the receiver
        if (this.queue.has(clientId)) {
            const messages = this.queue.get(clientId) ?? [];
            if (messages.length > 0) (0, $8LcKM.emitter)().emit({
                type: 'queue-cleared',
                clientId: clientId,
                messageCount: this.messageCount - messages.length,
                reason: 'client-teardown'
            });
            // notify before dropping messages
            if (this.onInvocationDropped) for (const message of messages)this.onInvocationDropped(message);
            droppedCount += messages.length;
            // delete immediately - we do not want to process this queue below
            this.queue.delete(clientId);
        }
        // remove all messages where this client is the sender
        for (const [receiverId, messages] of this.queue){
            const messagesLength = messages.length;
            const messagesToKeep = messages.filter((message)=>{
                if (message.senderId === clientId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    return false;
                }
                return true;
            });
            const removedCount = messagesLength - messagesToKeep.length;
            if (removedCount > 0) {
                droppedCount += removedCount;
                if (messagesToKeep.length === 0) toDelete.add(receiverId);
                else this.queue.set(receiverId, messagesToKeep);
            }
        }
        // clean up empty queues and stop tick
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
	 * Drops a specific buffered message by its invocation ID.
	 *
	 * @param invocationId The unique identifier of the message to drop
	 * @returns true if the message was found and dropped, false otherwise
	 */ cancel(invocationId) {
        for (const [receiverId, messages] of this.queue){
            const messageIndex = messages.findIndex((msg)=>msg.invocationId === invocationId);
            if (messageIndex !== -1) {
                const droppedMessage = messages[messageIndex];
                // notify before dropping message
                if (this.onInvocationDropped) this.onInvocationDropped(droppedMessage);
                // remove the message
                messages.splice(messageIndex, 1);
                // if no more messages for this receiver, clean up
                if (messages.length === 0) this.deleteClientFromQueue(receiverId);
                return true;
            }
        }
        return false;
    }
    /**
	 * Cancels all buffered messages that match a specific group ID.
	 *
	 * @param groupId The group identifier of messages to cancel
	 * @returns number of messages that were cancelled
	 */ cancelGroup(groupId) {
        let droppedCount = 0;
        const toDelete = new Set();
        for (const [receiverId, messages] of this.queue){
            const messagesToKeep = messages.filter((message)=>{
                if (message.params.groupId === groupId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    droppedCount++;
                    return false;
                }
                return true;
            });
            if (messagesToKeep.length === 0) toDelete.add(receiverId);
            else if (messagesToKeep.length !== messages.length) this.queue.set(receiverId, messagesToKeep);
        }
        // clean up empty queues
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
	 * Clear all state relevant to the queue.
	 */ destroy() {
        this.queue.clear();
        if (this.tick) {
            clearInterval(this.tick);
            this.tick = undefined;
        }
        // clear callback references
        this.onTickCallback = undefined;
        this.onInvocationDropped = undefined;
    }
    /**
	 * Checks the lifetime of all messages in the queue and drops them if they have exceeded their
	 * maximum allowed lifetime of {@link MESSAGE_LIFETIME_IN_MILLIS}.
	 */ checkLifetimeAndDrop() {
        const now = performance.now();
        const toDelete = new Set();
        // cull all messages for each receiver which have expired
        for (const [receiverId, messages] of this.queue){
            let needle = 0;
            // find the first message that has not expired (since messages are chronologically ordered)
            for(let idx = 0; idx < messages.length; idx++){
                const waitTime = now - messages[idx].enqueuedAt;
                if (waitTime <= (0, $193c3b479529650b$export$ac4b6c122e5e5626)) {
                    needle = idx;
                    break;
                } else needle = messages.length;
            }
            // remove all expired messages in one sweep
            if (needle > 0) {
                // notify before dropping messages
                if (this.onInvocationDropped) for(let idx = 0; idx < needle; idx++)this.onInvocationDropped(messages[idx]);
                // remove expired messages
                messages.splice(0, needle);
            }
            // if we no longer have any messages, we should clear this entry entirely
            if (messages.length === 0) toDelete.add(receiverId);
        }
        // clean up all empty entries
        this.deleteClientsFromQueue(toDelete);
    }
    /**
	 * Drops the oldest messages across all receivers when the total queue size is exceeded.
	 */ checkAndDropOldestMessage() {
        let oldest = Infinity;
        let receiver = null;
        for (const [receiverId, messages] of this.queue)if (messages.length > 0 && messages[0].enqueuedAt < oldest) {
            oldest = messages[0].enqueuedAt;
            receiver = receiverId;
        }
        // drop the oldest message
        if (receiver) {
            const queue = this.queue.get(receiver) ?? [];
            queue.shift();
            // if no more messages - clean up
            if (queue.length === 0) this.deleteClientFromQueue(receiver);
        }
    }
    /**
	 * Resets the enqueuedAt time for all messages with the specified groupId across all receivers.
	 * This ensures that when a new message with a groupId is enqueued, all messages in the same
	 * group get their timer reset, allowing the entire group to stay alive for MESSAGE_LIFETIME_IN_MILLIS
	 * after the last message in the group.
	 *
	 * @param groupId The group identifier to reset timers for
	 * @param newTime The new enqueuedAt time to set for all messages in the group
	 */ resetGroupTimers(groupId, newTime) {
        for (const messages of this.queue.values()){
            for (const message of messages)if (message.params.groupId === groupId) message.enqueuedAt = newTime;
        }
    }
    /**
	 * Extracts unique senderId/receiverId pairs from all buffered messages.
	 * @returns Array of unique sender/receiver pairs that are still waiting to connect
	 */ getUniquePendingConnections() {
        const uniquePairs = new Map();
        for (const messages of this.queue.values())for (const message of messages){
            const key = `${message.senderId}:${message.receiverId}`;
            if (!uniquePairs.has(key)) uniquePairs.set(key, {
                senderId: message.senderId,
                receiverId: message.receiverId
            });
        }
        return Array.from(uniquePairs.values());
    }
    /**
	 * Safely deletes a single client from the queue and handles cleanup.
	 *
	 * @param clientId The client to remove from the queue
	 * @private
	 */ deleteClientFromQueue(clientId) {
        this.queue.delete(clientId);
        this.stopTick();
    }
    /**
	 * Safely deletes multiple clients from the queue and handles cleanup.
	 *
	 * @param clientIds Set of client IDs to remove from the queue
	 * @private
	 */ deleteClientsFromQueue(clientIds) {
        for (const clientId of clientIds)this.queue.delete(clientId);
        this.stopTick();
    }
    constructor(){
        /**
	 * A queue of messages keyed against a recipient client ID.
	 *
	 * @description Once the receiver is ready, we will flush all messages to them, IF they have not expired.
	 */ this.queue = new Map();
        /**
	 * A lazy tick which is executed only if there are buffered messages, and cleans up a message after
	 * {@link MESSAGE_LIFETIME_IN_MILLIS} have elapsed since the message was enqueued.
	 *
	 * @description NOTE: It is important to ensure there is only one interval which can run at any given time.
	 * Too many timers can clog up the event loop and slow execution:
	 */ this.tick = undefined;
        /**
	 * Starts an interval which does a full sweep every {@link MESSAGE_TICK_TIME_IN_MILLIS} to drop messages
	 * which have gone beyond their lifetime.
	 *
	 * @description NOTE: The use of {@link setInterval} is deliberate here, as browsers will try their best
	 * to continue executing {@link setInterval} callbacks even if a tab is unfocused. If the tab enters the
	 * 'frozen' state in Chromium browsers, then execution is completely paused as per:
	 * @see {@link https://developer.chrome.com/docs/web-platform/page-lifecycle-api}
	 */ this.startTick = ()=>{
            if (this.tick) return;
            this.tick = setInterval(()=>{
                this.checkLifetimeAndDrop();
                // Call the onTick callback if registered and there are buffered messages
                if (this.onTickCallback && this.queue.size > 0) {
                    const pendingConnections = this.getUniquePendingConnections();
                    this.onTickCallback(pendingConnections);
                }
            }, (0, $193c3b479529650b$export$5176aa4eceb2405e));
        };
        /**
	 * Stops the tick if there are no more messages to process.
	 */ this.stopTick = ()=>{
            if (this.queue.size > 0) return;
            clearInterval(this.tick);
            this.tick = undefined;
        };
    }
}

});
// Max time in millis an enqueued invocation message is allowed to live on the queue.
// NOTE: we choose a number which represents a reasonable portion of a user's session.
// I.e., if a user is SPA navigating a web / desktop app, we expect them to stick around
// for more than a typical web page. The longer they stay, the more the probability of objects
// starting to hang around in memory. But also: we don't want to clean up too soon in case we
// have a flakey receiver / want to peform a full event replay / rehydration. Hence the number
// chosen below. For future readers consider AI networking streams & events (long-running).
const $193c3b479529650b$export$ac4b6c122e5e5626 = 90000;
const $193c3b479529650b$export$5176aa4eceb2405e = 100;
const $193c3b479529650b$export$1552419560d53c41 = 1000;
const $193c3b479529650b$export$2805cdefd9b18065 = 10000;


parcelRegister("b1lgN", function(module, exports) {
$parcel$export(module.exports, "createInvocationId", () => $f053f8cf446b2ea3$export$4f25fe9107a7301c);
$parcel$export(module.exports, "rpcCommand", () => $f053f8cf446b2ea3$export$e414fa4333835a96);
$parcel$export(module.exports, "rpcSuccess", () => $f053f8cf446b2ea3$export$8dddc5c53da4c063);
$parcel$export(module.exports, "rpcError", () => $f053f8cf446b2ea3$export$97e0f665ead0e435);
$parcel$export(module.exports, "isRPCRequest", () => $f053f8cf446b2ea3$export$94e3360fcddccc76);
$parcel$export(module.exports, "isRPCResponse", () => $f053f8cf446b2ea3$export$c2a53faed5b3a8da);

var $hWMeR = parcelRequire("hWMeR");
function $f053f8cf446b2ea3$export$4f25fe9107a7301c(commandClass, commandProperties) {
    const parts = [
        'rovo-bridge-api',
        commandProperties.senderId,
        commandProperties.receiverId,
        commandClass.identifier,
        commandProperties._invocationId ?? 'unspecified-id'
    ];
    return parts.join(':');
}
function $f053f8cf446b2ea3$export$e414fa4333835a96(id, commandClass, commandProperties) {
    return (0, $hWMeR.createJSONRPCRequest)(id, commandClass.identifier, commandProperties);
}
function $f053f8cf446b2ea3$export$8dddc5c53da4c063(id, senderId, receiverId, result) {
    const response = (0, $hWMeR.createJSONRPCSuccessResponse)(id, result);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $f053f8cf446b2ea3$export$97e0f665ead0e435(id, senderId, receiverId, code = (0, $hWMeR.JSONRPCErrorCode).InternalError, error) {
    const response = (0, $hWMeR.createJSONRPCErrorResponse)(id, code, error.message, error.stack);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $f053f8cf446b2ea3$export$94e3360fcddccc76(request) {
    return Boolean((0, $hWMeR.isJSONRPCRequest)(request) && request.id && typeof request.id === 'string');
}
function $f053f8cf446b2ea3$export$c2a53faed5b3a8da(response) {
    return Boolean((0, $hWMeR.isJSONRPCResponse)(response) && response.id && typeof response.id === 'string');
}

});
parcelRegister("hWMeR", function(module, exports) {
"use strict";
var $d10d45a21fca528c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d10d45a21fca528c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d10d45a21fca528c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d10d45a21fca528c$var$__exportStar((parcelRequire("8uVSL")), module.exports);

$d10d45a21fca528c$var$__exportStar((parcelRequire("3pyt0")), module.exports);

$d10d45a21fca528c$var$__exportStar((parcelRequire("8IiaE")), module.exports);

$d10d45a21fca528c$var$__exportStar((parcelRequire("gFn4S")), module.exports);

$d10d45a21fca528c$var$__exportStar((parcelRequire("hlWW5")), module.exports);

});
parcelRegister("8uVSL", function(module, exports) {
"use strict";
var $62fe0643e6fd33ee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62fe0643e6fd33ee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCClient = void 0;

var $8IiaE = parcelRequire("8IiaE");

var $2Rtck = parcelRequire("2Rtck");
var $62fe0643e6fd33ee$var$JSONRPCClient = /** @class */ function() {
    function JSONRPCClient(_send, createID) {
        this._send = _send;
        this.createID = createID;
        this.idToResolveMap = new Map();
        this.id = 0;
    }
    JSONRPCClient.prototype._createID = function() {
        if (this.createID) return this.createID();
        else return ++this.id;
    };
    JSONRPCClient.prototype.timeout = function(delay, overrideCreateJSONRPCErrorResponse) {
        var _this = this;
        if (overrideCreateJSONRPCErrorResponse === void 0) overrideCreateJSONRPCErrorResponse = function(id) {
            return (0, $8IiaE.createJSONRPCErrorResponse)(id, $2Rtck.DefaultErrorCode, "Request timeout");
        };
        var timeoutRequest = function(ids, request) {
            var timeoutID = setTimeout(function() {
                ids.forEach(function(id) {
                    var resolve = _this.idToResolveMap.get(id);
                    if (resolve) {
                        _this.idToResolveMap.delete(id);
                        resolve(overrideCreateJSONRPCErrorResponse(id));
                    }
                });
            }, delay);
            return request().then(function(result) {
                clearTimeout(timeoutID);
                return result;
            }, function(error) {
                clearTimeout(timeoutID);
                return Promise.reject(error);
            });
        };
        var requestAdvanced = function(request, clientParams) {
            var ids = (!Array.isArray(request) ? [
                request
            ] : request).map(function(request) {
                return request.id;
            }).filter($62fe0643e6fd33ee$var$isDefinedAndNonNull);
            return timeoutRequest(ids, function() {
                return _this.requestAdvanced(request, clientParams);
            });
        };
        return {
            request: function(method, params, clientParams) {
                var id = _this._createID();
                return timeoutRequest([
                    id
                ], function() {
                    return _this.requestWithID(method, params, clientParams, id);
                });
            },
            requestAdvanced: function(request, clientParams) {
                return requestAdvanced(request, clientParams);
            }
        };
    };
    JSONRPCClient.prototype.request = function(method, params, clientParams) {
        return this.requestWithID(method, params, clientParams, this._createID());
    };
    JSONRPCClient.prototype.requestWithID = function(method, params, clientParams, id) {
        return $62fe0643e6fd33ee$var$__awaiter(this, void 0, void 0, function() {
            var request, response;
            return $62fe0643e6fd33ee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        request = (0, $8IiaE.createJSONRPCRequest)(id, method, params);
                        return [
                            4 /*yield*/ ,
                            this.requestAdvanced(request, clientParams)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.result !== undefined && !response.error) return [
                            2 /*return*/ ,
                            response.result
                        ];
                        else if (response.result === undefined && response.error) return [
                            2 /*return*/ ,
                            Promise.reject(new $8IiaE.JSONRPCErrorException(response.error.message, response.error.code, response.error.data))
                        ];
                        else return [
                            2 /*return*/ ,
                            Promise.reject(new Error("An unexpected error occurred"))
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCClient.prototype.requestAdvanced = function(requests, clientParams) {
        var _this = this;
        var areRequestsOriginallyArray = Array.isArray(requests);
        if (!Array.isArray(requests)) requests = [
            requests
        ];
        var requestsWithID = requests.filter(function(request) {
            return $62fe0643e6fd33ee$var$isDefinedAndNonNull(request.id);
        });
        var promises = requestsWithID.map(function(request) {
            return new Promise(function(resolve) {
                return _this.idToResolveMap.set(request.id, resolve);
            });
        });
        var promise = Promise.all(promises).then(function(responses) {
            if (areRequestsOriginallyArray || !responses.length) return responses;
            else return responses[0];
        });
        return this.send(areRequestsOriginallyArray ? requests : requests[0], clientParams).then(function() {
            return promise;
        }, function(error) {
            requestsWithID.forEach(function(request) {
                _this.receive((0, $8IiaE.createJSONRPCErrorResponse)(request.id, $2Rtck.DefaultErrorCode, error && error.message || "Failed to send a request"));
            });
            return promise;
        });
    };
    JSONRPCClient.prototype.notify = function(method, params, clientParams) {
        var request = (0, $8IiaE.createJSONRPCNotification)(method, params);
        this.send(request, clientParams).then(undefined, function() {
            return undefined;
        });
    };
    JSONRPCClient.prototype.send = function(payload, clientParams) {
        return $62fe0643e6fd33ee$var$__awaiter(this, void 0, void 0, function() {
            return $62fe0643e6fd33ee$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._send(payload, clientParams)
                ];
            });
        });
    };
    JSONRPCClient.prototype.rejectAllPendingRequests = function(message) {
        this.idToResolveMap.forEach(function(resolve, id) {
            return resolve((0, $8IiaE.createJSONRPCErrorResponse)(id, $2Rtck.DefaultErrorCode, message));
        });
        this.idToResolveMap.clear();
    };
    JSONRPCClient.prototype.receive = function(responses) {
        var _this = this;
        if (!Array.isArray(responses)) responses = [
            responses
        ];
        responses.forEach(function(response) {
            var resolve = _this.idToResolveMap.get(response.id);
            if (resolve) {
                _this.idToResolveMap.delete(response.id);
                resolve(response);
            }
        });
    };
    return JSONRPCClient;
}();
module.exports.JSONRPCClient = $62fe0643e6fd33ee$var$JSONRPCClient;
var $62fe0643e6fd33ee$var$isDefinedAndNonNull = function(value) {
    return value !== undefined && value !== null;
};

});
parcelRegister("8IiaE", function(module, exports) {
"use strict";
var $658087206f25ccc9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJSONRPCNotification = module.exports.createJSONRPCRequest = module.exports.createJSONRPCSuccessResponse = module.exports.createJSONRPCErrorResponse = module.exports.JSONRPCErrorCode = module.exports.JSONRPCErrorException = module.exports.isJSONRPCResponses = module.exports.isJSONRPCResponse = module.exports.isJSONRPCRequests = module.exports.isJSONRPCRequest = module.exports.isJSONRPCID = module.exports.JSONRPC = void 0;
module.exports.JSONRPC = "2.0";
var $658087206f25ccc9$var$isJSONRPCID = function(id) {
    return typeof id === "string" || typeof id === "number" || id === null;
};
module.exports.isJSONRPCID = $658087206f25ccc9$var$isJSONRPCID;
var $658087206f25ccc9$var$isJSONRPCRequest = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.method !== undefined && payload.result === undefined && payload.error === undefined;
};
module.exports.isJSONRPCRequest = $658087206f25ccc9$var$isJSONRPCRequest;
var $658087206f25ccc9$var$isJSONRPCRequests = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCRequest);
};
module.exports.isJSONRPCRequests = $658087206f25ccc9$var$isJSONRPCRequests;
var $658087206f25ccc9$var$isJSONRPCResponse = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.id !== undefined && (payload.result !== undefined || payload.error !== undefined);
};
module.exports.isJSONRPCResponse = $658087206f25ccc9$var$isJSONRPCResponse;
var $658087206f25ccc9$var$isJSONRPCResponses = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCResponse);
};
module.exports.isJSONRPCResponses = $658087206f25ccc9$var$isJSONRPCResponses;
var $658087206f25ccc9$var$createJSONRPCError = function(code, message, data) {
    var error = {
        code: code,
        message: message
    };
    if (data != null) error.data = data;
    return error;
};
var $658087206f25ccc9$var$JSONRPCErrorException = /** @class */ function(_super) {
    $658087206f25ccc9$var$__extends(JSONRPCErrorException, _super);
    function JSONRPCErrorException(message, code, data) {
        var _this = _super.call(this, message) || this;
        // Manually set the prototype to fix TypeScript issue:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, JSONRPCErrorException.prototype);
        _this.code = code;
        _this.data = data;
        return _this;
    }
    JSONRPCErrorException.prototype.toObject = function() {
        return $658087206f25ccc9$var$createJSONRPCError(this.code, this.message, this.data);
    };
    return JSONRPCErrorException;
}(Error);
module.exports.JSONRPCErrorException = $658087206f25ccc9$var$JSONRPCErrorException;
var $658087206f25ccc9$var$JSONRPCErrorCode;
(function(JSONRPCErrorCode) {
    JSONRPCErrorCode[JSONRPCErrorCode["ParseError"] = -32700] = "ParseError";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidRequest"] = -32600] = "InvalidRequest";
    JSONRPCErrorCode[JSONRPCErrorCode["MethodNotFound"] = -32601] = "MethodNotFound";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidParams"] = -32602] = "InvalidParams";
    JSONRPCErrorCode[JSONRPCErrorCode["InternalError"] = -32603] = "InternalError";
})($658087206f25ccc9$var$JSONRPCErrorCode = module.exports.JSONRPCErrorCode || (module.exports.JSONRPCErrorCode = {}));
var $658087206f25ccc9$var$createJSONRPCErrorResponse = function(id, code, message, data) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        error: $658087206f25ccc9$var$createJSONRPCError(code, message, data)
    };
};
module.exports.createJSONRPCErrorResponse = $658087206f25ccc9$var$createJSONRPCErrorResponse;
var $658087206f25ccc9$var$createJSONRPCSuccessResponse = function(id, result) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        result: result !== null && result !== void 0 ? result : null
    };
};
module.exports.createJSONRPCSuccessResponse = $658087206f25ccc9$var$createJSONRPCSuccessResponse;
var $658087206f25ccc9$var$createJSONRPCRequest = function(id, method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCRequest = $658087206f25ccc9$var$createJSONRPCRequest;
var $658087206f25ccc9$var$createJSONRPCNotification = function(method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCNotification = $658087206f25ccc9$var$createJSONRPCNotification;

});

parcelRegister("2Rtck", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorCode = void 0;
module.exports.DefaultErrorCode = 0;

});


parcelRegister("3pyt0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gFn4S", function(module, exports) {
"use strict";
var $c222606c816c6de7$var$__assign = module.exports && module.exports.__assign || function() {
    $c222606c816c6de7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c222606c816c6de7$var$__assign.apply(this, arguments);
};
var $c222606c816c6de7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c222606c816c6de7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c222606c816c6de7$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServer = void 0;

var $8IiaE = parcelRequire("8IiaE");

var $2Rtck = parcelRequire("2Rtck");
var $c222606c816c6de7$var$createParseErrorResponse = function() {
    return (0, $8IiaE.createJSONRPCErrorResponse)(null, $8IiaE.JSONRPCErrorCode.ParseError, "Parse error");
};
var $c222606c816c6de7$var$createInvalidRequestResponse = function(request) {
    return (0, $8IiaE.createJSONRPCErrorResponse)((0, $8IiaE.isJSONRPCID)(request.id) ? request.id : null, $8IiaE.JSONRPCErrorCode.InvalidRequest, "Invalid Request");
};
var $c222606c816c6de7$var$createMethodNotFoundResponse = function(id) {
    return (0, $8IiaE.createJSONRPCErrorResponse)(id, $8IiaE.JSONRPCErrorCode.MethodNotFound, "Method not found");
};
var $c222606c816c6de7$var$JSONRPCServer = /** @class */ function() {
    function JSONRPCServer(options) {
        if (options === void 0) options = {};
        var _a;
        this.mapErrorToJSONRPCErrorResponse = $c222606c816c6de7$var$defaultMapErrorToJSONRPCErrorResponse;
        this.nameToMethodDictionary = {};
        this.middleware = null;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServer.prototype.hasMethod = function(name) {
        return !!this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.addMethod = function(name, method) {
        this.addMethodAdvanced(name, this.toJSONRPCMethod(method));
    };
    JSONRPCServer.prototype.removeMethod = function(name) {
        delete this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.toJSONRPCMethod = function(method) {
        return function(request, serverParams) {
            var response = method(request.params, serverParams);
            return Promise.resolve(response).then(function(result) {
                return $c222606c816c6de7$var$mapResultToJSONRPCResponse(request.id, result);
            });
        };
    };
    JSONRPCServer.prototype.addMethodAdvanced = function(name, method) {
        var _a;
        this.nameToMethodDictionary = $c222606c816c6de7$var$__assign($c222606c816c6de7$var$__assign({}, this.nameToMethodDictionary), (_a = {}, _a[name] = method, _a));
    };
    JSONRPCServer.prototype.receiveJSON = function(json, serverParams) {
        var request = this.tryParseRequestJSON(json);
        if (request) return this.receive(request, serverParams);
        else return Promise.resolve($c222606c816c6de7$var$createParseErrorResponse());
    };
    JSONRPCServer.prototype.tryParseRequestJSON = function(json) {
        try {
            return JSON.parse(json);
        } catch (_a) {
            return null;
        }
    };
    JSONRPCServer.prototype.receive = function(request, serverParams) {
        if (Array.isArray(request)) return this.receiveMultiple(request, serverParams);
        else return this.receiveSingle(request, serverParams);
    };
    JSONRPCServer.prototype.receiveMultiple = function(requests, serverParams) {
        return $c222606c816c6de7$var$__awaiter(this, void 0, void 0, function() {
            var responses;
            var _this = this;
            return $c222606c816c6de7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(requests.map(function(request) {
                                return _this.receiveSingle(request, serverParams);
                            }))
                        ];
                    case 1:
                        responses = _a.sent().filter($c222606c816c6de7$var$isNonNull);
                        if (responses.length === 1) return [
                            2 /*return*/ ,
                            responses[0]
                        ];
                        else if (responses.length) return [
                            2 /*return*/ ,
                            responses
                        ];
                        else return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.receiveSingle = function(request, serverParams) {
        return $c222606c816c6de7$var$__awaiter(this, void 0, void 0, function() {
            var method, response;
            return $c222606c816c6de7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        method = this.nameToMethodDictionary[request.method];
                        if (!!(0, $8IiaE.isJSONRPCRequest)(request)) return [
                            3 /*break*/ ,
                            1
                        ];
                        return [
                            2 /*return*/ ,
                            $c222606c816c6de7$var$createInvalidRequestResponse(request)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.callMethod(method, request, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            $c222606c816c6de7$var$mapResponse(request, response)
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.applyMiddleware = function() {
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        if (this.middleware) this.middleware = this.combineMiddlewares($c222606c816c6de7$var$__spreadArray([
            this.middleware
        ], middlewares, true));
        else this.middleware = this.combineMiddlewares(middlewares);
    };
    JSONRPCServer.prototype.combineMiddlewares = function(middlewares) {
        if (!middlewares.length) return null;
        else return middlewares.reduce(this.middlewareReducer);
    };
    JSONRPCServer.prototype.middlewareReducer = function(prevMiddleware, nextMiddleware) {
        return function(next, request, serverParams) {
            return prevMiddleware(function(request, serverParams) {
                return nextMiddleware(next, request, serverParams);
            }, request, serverParams);
        };
    };
    JSONRPCServer.prototype.callMethod = function(method, request, serverParams) {
        var _this = this;
        var callMethod = function(request, serverParams) {
            if (method) return method(request, serverParams);
            else if (request.id !== undefined) return Promise.resolve($c222606c816c6de7$var$createMethodNotFoundResponse(request.id));
            else return Promise.resolve(null);
        };
        var onError = function(error) {
            _this.errorListener("An unexpected error occurred while executing \"".concat(request.method, "\" JSON-RPC method:"), error);
            return Promise.resolve(_this.mapErrorToJSONRPCErrorResponseIfNecessary(request.id, error));
        };
        try {
            return (this.middleware || $c222606c816c6de7$var$noopMiddleware)(callMethod, request, serverParams).then(undefined, onError);
        } catch (error) {
            return onError(error);
        }
    };
    JSONRPCServer.prototype.mapErrorToJSONRPCErrorResponseIfNecessary = function(id, error) {
        if (id !== undefined) return this.mapErrorToJSONRPCErrorResponse(id, error);
        else return null;
    };
    return JSONRPCServer;
}();
module.exports.JSONRPCServer = $c222606c816c6de7$var$JSONRPCServer;
var $c222606c816c6de7$var$isNonNull = function(value) {
    return value !== null;
};
var $c222606c816c6de7$var$noopMiddleware = function(next, request, serverParams) {
    return next(request, serverParams);
};
var $c222606c816c6de7$var$mapResultToJSONRPCResponse = function(id, result) {
    if (id !== undefined) return (0, $8IiaE.createJSONRPCSuccessResponse)(id, result);
    else return null;
};
var $c222606c816c6de7$var$defaultMapErrorToJSONRPCErrorResponse = function(id, error) {
    var _a;
    var message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "An unexpected error occurred";
    var code = $2Rtck.DefaultErrorCode;
    var data;
    if (error instanceof $8IiaE.JSONRPCErrorException) {
        code = error.code;
        data = error.data;
    }
    return (0, $8IiaE.createJSONRPCErrorResponse)(id, code, message, data);
};
var $c222606c816c6de7$var$mapResponse = function(request, response) {
    if (response) return response;
    else if (request.id !== undefined) return (0, $8IiaE.createJSONRPCErrorResponse)(request.id, $8IiaE.JSONRPCErrorCode.InternalError, "Internal error");
    else return null;
};

});

parcelRegister("hlWW5", function(module, exports) {
"use strict";
var $ca221d4022531052$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca221d4022531052$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServerAndClient = void 0;

var $8IiaE = parcelRequire("8IiaE");
var $ca221d4022531052$var$JSONRPCServerAndClient = /** @class */ function() {
    function JSONRPCServerAndClient(server, client, options) {
        if (options === void 0) options = {};
        var _a;
        this.server = server;
        this.client = client;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServerAndClient.prototype.applyServerMiddleware = function() {
        var _a;
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        (_a = this.server).applyMiddleware.apply(_a, middlewares);
    };
    JSONRPCServerAndClient.prototype.hasMethod = function(name) {
        return this.server.hasMethod(name);
    };
    JSONRPCServerAndClient.prototype.addMethod = function(name, method) {
        this.server.addMethod(name, method);
    };
    JSONRPCServerAndClient.prototype.addMethodAdvanced = function(name, method) {
        this.server.addMethodAdvanced(name, method);
    };
    JSONRPCServerAndClient.prototype.removeMethod = function(name) {
        this.server.removeMethod(name);
    };
    JSONRPCServerAndClient.prototype.timeout = function(delay) {
        return this.client.timeout(delay);
    };
    JSONRPCServerAndClient.prototype.request = function(method, params, clientParams) {
        return this.client.request(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.requestAdvanced = function(jsonRPCRequest, clientParams) {
        return this.client.requestAdvanced(jsonRPCRequest, clientParams);
    };
    JSONRPCServerAndClient.prototype.notify = function(method, params, clientParams) {
        this.client.notify(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.rejectAllPendingRequests = function(message) {
        this.client.rejectAllPendingRequests(message);
    };
    JSONRPCServerAndClient.prototype.receiveAndSend = function(payload, serverParams, clientParams) {
        return $ca221d4022531052$var$__awaiter(this, void 0, void 0, function() {
            var response, message;
            return $ca221d4022531052$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!((0, $8IiaE.isJSONRPCResponse)(payload) || (0, $8IiaE.isJSONRPCResponses)(payload))) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.client.receive(payload);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        if (!((0, $8IiaE.isJSONRPCRequest)(payload) || (0, $8IiaE.isJSONRPCRequests)(payload))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.server.receive(payload, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        if (response) return [
                            2 /*return*/ ,
                            this.client.send(response, clientParams)
                        ];
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        message = "Received an invalid JSON-RPC message";
                        this.errorListener(message, payload);
                        return [
                            2 /*return*/ ,
                            Promise.reject(new Error(message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return JSONRPCServerAndClient;
}();
module.exports.JSONRPCServerAndClient = $ca221d4022531052$var$JSONRPCServerAndClient;

});



parcelRegister("bcqEj", function(module, exports) {
$parcel$export(module.exports, "RequestHandler", () => $a98e4091d827d994$export$d51c578aa8736606);

var $hWMeR = parcelRequire("hWMeR");

var $iqfTZ = parcelRequire("iqfTZ");

var $8LcKM = parcelRequire("8LcKM");

var $b1lgN = parcelRequire("b1lgN");
class $a98e4091d827d994$export$d51c578aa8736606 {
    constructor(transport){
        this.transport = transport;
        /**
	 * A mapping from clientId:commandName -> handlers for those commands.
	 *
	 * @description We enforce only 1 handler per clientId+command pair, so that callees can listen for responses to a command.
	 * This allows multiple clients to register handlers for the same command type.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // oxlint-disable-next-line typescript-eslint/no-explicit-any
        this.handlers = new Map();
    }
    /**
	 * Register a handler for a specific command type for a specific client.
	 *
	 * @description When a command of type {@link CommandClass} is received, the handler will be invoked in a 1-1 manner.
	 * This is to ensure the result of the command invocation can be cleanly passed to the callee.
	 *
	 * @param clientId The client identifier that this handler is registered for
	 * @param CommandClass The command class to register a handler for
	 * @param handler The handler function to invoke when the command is received
	 * @returns void
	 */ register(clientId, CommandClass, handler) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.set(handlerKey, handler);
    }
    /**
	 * Unregisters a handler for a specific command type for a specific client.
	 */ unregister(clientId, CommandClass) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.delete(handlerKey);
    }
    /**
	 * Unregisters all handlers for a specific client.
	 *
	 * @param clientId The client identifier to remove all handlers for
	 * @returns number of handlers removed
	 */ unregisterAll(clientId) {
        const keysToDelete = [];
        const prefix = `${clientId}:`;
        // find all relevant keys
        for (const key of this.handlers.keys())if (key.startsWith(prefix)) keysToDelete.push(key);
        // drop them
        for (const key of keysToDelete)this.handlers.delete(key);
        return keysToDelete.length;
    }
    /**
	 * Invokes the appropriate handler for a given {@link RPCRequest}, and yields the result via
	 * {@link transport} to the appropriate JavaScript context. If the handler throws, propagates an
	 * {@link RPCResponse} with an error body. Vice versa for a successful handler response.
	 *
	 * @param request incoming RPC request (delegated method call, as a command)
	 */ async handleRequest(request) {
        const params = request.params;
        const handlerKey = this.createHandlerKey(params.receiverId, request.method);
        const handler = this.handlers.get(handlerKey);
        (0, $8LcKM.emitter)().emit({
            type: 'command-received',
            commandId: request.id,
            commandType: request.method,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for ${request.method} with clientId ${params.receiverId}`;
            console.warn(err);
            // emit command failed event
            (0, $8LcKM.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            // communicate to sender that handler failed
            this.sendResponse(request, (0, $b1lgN.rpcError)(request.id, params.receiverId, params.senderId, (0, $hWMeR.JSONRPCErrorCode).MethodNotFound, new Error(err)));
            return;
        }
        const startTime = performance.now();
        try {
            const result = await handler(request.params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $8LcKM.emitter)().emit({
                type: 'command-completed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            this.sendResponse(request, (0, $b1lgN.rpcSuccess)(request.id, params.receiverId, params.senderId, result));
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $8LcKM.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            this.sendResponse(request, (0, $b1lgN.rpcError)(request.id, params.receiverId, params.senderId, (0, $hWMeR.JSONRPCErrorCode).InternalError, err));
            console.error(err);
        }
    }
    sendResponse(request, response) {
        if ((0, $iqfTZ.fg)('rovo_bridge_validate_message_origin')) this.transport.send(response, request);
        else this.transport.send(response);
    }
    /**
	 * Directly invoke a handler of a specific command for a specific client.
	 */ async invoke(command, params) {
        const handlerKey = this.createHandlerKey(params.receiverId, command.identifier);
        const handler = this.handlers.get(handlerKey);
        (0, $8LcKM.emitter)().emit({
            type: 'command-received',
            commandId: params._invocationId ?? 'local-invocation',
            commandType: command.identifier,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: params,
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for command ${command.identifier} with clientId ${params.receiverId}`;
            console.error(err);
            // emit command failed event
            (0, $8LcKM.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId ?? 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            return undefined;
        }
        const startTime = performance.now();
        try {
            const result = handler?.(params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $8LcKM.emitter)().emit({
                type: 'command-completed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            return result;
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $8LcKM.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            throw err;
        }
    }
    /**
	 * Clear all relevant state for handling of responses.
	 */ destroy() {
        this.handlers.clear();
    }
    /**
	 * Creates a unique key for the handler mapping using clientId and command name.
	 */ createHandlerKey(clientId, commandName) {
        return `${clientId}:${commandName}`;
    }
}

});

parcelRegister("arHYA", function(module, exports) {
$parcel$export(module.exports, "ResponseHandler", () => $9ba681bb38b0601a$export$f456c9835cc63582);
class $9ba681bb38b0601a$export$f456c9835cc63582 {
    /**
	 * Creates a deferred promise handler for a given command invocation.
	 * @param id unique ID for the command invocation
	 * @param senderId the callee
	 * @param receiverId the receiver which implements a handler for the command
	 * @returns a deferrable which is resolved upon a response being yielded by the receiver
	 */ getOrCreate(id, senderId, receiverId) {
        // if we already have a deferred promise waiting for this specific invocation, we do not need another one.
        const existing = this.get(id);
        if (existing) return existing.promise;
        let deferredResolve;
        let deferredReject;
        const promise = new Promise((resolve, reject)=>{
            deferredResolve = resolve;
            deferredReject = reject;
        });
        const result = {
            senderId: senderId,
            receiverId: receiverId,
            promise: promise,
            // @ts-expect-error - Promise executor runs synchronously so deferredResolve is guaranteed assigned; TypeScript cannot infer this
            resolve: deferredResolve,
            // @ts-expect-error - Promise executor runs synchronously so deferredReject is guaranteed assigned; TypeScript cannot infer this
            reject: deferredReject
        };
        this.responses.set(id, result);
        return promise;
    }
    /**
	 * Yields the current deferrable state for a command invocation.
	 * @param id unique ID for the command invocation.
	 * @returns deferrable state for a command invocation.
	 */ get(id) {
        return this.responses.get(id);
    }
    /**
	 * Resolves a promise reference based upon the ID of an RPC response.
	 *
	 * @description If the RPC response is successful, will resolve the promise with the expected return shape.
	 * @description If the RPC response is unsuccessful, will reject the promise with an error.
	 *
	 * @param _response response yielded by the receiver of the original message.
	 */ resolveWithResponse(response) {
        const id = response.id;
        const deferred = this.responses.get(id);
        // no one waiting - exit
        if (!deferred) return;
        // drop the deferrable from storage now
        this.responses.delete(id);
        // yield correct outcome
        if (response.error) deferred.reject(new Error(response.error.message));
        else deferred.resolve(response.result);
    }
    /**
	 * Cancels a specific promise by resolving it to undefined to avoid unhandled rejections
	 * in fire-and-forget scenarios.
	 *
	 * @description In JavaScript if you do the following:
	 * ```typescript
	 * const promise = () => new Promise((_, reject) => reject(new Error('oh boy')));
	 * promise();
	 * ```
	 * Even though you are not explicitly calling `await` on the result of the promise, it will
	 * reject and result in an unhandled rejection. Specifically when working with commands, we
	 * often want to send them in a fire-and-forget manner. When a 'cancellation' takes place,
	 * we therefore DO NOT want an unhandled rejection to result. Hence, we treat all command
	 * results similar to distributed system communications - as always nullable.
	 *
	 * Cancellation events to consider: component unmounts, route transitions.
	 *
	 * For more, see:
	 * - {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event}
	 * - {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_promises#promise_rejection_events}
	 * - {@link https://typescript-eslint.io/rules/no-floating-promises/}
	 *
	 * @param id unique ID for the command invocation to cancel
	 */ cancel(id) {
        const deferred = this.responses.get(id);
        if (!deferred) return;
        // clear out in-memory reference
        this.responses.delete(id);
        // resolve to undefined to avoid unhandled promise rejections
        deferred.resolve(undefined);
    }
    /**
	 * Clears response handlers for a specific client to prevent memory leaks during client teardown.
	 *
	 * @param clientId The client ID to clear responses for (as sender or receiver)
	 */ teardown(clientId) {
        const toDelete = [];
        for (const [id, deferred] of this.responses)if (deferred.senderId === clientId || deferred.receiverId === clientId) {
            // Resolve to undefined to avoid unhandled promise rejections
            deferred.resolve(undefined);
            toDelete.push(id);
        }
        for (const id of toDelete)this.responses.delete(id);
    }
    /**
	 * Destroy all relevant state.
	 */ clear() {
        // Resolve all pending promises to avoid unhandled rejections
        for (const deferred of this.responses.values())deferred.resolve(undefined);
        this.responses.clear();
    }
    constructor(){
        /**
	 * A mapping from unique command invocations to deferred promises waiting
	 * for their result. Used for match-making the result of a delegated RPC call
	 * back to its callee. TODO - hook up to methods in CNS-18261.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // oxlint-disable-next-line typescript-eslint/no-explicit-any
        this.responses = new Map();
    }
}

});


parcelRegister("5s3v4", function(module, exports) {
$parcel$export(module.exports, "mountAPI", () => $4fed76d4d1632116$export$aca538b4585bd0c8);
$parcel$export(module.exports, "readAPI", () => $4fed76d4d1632116$export$7f2206c1a009e207);
$parcel$export(module.exports, "clearAPI", () => $4fed76d4d1632116$export$d61f9ff9c1abb253);

var $BUV1j = parcelRequire("BUV1j");
const $4fed76d4d1632116$export$aca538b4585bd0c8 = (bridgeAPI)=>{
    try {
        const topmostSameOriginWindow = (0, $BUV1j.findTopmostSameOriginWindow)(window);
        // do not override if already existing on topmost same-origin window
        if (topmostSameOriginWindow.__rovoContentBridgeAPI__) return;
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = bridgeAPI;
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = $4fed76d4d1632116$var$startDebugger;
    } catch  {
        // bail out if any errors take place (browser quirks on accessing window.top from a cross-origin frame)
        return;
    }
};
const $4fed76d4d1632116$export$7f2206c1a009e207 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $BUV1j.findTopmostSameOriginWindow)(window);
        return topmostSameOriginWindow.__rovoContentBridgeAPI__ ?? null;
    } catch  {
        return null;
    }
};
const $4fed76d4d1632116$export$d61f9ff9c1abb253 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $BUV1j.findTopmostSameOriginWindow)(window);
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = undefined;
        // Also clear debug API to prevent memory leaks
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = undefined;
    } catch  {
        return;
    }
};

async function $4fed76d4d1632116$var$startDebugger() {
    try {
        await (parcelRequire("lSEbf"));
    } catch (err) {
        console.error('failed to initialise rovo-debug API', err);
    }
}

});
parcelRegister("BUV1j", function(module, exports) {
$parcel$export(module.exports, "isSameOrigin", () => $0365fd5afb678ec5$export$655d79b04044cb4a);
$parcel$export(module.exports, "isTop", () => $0365fd5afb678ec5$export$9be37efcc8d5d23a);
$parcel$export(module.exports, "findTopmostSameOriginWindow", () => $0365fd5afb678ec5$export$8d6146aae4595d39);
/**
 * Utility which computes whether a target window and {@link window.top} conform to the same origin policy.
 *
 * @description If they do, then they share JavaScript execution contexts.
 * @description If they do not, they are the traditional cross-origin `iframe` and host.
 *
 * @param window
 * @returns true if same origin, false if not - if true, then {@link window.top} must be defined.
 */ const $0365fd5afb678ec5$export$655d79b04044cb4a = (window)=>{
    try {
        return Boolean(window.origin && window.origin === window.top?.origin);
    } catch  {
        return false;
    }
};
const $0365fd5afb678ec5$export$9be37efcc8d5d23a = (window)=>{
    try {
        return Boolean(window.top && window === window.top);
    } catch  {
        return false;
    }
};
/**
 * Maximum depth to traverse when finding topmost same-origin window.
 * Prevents infinite loops in edge cases while supporting deep nesting.
 */ const $0365fd5afb678ec5$var$MAX_PARENT_TRAVERSAL_DEPTH = 16;
const $0365fd5afb678ec5$export$8d6146aae4595d39 = (window)=>{
    let current = window;
    let depth = 0;
    while(depth < $0365fd5afb678ec5$var$MAX_PARENT_TRAVERSAL_DEPTH)try {
        // If we're at the top, return current
        if (current.parent === current) return current;
        // Try to access parent.origin (will throw SecurityError if cross-origin)
        const parentOrigin = current.parent.origin;
        // Check if parent is same origin
        if (current.origin !== parentOrigin) return current;
        // Parent is same-origin, keep going up
        current = current.parent;
        depth++;
    } catch  {
        // Parent is cross-origin (accessing parent.origin threw)
        return current;
    }
    // Safety: return current window if max depth reached
    return current;
};

});

parcelRegister("lSEbf", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lcdl3").then(()=>parcelRequire('adC9F'));

});


parcelRegister("iGQVw", function(module, exports) {
$parcel$export(module.exports, "BrowserTransport", () => $3f8dd67b1691875c$export$7f6b50c45cbf4d90);

var $iqfTZ = parcelRequire("iqfTZ");

var $8LcKM = parcelRequire("8LcKM");

var $b1lgN = parcelRequire("b1lgN");

var $1qnMA = parcelRequire("1qnMA");

var $BUV1j = parcelRequire("BUV1j");

var $dO98R = parcelRequire("dO98R");

var $appZs = parcelRequire("appZs");
const $3f8dd67b1691875c$var$MESSAGE_ORIGIN_VALIDATION_GATE = 'rovo_bridge_validate_message_origin';
const $3f8dd67b1691875c$var$DEDUPE_TARGET_WARNING_GATE = 'rovo_bridge_dedupe_target_warning';
const $3f8dd67b1691875c$var$normaliseOrigins = (origins)=>{
    const result = new Set();
    for (const value of origins ?? [])try {
        const origin = new URL(value).origin;
        if (origin !== 'null') result.add(origin);
    } catch  {
    // An invalid value must not accidentally widen the trust boundary.
    }
    return result;
};
/**
 * Narrows a {@link MessageEvent.source} to a window.
 *
 * @description A window proxy exposes `window` as a self-reference even across an origin boundary,
 * which message ports and service workers do not.
 */ const $3f8dd67b1691875c$var$isWindowSource = (source)=>{
    try {
        return Boolean(source) && source.window === source;
    } catch  {
        return false;
    }
};
class $3f8dd67b1691875c$export$7f6b50c45cbf4d90 {
    constructor(source, options = {}){
        this.source = source;
        this.options = options;
        /**
	 * A mapping of receiver IDs to known targets.
	 *
	 * Communication will ultimately take place with this target, via the {@link HTMLIFrameElement.contentWindow} property.
	 */ this.targets = new Map();
        /**
	 * Receivers whose missing target has already been logged.
	 *
	 * @description Discovery retries a pending receiver every tick, so without this a receiver which never mounts
	 * (e.g. Rovo chat before its panel is opened) logs a warning every 100ms until its messages expire.
	 */ this.unreachableReceivers = new Set();
        // New requests can use an authenticated peer origin; replies retain their own request's destination.
        this.authenticatedOrigins = new WeakMap();
        this.replyTargets = new WeakMap();
        /**
	 * Handles incoming messages received via {@link window.postMessage}.
	 */ this.handler = undefined;
        /**
	 * Cleanup handler registered for incoming messages
	 */ this.cleanup = undefined;
        this.allowedOrigins = $3f8dd67b1691875c$var$normaliseOrigins(options.allowedOrigins);
        (0, $8LcKM.emitter)().emit({
            type: 'transport-ready',
            transportType: this.source
        });
    }
    /**
	 * Check to see if this message can be sent to its intended cross-origin target currently.
	 *
	 * @description Determined by availability of the target window in the DOM.
	 * @description If this method does not yield true, the message will be buffered & tried again later.
	 *
	 * @param message intended RPC message for the receiver
	 * @returns true if the transport target is queryable via DOM, otherwise false
	 */ canSend(message) {
        // trying to communicate with desktop process
        if ((0, $dO98R.isWebviewContext)()) return true;
        // passthrough for same-origin communication
        if ((0, $BUV1j.isSameOrigin)(window)) return true;
        // otherwise find the cross-origin target & communicate with it
        const target = this.findTarget(message.params.receiverId);
        return Boolean(target);
    }
    /**
	 * Sends a cross-origin message using {@link window.postMessage}.
	 * @param message intended RPC message for the receiver
	 * @param replyTo original accepted request, required for browser replies while origin validation is enabled
	 * @returns void
	 */ send(message, replyTo) {
        // in a webview context and trying to communicate with main process
        if ((0, $dO98R.isWebviewContext)()) {
            (0, $dO98R.sendToMainProcess)(message, this.source);
            return;
        }
        const validateOrigin = (0, $iqfTZ.fg)($3f8dd67b1691875c$var$MESSAGE_ORIGIN_VALIDATION_GATE);
        const target = validateOrigin && (0, $b1lgN.isRPCResponse)(message) ? replyTo && this.replyTargets.get(replyTo) : this.findTarget(message.params.receiverId);
        if (!target) {
            (0, $8LcKM.emitter)().emit({
                type: 'transport-error',
                transportType: this.source,
                direction: 'outbound',
                messageId: message.id,
                error: {
                    message: `Transport target not found for receiver: ${message.params.receiverId}`,
                    code: 'TARGET_NOT_FOUND'
                }
            });
            return;
        }
        const envelope = {
            version: 1,
            source: this.source,
            message: message
        };
        (0, $8LcKM.emitter)().emit({
            type: 'transport-message-sent',
            transportType: this.source,
            direction: 'outbound',
            messageId: message.id,
            message: {
                ...envelope
            }
        });
        target.target.postMessage(envelope, validateOrigin ? this.outboundOrigin(target) : '*');
        if (validateOrigin && replyTo) this.replyTargets.delete(replyTo);
        return;
    }
    /**
	 * Handles incoming events from other bridge API clients.
	 * @param handler responds to a given RPC message from a remote client.
	 */ onMessage(handler) {
        // do not allow overriding of handlers.
        if (this.handler) return;
        // stable reference so we can destroy it later
        this.handler = (envelope)=>this.handleEnvelope(envelope, handler);
        // listen for messsages from webview context
        if ((0, $dO98R.isWebviewContext)()) {
            const webviewAPI = (0, $dO98R.getWebviewAPI)();
            if (!webviewAPI) return;
            this.cleanup = webviewAPI.onMessageFromMain((envelope)=>this.handler?.(envelope));
        } else {
            // Find topmost same-origin window to listen on
            const targetWindow = (0, $BUV1j.findTopmostSameOriginWindow)(window);
            // web-compatible handler
            const handler = (event)=>{
                if (!(0, $iqfTZ.fg)($3f8dd67b1691875c$var$MESSAGE_ORIGIN_VALIDATION_GATE)) {
                    this.handler?.(event.data);
                    return;
                }
                if (this.isTrustedSender(event, targetWindow)) {
                    this.recordAuthenticatedPeer(event);
                    this.handler?.(event.data);
                }
            };
            targetWindow.addEventListener('message', handler);
            this.cleanup = ()=>targetWindow.removeEventListener('message', handler);
        }
    }
    /**
	 * Tears down a specific client by removing its target reference.
	 * @description This is important to release iframe / window references fully.
	 */ teardown(clientId) {
        this.targets.delete(clientId);
        this.unreachableReceivers.delete(clientId);
    }
    /**
	 * Clears all relevant state.
	 */ destroy() {
        // clean up handler
        if (this.cleanup) {
            this.cleanup();
            this.cleanup = undefined;
        }
        // clean up handler reference
        if (this.handler) this.handler = undefined;
        // clear all target references
        this.targets.clear();
        this.unreachableReceivers.clear();
        this.authenticatedOrigins = new WeakMap();
        this.replyTargets = new WeakMap();
        // emit transport destroyed event
        (0, $8LcKM.emitter)().emit({
            type: 'transport-destroyed',
            transportType: this.source
        });
    }
    /**
	 * Find a target for the given receiver in one of three ways:
	 * - Using the existing mapping of known targets ({@link #targets})
	 * - Using a DOM query for a cross-origin `iframe`, based on a specific DOM selector contract
	 * - Using {@link window.top} if communicating cross-origin from inside of a frame
	 *
	 * @description If a target is find with one of the latter strategies, it is added to {@link #targets} for subsequent reads.
	 *
	 * @param receiverId intended target of the current message
	 * @returns target if found, otherwise undefined
	 */ findTarget(receiverId) {
        // if existing, return
        const target = this.targets.get(receiverId);
        if (target) {
            if (!(0, $iqfTZ.fg)('rovo_bridge_remote_teardown_cleanup') || !target.target.closed) return target;
            // A teardown reply can recache a target before its iframe is removed.
            // Discard destroyed browsing contexts, including those without a teardown.
            this.targets.delete(receiverId);
        }
        // Find target using a provided resolution strategy
        const resolvedTarget = this.options.resolveTarget?.({
            receiverId: receiverId,
            source: this.source
        });
        if (resolvedTarget) {
            const resolved = {
                target: resolvedTarget
            };
            this.targets.set(receiverId, resolved);
            return resolved;
        }
        // Find target using resolution strategies
        const browserTarget = (0, $appZs.findCrossOriginTarget)(receiverId);
        if (browserTarget) {
            this.targets.set(receiverId, browserTarget);
            return browserTarget;
        }
        if (!(0, $iqfTZ.fg)($3f8dd67b1691875c$var$DEDUPE_TARGET_WARNING_GATE) || !this.unreachableReceivers.has(receiverId)) {
            this.unreachableReceivers.add(receiverId);
            console.warn(`transport target not found for message with intended recipient: ${receiverId}`);
        }
        return undefined;
    }
    recordAuthenticatedPeer(event) {
        if (!$3f8dd67b1691875c$var$isWindowSource(event.source)) return;
        this.authenticatedOrigins.set(event.source, event.origin);
        if ((0, $b1lgN.isRPCRequest)(event.data.message)) this.replyTargets.set(event.data.message, {
            target: event.source,
            origin: event.origin
        });
    }
    outboundOrigin(target) {
        return target.origin ?? this.authenticatedOrigins.get(target.target) ?? '*';
    }
    /**
	 * Whether the envelope's self-declared source agrees with the origin the browser stamped on the event.
	 */ hasAttestedOrigin(event) {
        return (0, $1qnMA.isTransportEnvelope)(event.data) && event.data.source === event.origin;
    }
    /**
	 * Whether an inbound message satisfies the transport's origin and peer checks.
	 *
	 * Same-origin messages are accepted after their envelope source is checked. Cross-origin messages
	 * must also match a resolved peer using two fields supplied by the browser:
	 * - {@link MessageEvent.source}: a live reference to the actual sending window. Compared by identity
	 *   against the window resolved by {@link findTarget}, so another window cannot claim its identity.
	 * - {@link MessageEvent.origin}: the sender's origin when the message was sent. Matched against
	 *   the peer origin we derived ourselves (an iframe `src` or ancestor origin) or, only when unknown, an origin in
	 *   {@link BrowserTransportOptions.allowedOrigins}.
	 *
	 * @description Everything inside {@link MessageEvent.data} is attacker-controlled and treated only as
	 * a claim: the self-declared envelope `source` and the `senderId` / `receiverId`. `senderId` is used
	 * purely as a lookup key whose result is then re-checked against the unforgeable fields above, and
	 * {@link hasAttestedOrigin} ties the self-declared `source` back to the browser-stamped origin.
	 */ isTrustedSender(event, targetWindow) {
        if (!this.hasAttestedOrigin(event)) return false;
        if (event.origin === targetWindow.location.origin) return true;
        const senderId = event.data.message.params?.senderId;
        if (typeof senderId !== 'string') return false;
        const sender = this.findTarget(senderId);
        const trustedOrigin = sender?.origin !== undefined ? sender.origin === event.origin : this.allowedOrigins.has(event.origin);
        return Boolean(event.source && sender && event.source === sender.target && trustedOrigin);
    }
    /**
	 * Handles a transport envelope received from a remote source.
	 * @param envelope the transport envelope containing the RPC message
	 * @param handler the handler to invoke for the RPC message contained in the envelope
	 * @returns void
	 */ handleEnvelope(envelope, handler) {
        // always validate first - if invalid, ignore
        if (!(0, $1qnMA.isTransportEnvelope)(envelope)) return;
        // ensure message is not from the current window to itself
        if (envelope.source === this.source) return;
        (0, $8LcKM.emitter)().emit({
            type: 'transport-message-received',
            transportType: this.source,
            direction: 'inbound',
            messageId: envelope.message.id,
            transportData: {
                source: envelope.source,
                version: envelope.version,
                message: envelope.message
            }
        });
        handler(envelope.message);
    }
}

});
parcelRegister("1qnMA", function(module, exports) {
$parcel$export(module.exports, "isTransportEnvelope", () => $ead864c65c47ac2b$export$d22e131e673e4be0);

var $b1lgN = parcelRequire("b1lgN");
const $ead864c65c47ac2b$export$d22e131e673e4be0 = (envelope)=>{
    return Boolean(envelope && typeof envelope.version === 'number' && typeof envelope.source === 'string' && envelope.message && typeof envelope.message === 'object' && ((0, $b1lgN.isRPCRequest)(envelope.message) || (0, $b1lgN.isRPCResponse)(envelope.message)));
};

});

parcelRegister("dO98R", function(module, exports) {
$parcel$export(module.exports, "isWebviewContext", () => $57c62bf0c204c1b9$export$a06801d4af98f3a3);
$parcel$export(module.exports, "getWebviewAPI", () => $57c62bf0c204c1b9$export$60ac5c5fdfd88da);
$parcel$export(module.exports, "sendToMainProcess", () => $57c62bf0c204c1b9$export$7f13f4efe0e0c1f3);

var $8LcKM = parcelRequire("8LcKM");
const $57c62bf0c204c1b9$export$a06801d4af98f3a3 = ()=>{
    try {
        return Boolean(typeof window !== 'undefined' && window.webviewAPI && typeof window.webviewAPI.isElectron === 'function' && window.webviewAPI.isElectron());
    } catch  {
        return false;
    }
};
const $57c62bf0c204c1b9$export$60ac5c5fdfd88da = ()=>{
    try {
        if ($57c62bf0c204c1b9$export$a06801d4af98f3a3()) return window.webviewAPI;
        return undefined;
    } catch  {
        return undefined;
    }
};
const $57c62bf0c204c1b9$export$7f13f4efe0e0c1f3 = (message, transportSource)=>{
    const electronAPI = $57c62bf0c204c1b9$export$60ac5c5fdfd88da();
    if (!electronAPI) {
        (0, $8LcKM.emitter)().emit({
            type: 'transport-error',
            transportType: transportSource,
            direction: 'outbound',
            messageId: message.id,
            error: {
                message: 'Webview API not available',
                code: 'WEBVIEW_API_UNAVAILABLE'
            }
        });
        return;
    }
    const envelope = {
        version: 1,
        source: transportSource,
        message: message
    };
    (0, $8LcKM.emitter)().emit({
        type: 'transport-message-sent',
        transportType: transportSource,
        direction: 'outbound',
        messageId: message.id,
        message: {
            ...envelope
        }
    });
    // use the exposed to send to main
    electronAPI.postMessageToMain(envelope);
};
const $57c62bf0c204c1b9$export$206d5b20b7c5c9d6 = 'rovo-bridge-message-channel';
const $57c62bf0c204c1b9$export$c2e3eb4b2d131505 = 'desktop-main';

});

parcelRegister("appZs", function(module, exports) {
$parcel$export(module.exports, "findCrossOriginTarget", () => $192088c838205c51$export$6052a3134234724b);

var $iqfTZ = parcelRequire("iqfTZ");

var $BUV1j = parcelRequire("BUV1j");
const $192088c838205c51$var$MAX_FRAME_TRAVERSAL_DEPTH = 16;
const $192088c838205c51$var$findIframe = (targetDocument, receiverId)=>{
    if ((0, $iqfTZ.fg)('rovo_bridge_validate_message_origin')) // Client IDs come from messages and must not be interpreted as selector syntax.
    return Array.from(targetDocument?.querySelectorAll('iframe[data-rovo-receiver-id]') ?? []).find((frame)=>frame.getAttribute('data-rovo-receiver-id') === receiverId);
    return targetDocument?.querySelector(`[data-rovo-receiver-id="${receiverId}"]`) ?? undefined;
};
const $192088c838205c51$var$getDocument = (targetWindow)=>{
    try {
        return targetWindow.document;
    } catch  {
        return undefined;
    }
};
const $192088c838205c51$var$getFrames = (targetWindow)=>{
    try {
        return Array.from(targetWindow.frames);
    } catch  {
        return [];
    }
};
/**
 * Traverses through all child frames (same-origin) which the current window has access to.
 * Required to discover child frames which are deeply nested as transport targets.
 *
 * @param receiverId bridge API client we are attempting to communicate with
 * @param rootWindow the current host / root window we are traversing down
 * @param visited windows we have already searched through
 * @param depth current depth - to enforce a maximum depth in our DFS
 *
 * @returns the relevant window or undefined
 */ const $192088c838205c51$var$resolveChildIframeFromWindow = (receiverId, rootWindow, visited, depth)=>{
    // if we have already searched this window, early exit
    if (visited.has(rootWindow)) return undefined;
    // if we can no longer traverse further downwards, early exit
    if (depth > $192088c838205c51$var$MAX_FRAME_TRAVERSAL_DEPTH) return undefined;
    // mark as visited
    visited.add(rootWindow);
    // get hold of the document & look for the current receiver of interest
    const rootDocument = $192088c838205c51$var$getDocument(rootWindow);
    const frame = $192088c838205c51$var$findIframe(rootDocument, receiverId);
    if (frame?.contentWindow) return frame;
    // if not found at the top-level, traverse down
    for (const childWindow of $192088c838205c51$var$getFrames(rootWindow)){
        const target = $192088c838205c51$var$resolveChildIframeFromWindow(receiverId, childWindow, visited, depth + 1);
        // found in sub-frame
        if (target) return target;
    }
    // not found amongst this window & all of its sub-frames
    return undefined;
};
/**
 * Resolves a target window by querying same-origin reachable DOM trees for an iframe with a
 * specific data attribute.
 *
 * @description The bridge API is mounted on the topmost same-origin window, but the target iframe
 * may be nested inside another same-origin iframe. Starting from the topmost same-origin window and
 * walking accessible child frame documents lets the shared transport discover cross-origin frames
 * that are only present inside nested same-origin containers.
 *
 * @param receiverId - The receiver ID to search for
 * @returns The iframe's contentWindow if found, otherwise undefined
 */ const $192088c838205c51$var$resolveChildIframe = (receiverId)=>{
    const frame = $192088c838205c51$var$findIframe(window?.document, receiverId);
    if (!frame || !frame.contentWindow) return undefined;
    return $192088c838205c51$var$resolveChildIframeFromWindow(receiverId, (0, $BUV1j.findTopmostSameOriginWindow)(window), new WeakSet(), 0);
};
const $192088c838205c51$export$3888b6e26a971bed = (receiverId)=>$192088c838205c51$var$resolveChildIframe(receiverId)?.contentWindow ?? undefined;
const $192088c838205c51$export$b2c3e80b3e42c109 = ()=>{
    if (window.top && !(0, $BUV1j.isTop)(window)) return window.top;
    return undefined;
};
const $192088c838205c51$var$getOrigin = (url)=>{
    if (!url) return undefined;
    try {
        const origin = new URL(url, window.location.href).origin;
        return origin === 'null' ? undefined : origin;
    } catch  {
        return undefined;
    }
};
const $192088c838205c51$var$getTopmostAncestorOrigin = ()=>{
    try {
        const { ancestorOrigins: ancestorOrigins } = window.location;
        if (ancestorOrigins.length > 0) return ancestorOrigins.item(ancestorOrigins.length - 1) ?? undefined;
    } catch  {}
    const referrerOrigin = $192088c838205c51$var$getOrigin(window.document.referrer);
    return referrerOrigin === window.location.origin ? undefined : referrerOrigin;
};
const $192088c838205c51$export$6052a3134234724b = (receiverId)=>{
    const frame = $192088c838205c51$var$resolveChildIframe(receiverId);
    if (frame?.contentWindow) return {
        target: frame.contentWindow,
        origin: $192088c838205c51$var$getOrigin(frame.src)
    };
    const parent = $192088c838205c51$export$b2c3e80b3e42c109();
    return parent ? {
        target: parent,
        origin: $192088c838205c51$var$getTopmostAncestorOrigin()
    } : undefined;
};

});






/**
 * The AI Planner bridge command/identifier/type contract lives in the shared,
 * versioned package `@atlassian/ai-planner-embed-bridge` (subpath
 * `@atlassian/ai-planner-embed-bridge/AiPlannerBridgeCommands`). Import command
 * constructors, client ids, method strings, types and `getAiPlannerEmbedReceiverId()`
 * from there.
 *
 * The only thing that remains Jira-local is the DOM attribute name below: the
 * attribute used to tag the planner iframe element. That is a Rovo Content
 * Bridge transport/wiring detail of the host, not part of the planner command
 * contract, so it is not published by the package.
 *
 * Attribute the planner iframe element MUST carry so the bridge transport can
 * route commands to the planner window: `data-rovo-receiver-id="ai-planner-embed"`.
 * The value is supplied by `getAiPlannerEmbedReceiverId()` from the package.
 */ const $36299dcc0b1a7512$export$111797c9d1b433fd = 'data-rovo-receiver-id';

parcelRegister("52rYh", function(module, exports) {
$parcel$export(module.exports, "getAiPlannerOrigin", () => $07629c3044425158$export$ef289b53a6562c1a);
$parcel$export(module.exports, "getBifrostOverrideFromLocation", () => $07629c3044425158$export$ffc4c605b15bf39);
$parcel$export(module.exports, "getAiPlannerUrl", () => $07629c3044425158$export$424d2fcebcd50989);

var $kU3j1 = parcelRequire("kU3j1");
const $07629c3044425158$var$HOST_OWNED_PLANNER_PARAMS = [
    'embed',
    'cloudId',
    'accountId',
    'colorMode',
    'bifrost-override',
    'ai-planner-bifrost-override',
    (0, $kU3j1.AI_PLANNER_BRIDGE_INSTANCE_PARAM)
];
/**
 * Builds the Planner embed URL that the iframe modal renders.
 *
 * The path mirrors the AI planning link convention:
 * - a specific plan resolves to `<base>/plan/:planId`
 * - the planner overview / create flow resolves to `<base>`
 *
 * Embed mode is requested via query params (the planner's documented contract):
 * - `embed=true` — renders the planner without its top nav / global sidebar
 * - `cloudId` — lets the planner skip the `/_edge/tenant_info` round-trip
 * - `accountId` — seeds the planner's telemetry / feature-gate targeting
 * - `colorMode` — tells the planner whether to render light or dark, matching
 *   Jira's current theme (never the OS preference)
 *
 * Keeping this in one place means the iframe modal and any consumer wiring
 * stay in sync with the planner embed contract.
 *
 * IMPORTANT: the planner reads `colorMode` (like the rest of embed context)
 * once per iframe load — it never re-reads it live. If Jira's theme changes
 * while an iframe built from this URL is still mounted, the caller must
 * recreate/reload that iframe (e.g. bump a `key`, or re-set `src`) for the new
 * value to take effect.
 */ // The planner is served from the same origin as Jira, so the iframe uses the
// relative `/planner` base. A specific planner build can still be pinned at
// runtime via the `ai-planner-bifrost-override` query param (see below).
const $07629c3044425158$var$PLANNER_BASE_PATH = '/planner';
const $07629c3044425158$export$ef289b53a6562c1a = ()=>{
    try {
        // An absolute base has an origin distinct from a relative path.
        const url = new URL($07629c3044425158$var$PLANNER_BASE_PATH, 'https://relative.invalid');
        return url.origin === 'https://relative.invalid' ? null : url.origin;
    } catch  {
        return null;
    }
};
const $07629c3044425158$export$ffc4c605b15bf39 = ()=>{
    if (typeof globalThis.location === 'undefined') return null;
    const value = new URLSearchParams(globalThis.location.search).get('ai-planner-bifrost-override');
    return value != null && value !== '' ? value : null;
};
const $07629c3044425158$export$424d2fcebcd50989 = (embedContext, planId, // When set, forwarded to the planner as `bifrost-override` so a specific
// planner Bifrost build can be pinned (sourced from the Jira page URL's
// `ai-planner-bifrost-override` query param via getBifrostOverrideFromLocation).
bifrostOverride, plannerSearch, // Per-iframe bridge instance id. When set, forwarded so the planner derives a
// private Rovo bridge channel for this embed; when absent the planner falls
// back to the global bridge ids.
bridgeInstanceId, // Jira's current color mode, sourced from Jira's theme state (see
// `AiPlannerColorMode`) — never the OS preference. Defaults to 'light' for
// callers that haven't resolved a theme yet (e.g. very first paint).
colorMode = 'light')=>{
    const path = planId != null && planId !== '' ? `${$07629c3044425158$var$PLANNER_BASE_PATH}/plan/${encodeURIComponent(planId)}` : $07629c3044425158$var$PLANNER_BASE_PATH;
    const params = new URLSearchParams(plannerSearch);
    for (const param of $07629c3044425158$var$HOST_OWNED_PLANNER_PARAMS)params.delete(param);
    params.set('embed', 'true');
    params.set('cloudId', embedContext.cloudId);
    if (embedContext.accountId != null && embedContext.accountId !== '') params.set('accountId', embedContext.accountId);
    params.set('colorMode', colorMode);
    if (bifrostOverride != null && bifrostOverride !== '') params.set('bifrost-override', bifrostOverride);
    if (bridgeInstanceId != null && bridgeInstanceId !== '') params.set((0, $kU3j1.AI_PLANNER_BRIDGE_INSTANCE_PARAM), bridgeInstanceId);
    return `${path}?${params.toString()}`;
};

});

parcelRegister("kZ3gK", function(module, exports) {
$parcel$export(module.exports, "getValidatedPlannerNavigationPath", () => $c273012ba180d6f5$export$565a5b7ee5caa651);
const $c273012ba180d6f5$var$PLANNER_PLAN_PATH_PATTERN = /^\/jira\/software\/(?:c\/)?projects\/[A-Z][A-Z0-9_]*\/planner\/[A-Za-z0-9_-]+$/;
const $c273012ba180d6f5$export$565a5b7ee5caa651 = (requestedUrl, currentOrigin)=>{
    let parsedUrl;
    try {
        parsedUrl = new URL(requestedUrl);
    } catch  {
        return null;
    }
    if (parsedUrl.origin !== currentOrigin || parsedUrl.username !== '' || parsedUrl.password !== '' || !$c273012ba180d6f5$var$PLANNER_PLAN_PATH_PATTERN.test(parsedUrl.pathname)) return null;
    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};

});

parcelRegister("1t7ix", function(module, exports) {
$parcel$export(module.exports, "isMoveBeforeSupported", () => $e4a78e076e002914$export$294d1a58d945551c);
$parcel$export(module.exports, "moveNodeBefore", () => $e4a78e076e002914$export$e80c4c70821e6790);
const $e4a78e076e002914$export$294d1a58d945551c = ()=>{
    if (typeof Element === 'undefined') return false;
    // `moveBefore` is newer than the DOM lib types, so it is read through a type
    // that admits it rather than asserted onto Element.
    const proto = Element.prototype;
    return typeof proto.moveBefore === 'function';
};
const $e4a78e076e002914$export$e80c4c70821e6790 = (node, targetParent)=>{
    if (node == null || targetParent == null) return false;
    if (node.parentElement === targetParent) return true;
    if (!$e4a78e076e002914$export$294d1a58d945551c()) return false;
    const target = targetParent;
    if (typeof target.moveBefore !== 'function') return false;
    if (!node.isConnected || !targetParent.isConnected || node.ownerDocument !== targetParent.ownerDocument) return false;
    try {
        target.moveBefore(node, null);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("cPYhH", function(module, exports) {
$parcel$export(module.exports, "useAiPlannerBridge", () => $b97915ebb217d2ac$export$efe6385d43f539f1);

var $3yzOx = parcelRequire("3yzOx");

var $kU3j1 = parcelRequire("kU3j1");

var $i860n = parcelRequire("i860n");

var $Ajiv7 = parcelRequire("Ajiv7");

var $hnZqe = parcelRequire("hnZqe");
let $b97915ebb217d2ac$var$requestCounter = 0;
const $b97915ebb217d2ac$var$nextRequestId = ()=>{
    $b97915ebb217d2ac$var$requestCounter += 1;
    return `jira-ai-planner-${$b97915ebb217d2ac$var$requestCounter}`;
};
const $b97915ebb217d2ac$export$efe6385d43f539f1 = ({ onTransition: onTransition, defaultJiraSpaceKey: defaultJiraSpaceKey, defaultConfluenceSpaceKey: defaultConfluenceSpaceKey, onBack: onBack, onClose: onClose, onNavigate: onNavigate, onViewChange: onViewChange, bridgeInstanceId: bridgeInstanceId })=>{
    // Derive the bridge identities from the per-iframe instance id
    const hostClientId = (0, $kU3j1.getAiPlannerEmbedHostClientId)(bridgeInstanceId);
    const embedClientId = (0, $kU3j1.getAiPlannerEmbedClientId)(bridgeInstanceId);
    const apiRef = (0, $3yzOx.useRef)(null);
    // Keep the latest callbacks without re-creating the client on every render.
    const onTransitionRef = (0, $3yzOx.useRef)(onTransition);
    const onBackRef = (0, $3yzOx.useRef)(onBack);
    const onCloseRef = (0, $3yzOx.useRef)(onClose);
    const onNavigateRef = (0, $3yzOx.useRef)(onNavigate);
    const onViewChangeRef = (0, $3yzOx.useRef)(onViewChange);
    const defaultJiraSpaceKeyRef = (0, $3yzOx.useRef)(defaultJiraSpaceKey);
    const defaultConfluenceSpaceKeyRef = (0, $3yzOx.useRef)(defaultConfluenceSpaceKey);
    (0, $3yzOx.useEffect)(()=>{
        onTransitionRef.current = onTransition;
        onBackRef.current = onBack;
        onCloseRef.current = onClose;
        onNavigateRef.current = onNavigate;
        onViewChangeRef.current = onViewChange;
        defaultJiraSpaceKeyRef.current = defaultJiraSpaceKey;
        defaultConfluenceSpaceKeyRef.current = defaultConfluenceSpaceKey;
    }, [
        onTransition,
        onBack,
        onClose,
        onNavigate,
        onViewChange,
        defaultJiraSpaceKey,
        defaultConfluenceSpaceKey
    ]);
    // True once the planner has announced itself (first transition received).
    // Until then, loadPlan requests are buffered to honour the contract's
    // "wait for the initial idle before sending the first loadPlan".
    const plannerReadyRef = (0, $3yzOx.useRef)(false);
    // The most recent plan requested before the planner was ready (last wins).
    const pendingPlanRef = (0, $3yzOx.useRef)(null);
    // Prewarm ids requested before the planner was ready. Unlike loadPlan these
    // accumulate (a union, deduped) and are flushed together on the first
    // transition, so hovers during the iframe's cold boot are not lost.
    const pendingPrewarmIdsRef = (0, $3yzOx.useRef)(new Set());
    // Latest visibility requested before the planner was ready. `null` means
    // nothing is pending; `false` is a real value and must not be dropped.
    const pendingVisibilityRef = (0, $3yzOx.useRef)(null);
    const dispatchLoadPlan = (0, $3yzOx.useCallback)((requestId, planId)=>{
        const api = apiRef.current;
        if (api == null) return;
        try {
            api.send((0, $kU3j1.AiPlannerLoadPlanCommand), {
                senderId: hostClientId,
                receiverId: embedClientId,
                requestId: requestId,
                planId: planId,
                ...defaultJiraSpaceKeyRef.current != null && defaultJiraSpaceKeyRef.current !== '' ? {
                    defaultJiraSpaceKey: defaultJiraSpaceKeyRef.current
                } : {},
                ...defaultConfluenceSpaceKeyRef.current != null && defaultConfluenceSpaceKeyRef.current !== '' ? {
                    defaultConfluenceSpaceKey: defaultConfluenceSpaceKeyRef.current
                } : {},
                // The host owns shell behaviour and modal presentation. Advertise each capability only
                // when the current embed surface can honour it; capabilities are read
                // from the latest loadPlan, so we send them every time.
                capabilities: {
                    canBack: onBackRef.current != null,
                    canClose: onCloseRef.current != null,
                    canNavigate: onNavigateRef.current != null,
                    canHandleViewChanges: (0, $i860n.fg)('resize_planner_modal_on_navigate') && onViewChangeRef.current != null
                }
            });
        } catch  {
        // Swallow — the planner may not be registered yet.
        }
    }, [
        hostClientId,
        embedClientId
    ]);
    const dispatchPrewarm = (0, $3yzOx.useCallback)((planIds)=>{
        const api = apiRef.current;
        if (api == null || planIds.length === 0) return;
        try {
            // Best-effort and fire-and-forget — the host never blocks on the
            // `{ accepted: true }` result.
            api.send((0, $kU3j1.AiPlannerPrewarmPlansCommand), {
                senderId: hostClientId,
                receiverId: embedClientId,
                planIds: planIds
            });
        } catch  {
        // Swallow — prewarm is best-effort; loadPlan will fetch on click.
        }
    }, [
        hostClientId,
        embedClientId
    ]);
    const dispatchVisibility = (0, $3yzOx.useCallback)((isVisible)=>{
        const api = apiRef.current;
        if (api == null) return;
        try {
            api.send((0, $kU3j1.AiPlannerSetVisibilityCommand), {
                senderId: hostClientId,
                receiverId: embedClientId,
                isVisible: isVisible
            });
        } catch  {
        // Swallow — the planner may not be registered yet.
        }
    }, [
        hostClientId,
        embedClientId
    ]);
    const sendPrewarmPlans = (0, $3yzOx.useCallback)((planIds)=>{
        // Trim, drop empties and dedupe so repeated hover prewarms stay cheap and
        // we never send a degenerate message. The planner dedupes too, but
        // keeping the wire payload tidy avoids relying on it.
        const seenIds = new Set();
        const uniqueIds = [];
        for (const rawId of planIds){
            const id = rawId.trim();
            if (id !== '' && !seenIds.has(id)) {
                seenIds.add(id);
                uniqueIds.push(id);
            }
        }
        if (uniqueIds.length === 0) return;
        if (plannerReadyRef.current) {
            dispatchPrewarm(uniqueIds);
            return;
        }
        // Planner not ready yet (e.g. first hover during the iframe's cold
        // boot). Buffer the ids — accumulating a deduped union — and flush them
        // once the planner announces itself, so the warm is never lost.
        for (const id of uniqueIds)pendingPrewarmIdsRef.current.add(id);
    }, [
        dispatchPrewarm
    ]);
    (0, $3yzOx.useEffect)(()=>{
        if (typeof globalThis.window === 'undefined') return undefined;
        // Capture the (stable, ref-held) prewarm buffer so the cleanup clears the
        // same Set instance the effect used, satisfying react-hooks/exhaustive-deps.
        const pendingPrewarmIds = pendingPrewarmIdsRef.current;
        let api = null;
        try {
            api = (0, $Ajiv7.createBridgeClient)(hostClientId, (0, $hnZqe.getBrowserBridgeAPI)(), (on)=>{
                on((0, $kU3j1.AiPlannerTransitionCommand), (props)=>{
                    // The planner is now listening: flush any queued navigation,
                    // visibility, and any prewarms buffered during the iframe's cold
                    // boot. Visibility goes first so a pending `false` can hide
                    // placeholder animations before loadPlan runs; the planner
                    // defaults to visible until the first command arrives.
                    if (!plannerReadyRef.current) {
                        plannerReadyRef.current = true;
                        const pendingVisibility = pendingVisibilityRef.current;
                        pendingVisibilityRef.current = null;
                        if (pendingVisibility !== null) dispatchVisibility(pendingVisibility);
                        const pending = pendingPlanRef.current;
                        pendingPlanRef.current = null;
                        if (pending != null) dispatchLoadPlan(pending.requestId, pending.planId);
                        const pendingPrewarms = [
                            ...pendingPrewarmIdsRef.current
                        ];
                        pendingPrewarmIdsRef.current.clear();
                        dispatchPrewarm(pendingPrewarms);
                    }
                    onTransitionRef.current({
                        requestId: props.requestId,
                        state: props.state,
                        isLoading: props.isLoading
                    });
                });
                // Payload-less intents: the planner signals, the host owns the
                // behaviour (shell-level back / dismissing the embed).
                on((0, $kU3j1.AiPlannerBackCommand), ()=>{
                    onBackRef.current?.();
                });
                on((0, $kU3j1.AiPlannerCloseCommand), ()=>{
                    onCloseRef.current?.();
                });
                on((0, $kU3j1.AiPlannerNavigateCommand), ({ url: url })=>{
                    onNavigateRef.current?.(url);
                });
                if ((0, $i860n.fg)('resize_planner_modal_on_navigate')) on((0, $kU3j1.AiPlannerViewChangedCommand), ({ isHomeView: isHomeView })=>{
                    onViewChangeRef.current?.(isHomeView);
                });
            });
            apiRef.current = api;
        } catch  {
            // Bridge unavailable — leave sendLoadPlan as a no-op.
            apiRef.current = null;
        }
        return ()=>{
            try {
                api?.teardown(hostClientId);
            } catch  {
            // best-effort teardown
            }
            apiRef.current = null;
            plannerReadyRef.current = false;
            pendingPlanRef.current = null;
            pendingVisibilityRef.current = null;
            pendingPrewarmIds.clear();
        };
    }, [
        dispatchLoadPlan,
        dispatchPrewarm,
        dispatchVisibility,
        hostClientId
    ]);
    const sendLoadPlan = (0, $3yzOx.useCallback)((planId)=>{
        const requestId = $b97915ebb217d2ac$var$nextRequestId();
        if (plannerReadyRef.current) dispatchLoadPlan(requestId, planId);
        else // Planner not ready yet — buffer the latest request (last wins).
        pendingPlanRef.current = {
            requestId: requestId,
            planId: planId
        };
        return requestId;
    }, [
        dispatchLoadPlan
    ]);
    const sendVisibility = (0, $3yzOx.useCallback)((isVisible)=>{
        if (plannerReadyRef.current) {
            dispatchVisibility(isVisible);
            return;
        }
        // Planner not ready yet — keep the latest boolean, including `false`.
        pendingVisibilityRef.current = isVisible;
    }, [
        dispatchVisibility
    ]);
    return {
        sendLoadPlan: sendLoadPlan,
        sendPrewarmPlans: sendPrewarmPlans,
        sendVisibility: sendVisibility
    };
};

});
parcelRegister("Ajiv7", function(module, exports) {
$parcel$export(module.exports, "createBridgeClient", () => $abeb271aaf5a7108$export$1e90dec72d53d0f1);
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $abeb271aaf5a7108$export$1e90dec72d53d0f1 = (id, api, setupHandlers = ()=>{})=>{
    // setup command handlers before indicating this client is ready
    setupHandlers?.((command, handler)=>api.on(id, command, handler));
    // indicate as ready
    api.ready(id);
    // start using the API
    return api;
};

});


parcelRegister("hRTng", function(module, exports) {
$parcel$export(module.exports, "useAiPlannerColorMode", () => $61649990e864c22b$export$3cd99341ab5b8e);

var $4C7HL = parcelRequire("4C7HL");
const $61649990e864c22b$export$3cd99341ab5b8e = ()=>{
    const { colorMode: colorMode } = (0, $4C7HL.useThemeObserver)();
    return colorMode === 'dark' ? 'dark' : 'light';
};

});


parcelRegister("7jBdz", function(module, exports) {
$parcel$export(module.exports, "useAiPlannerUniversalCreateEnabled", () => $807cc5305f579056$export$dabdd18e00837323);

var $i860n = parcelRequire("i860n");

var $6bGyp = parcelRequire("6bGyp");
const $807cc5305f579056$export$dabdd18e00837323 = ()=>{
    const { data: rovoEntitlementData } = (0, $6bGyp.useRovoEntitlementResource)();
    // TODO: Add Planner provisioning checks
    return rovoEntitlementData?.isRovoLLMEnabled === true && rovoEntitlementData?.isBetaAiFeaturesEnabled === true && (0, $i860n.fg)('jira_planner_uc_enabled');
};

});

parcelRegister("7IK6V", function(module, exports) {
$parcel$export(module.exports, "REQUIRED", () => $e122ec4cdc64cb82$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $e122ec4cdc64cb82$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $e122ec4cdc64cb82$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $e122ec4cdc64cb82$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $e122ec4cdc64cb82$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $e122ec4cdc64cb82$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $e122ec4cdc64cb82$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $e122ec4cdc64cb82$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $e122ec4cdc64cb82$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $e122ec4cdc64cb82$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $e122ec4cdc64cb82$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $e122ec4cdc64cb82$export$8170252f0ea43511);
$parcel$export(module.exports, "SUPPORTED_MODERNISED_PROJECT_TYPES", () => $e122ec4cdc64cb82$export$91032066c893b7fc);
/* eslint-disable jira/filename-case */ const $e122ec4cdc64cb82$var$WORK_LOG_FIELD_TYPE = 'worklog';
const $e122ec4cdc64cb82$export$b1c05b34d317c074 = 'REQUIRED';
const $e122ec4cdc64cb82$export$f10b32dfda12e96e = 'unknown';
const $e122ec4cdc64cb82$export$e5e4b8c32e68dd0b = 'networkError';
const $e122ec4cdc64cb82$export$2d06efb8146cd043 = 'graphQLError';
const $e122ec4cdc64cb82$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $e122ec4cdc64cb82$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $e122ec4cdc64cb82$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $e122ec4cdc64cb82$export$aac4661200ba4104 = 'worklog_startDate';
const $e122ec4cdc64cb82$export$a23c32d5cf54cba0 = 'worklog_description';
const $e122ec4cdc64cb82$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $e122ec4cdc64cb82$var$LOG_WORK_ERROR_KEYS = [
    ...$e122ec4cdc64cb82$export$74ab3898ae683660,
    $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f,
    $e122ec4cdc64cb82$export$cf70f9220e6a2f50,
    $e122ec4cdc64cb82$export$aac4661200ba4104,
    $e122ec4cdc64cb82$export$a23c32d5cf54cba0
];
const $e122ec4cdc64cb82$export$983715bb9b0f9b2c = {
    [$e122ec4cdc64cb82$var$WORK_LOG_FIELD_TYPE]: $e122ec4cdc64cb82$var$LOG_WORK_ERROR_KEYS
};
const $e122ec4cdc64cb82$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $e122ec4cdc64cb82$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $e122ec4cdc64cb82$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $e122ec4cdc64cb82$export$8170252f0ea43511 = 'QuickCreateIssue';
const $e122ec4cdc64cb82$export$91032066c893b7fc = [
    'business',
    'software'
];

});

parcelRegister("fZL4f", function(module, exports) {
$parcel$export(module.exports, "useSmartFieldsMachineLearning", () => $92cf146647c83b5b$export$2d70bc5538735402);

var $58tmX = parcelRequire("58tmX");

var $k6ufm = parcelRequire("k6ufm");

var $hB5dG = parcelRequire("hB5dG");
const $92cf146647c83b5b$export$f66e1f764818b2e = ()=>{
    return (0, $k6ufm.useResource)((0, $hB5dG.gicSmartFieldsFeatureResource));
};
const $92cf146647c83b5b$export$2d70bc5538735402 = ()=>{
    const $ = (0, $58tmX.c)(2);
    const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } = $92cf146647c83b5b$export$f66e1f764818b2e();
    const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;
    const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;
    let t0;
    if ($[0] !== withMachineLearning) {
        t0 = {
            withMachineLearning: withMachineLearning
        };
        $[0] = withMachineLearning;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};

});

parcelRegister("bmXzb", function(module, exports) {
$parcel$export(module.exports, "preloadModalLoadQuery", () => $40c4a9ab63465fb0$export$6a43d3f2704ba51c);

var $6CfY5 = parcelRequire("6CfY5");


var $cNo3d = parcelRequire("cNo3d");

var $b92la = parcelRequire("b92la");

var $iEXfT = parcelRequire("iEXfT");

var $7Xc3n = parcelRequire("7Xc3n");

var $de86o = parcelRequire("de86o");
const $40c4a9ab63465fb0$export$6a43d3f2704ba51c = ({ projectContext: projectContext, storageVariables: storageVariables, withMachineLearning: withMachineLearning, originUrl: originUrl })=>{
    const query = (0, $de86o.getConsolidatedCreateConfigQuery)({
        isInContext: false,
        isSubtask: false,
        withML: withMachineLearning,
        isCreateLinkedIssue: false,
        evaluateMiniMode: true,
        isModernised: true
    });
    const variables = {
        ...(0, $7Xc3n.getQueryVariables)((0, $iEXfT.getIssueCreateProjectForMount)(projectContext), null),
        issueTypes: null,
        requestTypes: null,
        additionalContext: null,
        defaultValues: null,
        parentId: null,
        ...storageVariables,
        evaluateMiniMode: true
    };
    const client = (0, $cNo3d.getClient)({
        clientId: (0, $9d67e4bc255d2def$export$9c9ee93e509f8666),
        clientCreator: ()=>(0, $b92la.getGiraClient)().clientCreator(originUrl)
    });
    client.query({
        query: query,
        variables: variables,
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
    }).catch((error)=>{
        (0, $6CfY5.default).safeWarnWithoutCustomerData('issue-create-modal.services.modal-load-query.preload-modal-load-query', 'Best-effort modal-load query preload failed; click-time fetch will retry', error instanceof Error ? error : new Error(String(error)));
    });
};

});
/* eslint-disable jira/filename-case */ const $9d67e4bc255d2def$export$9c9ee93e509f8666 = 'gira';

parcelRegister("cNo3d", function(module, exports) {
$parcel$export(module.exports, "resetCache", () => $3026e9e8ef7d650a$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $3026e9e8ef7d650a$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $3026e9e8ef7d650a$export$8e363dbef886ff17);
// eslint-disable-next-line jira/filename-case

var $3yzOx = parcelRequire("3yzOx");

var $jJGWf = parcelRequire("jJGWf");

var $dWPnm = parcelRequire("dWPnm");

var $gXtG2 = parcelRequire("gXtG2");
let $3026e9e8ef7d650a$var$CLIENTS_CACHE = {};
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $3026e9e8ef7d650a$var$CLIENTS_CACHE = {};
});
const $3026e9e8ef7d650a$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $3026e9e8ef7d650a$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $3026e9e8ef7d650a$var$CLIENTS_CACHE[clientId];
};
const $3026e9e8ef7d650a$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $3026e9e8ef7d650a$var$CLIENTS_CACHE[clientId];
    delete $3026e9e8ef7d650a$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $3026e9e8ef7d650a$export$44dd3e9494f887fc = ()=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($3026e9e8ef7d650a$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $3026e9e8ef7d650a$var$CLIENTS_CACHE[key].extract()
        }), {});
const $3026e9e8ef7d650a$export$6bb76d6eba7e258c = ({ clientId: clientId, clientCreator: clientCreator })=>{
    let client = $3026e9e8ef7d650a$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator();
        $3026e9e8ef7d650a$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $3026e9e8ef7d650a$export$8e363dbef886ff17 extends (0, $3yzOx.Component) {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    getClient() {
        return $3026e9e8ef7d650a$export$6bb76d6eba7e258c(this.props.client);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jJGWf)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        const client = this.getClient();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $dWPnm.ApolloProvider), {
            client: client
        }, children);
    }
}
$3026e9e8ef7d650a$export$8e363dbef886ff17.displayName = "ApolloClientProvider";

});
parcelRegister("dWPnm", function(module, exports) {
$parcel$export(module.exports, "getApolloContext", () => $a2788b49cf7d0148$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $a2788b49cf7d0148$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $a2788b49cf7d0148$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $a2788b49cf7d0148$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $a2788b49cf7d0148$export$8f49e4af10703ce3);

var $3yzOx = parcelRequire("3yzOx");

var $9yrsD = parcelRequire("9yrsD");
var $a2788b49cf7d0148$var$apolloContext;
function $a2788b49cf7d0148$export$a47505d961ee3a1() {
    if (!$a2788b49cf7d0148$var$apolloContext) $a2788b49cf7d0148$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createContext({});
    return $a2788b49cf7d0148$var$apolloContext;
}
function $a2788b49cf7d0148$export$c2ee824bcc89ca6a() {
    $a2788b49cf7d0148$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createContext({});
}
var $a2788b49cf7d0148$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $a2788b49cf7d0148$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $9yrsD.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $a2788b49cf7d0148$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $a2788b49cf7d0148$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $9yrsD.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $a2788b49cf7d0148$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($a2788b49cf7d0148$export$d1d99cf900472499 || ($a2788b49cf7d0148$export$d1d99cf900472499 = {}));
var $a2788b49cf7d0148$var$cache = new Map();
function $a2788b49cf7d0148$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $a2788b49cf7d0148$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $a2788b49cf7d0148$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $a2788b49cf7d0148$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $a2788b49cf7d0148$export$8f49e4af10703ce3(document) {
    var cached = $a2788b49cf7d0148$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $9yrsD.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $9yrsD.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $9yrsD.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $a2788b49cf7d0148$export$d1d99cf900472499.Query : $a2788b49cf7d0148$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $a2788b49cf7d0148$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $9yrsD.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $a2788b49cf7d0148$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("9yrsD", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $6f4c972ad88fa498$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $6f4c972ad88fa498$export$f5708dca728d7177);

var $9NQPN = parcelRequire("9NQPN");

var $5tX2G = parcelRequire("5tX2G");
var $6f4c972ad88fa498$var$genericMessage = "Invariant Violation";
var $6f4c972ad88fa498$var$_a = Object.setPrototypeOf, $6f4c972ad88fa498$var$setPrototypeOf = $6f4c972ad88fa498$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $6f4c972ad88fa498$var$_a;
var $6f4c972ad88fa498$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $9NQPN.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $6f4c972ad88fa498$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $6f4c972ad88fa498$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $6f4c972ad88fa498$var$genericMessage;
        $6f4c972ad88fa498$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $6f4c972ad88fa498$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $6f4c972ad88fa498$export$cea12affaee22fe8(message);
}
function $6f4c972ad88fa498$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $6f4c972ad88fa498$var$wrapConsoleMethod("warn");
    invariant.error = $6f4c972ad88fa498$var$wrapConsoleMethod("error");
})($6f4c972ad88fa498$export$f5708dca728d7177 || ($6f4c972ad88fa498$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $6f4c972ad88fa498$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $5tX2G === "object") $6f4c972ad88fa498$export$e54fe5b0f43758f7 = $5tX2G;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($6f4c972ad88fa498$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $6f4c972ad88fa498$var$invariant$1 = $6f4c972ad88fa498$export$f5708dca728d7177;
var $6f4c972ad88fa498$export$2e2bcd8739ae039 = $6f4c972ad88fa498$var$invariant$1;

});



parcelRegister("b92la", function(module, exports) {
$parcel$export(module.exports, "getGiraClient", () => $f1e8a2141a7aae53$export$4cea60a165c59df0);
$parcel$export(module.exports, "useIssueCreateFromAnywhereContext", () => $f1e8a2141a7aae53$export$f99899ced542f49a);
/* eslint-disable jira/filename-case */ 
var $3yzOx = parcelRequire("3yzOx");

var $bVhVP = parcelRequire("bVhVP");

var $jwOsd = parcelRequire("jwOsd");

var $9LlSf = parcelRequire("9LlSf");
const $f1e8a2141a7aae53$export$4cea60a165c59df0 = ()=>(0, $9LlSf.default);
const $f1e8a2141a7aae53$export$f99899ced542f49a = ()=>{
    const cloudIdRef = (0, $3yzOx.useRef)('');
    const [{ selectedCloudId: selectedCloudId }] = (0, $jwOsd.useSitePickerContext)();
    (0, $3yzOx.useEffect)(()=>{
        if (selectedCloudId && cloudIdRef.current !== selectedCloudId) cloudIdRef.current = selectedCloudId;
    }, [
        selectedCloudId
    ]);
    const originUrl = (0, $3yzOx.useMemo)(()=>(0, $bVhVP.transformOriginUrl)(selectedCloudId), [
        selectedCloudId
    ]);
    return {
        giraClient: {
            ...$f1e8a2141a7aae53$export$4cea60a165c59df0(),
            ...originUrl && {
                clientCreator: ()=>$f1e8a2141a7aae53$export$4cea60a165c59df0()?.clientCreator(originUrl)
            }
        },
        // oxlint-disable-next-line react/refs
        resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId
    };
};

});
parcelRegister("bVhVP", function(module, exports) {
$parcel$export(module.exports, "transformStargateUrl", () => $053e9ab6f82feaca$export$96f8b7181eacc12a);
$parcel$export(module.exports, "transformCreateIssueUrl", () => $053e9ab6f82feaca$export$3092c86dfb3d9d95);
$parcel$export(module.exports, "transformOriginUrl", () => $053e9ab6f82feaca$export$e32687a94f0c0d0c);
/* eslint-disable jira/filename-case */ const $053e9ab6f82feaca$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};
const $053e9ab6f82feaca$export$3092c86dfb3d9d95 = ({ issueUrl: issueUrl, selectedCloudId: selectedCloudId })=>{
    if (!selectedCloudId) return issueUrl;
    return `/gateway/api/ex/jira/${selectedCloudId}${issueUrl}`;
};
const $053e9ab6f82feaca$export$e32687a94f0c0d0c = (selectedCloudId)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    selectedCloudId ? `${window.origin}/gateway/api/ex/jira/${selectedCloudId}` : null;

});

parcelRegister("jwOsd", function(module, exports) {
$parcel$export(module.exports, "useSitePickerContext", () => $466537c9aa0efbb5$export$f8b5aae013e4cf77);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $466537c9aa0efbb5$var$initialState = {
    selectedCloudId: '',
    siteDomain: ''
};
const $466537c9aa0efbb5$var$actions = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $466537c9aa0efbb5$var$store = (0, $5QDqc.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $466537c9aa0efbb5$var$initialState,
    actions: $466537c9aa0efbb5$var$actions
});
const $466537c9aa0efbb5$export$f8b5aae013e4cf77 = (0, $3h1FP.createHook)($466537c9aa0efbb5$var$store);

});

parcelRegister("9LlSf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c00d14fe10fbb976$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $jJGWf = parcelRequire("jJGWf");

var $exVei = parcelRequire("exVei");

var $9Oiqw = parcelRequire("9Oiqw");

var $6hdKg = parcelRequire("6hdKg");
var $bYR26 = parcelRequire("bYR26");

var $cCzxP = parcelRequire("cCzxP");

var $eBUKk = parcelRequire("eBUKk");

var $kM9Y5 = parcelRequire("kM9Y5");

var $44lBj = parcelRequire("44lBj");

var $6CfY5 = parcelRequire("6CfY5");

var $DhaVC = parcelRequire("DhaVC");

var $gXtG2 = parcelRequire("gXtG2");

var $85J5e = parcelRequire("85J5e");

var $dEp2z = parcelRequire("dEp2z");


const $c00d14fe10fbb976$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $c00d14fe10fbb976$var$CACHE_NAME = `apollo-cache/${$c00d14fe10fbb976$var$GIRA_APOLLO_CLIENT_ID}`;
const $c00d14fe10fbb976$var$LOG_NAMESPACE = `apollo.${$c00d14fe10fbb976$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $c00d14fe10fbb976$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $c00d14fe10fbb976$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $c00d14fe10fbb976$export$851a7159daf49c89 = new (0, $exVei.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($85J5e))
});
const $c00d14fe10fbb976$var$errorLink = (0, $cCzxP.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $dEp2z.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $dEp2z.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $6CfY5.default).safeErrorWithoutCustomerData($c00d14fe10fbb976$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $6CfY5.default).safeErrorWithoutCustomerData($c00d14fe10fbb976$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($jJGWf)))(operation.getContext(), [
            $c00d14fe10fbb976$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $6CfY5.default).safeErrorWithoutCustomerData($c00d14fe10fbb976$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$c00d14fe10fbb976$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $c00d14fe10fbb976$var$retryLinkWithFama = new (0, $kM9Y5.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $dEp2z.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $c00d14fe10fbb976$var$CancelableRequestLink extends (0, $6hdKg.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $bYR26.default)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
$c00d14fe10fbb976$var$CancelableRequestLink.displayName = "CancelableRequestLink";
const $c00d14fe10fbb976$export$625a51ede6ece419 = (object)=>{
    if (object.__typename === 'JiraTabLayout') return undefined;
    return object.id ? `${object.id}${object.__typename}` : undefined;
};
// apollo-link-state-fragment@0.1.8 types getFragment's args as { id, __typename }, which is
// narrower than apollo-cache-inmemory's CacheResolver (args: { [argName: string]: any }). Wrap it
// in a CacheResolver-typed function so the resolver conforms to Apollo's cacheRedirects contract.
const { getFragment: $c00d14fe10fbb976$var$getFragment } = (0, $44lBj.fragmentCacheRedirect)();
const $c00d14fe10fbb976$var$getFragmentResolver = (rootValue, args)=>$c00d14fe10fbb976$var$getFragment(rootValue, {
        id: args.id,
        __typename: args.__typename
    });
const $c00d14fe10fbb976$var$cache = new (0, $exVei.InMemoryCache)({
    cacheRedirects: {
        Query: {
            getFragment: $c00d14fe10fbb976$var$getFragmentResolver
        }
    },
    fragmentMatcher: $c00d14fe10fbb976$export$851a7159daf49c89,
    dataIdFromObject: $c00d14fe10fbb976$export$625a51ede6ece419
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$c00d14fe10fbb976$var$isSsrSuccessful() && window.SPA_STATE[$c00d14fe10fbb976$var$CACHE_NAME] || {});
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $c00d14fe10fbb976$var$cache.reset();
});
const $c00d14fe10fbb976$export$de66868aab9e79ea = (originUrl = '')=>new (0, $9Oiqw.ApolloClient)({
        name: $c00d14fe10fbb976$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $c00d14fe10fbb976$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $6hdKg.ApolloLink).from([
            $c00d14fe10fbb976$var$retryLinkWithFama,
            $c00d14fe10fbb976$var$errorLink,
            (0, $DhaVC.UFOLoggerLink),
            (0, $44lBj.fragmentLinkState)($c00d14fe10fbb976$var$cache),
            ...!$c00d14fe10fbb976$var$isSsrSuccessful() ? [
                new $c00d14fe10fbb976$var$CancelableRequestLink()
            ] : [],
            new (0, $eBUKk.HttpLink)({
                uri: ({ operationName: operationName })=>`${originUrl}/rest/${$c00d14fe10fbb976$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$c00d14fe10fbb976$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $c00d14fe10fbb976$var$cache,
        connectToDevTools: false
    });
const $c00d14fe10fbb976$var$ExportedComponent = {
    clientId: $c00d14fe10fbb976$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $c00d14fe10fbb976$export$de66868aab9e79ea
};
var $c00d14fe10fbb976$export$2e2bcd8739ae039 = $c00d14fe10fbb976$var$ExportedComponent;

});
parcelRegister("exVei", function(module, exports) {
$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $a9708a5aa2e5c185$export$3b71c6b829c99d21);
$parcel$export(module.exports, "InMemoryCache", () => $a9708a5aa2e5c185$export$467265324939f47f);

var $9NQPN = parcelRequire("9NQPN");

var $jO2wX = parcelRequire("jO2wX");

var $9tOGL = parcelRequire("9tOGL");
var $s6yhU = parcelRequire("s6yhU");

var $hRzkM = parcelRequire("hRzkM");

var $9yrsD = parcelRequire("9yrsD");
var $a9708a5aa2e5c185$var$haveWarned = false;
function $a9708a5aa2e5c185$var$shouldWarn() {
    var answer = !$a9708a5aa2e5c185$var$haveWarned;
    if (!(0, $9tOGL.isTest)()) $a9708a5aa2e5c185$var$haveWarned = true;
    return answer;
}
var $a9708a5aa2e5c185$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $a9708a5aa2e5c185$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $a9708a5aa2e5c185$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $a9708a5aa2e5c185$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $9yrsD.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $9yrsD.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $a9708a5aa2e5c185$var$hasOwn = Object.prototype.hasOwnProperty;
var $a9708a5aa2e5c185$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $hRzkM.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($a9708a5aa2e5c185$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$a9708a5aa2e5c185$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $a9708a5aa2e5c185$var$defaultNormalizedCacheFactory(seed) {
    return new $a9708a5aa2e5c185$var$DepTrackingCache(seed);
}
var $a9708a5aa2e5c185$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $hRzkM.KeyTrie)((0, $9tOGL.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $hRzkM.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $a9708a5aa2e5c185$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $hRzkM.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $a9708a5aa2e5c185$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $hRzkM.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $a9708a5aa2e5c185$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $9tOGL.getQueryDefinition)(query);
        variables = (0, $9tOGL.assign)({}, (0, $9tOGL.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        const name = query.definitions && query.definitions[0] && query.definitions[0].name && query.definitions[0].name.value;
        const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.diffStore;
        if (name && stats) {
            stats[name] = stats[name] || 0;
            stats[name]++;
        }
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $9yrsD.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $s6yhU.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $a9708a5aa2e5c185$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $9tOGL.getMainDefinition)(query);
        var fragments = (0, $9tOGL.getFragmentDefinitions)(query);
        var fragmentMap = (0, $9tOGL.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $9tOGL.shouldInclude)(selection, variables)) return;
            if ((0, $9tOGL.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $9tOGL.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $9yrsD.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $9tOGL.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $9tOGL.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $9tOGL.resultKeyNameFromField)(field),
            directives: (0, $9tOGL.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $a9708a5aa2e5c185$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $a9708a5aa2e5c185$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $a9708a5aa2e5c185$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $a9708a5aa2e5c185$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $9tOGL.isIdValue)(value)) throw new (0, $9yrsD.InvariantError)(10);
}
function $a9708a5aa2e5c185$var$defaultFragmentMatcher() {
    return true;
}
function $a9708a5aa2e5c185$export$7a4899fe13f33235(idValue) {
    (0, $9yrsD.invariant)((0, $9tOGL.isIdValue)(idValue), 11);
}
function $a9708a5aa2e5c185$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $9tOGL.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $9tOGL.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $9tOGL.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $a9708a5aa2e5c185$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $a9708a5aa2e5c185$export$7e2b40d1002de152(seed) {
    return new $a9708a5aa2e5c185$export$ee7258b8691956a3(seed);
}
var $a9708a5aa2e5c185$export$de4e6870dc6ac801 = function(_super) {
    (0, $9NQPN.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $a9708a5aa2e5c185$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $a9708a5aa2e5c185$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $a9708a5aa2e5c185$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $a9708a5aa2e5c185$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $a9708a5aa2e5c185$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $9tOGL.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $9tOGL.assign)({}, (0, $9tOGL.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $9tOGL.createFragmentMap)((0, $9tOGL.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $a9708a5aa2e5c185$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $9tOGL.shouldInclude)(selection, variables)) return;
            if ((0, $9tOGL.isField)(selection)) {
                var resultFieldKey = (0, $9tOGL.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $9yrsD.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $9tOGL.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $a9708a5aa2e5c185$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $9tOGL.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $9tOGL.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$a9708a5aa2e5c185$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $9yrsD.invariant)(!semanticId || !$a9708a5aa2e5c185$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$a9708a5aa2e5c185$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $9tOGL.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $9tOGL.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $9yrsD.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $9yrsD.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $a9708a5aa2e5c185$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $s6yhU.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$a9708a5aa2e5c185$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $9tOGL.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $a9708a5aa2e5c185$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $a9708a5aa2e5c185$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $9tOGL.isIdValue)(value) && $a9708a5aa2e5c185$var$isGeneratedId(value.id) && (0, $9tOGL.isIdValue)(realValue) && !(0, $s6yhU.equal)(value, realValue) && $a9708a5aa2e5c185$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, generated), real);
    if ((0, $s6yhU.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $a9708a5aa2e5c185$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $a9708a5aa2e5c185$var$defaultConfig = {
    fragmentMatcher: new $a9708a5aa2e5c185$export$5d3fcf53267091de(),
    dataIdFromObject: $a9708a5aa2e5c185$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $a9708a5aa2e5c185$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $a9708a5aa2e5c185$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $a9708a5aa2e5c185$var$OptimisticCacheLayer = function(_super) {
    (0, $9NQPN.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $a9708a5aa2e5c185$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($a9708a5aa2e5c185$export$ee7258b8691956a3);
var $a9708a5aa2e5c185$export$467265324939f47f = function(_super) {
    (0, $9NQPN.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $hRzkM.KeyTrie)((0, $9tOGL.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, $a9708a5aa2e5c185$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $a9708a5aa2e5c185$var$DepTrackingCache() : new $a9708a5aa2e5c185$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $a9708a5aa2e5c185$export$eb8361c5d132fb8f();
        _this.storeReader = new $a9708a5aa2e5c185$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $hRzkM.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $a9708a5aa2e5c185$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $9yrsD.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $a9708a5aa2e5c185$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $a9708a5aa2e5c185$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $9tOGL.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $jO2wX.ApolloCache));

});
parcelRegister("jO2wX", function(module, exports) {
$parcel$export(module.exports, "ApolloCache", () => $e6b4a65b31a172a8$export$5fc74f25506aa9c);

var $9tOGL = parcelRequire("9tOGL");
function $e6b4a65b31a172a8$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $e6b4a65b31a172a8$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $e6b4a65b31a172a8$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $e6b4a65b31a172a8$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $e6b4a65b31a172a8$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $e6b4a65b31a172a8$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $e6b4a65b31a172a8$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $e6b4a65b31a172a8$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $e6b4a65b31a172a8$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $9tOGL.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $9tOGL.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $e6b4a65b31a172a8$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $e6b4a65b31a172a8$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $e6b4a65b31a172a8$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $e6b4a65b31a172a8$export$94affb487e701bf2;
$e6b4a65b31a172a8$export$94affb487e701bf2 || ($e6b4a65b31a172a8$export$94affb487e701bf2 = {});

});
parcelRegister("9tOGL", function(module, exports) {
$parcel$export(module.exports, "storeKeyNameFromField", () => $6e6e243337bc25ab$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $6e6e243337bc25ab$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $6e6e243337bc25ab$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $6e6e243337bc25ab$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $6e6e243337bc25ab$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $6e6e243337bc25ab$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $6e6e243337bc25ab$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $6e6e243337bc25ab$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $6e6e243337bc25ab$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $6e6e243337bc25ab$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $6e6e243337bc25ab$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $6e6e243337bc25ab$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $6e6e243337bc25ab$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $6e6e243337bc25ab$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $6e6e243337bc25ab$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $6e6e243337bc25ab$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $6e6e243337bc25ab$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $6e6e243337bc25ab$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $6e6e243337bc25ab$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $6e6e243337bc25ab$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $6e6e243337bc25ab$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $6e6e243337bc25ab$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $6e6e243337bc25ab$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $6e6e243337bc25ab$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $6e6e243337bc25ab$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $6e6e243337bc25ab$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $6e6e243337bc25ab$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $6e6e243337bc25ab$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $6e6e243337bc25ab$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $6e6e243337bc25ab$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $6e6e243337bc25ab$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $6e6e243337bc25ab$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $6e6e243337bc25ab$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $6e6e243337bc25ab$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $6e6e243337bc25ab$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $6e6e243337bc25ab$export$160070228be94b08);

var $gWlQ0 = parcelRequire("gWlQ0");

var $9yrsD = parcelRequire("9yrsD");

var $9NQPN = parcelRequire("9NQPN");

var $73ReM = parcelRequire("73ReM");

var $s6yhU = parcelRequire("s6yhU");

var $5tX2G = parcelRequire("5tX2G");
function $6e6e243337bc25ab$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $6e6e243337bc25ab$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $6e6e243337bc25ab$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $6e6e243337bc25ab$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $6e6e243337bc25ab$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $6e6e243337bc25ab$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $6e6e243337bc25ab$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $6e6e243337bc25ab$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $6e6e243337bc25ab$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $6e6e243337bc25ab$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $6e6e243337bc25ab$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $6e6e243337bc25ab$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($6e6e243337bc25ab$var$isIntValue(value) || $6e6e243337bc25ab$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($6e6e243337bc25ab$var$isBooleanValue(value) || $6e6e243337bc25ab$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($6e6e243337bc25ab$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $6e6e243337bc25ab$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($6e6e243337bc25ab$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($6e6e243337bc25ab$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $6e6e243337bc25ab$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($6e6e243337bc25ab$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($6e6e243337bc25ab$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $9yrsD.InvariantError)(17);
}
function $6e6e243337bc25ab$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $6e6e243337bc25ab$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6e6e243337bc25ab$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $6e6e243337bc25ab$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $6e6e243337bc25ab$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $6e6e243337bc25ab$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($73ReM)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($6e6e243337bc25ab$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $6e6e243337bc25ab$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6e6e243337bc25ab$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $6e6e243337bc25ab$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $6e6e243337bc25ab$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $6e6e243337bc25ab$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $6e6e243337bc25ab$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $6e6e243337bc25ab$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $9NQPN.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $6e6e243337bc25ab$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $6e6e243337bc25ab$var$defaultValueFromVariable(node) {
    throw new (0, $9yrsD.InvariantError)(18);
}
function $6e6e243337bc25ab$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $6e6e243337bc25ab$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $6e6e243337bc25ab$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $6e6e243337bc25ab$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $6e6e243337bc25ab$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $6e6e243337bc25ab$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $6e6e243337bc25ab$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $6e6e243337bc25ab$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $9yrsD.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $6e6e243337bc25ab$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $gWlQ0.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $6e6e243337bc25ab$export$2dafb573e282fe8d(names, doc) {
    return $6e6e243337bc25ab$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $6e6e243337bc25ab$export$8d1e9e5bbfa5d09a(document) {
    return document && $6e6e243337bc25ab$export$2dafb573e282fe8d([
        'client'
    ], document) && $6e6e243337bc25ab$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $6e6e243337bc25ab$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $6e6e243337bc25ab$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($6e6e243337bc25ab$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $9yrsD.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $9yrsD.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $9yrsD.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $6e6e243337bc25ab$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $9yrsD.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $9yrsD.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, document), {
        definitions: (0, $9NQPN.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $6e6e243337bc25ab$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $6e6e243337bc25ab$export$a92e7a440b22bdf0(doc) {
    $6e6e243337bc25ab$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $9yrsD.invariant)(mutationDef, 1);
    return mutationDef;
}
function $6e6e243337bc25ab$export$a7d0d8111d2386df(doc) {
    (0, $9yrsD.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $9yrsD.InvariantError)(3);
        return definition;
    });
    (0, $9yrsD.invariant)(operations.length <= 1, 4);
    return doc;
}
function $6e6e243337bc25ab$export$7a5b1fa979d2c158(doc) {
    $6e6e243337bc25ab$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $6e6e243337bc25ab$export$78a8e95d8d43ad7f(document) {
    var def = $6e6e243337bc25ab$export$7a5b1fa979d2c158(document);
    (0, $9yrsD.invariant)(def, 5);
    return def;
}
function $6e6e243337bc25ab$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $6e6e243337bc25ab$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $6e6e243337bc25ab$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $6e6e243337bc25ab$export$7a5b1fa979d2c158(doc);
    (0, $9yrsD.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $6e6e243337bc25ab$export$772111caef41b3f5(doc) {
    (0, $9yrsD.invariant)(doc.kind === 'Document', 7);
    (0, $9yrsD.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $9yrsD.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $6e6e243337bc25ab$export$f431198736b7f96d(queryDoc) {
    $6e6e243337bc25ab$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $9yrsD.InvariantError)(10);
}
function $6e6e243337bc25ab$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $6e6e243337bc25ab$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $6e6e243337bc25ab$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $6e6e243337bc25ab$export$e6e34fd1f2686227.apply(void 0, (0, $9NQPN.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $6e6e243337bc25ab$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $6e6e243337bc25ab$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $6e6e243337bc25ab$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $6e6e243337bc25ab$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $6e6e243337bc25ab$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $6e6e243337bc25ab$var$nullIfDocIsEmpty(doc) {
    return $6e6e243337bc25ab$var$isEmpty($6e6e243337bc25ab$export$7a5b1fa979d2c158(doc) || $6e6e243337bc25ab$export$772111caef41b3f5(doc), $6e6e243337bc25ab$export$193789b4c8246dd4($6e6e243337bc25ab$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $6e6e243337bc25ab$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $6e6e243337bc25ab$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $6e6e243337bc25ab$var$nullIfDocIsEmpty((0, $gWlQ0.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($6e6e243337bc25ab$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $6e6e243337bc25ab$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($6e6e243337bc25ab$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $6e6e243337bc25ab$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $6e6e243337bc25ab$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $6e6e243337bc25ab$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $6e6e243337bc25ab$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $6e6e243337bc25ab$export$43b332f87950a467(doc) {
    return (0, $gWlQ0.visit)($6e6e243337bc25ab$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $6e6e243337bc25ab$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($6e6e243337bc25ab$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, node), {
                    selections: (0, $9NQPN.__spreadArrays)(selections, [
                        $6e6e243337bc25ab$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $6e6e243337bc25ab$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $6e6e243337bc25ab$export$74985f3324559867(doc) {
    return $6e6e243337bc25ab$export$e5ae0530da5fe96c([
        $6e6e243337bc25ab$var$connectionRemoveConfig
    ], $6e6e243337bc25ab$export$a7d0d8111d2386df(doc));
}
function $6e6e243337bc25ab$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $6e6e243337bc25ab$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $6e6e243337bc25ab$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$6e6e243337bc25ab$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($6e6e243337bc25ab$var$getDirectiveMatcher(directives)) || nestedCheck && $6e6e243337bc25ab$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $6e6e243337bc25ab$export$deed3420cb5d2e1d(directives, doc) {
    $6e6e243337bc25ab$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $6e6e243337bc25ab$var$nullIfDocIsEmpty((0, $gWlQ0.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $6e6e243337bc25ab$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($6e6e243337bc25ab$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $6e6e243337bc25ab$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $6e6e243337bc25ab$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $6e6e243337bc25ab$var$getArgumentMatcher(config);
    return $6e6e243337bc25ab$var$nullIfDocIsEmpty((0, $gWlQ0.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $6e6e243337bc25ab$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $6e6e243337bc25ab$var$nullIfDocIsEmpty((0, $gWlQ0.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $6e6e243337bc25ab$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($6e6e243337bc25ab$export$fb56ad75dd311c12(selection) || $6e6e243337bc25ab$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $6e6e243337bc25ab$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $6e6e243337bc25ab$export$57c368c23873f32b(document) {
    var definition = $6e6e243337bc25ab$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $gWlQ0.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $6e6e243337bc25ab$export$8eae69e876ee321e(document) {
    $6e6e243337bc25ab$export$a7d0d8111d2386df(document);
    var modifiedDoc = $6e6e243337bc25ab$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $gWlQ0.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $6e6e243337bc25ab$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $6e6e243337bc25ab$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $6e6e243337bc25ab$var$toString = Object.prototype.toString;
function $6e6e243337bc25ab$export$629a2bd3f5a49ecc(value) {
    return $6e6e243337bc25ab$var$cloneDeepHelper(value, new Map());
}
function $6e6e243337bc25ab$var$cloneDeepHelper(val, seen) {
    switch($6e6e243337bc25ab$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $6e6e243337bc25ab$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $6e6e243337bc25ab$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $6e6e243337bc25ab$export$4bd44a2aa29d3d6e() {
    if (typeof $5tX2G !== 'undefined' && "production") return "production";
    return 'development';
}
function $6e6e243337bc25ab$export$f0cb0fda19c18b37(env) {
    return $6e6e243337bc25ab$export$4bd44a2aa29d3d6e() === env;
}
function $6e6e243337bc25ab$export$f15d00aa73aafac4() {
    return $6e6e243337bc25ab$export$f0cb0fda19c18b37('production') === true;
}
function $6e6e243337bc25ab$export$df77466336fe5355() {
    return $6e6e243337bc25ab$export$f0cb0fda19c18b37('development') === true;
}
function $6e6e243337bc25ab$export$410cbc2864fa25b5() {
    return $6e6e243337bc25ab$export$f0cb0fda19c18b37('test') === true;
}
function $6e6e243337bc25ab$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $6e6e243337bc25ab$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $6e6e243337bc25ab$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $6e6e243337bc25ab$var$deepFreeze(o[prop]);
    });
    return o;
}
function $6e6e243337bc25ab$export$7f9c177735b71f18(obj) {
    if ($6e6e243337bc25ab$export$df77466336fe5355() || $6e6e243337bc25ab$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $6e6e243337bc25ab$var$deepFreeze(obj);
    }
    return obj;
}
var $6e6e243337bc25ab$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6e6e243337bc25ab$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $6e6e243337bc25ab$export$160070228be94b08(sources);
}
function $6e6e243337bc25ab$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $6e6e243337bc25ab$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $6e6e243337bc25ab$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $6e6e243337bc25ab$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $6e6e243337bc25ab$var$mergeHelper(target, source, pastCopies) {
    if ($6e6e243337bc25ab$var$isObject(source) && $6e6e243337bc25ab$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $6e6e243337bc25ab$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($6e6e243337bc25ab$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $6e6e243337bc25ab$var$mergeHelper($6e6e243337bc25ab$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $6e6e243337bc25ab$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $9NQPN.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $6e6e243337bc25ab$var$haveWarned = Object.create({});
function $6e6e243337bc25ab$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$6e6e243337bc25ab$export$f15d00aa73aafac4() && !$6e6e243337bc25ab$var$haveWarned[msg]) {
        if (!$6e6e243337bc25ab$export$410cbc2864fa25b5()) $6e6e243337bc25ab$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $6e6e243337bc25ab$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("gWlQ0", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $c55300aaef1312f3$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $c55300aaef1312f3$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $c55300aaef1312f3$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $c55300aaef1312f3$export$728beebeea393478);

var $9nV2v = parcelRequire("9nV2v");

var $l8X7p = parcelRequire("l8X7p");
var $c55300aaef1312f3$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $c55300aaef1312f3$export$a89c95c098ac2a58 = Object.freeze({});
function $c55300aaef1312f3$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $c55300aaef1312f3$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $l8X7p.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $9nV2v.default)(node), "."));
            var visitFn = $c55300aaef1312f3$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $c55300aaef1312f3$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $l8X7p.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $c55300aaef1312f3$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $c55300aaef1312f3$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $c55300aaef1312f3$export$a89c95c098ac2a58) skipping[i] = $c55300aaef1312f3$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $c55300aaef1312f3$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $c55300aaef1312f3$export$a89c95c098ac2a58) skipping[i] = $c55300aaef1312f3$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $c55300aaef1312f3$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("9nV2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d5281e425c3fe8a$export$2e2bcd8739ae039);

var $kQnqF = parcelRequire("kQnqF");
function $6d5281e425c3fe8a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6d5281e425c3fe8a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6d5281e425c3fe8a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6d5281e425c3fe8a$var$_typeof(obj);
}
var $6d5281e425c3fe8a$var$MAX_ARRAY_LENGTH = 10;
var $6d5281e425c3fe8a$var$MAX_RECURSIVE_DEPTH = 2;
function $6d5281e425c3fe8a$export$2e2bcd8739ae039(value) {
    return $6d5281e425c3fe8a$var$formatValue(value, []);
}
function $6d5281e425c3fe8a$var$formatValue(value, seenValues) {
    switch($6d5281e425c3fe8a$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $6d5281e425c3fe8a$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $6d5281e425c3fe8a$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $6d5281e425c3fe8a$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $6d5281e425c3fe8a$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $6d5281e425c3fe8a$var$formatArray(value, seenValues);
    return $6d5281e425c3fe8a$var$formatObject(value, seenValues);
}
function $6d5281e425c3fe8a$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $6d5281e425c3fe8a$var$MAX_RECURSIVE_DEPTH) return '[' + $6d5281e425c3fe8a$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $6d5281e425c3fe8a$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $6d5281e425c3fe8a$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $6d5281e425c3fe8a$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($6d5281e425c3fe8a$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($6d5281e425c3fe8a$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $6d5281e425c3fe8a$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $kQnqF.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $6d5281e425c3fe8a$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("kQnqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2cad6867ac47ccc$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $f2cad6867ac47ccc$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $f2cad6867ac47ccc$export$2e2bcd8739ae039 = $f2cad6867ac47ccc$var$nodejsCustomInspectSymbol;

});


parcelRegister("l8X7p", function(module, exports) {
$parcel$export(module.exports, "Location", () => $03f8e810a7e4bc64$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $03f8e810a7e4bc64$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $03f8e810a7e4bc64$export$8ee0fc9ee280b4ee);

var $9fSaY = parcelRequire("9fSaY");
var $03f8e810a7e4bc64$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $9fSaY.default)($03f8e810a7e4bc64$export$18a2be9195644f38);
var $03f8e810a7e4bc64$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $9fSaY.default)($03f8e810a7e4bc64$export$50792b0e93539fde);
function $03f8e810a7e4bc64$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("9fSaY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bcf89fb9ab29c7b$export$2e2bcd8739ae039);

var $cZeWX = parcelRequire("cZeWX");

var $kQnqF = parcelRequire("kQnqF");
function $6bcf89fb9ab29c7b$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $cZeWX.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $kQnqF.default) classObject.prototype[0, $kQnqF.default] = fn;
}

});
parcelRegister("cZeWX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9746c746c4eee7e7$export$2e2bcd8739ae039);
function $9746c746c4eee7e7$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("73ReM", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("s6yhU", function(module, exports) {
$parcel$export(module.exports, "equal", () => $0547b2bc6823a5da$export$411ce8e5a71e3069);
var $0547b2bc6823a5da$var$_a = Object.prototype, $0547b2bc6823a5da$var$toString = $0547b2bc6823a5da$var$_a.toString, $0547b2bc6823a5da$var$hasOwnProperty = $0547b2bc6823a5da$var$_a.hasOwnProperty;
var $0547b2bc6823a5da$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $0547b2bc6823a5da$export$411ce8e5a71e3069(a, b) {
    try {
        return $0547b2bc6823a5da$var$check(a, b);
    } finally{
        $0547b2bc6823a5da$var$previousComparisons.clear();
    }
}
function $0547b2bc6823a5da$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $0547b2bc6823a5da$var$toString.call(a);
    var bTag = $0547b2bc6823a5da$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($0547b2bc6823a5da$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$0547b2bc6823a5da$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$0547b2bc6823a5da$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($0547b2bc6823a5da$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$0547b2bc6823a5da$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $0547b2bc6823a5da$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $0547b2bc6823a5da$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $0547b2bc6823a5da$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $0547b2bc6823a5da$export$2e2bcd8739ae039 = $0547b2bc6823a5da$export$411ce8e5a71e3069;

});



parcelRegister("hRzkM", function(module, exports) {
$parcel$export(module.exports, "KeyTrie", () => $d012cb85d3d8bb77$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $d012cb85d3d8bb77$export$4997ffc0176396a6);

var $bATal = parcelRequire("bATal");
function $d012cb85d3d8bb77$var$defaultDispose() {}
var $d012cb85d3d8bb77$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $d012cb85d3d8bb77$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $d012cb85d3d8bb77$var$parentEntrySlot = new (0, $bATal.Slot)();
var $d012cb85d3d8bb77$var$reusableEmptyArray = [];
var $d012cb85d3d8bb77$var$emptySetPool = [];
var $d012cb85d3d8bb77$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $d012cb85d3d8bb77$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $d012cb85d3d8bb77$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $d012cb85d3d8bb77$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $d012cb85d3d8bb77$var$valueCopy(value) {
    return value.slice(0);
}
var $d012cb85d3d8bb77$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $d012cb85d3d8bb77$var$assert(!this.recomputing, "already recomputing");
        if (!$d012cb85d3d8bb77$var$rememberParent(this) && $d012cb85d3d8bb77$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $d012cb85d3d8bb77$var$mightBeDirty(this) ? $d012cb85d3d8bb77$var$reallyRecompute(this) : $d012cb85d3d8bb77$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $d012cb85d3d8bb77$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $d012cb85d3d8bb77$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $d012cb85d3d8bb77$var$forgetChildren(this).forEach($d012cb85d3d8bb77$var$maybeReportOrphan);
        $d012cb85d3d8bb77$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $d012cb85d3d8bb77$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $d012cb85d3d8bb77$var$rememberParent(child) {
    var parent = $d012cb85d3d8bb77$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($d012cb85d3d8bb77$var$mightBeDirty(child)) $d012cb85d3d8bb77$var$reportDirtyChild(parent, child);
        else $d012cb85d3d8bb77$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $d012cb85d3d8bb77$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $d012cb85d3d8bb77$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $d012cb85d3d8bb77$var$parentEntrySlot.withValue(entry, $d012cb85d3d8bb77$var$recomputeNewValue, [
        entry
    ]);
    if ($d012cb85d3d8bb77$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $d012cb85d3d8bb77$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($d012cb85d3d8bb77$var$maybeReportOrphan);
    return $d012cb85d3d8bb77$var$valueGet(entry.value);
}
function $d012cb85d3d8bb77$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $d012cb85d3d8bb77$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $d012cb85d3d8bb77$var$setClean(entry) {
    entry.dirty = false;
    if ($d012cb85d3d8bb77$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $d012cb85d3d8bb77$var$reportClean(entry);
}
function $d012cb85d3d8bb77$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $d012cb85d3d8bb77$var$reportDirtyChild(parent, child);
    });
}
function $d012cb85d3d8bb77$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $d012cb85d3d8bb77$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $d012cb85d3d8bb77$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $d012cb85d3d8bb77$var$assert(parent.childValues.has(child));
    $d012cb85d3d8bb77$var$assert($d012cb85d3d8bb77$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $d012cb85d3d8bb77$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $d012cb85d3d8bb77$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $d012cb85d3d8bb77$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $d012cb85d3d8bb77$var$assert(parent.childValues.has(child));
    $d012cb85d3d8bb77$var$assert(!$d012cb85d3d8bb77$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $d012cb85d3d8bb77$var$valueCopy(child.value));
    else if (!$d012cb85d3d8bb77$var$valueIs(childValue, child.value)) parent.setDirty();
    $d012cb85d3d8bb77$var$removeDirtyChild(parent, child);
    if ($d012cb85d3d8bb77$var$mightBeDirty(parent)) return;
    $d012cb85d3d8bb77$var$reportClean(parent);
}
function $d012cb85d3d8bb77$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($d012cb85d3d8bb77$var$emptySetPool.length < $d012cb85d3d8bb77$var$POOL_TARGET_SIZE) $d012cb85d3d8bb77$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $d012cb85d3d8bb77$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $d012cb85d3d8bb77$var$forgetChildren(parent) {
    var children = $d012cb85d3d8bb77$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $d012cb85d3d8bb77$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $d012cb85d3d8bb77$var$assert(parent.dirtyChildren === null);
    return children;
}
function $d012cb85d3d8bb77$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $d012cb85d3d8bb77$var$removeDirtyChild(parent, child);
}
function $d012cb85d3d8bb77$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $d012cb85d3d8bb77$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $d012cb85d3d8bb77$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $d012cb85d3d8bb77$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $d012cb85d3d8bb77$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $d012cb85d3d8bb77$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $d012cb85d3d8bb77$var$keyTrie = new $d012cb85d3d8bb77$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $d012cb85d3d8bb77$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $d012cb85d3d8bb77$var$keyTrie.lookupArray(args);
}
var $d012cb85d3d8bb77$var$caches = new Set();
function $d012cb85d3d8bb77$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $d012cb85d3d8bb77$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $d012cb85d3d8bb77$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$d012cb85d3d8bb77$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $d012cb85d3d8bb77$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $d012cb85d3d8bb77$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$d012cb85d3d8bb77$var$parentEntrySlot.hasValue()) {
            $d012cb85d3d8bb77$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $d012cb85d3d8bb77$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("bATal", function(module, exports) {
$parcel$export(module.exports, "Slot", () => $870dd94ea20dae89$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $870dd94ea20dae89$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $870dd94ea20dae89$var$MISSING_VALUE = {};
var $870dd94ea20dae89$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $870dd94ea20dae89$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $870dd94ea20dae89$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $870dd94ea20dae89$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $870dd94ea20dae89$var$MISSING_VALUE) break;
                if (context_1 !== $870dd94ea20dae89$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $870dd94ea20dae89$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($870dd94ea20dae89$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $870dd94ea20dae89$var$currentContext.slots[this.id] = $870dd94ea20dae89$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $870dd94ea20dae89$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $870dd94ea20dae89$var$currentContext;
            $870dd94ea20dae89$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $870dd94ea20dae89$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $870dd94ea20dae89$var$currentContext;
            return function() {
                var saved = $870dd94ea20dae89$var$currentContext;
                try {
                    $870dd94ea20dae89$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $870dd94ea20dae89$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($870dd94ea20dae89$var$currentContext) {
                var saved = $870dd94ea20dae89$var$currentContext;
                try {
                    $870dd94ea20dae89$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $870dd94ea20dae89$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $870dd94ea20dae89$var$globalKey = "@wry/context:Slot";
var $870dd94ea20dae89$var$host = Array;
var $870dd94ea20dae89$export$8c6ed5c666ac1360 = $870dd94ea20dae89$var$host[$870dd94ea20dae89$var$globalKey] || function() {
    var Slot = $870dd94ea20dae89$var$makeSlotClass();
    try {
        Object.defineProperty($870dd94ea20dae89$var$host, $870dd94ea20dae89$var$globalKey, {
            value: $870dd94ea20dae89$var$host[$870dd94ea20dae89$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $870dd94ea20dae89$export$2385a24977818dd0 = $870dd94ea20dae89$export$8c6ed5c666ac1360.bind, $870dd94ea20dae89$export$9fa6f2e300a97f8 = $870dd94ea20dae89$export$8c6ed5c666ac1360.noContext;
function $870dd94ea20dae89$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($870dd94ea20dae89$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $870dd94ea20dae89$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $870dd94ea20dae89$export$2385a24977818dd0(gen.next);
        var boundThrow = $870dd94ea20dae89$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($870dd94ea20dae89$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $870dd94ea20dae89$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $870dd94ea20dae89$var$wrappedFibers = [];
function $870dd94ea20dae89$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($870dd94ea20dae89$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $870dd94ea20dae89$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $870dd94ea20dae89$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("9Oiqw", function(module, exports) {
$parcel$export(module.exports, "NetworkStatus", () => $724713ba9b033ea8$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $724713ba9b033ea8$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $724713ba9b033ea8$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $724713ba9b033ea8$export$13f5a5f0f1dbab88);

var $9NQPN = parcelRequire("9NQPN");

var $9tOGL = parcelRequire("9tOGL");
var $s6yhU = parcelRequire("s6yhU");

var $6hdKg = parcelRequire("6hdKg");
var $bYR26 = parcelRequire("bYR26");

var $5rBSo = parcelRequire("5rBSo");

var $9yrsD = parcelRequire("9yrsD");

var $gWlQ0 = parcelRequire("gWlQ0");
var $724713ba9b033ea8$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($724713ba9b033ea8$export$bd096ddbd246c79c || ($724713ba9b033ea8$export$bd096ddbd246c79c = {}));
function $724713ba9b033ea8$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $724713ba9b033ea8$var$Observable = function(_super) {
    (0, $9NQPN.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $5rBSo.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $bYR26.default));
function $724713ba9b033ea8$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $724713ba9b033ea8$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $724713ba9b033ea8$var$generateErrorMessage = function(err) {
    var message = '';
    if ($724713ba9b033ea8$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $724713ba9b033ea8$export$26a337512320b8c6 = function(_super) {
    (0, $9NQPN.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $724713ba9b033ea8$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $724713ba9b033ea8$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($724713ba9b033ea8$export$160bafb6ac1e0641 || ($724713ba9b033ea8$export$160bafb6ac1e0641 = {}));
var $724713ba9b033ea8$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $724713ba9b033ea8$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $724713ba9b033ea8$export$6c1b56eac59c9584 = function(_super) {
    (0, $9NQPN.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $9tOGL.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $724713ba9b033ea8$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($724713ba9b033ea8$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $724713ba9b033ea8$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $724713ba9b033ea8$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $724713ba9b033ea8$export$bd096ddbd246c79c.loading : $724713ba9b033ea8$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, result), {
            stale: false
        }));
        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $s6yhU.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $9yrsD.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $s6yhU.equal)(this.variables, variables)) this.variables = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.variables), variables);
        if (!(0, $s6yhU.equal)(this.options.variables, this.variables)) this.options.variables = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $724713ba9b033ea8$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $9yrsD.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $9NQPN.__assign)((0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $724713ba9b033ea8$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $s6yhU.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $9tOGL.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $724713ba9b033ea8$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $9tOGL.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $724713ba9b033ea8$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $724713ba9b033ea8$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $724713ba9b033ea8$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $724713ba9b033ea8$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $s6yhU.equal)(previousVariables, variables)) _this.refetch();
                        else $724713ba9b033ea8$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $724713ba9b033ea8$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($724713ba9b033ea8$var$Observable);
function $724713ba9b033ea8$var$defaultSubscriptionObserverErrorCallback(error) {}
function $724713ba9b033ea8$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $724713ba9b033ea8$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $9yrsD.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $724713ba9b033ea8$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $724713ba9b033ea8$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $9yrsD.invariant)(!previousQuery || previousQuery.document === query.document || (0, $s6yhU.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $724713ba9b033ea8$export$bd096ddbd246c79c.loading) {
            if (!(0, $s6yhU.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.refetch;
        else networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $724713ba9b033ea8$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $724713ba9b033ea8$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $724713ba9b033ea8$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $724713ba9b033ea8$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $9tOGL.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $9tOGL.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            return (0, $9NQPN.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $9tOGL.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $9tOGL.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $9yrsD.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            return (0, $9NQPN.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $9NQPN.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $gWlQ0.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $gWlQ0.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $9tOGL.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $9NQPN.__generator)(this, function(_b) {
                mainDefinition = (0, $9tOGL.getMainDefinition)(document);
                fragments = (0, $9tOGL.getFragmentDefinitions)(document);
                fragmentMap = (0, $9tOGL.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $724713ba9b033ea8$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $9NQPN.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $9NQPN.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $9NQPN.__generator)(this, function(_a) {
                            if (!(0, $9tOGL.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $9tOGL.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $9tOGL.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $9yrsD.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $9tOGL.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $9NQPN.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $9tOGL.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $9tOGL.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $724713ba9b033ea8$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $724713ba9b033ea8$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $724713ba9b033ea8$var$asyncMap(observable, mapFn) {
    return new $724713ba9b033ea8$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $724713ba9b033ea8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $724713ba9b033ea8$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $724713ba9b033ea8$var$MutationStore();
        this.queryStore = new $724713ba9b033ea8$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $9tOGL.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $724713ba9b033ea8$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $9yrsD.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $9NQPN.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $9yrsD.invariant)(mutation, 9);
                        (0, $9yrsD.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $724713ba9b033ea8$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $9tOGL.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $724713ba9b033ea8$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $724713ba9b033ea8$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($724713ba9b033ea8$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $9tOGL.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $9NQPN.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $9NQPN.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $9tOGL.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $724713ba9b033ea8$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $724713ba9b033ea8$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($724713ba9b033ea8$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $724713ba9b033ea8$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $724713ba9b033ea8$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $724713ba9b033ea8$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $724713ba9b033ea8$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $724713ba9b033ea8$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $9tOGL.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $9tOGL.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $9tOGL.getDefaultValues)((0, $9tOGL.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $9yrsD.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $9NQPN.__assign)({}, options);
        return new $724713ba9b033ea8$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $9yrsD.invariant)(options.query, 12);
        (0, $9yrsD.invariant)(options.query.kind === 'Document', 13);
        (0, $9yrsD.invariant)(!options.returnPartialData, 14);
        (0, $9yrsD.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $9yrsD.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $9tOGL.graphQLResultHasError)(result)) throw new $724713ba9b033ea8$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $724713ba9b033ea8$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $9yrsD.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) {
                const name = info && info.document && info.document.definitions && info.document.definitions[0] && info.document.definitions[0].name && info.document.definitions[0].name.value;
                const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.broadcast;
                if (name && stats) {
                    stats[name] = stats[name] || 0;
                    stats[name]++;
                }
                info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $9tOGL.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $724713ba9b033ea8$var$multiplex((0, $6hdKg.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $724713ba9b033ea8$var$multiplex((0, $6hdKg.execute)(link, operation));
        } else {
            observable = $724713ba9b033ea8$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $724713ba9b033ea8$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $724713ba9b033ea8$var$isNonEmptyArray(result.errors)) return reject(new $724713ba9b033ea8$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $724713ba9b033ea8$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $724713ba9b033ea8$export$bd096ddbd246c79c.ready && query.networkStatus !== $724713ba9b033ea8$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $9yrsD.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $724713ba9b033ea8$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $724713ba9b033ea8$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $9tOGL.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $9tOGL.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $9tOGL.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $9tOGL.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $9tOGL.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $9tOGL.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $9tOGL.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $724713ba9b033ea8$var$version = "2.6.10";
var $724713ba9b033ea8$var$hasSuggestedDevtools = false;
var $724713ba9b033ea8$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $6hdKg.ApolloLink).empty();
        if (!link || !cache) throw new (0, $9yrsD.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $724713ba9b033ea8$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        $724713ba9b033ea8$var$hasSuggestedDevtools;
        this.version = $724713ba9b033ea8$var$version;
        this.localState = new $724713ba9b033ea8$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $724713ba9b033ea8$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.defaultOptions.query), options);
        (0, $9yrsD.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $6hdKg.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $724713ba9b033ea8$export$2e2bcd8739ae039 = $724713ba9b033ea8$export$13f5a5f0f1dbab88;

});
parcelRegister("6hdKg", function(module, exports) {
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("bYR26")).default);

var $bYR26 = parcelRequire("bYR26");

var $9yrsD = parcelRequire("9yrsD");

var $9NQPN = parcelRequire("9NQPN");

var $9tOGL = parcelRequire("9tOGL");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $9yrsD.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $9NQPN.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $bYR26.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $bYR26.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $9tOGL.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $9NQPN.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $9NQPN.__assign)({}, context, next(context));
        else context = (0, $9NQPN.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $9NQPN.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $bYR26.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $bYR26.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $bYR26.default).of() : rightLink.request(operation) || (0, $bYR26.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $bYR26.default).of() : rightLink.request(operation, forward) || (0, $bYR26.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $bYR26.default).of();
        }) || (0, $bYR26.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $bYR26.default).of();
        }) || (0, $bYR26.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $9yrsD.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $bYR26.default).of();
}

});
parcelRegister("bYR26", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b8e6f892029c91a$export$2e2bcd8739ae039);

var $721hZ = parcelRequire("721hZ");
var $8b8e6f892029c91a$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($721hZ)));
var $8b8e6f892029c91a$export$2e2bcd8739ae039 = $8b8e6f892029c91a$export$77cea355fa80b5f4;

});
parcelRegister("721hZ", function(module, exports) {

module.exports = (parcelRequire("eQec2")).Observable;

});
parcelRegister("eQec2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $ace0ee80b40d33c4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ace0ee80b40d33c4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ace0ee80b40d33c4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ace0ee80b40d33c4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ace0ee80b40d33c4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $ace0ee80b40d33c4$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $ace0ee80b40d33c4$var$hasSymbol = function(name) {
    return $ace0ee80b40d33c4$var$hasSymbols() && Boolean(Symbol[name]);
};
var $ace0ee80b40d33c4$var$getSymbol = function(name) {
    return $ace0ee80b40d33c4$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($ace0ee80b40d33c4$var$hasSymbols() && !$ace0ee80b40d33c4$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $ace0ee80b40d33c4$var$SymbolIterator = $ace0ee80b40d33c4$var$getSymbol('iterator');
var $ace0ee80b40d33c4$var$SymbolObservable = $ace0ee80b40d33c4$var$getSymbol('observable');
var $ace0ee80b40d33c4$var$SymbolSpecies = $ace0ee80b40d33c4$var$getSymbol('species'); // === Abstract Operations ===
function $ace0ee80b40d33c4$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $ace0ee80b40d33c4$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$ace0ee80b40d33c4$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $ace0ee80b40d33c4$var$Observable;
}
function $ace0ee80b40d33c4$var$isObservable(x) {
    return x instanceof $ace0ee80b40d33c4$var$Observable; // SPEC: Brand check
}
function $ace0ee80b40d33c4$var$hostReportError(e) {
    if ($ace0ee80b40d33c4$var$hostReportError.log) $ace0ee80b40d33c4$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $ace0ee80b40d33c4$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $ace0ee80b40d33c4$var$hostReportError(e);
        }
    });
}
function $ace0ee80b40d33c4$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $ace0ee80b40d33c4$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $ace0ee80b40d33c4$var$hostReportError(e);
    }
}
function $ace0ee80b40d33c4$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $ace0ee80b40d33c4$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $ace0ee80b40d33c4$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $ace0ee80b40d33c4$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $ace0ee80b40d33c4$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $ace0ee80b40d33c4$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $ace0ee80b40d33c4$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $ace0ee80b40d33c4$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $ace0ee80b40d33c4$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $ace0ee80b40d33c4$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $ace0ee80b40d33c4$var$enqueue(function() {
            return $ace0ee80b40d33c4$var$flushSubscription(subscription);
        });
        return;
    }
    $ace0ee80b40d33c4$var$notifySubscription(subscription, type, value);
}
var $ace0ee80b40d33c4$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $ace0ee80b40d33c4$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $ace0ee80b40d33c4$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $ace0ee80b40d33c4$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $ace0ee80b40d33c4$var$closeSubscription(this);
                    $ace0ee80b40d33c4$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $ace0ee80b40d33c4$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $ace0ee80b40d33c4$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $ace0ee80b40d33c4$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $ace0ee80b40d33c4$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $ace0ee80b40d33c4$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $ace0ee80b40d33c4$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $ace0ee80b40d33c4$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $ace0ee80b40d33c4$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $ace0ee80b40d33c4$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $ace0ee80b40d33c4$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $ace0ee80b40d33c4$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $ace0ee80b40d33c4$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $ace0ee80b40d33c4$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $ace0ee80b40d33c4$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $ace0ee80b40d33c4$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $ace0ee80b40d33c4$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $ace0ee80b40d33c4$var$getMethod(x, $ace0ee80b40d33c4$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($ace0ee80b40d33c4$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($ace0ee80b40d33c4$var$hasSymbol('iterator')) {
                    method = $ace0ee80b40d33c4$var$getMethod(x, $ace0ee80b40d33c4$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $ace0ee80b40d33c4$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $ace0ee80b40d33c4$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $ace0ee80b40d33c4$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $ace0ee80b40d33c4$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $ace0ee80b40d33c4$var$Observable;
if ($ace0ee80b40d33c4$var$hasSymbols()) Object.defineProperty($ace0ee80b40d33c4$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $ace0ee80b40d33c4$var$SymbolObservable,
        hostReportError: $ace0ee80b40d33c4$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("cCzxP", function(module, exports) {
$parcel$export(module.exports, "onError", () => $93049b121f50080a$export$2288787135a8f66e);

var $9NQPN = parcelRequire("9NQPN");

var $6hdKg = parcelRequire("6hdKg");
var $bYR26 = parcelRequire("bYR26");
function $93049b121f50080a$export$2288787135a8f66e(errorHandler) {
    return new (0, $6hdKg.ApolloLink)(function(operation, forward) {
        return new (0, $bYR26.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $93049b121f50080a$export$d2c8415987899609 = function(_super) {
    (0, $9NQPN.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $93049b121f50080a$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $6hdKg.ApolloLink));

});

parcelRegister("eBUKk", function(module, exports) {
$parcel$export(module.exports, "HttpLink", () => $aa308a08f03bffee$export$f4bbf1aec241cc1);

var $9NQPN = parcelRequire("9NQPN");

var $6hdKg = parcelRequire("6hdKg");
var $bYR26 = parcelRequire("bYR26");

var $Yz4Ij = parcelRequire("Yz4Ij");
var $aa308a08f03bffee$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $9NQPN.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $Yz4Ij.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $6hdKg.ApolloLink)(function(operation) {
        var chosenURI = (0, $Yz4Ij.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $9NQPN.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $Yz4Ij.selectHttpOptionsAndBody)(operation, (0, $Yz4Ij.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $Yz4Ij.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $aa308a08f03bffee$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $6hdKg.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $Yz4Ij.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $6hdKg.fromError)(parseError);
        }
        return new (0, $bYR26.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $Yz4Ij.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $aa308a08f03bffee$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $Yz4Ij.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $Yz4Ij.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $aa308a08f03bffee$export$f4bbf1aec241cc1 = function(_super) {
    (0, $9NQPN.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $aa308a08f03bffee$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $6hdKg.ApolloLink));

});
parcelRegister("Yz4Ij", function(module, exports) {
$parcel$export(module.exports, "fallbackHttpConfig", () => $0b60cfe1846cc700$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $0b60cfe1846cc700$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $0b60cfe1846cc700$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $0b60cfe1846cc700$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $0b60cfe1846cc700$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $0b60cfe1846cc700$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $0b60cfe1846cc700$export$63ccc2571850f81a);

var $9NQPN = parcelRequire("9NQPN");

var $gNp4E = parcelRequire("gNp4E");

var $9yrsD = parcelRequire("9yrsD");
var $0b60cfe1846cc700$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $0b60cfe1846cc700$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $0b60cfe1846cc700$var$defaultOptions = {
    method: 'POST'
};
var $0b60cfe1846cc700$export$dd86f00dc866e75d = {
    http: $0b60cfe1846cc700$var$defaultHttpOptions,
    headers: $0b60cfe1846cc700$var$defaultHeaders,
    options: $0b60cfe1846cc700$var$defaultOptions
};
var $0b60cfe1846cc700$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $0b60cfe1846cc700$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $0b60cfe1846cc700$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $0b60cfe1846cc700$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $0b60cfe1846cc700$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $9yrsD.InvariantError)(1);
    }
};
var $0b60cfe1846cc700$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $0b60cfe1846cc700$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $9NQPN.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $9NQPN.__assign)({}, options, config.options, {
            headers: (0, $9NQPN.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $9NQPN.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $gNp4E.print)(query);
    return {
        options: options,
        body: body
    };
};
var $0b60cfe1846cc700$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $9yrsD.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $0b60cfe1846cc700$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});
parcelRegister("gNp4E", function(module, exports) {
$parcel$export(module.exports, "print", () => $c3a4ac250d532d1b$export$c2d084dc44961371);

var $gWlQ0 = parcelRequire("gWlQ0");

var $2EBvW = parcelRequire("2EBvW");
function $c3a4ac250d532d1b$export$c2d084dc44961371(ast) {
    return (0, $gWlQ0.visit)(ast, {
        leave: $c3a4ac250d532d1b$var$printDocASTReducer
    });
}
var $c3a4ac250d532d1b$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $c3a4ac250d532d1b$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $c3a4ac250d532d1b$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $c3a4ac250d532d1b$var$wrap('(', $c3a4ac250d532d1b$var$join(node.variableDefinitions, ', '), ')');
        var directives = $c3a4ac250d532d1b$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $c3a4ac250d532d1b$var$join([
            op,
            $c3a4ac250d532d1b$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $c3a4ac250d532d1b$var$wrap(' = ', defaultValue) + $c3a4ac250d532d1b$var$wrap(' ', $c3a4ac250d532d1b$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $c3a4ac250d532d1b$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $c3a4ac250d532d1b$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $c3a4ac250d532d1b$var$wrap('(', $c3a4ac250d532d1b$var$join(args, ', '), ')');
        if (argsLine.length > $c3a4ac250d532d1b$var$MAX_LINE_LENGTH) argsLine = prefix + $c3a4ac250d532d1b$var$wrap('(\n', $c3a4ac250d532d1b$var$indent($c3a4ac250d532d1b$var$join(args, '\n')), '\n)');
        return $c3a4ac250d532d1b$var$join([
            argsLine,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $c3a4ac250d532d1b$var$wrap(' ', $c3a4ac250d532d1b$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $c3a4ac250d532d1b$var$join([
            '...',
            $c3a4ac250d532d1b$var$wrap('on ', typeCondition),
            $c3a4ac250d532d1b$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($c3a4ac250d532d1b$var$wrap('(', $c3a4ac250d532d1b$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($c3a4ac250d532d1b$var$wrap('', $c3a4ac250d532d1b$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $2EBvW.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $c3a4ac250d532d1b$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $c3a4ac250d532d1b$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $c3a4ac250d532d1b$var$wrap('(', $c3a4ac250d532d1b$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $c3a4ac250d532d1b$var$join([
            'schema',
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $c3a4ac250d532d1b$var$join([
            'scalar',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $c3a4ac250d532d1b$var$join([
            'type',
            name,
            $c3a4ac250d532d1b$var$wrap('implements ', $c3a4ac250d532d1b$var$join(interfaces, ' & ')),
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($c3a4ac250d532d1b$var$hasMultilineItems(args) ? $c3a4ac250d532d1b$var$wrap('(\n', $c3a4ac250d532d1b$var$indent($c3a4ac250d532d1b$var$join(args, '\n')), '\n)') : $c3a4ac250d532d1b$var$wrap('(', $c3a4ac250d532d1b$var$join(args, ', '), ')')) + ': ' + type + $c3a4ac250d532d1b$var$wrap(' ', $c3a4ac250d532d1b$var$join(directives, ' '));
    }),
    InputValueDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $c3a4ac250d532d1b$var$join([
            name + ': ' + type,
            $c3a4ac250d532d1b$var$wrap('= ', defaultValue),
            $c3a4ac250d532d1b$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $c3a4ac250d532d1b$var$join([
            'interface',
            name,
            $c3a4ac250d532d1b$var$wrap('implements ', $c3a4ac250d532d1b$var$join(interfaces, ' & ')),
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $c3a4ac250d532d1b$var$join([
            'union',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $c3a4ac250d532d1b$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $c3a4ac250d532d1b$var$join([
            'enum',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $c3a4ac250d532d1b$var$join([
            name,
            $c3a4ac250d532d1b$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $c3a4ac250d532d1b$var$join([
            'input',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $c3a4ac250d532d1b$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($c3a4ac250d532d1b$var$hasMultilineItems(args) ? $c3a4ac250d532d1b$var$wrap('(\n', $c3a4ac250d532d1b$var$indent($c3a4ac250d532d1b$var$join(args, '\n')), '\n)') : $c3a4ac250d532d1b$var$wrap('(', $c3a4ac250d532d1b$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $c3a4ac250d532d1b$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $c3a4ac250d532d1b$var$join([
            'extend schema',
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $c3a4ac250d532d1b$var$join([
            'extend scalar',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $c3a4ac250d532d1b$var$join([
            'extend type',
            name,
            $c3a4ac250d532d1b$var$wrap('implements ', $c3a4ac250d532d1b$var$join(interfaces, ' & ')),
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $c3a4ac250d532d1b$var$join([
            'extend interface',
            name,
            $c3a4ac250d532d1b$var$wrap('implements ', $c3a4ac250d532d1b$var$join(interfaces, ' & ')),
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $c3a4ac250d532d1b$var$join([
            'extend union',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $c3a4ac250d532d1b$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $c3a4ac250d532d1b$var$join([
            'extend enum',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $c3a4ac250d532d1b$var$join([
            'extend input',
            name,
            $c3a4ac250d532d1b$var$join(directives, ' '),
            $c3a4ac250d532d1b$var$block(fields)
        ], ' ');
    }
};
function $c3a4ac250d532d1b$var$addDescription(cb) {
    return function(node) {
        return $c3a4ac250d532d1b$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $c3a4ac250d532d1b$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $c3a4ac250d532d1b$var$block(array) {
    return $c3a4ac250d532d1b$var$wrap('{\n', $c3a4ac250d532d1b$var$indent($c3a4ac250d532d1b$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $c3a4ac250d532d1b$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $c3a4ac250d532d1b$var$indent(str) {
    return $c3a4ac250d532d1b$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $c3a4ac250d532d1b$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $c3a4ac250d532d1b$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($c3a4ac250d532d1b$var$isMultiline);
}

});
parcelRegister("2EBvW", function(module, exports) {
$parcel$export(module.exports, "dedentBlockStringValue", () => $1eec6ab5f0e8cb3c$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $1eec6ab5f0e8cb3c$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $1eec6ab5f0e8cb3c$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $1eec6ab5f0e8cb3c$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $1eec6ab5f0e8cb3c$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $1eec6ab5f0e8cb3c$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $1eec6ab5f0e8cb3c$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $1eec6ab5f0e8cb3c$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $1eec6ab5f0e8cb3c$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("kM9Y5", function(module, exports) {
$parcel$export(module.exports, "RetryLink", () => $f20005c86df43ddb$export$943d544ad120494a);

var $9NQPN = parcelRequire("9NQPN");

var $6hdKg = parcelRequire("6hdKg");
var $bYR26 = parcelRequire("bYR26");
function $f20005c86df43ddb$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $f20005c86df43ddb$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $f20005c86df43ddb$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $9NQPN.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $9NQPN.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $f20005c86df43ddb$export$943d544ad120494a = function(_super) {
    (0, $9NQPN.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $f20005c86df43ddb$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $f20005c86df43ddb$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $f20005c86df43ddb$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bYR26.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $6hdKg.ApolloLink));

});

parcelRegister("44lBj", function(module, exports) {
$parcel$export(module.exports, "fragmentCacheRedirect", () => $2f684a9df5ce57a4$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $2f684a9df5ce57a4$export$3f9ecfb4d42ab23d);

var $9tOGL = parcelRequire("9tOGL");

var $aF9zq = parcelRequire("aF9zq");

var $2KdO2 = parcelRequire("2KdO2");
function $2f684a9df5ce57a4$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2KdO2.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $9tOGL.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $2f684a9df5ce57a4$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $aF9zq.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("aF9zq", function(module, exports) {
$parcel$export(module.exports, "withClientState", () => $7c352834d22f5784$export$a13f755900e15d9e);

var $6hdKg = parcelRequire("6hdKg");
var $bYR26 = parcelRequire("bYR26");

var $9tOGL = parcelRequire("9tOGL");

var $1UVCN = parcelRequire("1UVCN");

var $iruwf = parcelRequire("iruwf");
var $7c352834d22f5784$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7c352834d22f5784$var$graphql = $1UVCN.graphql;
var $7c352834d22f5784$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $7c352834d22f5784$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $7c352834d22f5784$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bYR26.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $iruwf.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $9tOGL.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $iruwf.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $7c352834d22f5784$var$capitalizeFirstLetter(((0, $9tOGL.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bYR26.default).of({
                data: {}
            });
            return new (0, $bYR26.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $7c352834d22f5784$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $6hdKg.ApolloLink)))();
};

});
parcelRegister("1UVCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.graphql = void 0;

var $9NQPN = parcelRequire("9NQPN");

var $9tOGL = parcelRequire("9tOGL");

var $ffWVZ = parcelRequire("ffWVZ");
function $1657b87ee927fd34$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = (0, $9tOGL.getMainDefinition)(document);
    var fragments = (0, $9tOGL.getFragmentDefinitions)(document);
    var fragmentMap = (0, $9tOGL.createFragmentMap)(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $1657b87ee927fd34$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $1657b87ee927fd34$var$graphql;
function $1657b87ee927fd34$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $9NQPN.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $9NQPN.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $9NQPN.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $9NQPN.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!(0, $9tOGL.shouldInclude)(selection, variables)) return [
                                            2
                                        ];
                                        if (!(0, $9tOGL.isField)(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $1657b87ee927fd34$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = (0, $9tOGL.resultKeyNameFromField)(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else (0, $ffWVZ.merge)(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named ".concat(selection.name.value));
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $1657b87ee927fd34$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        (0, $ffWVZ.merge)(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $1657b87ee927fd34$var$executeField(field, rootValue, execContext) {
    return $9NQPN.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $9NQPN.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = (0, $9tOGL.argumentsObjectFromField)(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: (0, $9tOGL.resultKeyNameFromField)(field),
                        directives: (0, $9tOGL.getDirectiveInfoFromField)(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $1657b87ee927fd34$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $1657b87ee927fd34$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $1657b87ee927fd34$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $1657b87ee927fd34$var$executeSubSelectedArray(field, item, execContext);
        return $1657b87ee927fd34$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("ffWVZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.merge = module.exports.graphql = void 0;

var $9tOGL = parcelRequire("9tOGL");
function $b1b5f8dc7f3ee839$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = (0, $9tOGL.getMainDefinition)(document);
    var fragments = (0, $9tOGL.getFragmentDefinitions)(document);
    var fragmentMap = (0, $9tOGL.createFragmentMap)(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $b1b5f8dc7f3ee839$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $b1b5f8dc7f3ee839$var$graphql;
function $b1b5f8dc7f3ee839$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !(0, $9tOGL.shouldInclude)(selection, variables)) return;
        if ((0, $9tOGL.isField)(selection)) {
            var fieldResult = $b1b5f8dc7f3ee839$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = (0, $9tOGL.resultKeyNameFromField)(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $b1b5f8dc7f3ee839$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named ".concat(selection.name.value));
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $b1b5f8dc7f3ee839$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $b1b5f8dc7f3ee839$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $b1b5f8dc7f3ee839$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = (0, $9tOGL.argumentsObjectFromField)(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: (0, $9tOGL.resultKeyNameFromField)(field),
        directives: (0, $9tOGL.getDirectiveInfoFromField)(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $b1b5f8dc7f3ee839$var$executeSubSelectedArray(field, result, execContext);
    return $b1b5f8dc7f3ee839$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $b1b5f8dc7f3ee839$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $b1b5f8dc7f3ee839$var$executeSubSelectedArray(field, item, execContext);
        return $b1b5f8dc7f3ee839$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $b1b5f8dc7f3ee839$var$hasOwn = Object.prototype.hasOwnProperty;
function $b1b5f8dc7f3ee839$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$b1b5f8dc7f3ee839$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $b1b5f8dc7f3ee839$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $b1b5f8dc7f3ee839$var$merge;

});


parcelRegister("iruwf", function(module, exports) {
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $d6d26c0ef5bb6b11$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $d6d26c0ef5bb6b11$export$467f9c465e4ace4e);

var $gNp4E = parcelRequire("gNp4E");

var $9tOGL = parcelRequire("9tOGL");
var $d6d26c0ef5bb6b11$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $d6d26c0ef5bb6b11$var$removed = new Map();
function $d6d26c0ef5bb6b11$export$8eae69e876ee321e(query) {
    var cached = $d6d26c0ef5bb6b11$var$removed.get(query);
    if (cached) return cached;
    (0, $9tOGL.checkDocument)(query);
    var docClone = (0, $9tOGL.removeDirectivesFromDocument)([
        $d6d26c0ef5bb6b11$var$connectionRemoveConfig
    ], query);
    $d6d26c0ef5bb6b11$var$removed.set(query, docClone);
    return docClone;
}
function $d6d26c0ef5bb6b11$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $gNp4E.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});


parcelRegister("2KdO2", function(module, exports) {
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1ffa96413dd45d23$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1ffa96413dd45d23$export$467265324939f47f);

var $9NQPN = parcelRequire("9NQPN");

var $jO2wX = parcelRequire("jO2wX");

var $9tOGL = parcelRequire("9tOGL");
var $s6yhU = parcelRequire("s6yhU");

var $hRzkM = parcelRequire("hRzkM");

var $9yrsD = parcelRequire("9yrsD");
var $1ffa96413dd45d23$var$haveWarned = false;
function $1ffa96413dd45d23$var$shouldWarn() {
    var answer = !$1ffa96413dd45d23$var$haveWarned;
    if (!(0, $9tOGL.isTest)()) $1ffa96413dd45d23$var$haveWarned = true;
    return answer;
}
var $1ffa96413dd45d23$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1ffa96413dd45d23$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1ffa96413dd45d23$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1ffa96413dd45d23$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $9yrsD.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $9yrsD.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1ffa96413dd45d23$var$hasOwn = Object.prototype.hasOwnProperty;
var $1ffa96413dd45d23$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $hRzkM.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1ffa96413dd45d23$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1ffa96413dd45d23$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1ffa96413dd45d23$var$defaultNormalizedCacheFactory(seed) {
    return new $1ffa96413dd45d23$var$DepTrackingCache(seed);
}
var $1ffa96413dd45d23$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $hRzkM.KeyTrie)((0, $9tOGL.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $hRzkM.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1ffa96413dd45d23$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $hRzkM.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1ffa96413dd45d23$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $hRzkM.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1ffa96413dd45d23$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $9tOGL.getQueryDefinition)(query);
        variables = (0, $9tOGL.assign)({}, (0, $9tOGL.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        const name = query.definitions && query.definitions[0] && query.definitions[0].name && query.definitions[0].name.value;
        const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.diffStore;
        if (name && stats) {
            stats[name] = stats[name] || 0;
            stats[name]++;
        }
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $9yrsD.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $s6yhU.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1ffa96413dd45d23$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $9tOGL.getMainDefinition)(query);
        var fragments = (0, $9tOGL.getFragmentDefinitions)(query);
        var fragmentMap = (0, $9tOGL.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $9tOGL.shouldInclude)(selection, variables)) return;
            if ((0, $9tOGL.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $9tOGL.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $9yrsD.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $9tOGL.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $9tOGL.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $9tOGL.resultKeyNameFromField)(field),
            directives: (0, $9tOGL.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1ffa96413dd45d23$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1ffa96413dd45d23$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1ffa96413dd45d23$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1ffa96413dd45d23$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $9tOGL.isIdValue)(value)) throw new (0, $9yrsD.InvariantError)(10);
}
function $1ffa96413dd45d23$var$defaultFragmentMatcher() {
    return true;
}
function $1ffa96413dd45d23$export$7a4899fe13f33235(idValue) {
    (0, $9yrsD.invariant)((0, $9tOGL.isIdValue)(idValue), 11);
}
function $1ffa96413dd45d23$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $9tOGL.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $9tOGL.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $9tOGL.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1ffa96413dd45d23$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1ffa96413dd45d23$export$7e2b40d1002de152(seed) {
    return new $1ffa96413dd45d23$export$ee7258b8691956a3(seed);
}
var $1ffa96413dd45d23$export$de4e6870dc6ac801 = function(_super) {
    (0, $9NQPN.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1ffa96413dd45d23$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1ffa96413dd45d23$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1ffa96413dd45d23$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1ffa96413dd45d23$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1ffa96413dd45d23$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $9tOGL.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $9tOGL.assign)({}, (0, $9tOGL.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $9tOGL.createFragmentMap)((0, $9tOGL.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1ffa96413dd45d23$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $9tOGL.shouldInclude)(selection, variables)) return;
            if ((0, $9tOGL.isField)(selection)) {
                var resultFieldKey = (0, $9tOGL.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $9tOGL.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $9yrsD.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $9tOGL.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1ffa96413dd45d23$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $9tOGL.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $9tOGL.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1ffa96413dd45d23$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $9yrsD.invariant)(!semanticId || !$1ffa96413dd45d23$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1ffa96413dd45d23$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $9tOGL.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $9tOGL.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $9yrsD.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $9yrsD.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1ffa96413dd45d23$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $s6yhU.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1ffa96413dd45d23$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $9tOGL.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1ffa96413dd45d23$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1ffa96413dd45d23$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $9tOGL.isIdValue)(value) && $1ffa96413dd45d23$var$isGeneratedId(value.id) && (0, $9tOGL.isIdValue)(realValue) && !(0, $s6yhU.equal)(value, realValue) && $1ffa96413dd45d23$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, generated), real);
    if ((0, $s6yhU.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1ffa96413dd45d23$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1ffa96413dd45d23$var$defaultConfig = {
    fragmentMatcher: new $1ffa96413dd45d23$export$5d3fcf53267091de(),
    dataIdFromObject: $1ffa96413dd45d23$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1ffa96413dd45d23$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1ffa96413dd45d23$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1ffa96413dd45d23$var$OptimisticCacheLayer = function(_super) {
    (0, $9NQPN.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1ffa96413dd45d23$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1ffa96413dd45d23$export$ee7258b8691956a3);
var $1ffa96413dd45d23$export$467265324939f47f = function(_super) {
    (0, $9NQPN.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $hRzkM.KeyTrie)((0, $9tOGL.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, $1ffa96413dd45d23$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1ffa96413dd45d23$var$DepTrackingCache() : new $1ffa96413dd45d23$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1ffa96413dd45d23$export$eb8361c5d132fb8f();
        _this.storeReader = new $1ffa96413dd45d23$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $hRzkM.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1ffa96413dd45d23$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $9yrsD.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1ffa96413dd45d23$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1ffa96413dd45d23$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $9tOGL.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $jO2wX.ApolloCache));

});


parcelRegister("DhaVC", function(module, exports) {
$parcel$export(module.exports, "UFOLoggerLink", () => $5e716004c63d2afb$export$fb326ed954631f3f);

var $6hdKg = parcelRequire("6hdKg");

var $siTdT = parcelRequire("siTdT");
const $5e716004c63d2afb$export$fb326ed954631f3f = new (0, $6hdKg.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $siTdT.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("85J5e", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraUser\"},{\"name\":\"JiraUserGroup\"}]},{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"INTERFACE\",\"name\":\"AutoManagedSprintJobError\",\"possibleTypes\":[{\"name\":\"AutoManagedSprintGenericError\"},{\"name\":\"AutoManagedSprintOpenSubtasksError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"BaseIssueField\",\"possibleTypes\":[{\"name\":\"AffectedServicesField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CmdbField\"},{\"name\":\"ColorField\"},{\"name\":\"CommentSummaryField\"},{\"name\":\"DateField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"DateTimeField\"},{\"name\":\"EpicColorField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"GlancesField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"LabelsField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"ParentField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"PriorityField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"ProjectField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"ResolutionField\"},{\"name\":\"SLACustomField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"StatusField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SubtasksField\"},{\"name\":\"TechLeadField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"TextField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"UserField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"VersionsField\"},{\"name\":\"WatchersField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"BaseSprint\",\"possibleTypes\":[{\"name\":\"SoftwareSprint\"},{\"name\":\"SprintWithStatistics\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"GQLField\",\"possibleTypes\":[{\"name\":\"GQLSearchableField\"},{\"name\":\"GQLSortableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"INTERFACE\",\"name\":\"HasMercuryProjectFields\",\"possibleTypes\":[{\"name\":\"JiraIssue\"}]},{\"kind\":\"INTERFACE\",\"name\":\"HasPageInfo\",\"possibleTypes\":[{\"name\":\"JiraAccessActorConnection\"},{\"name\":\"JiraActorConnection\"},{\"name\":\"JiraAssignableUsersConnection\"},{\"name\":\"JiraBulkEditFieldsConnection\"},{\"name\":\"JiraBulkMergeValidatedIssuesConnection\"},{\"name\":\"JiraFieldSchemesConnection\"},{\"name\":\"JiraFormattingRuleConnection\"},{\"name\":\"JiraNavigationItemConnection\"},{\"name\":\"JiraNavigationItemTypeConnection\"},{\"name\":\"JiraNotificationProjectPreferenceConnection\"},{\"name\":\"JiraProjectConnection\"},{\"name\":\"JiraProjectPolicyAssociationConnection\"},{\"name\":\"JiraProjectPolicyConnection\"},{\"name\":\"JiraProjectPolicyRuleConnection\"},{\"name\":\"JiraProjectPolicyRuleViolationConnection\"},{\"name\":\"JiraStatusConnection\"},{\"name\":\"JiraUserBroadcastMessageConnection\"},{\"name\":\"JiraWorkManagementSavedViewTypeConnection\"}]},{\"kind\":\"INTERFACE\",\"name\":\"HasTotal\",\"possibleTypes\":[{\"name\":\"JiraAccessActorConnection\"},{\"name\":\"JiraAssignableUsersConnection\"},{\"name\":\"JiraBulkEditFieldsConnection\"},{\"name\":\"JiraBulkMergeValidatedIssuesConnection\"},{\"name\":\"JiraFieldSchemesConnection\"},{\"name\":\"JiraNotificationProjectPreferenceConnection\"},{\"name\":\"JiraProjectConnection\"},{\"name\":\"JiraProjectPolicyAssociationConnection\"},{\"name\":\"JiraProjectPolicyConnection\"},{\"name\":\"JiraProjectPolicyRuleConnection\"},{\"name\":\"JiraProjectPolicyRuleViolationConnection\"},{\"name\":\"JiraUserBroadcastMessageConnection\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"INTERFACE\",\"name\":\"IssueTableParameters\",\"possibleTypes\":[{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"VotedGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAccessActor\",\"possibleTypes\":[{\"name\":\"JiraAccessUserActor\"},{\"name\":\"JiraAccessGroupActor\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraActor\",\"possibleTypes\":[{\"name\":\"JiraAgenticUser\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAggregatedDate\",\"possibleTypes\":[{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateTimePickerField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"JiraHistoryItem\"},{\"name\":\"JiraCommentItem\"},{\"name\":\"JiraWorklogItem\"},{\"name\":\"JiraApprovalItem\"},{\"name\":\"JiraHiddenCommentItem\"},{\"name\":\"JiraIncidentItem\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraAppNavigationConfig\",\"possibleTypes\":[{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraAppNavigationItemNestedLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"JiraApprovalCreated\"},{\"name\":\"JiraApproverDecision\"},{\"name\":\"JiraApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraAttachment\",\"possibleTypes\":[{\"name\":\"JiraPlatformAttachment\"},{\"name\":\"JiraServiceManagementAttachment\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraAutoManagedSprintJobError\",\"possibleTypes\":[{\"name\":\"JiraAutoManagedSprintGenericError\"},{\"name\":\"JiraAutoManagedSprintOpenSubtasksError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBackground\",\"possibleTypes\":[{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBacklogViewCardList\",\"possibleTypes\":[{\"name\":\"JiraBacklogViewColumnCardList\"},{\"name\":\"JiraBacklogViewSprintCardList\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBaseNextActionsEntity\",\"possibleTypes\":[{\"name\":\"JiraImproveDescriptionSuggestion\"},{\"name\":\"JiraRelatedLinkSuggestions\"},{\"name\":\"JiraSDLCSuggestions\"},{\"name\":\"JiraSimilarWorkItemSuggestions\"},{\"name\":\"JiraWorkBreakdownSuggestions\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBaseTimelineView\",\"possibleTypes\":[{\"name\":\"JiraGroupedTimelineView\"},{\"name\":\"JiraTimelineView\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBoardViewCardOption\",\"possibleTypes\":[{\"name\":\"JiraBoardViewFieldCardOption\"},{\"name\":\"JiraBoardViewSyntheticFieldCardOption\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBoardViewCellContainer\",\"possibleTypes\":[{\"name\":\"JiraBoardViewColumnLayout\"},{\"name\":\"JiraBoardViewFieldSwimlane\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBoardViewColumn\",\"possibleTypes\":[{\"name\":\"JiraBoardViewAssigneeColumn\"},{\"name\":\"JiraBoardViewCategoryColumn\"},{\"name\":\"JiraBoardViewPriorityColumn\"},{\"name\":\"JiraBoardViewStatusColumn\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardViewFieldSwimlaneValue\",\"possibleTypes\":[{\"name\":\"JiraBoardViewFieldSwimlaneAgent\"},{\"name\":\"JiraBoardViewFieldSwimlaneUser\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraTownsquareProject\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardViewLayout\",\"possibleTypes\":[{\"name\":\"JiraBoardViewColumnLayout\"},{\"name\":\"JiraBoardViewSwimlaneLayout\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraBoardViewSwimlane\",\"possibleTypes\":[{\"name\":\"JiraBoardViewFieldSwimlane\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBulkMergeValidationResult\",\"possibleTypes\":[{\"name\":\"JiraBulkMergeValidationResponse\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraCFOAnalyticsResult\",\"possibleTypes\":[{\"name\":\"JiraCFOBoardPerformanceAnalyticsResult\"},{\"name\":\"JiraCFODefaultAnalyticsResult\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraCFODataRow\",\"possibleTypes\":[{\"name\":\"JiraCFOBoardPerformanceDataRow\"},{\"name\":\"JiraCFODefaultDataRow\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraCFOMetricSummary\",\"possibleTypes\":[{\"name\":\"JiraCFOBoardPerformanceMetricSummary\"},{\"name\":\"JiraCFODefaultMetricSummary\"},{\"name\":\"JiraCFOLoadTimeMetricSummary\"},{\"name\":\"JiraCFOUserSetupMetricSummary\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraComment\",\"possibleTypes\":[{\"name\":\"JiraPlatformComment\"},{\"name\":\"JiraServiceManagementComment\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraConsolidatedResource\",\"possibleTypes\":[{\"name\":\"JiraAttachmentResource\"},{\"name\":\"JiraConfluenceLinkResource\"},{\"name\":\"JiraRemoteLinkResource\"},{\"name\":\"JiraWhiteboardResource\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraConsolidatedResourceDetails\",\"possibleTypes\":[{\"name\":\"JiraAttachmentDetails\"},{\"name\":\"JiraConfluenceLinkDetails\"},{\"name\":\"JiraRemoteLinkDetails\"},{\"name\":\"JiraWhiteboardDetails\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraDateLikeField\",\"possibleTypes\":[{\"name\":\"JiraDateFormulaField\"},{\"name\":\"JiraDatePickerField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraDevOpsProvider\",\"possibleTypes\":[{\"name\":\"JiraBitbucketDevOpsProvider\"},{\"name\":\"JiraClassicConnectDevOpsProvider\"},{\"name\":\"JiraOAuthDevOpsProvider\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraEmptyConnectionReason\",\"possibleTypes\":[{\"name\":\"JiraDefaultEmptyConnectionReason\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraEntityProperty\",\"possibleTypes\":[{\"name\":\"JiraEntityPropertyBoolean\"},{\"name\":\"JiraEntityPropertyInt\"},{\"name\":\"JiraEntityPropertyJSON\"},{\"name\":\"JiraEntityPropertyLastDismissedAnnouncementBanner\"},{\"name\":\"JiraEntityPropertyString\"},{\"name\":\"JiraNavigationUIStateUserProperty\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraProductDiscoveryCollection\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraFieldContextualData\",\"possibleTypes\":[{\"name\":\"JiraFieldContextualDataTeamsFilter\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraFieldError\",\"possibleTypes\":[]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraFieldSetsViewMetadata\",\"possibleTypes\":[{\"name\":\"JiraDetailedView\"},{\"name\":\"JiraFieldSetView\"},{\"name\":\"JiraGroupedListView\"},{\"name\":\"JiraGroupedTimelineView\"},{\"name\":\"JiraListView\"},{\"name\":\"JiraTimelineView\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraFilter\",\"possibleTypes\":[{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraSystemFilter\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFlatOption\",\"possibleTypes\":[{\"name\":\"JiraParentOption\"},{\"name\":\"JiraOption\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraFormFieldCondition\",\"possibleTypes\":[{\"name\":\"JiraFormSelectCondition\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormulaFieldValue\",\"possibleTypes\":[{\"name\":\"JiraFormulaFieldTextValue\"},{\"name\":\"JiraFormulaFieldNumberValue\"},{\"name\":\"JiraFormulaFieldDateValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraHasMultipleSelectedValues\",\"possibleTypes\":[{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraServiceManagementOrganizationField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraHasSelectableValueOptions\",\"possibleTypes\":[{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraCascadingSelectField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraParentOption\"},{\"name\":\"JiraServiceManagementOrganizationField\"},{\"name\":\"JiraSingleSelectField\"},{\"name\":\"JiraSingleVersionPickerField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraHasSingleSelectedValue\",\"possibleTypes\":[{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraSingleSelectField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraHistoryValue\",\"possibleTypes\":[{\"name\":\"JiraHistoryAssigneeFieldValue\"},{\"name\":\"JiraHistoryPriorityFieldValue\"},{\"name\":\"JiraHistoryStatusFieldValue\"},{\"name\":\"JiraHistoryWorkLogFieldValue\"},{\"name\":\"JiraHistoryRespondersFieldValue\"},{\"name\":\"JiraHistoryGenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"JiraResponderAlertAssignedValue\"},{\"name\":\"JiraAlertValue\"},{\"name\":\"JiraResponderAlertPriorityChangedValue\"},{\"name\":\"JiraStakeholderUpdatedValue\"},{\"name\":\"JiraIncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueAISummaryResult\",\"possibleTypes\":[{\"name\":\"JiraIssueAISummary\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueCommandPaletteAction\",\"possibleTypes\":[{\"name\":\"JiraIssueCommandPaletteUpdateFieldAction\"},{\"name\":\"JiraIssueGenericCommandPaletteAction\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCommandPaletteActionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCommandPaletteActionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueCreateService\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateProformaConfiguration\"},{\"name\":\"JiraIssueCreateWatchersConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueError\",\"possibleTypes\":[{\"name\":\"JiraRemoteLinkedIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueField\",\"possibleTypes\":[{\"name\":\"CalendarIssueField\"},{\"name\":\"GenericIssueField\"},{\"name\":\"JWMCategoryField\"},{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraAgentSessionsField\"},{\"name\":\"JiraAggregatedStatusField\"},{\"name\":\"JiraAggregatedTimelineField\"},{\"name\":\"JiraAssetField\"},{\"name\":\"JiraAtlasProjectField\"},{\"name\":\"JiraAtlassianTeamField\"},{\"name\":\"JiraAttachmentsField\"},{\"name\":\"JiraBoardCardCoverMediaField\"},{\"name\":\"JiraBooleanField\"},{\"name\":\"JiraCMDBField\"},{\"name\":\"JiraCascadingSelectField\"},{\"name\":\"JiraCheckboxesField\"},{\"name\":\"JiraColorField\"},{\"name\":\"JiraCommentSummaryField\"},{\"name\":\"JiraComponentsField\"},{\"name\":\"JiraConfluenceRemoteIssueLinksField\"},{\"name\":\"JiraConnectDateTimeField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraConnectNumberField\"},{\"name\":\"JiraConnectReadOnlyField\"},{\"name\":\"JiraConnectRichTextField\"},{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraConnectTextField\"},{\"name\":\"JiraCustomerServiceOrganizationField\"},{\"name\":\"JiraDataClassificationField\"},{\"name\":\"JiraDateFormulaField\"},{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateRangeField\"},{\"name\":\"JiraDateTimePickerField\"},{\"name\":\"JiraDevSummaryField\"},{\"name\":\"JiraDurationField\"},{\"name\":\"JiraEpicLinkField\"},{\"name\":\"JiraFallbackField\"},{\"name\":\"JiraFlagField\"},{\"name\":\"JiraForgeDateField\"},{\"name\":\"JiraForgeDatetimeField\"},{\"name\":\"JiraForgeGroupField\"},{\"name\":\"JiraForgeGroupsField\"},{\"name\":\"JiraForgeNumberField\"},{\"name\":\"JiraForgeObjectField\"},{\"name\":\"JiraForgeStringField\"},{\"name\":\"JiraForgeStringsField\"},{\"name\":\"JiraForgeUserField\"},{\"name\":\"JiraForgeUsersField\"},{\"name\":\"JiraGoalsField\"},{\"name\":\"JiraIssueCreatedProformaFormsField\"},{\"name\":\"JiraIssueLinkField\"},{\"name\":\"JiraIssueLinkRelationshipTypeField\"},{\"name\":\"JiraIssueRestrictionField\"},{\"name\":\"JiraIssueTypeField\"},{\"name\":\"JiraLabelsField\"},{\"name\":\"JiraMultipleGroupPickerField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleSelectUserPickerField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraNumberField\"},{\"name\":\"JiraNumberFormulaField\"},{\"name\":\"JiraOriginalTimeEstimateField\"},{\"name\":\"JiraParentIssueField\"},{\"name\":\"JiraPeopleField\"},{\"name\":\"JiraPriorityField\"},{\"name\":\"JiraProformaFormsField\"},{\"name\":\"JiraProjectField\"},{\"name\":\"JiraRadioSelectField\"},{\"name\":\"JiraRemainingTimeEstimateField\"},{\"name\":\"JiraRequestTypeField\"},{\"name\":\"JiraResolutionField\"},{\"name\":\"JiraRichTextField\"},{\"name\":\"JiraSecurityLevelField\"},{\"name\":\"JiraServiceManagementApprovalField\"},{\"name\":\"JiraServiceManagementChannelSourceField\"},{\"name\":\"JiraServiceManagementDateTimeField\"},{\"name\":\"JiraServiceManagementEntitlementField\"},{\"name\":\"JiraServiceManagementIncidentLinkingField\"},{\"name\":\"JiraServiceManagementMajorIncidentField\"},{\"name\":\"JiraServiceManagementMultipleSelectUserPickerField\"},{\"name\":\"JiraServiceManagementOrganizationField\"},{\"name\":\"JiraServiceManagementPeopleField\"},{\"name\":\"JiraServiceManagementRequestFeedbackField\"},{\"name\":\"JiraServiceManagementRequestLanguageField\"},{\"name\":\"JiraServiceManagementRequestTypeField\"},{\"name\":\"JiraServiceManagementRespondersField\"},{\"name\":\"JiraServiceManagementSentimentField\"},{\"name\":\"JiraServiceManagementSlaField\"},{\"name\":\"JiraSingleGroupPickerField\"},{\"name\":\"JiraSingleLineTextField\"},{\"name\":\"JiraSingleSelectField\"},{\"name\":\"JiraSingleSelectUserPickerField\"},{\"name\":\"JiraSingleVersionPickerField\"},{\"name\":\"JiraSprintField\"},{\"name\":\"JiraStatusCategoryField\"},{\"name\":\"JiraStatusField\"},{\"name\":\"JiraSubtaskSummaryField\"},{\"name\":\"JiraSubtasksField\"},{\"name\":\"JiraTeamField\"},{\"name\":\"JiraTeamViewField\"},{\"name\":\"JiraTextFormulaField\"},{\"name\":\"JiraTimeTrackingField\"},{\"name\":\"JiraTimelineField\"},{\"name\":\"JiraTownsquareProjectField\"},{\"name\":\"JiraUrlField\"},{\"name\":\"JiraVotesField\"},{\"name\":\"JiraWatchesField\"},{\"name\":\"JiraWorkCategoryField\"},{\"name\":\"JiraWorkLogField\"},{\"name\":\"JsmMultipleSelectUserPickerField\"},{\"name\":\"JsmOrganizationField\"},{\"name\":\"JsmPeopleField\"},{\"name\":\"JsmRequestTypeField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueFieldConfiguration\",\"possibleTypes\":[{\"name\":\"GenericIssueField\"},{\"name\":\"JWMCategoryField\"},{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraAgentSessionsField\"},{\"name\":\"JiraAssetField\"},{\"name\":\"JiraAtlasProjectField\"},{\"name\":\"JiraAtlassianTeamField\"},{\"name\":\"JiraAttachmentsField\"},{\"name\":\"JiraBooleanField\"},{\"name\":\"JiraCMDBField\"},{\"name\":\"JiraCascadingSelectField\"},{\"name\":\"JiraCheckboxesField\"},{\"name\":\"JiraColorField\"},{\"name\":\"JiraCommentSummaryField\"},{\"name\":\"JiraComponentsField\"},{\"name\":\"JiraConfluenceRemoteIssueLinksField\"},{\"name\":\"JiraConnectDateTimeField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraConnectNumberField\"},{\"name\":\"JiraConnectReadOnlyField\"},{\"name\":\"JiraConnectRichTextField\"},{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraConnectTextField\"},{\"name\":\"JiraCustomerServiceOrganizationField\"},{\"name\":\"JiraDataClassificationField\"},{\"name\":\"JiraDateFormulaField\"},{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateRangeField\"},{\"name\":\"JiraDateTimePickerField\"},{\"name\":\"JiraDurationField\"},{\"name\":\"JiraEpicLinkField\"},{\"name\":\"JiraFallbackField\"},{\"name\":\"JiraFlagField\"},{\"name\":\"JiraForgeDateField\"},{\"name\":\"JiraForgeDatetimeField\"},{\"name\":\"JiraForgeGroupField\"},{\"name\":\"JiraForgeGroupsField\"},{\"name\":\"JiraForgeNumberField\"},{\"name\":\"JiraForgeObjectField\"},{\"name\":\"JiraForgeStringField\"},{\"name\":\"JiraForgeStringsField\"},{\"name\":\"JiraForgeUserField\"},{\"name\":\"JiraForgeUsersField\"},{\"name\":\"JiraGoalsField\"},{\"name\":\"JiraIssueCreatedProformaFormsField\"},{\"name\":\"JiraIssueLinkField\"},{\"name\":\"JiraIssueLinkRelationshipTypeField\"},{\"name\":\"JiraIssueRestrictionField\"},{\"name\":\"JiraIssueTypeField\"},{\"name\":\"JiraLabelsField\"},{\"name\":\"JiraMultipleGroupPickerField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleSelectUserPickerField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraNumberField\"},{\"name\":\"JiraNumberFormulaField\"},{\"name\":\"JiraOriginalTimeEstimateField\"},{\"name\":\"JiraParentIssueField\"},{\"name\":\"JiraPeopleField\"},{\"name\":\"JiraPriorityField\"},{\"name\":\"JiraProformaFormsField\"},{\"name\":\"JiraProjectField\"},{\"name\":\"JiraRadioSelectField\"},{\"name\":\"JiraRemainingTimeEstimateField\"},{\"name\":\"JiraRequestTypeField\"},{\"name\":\"JiraResolutionField\"},{\"name\":\"JiraRichTextField\"},{\"name\":\"JiraSecurityLevelField\"},{\"name\":\"JiraServiceManagementApprovalField\"},{\"name\":\"JiraServiceManagementChannelSourceField\"},{\"name\":\"JiraServiceManagementDateTimeField\"},{\"name\":\"JiraServiceManagementEntitlementField\"},{\"name\":\"JiraServiceManagementIncidentLinkingField\"},{\"name\":\"JiraServiceManagementMajorIncidentField\"},{\"name\":\"JiraServiceManagementMultipleSelectUserPickerField\"},{\"name\":\"JiraServiceManagementOrganizationField\"},{\"name\":\"JiraServiceManagementPeopleField\"},{\"name\":\"JiraServiceManagementRequestFeedbackField\"},{\"name\":\"JiraServiceManagementRequestLanguageField\"},{\"name\":\"JiraServiceManagementRequestTypeField\"},{\"name\":\"JiraServiceManagementRespondersField\"},{\"name\":\"JiraServiceManagementSentimentField\"},{\"name\":\"JiraServiceManagementSlaField\"},{\"name\":\"JiraSingleGroupPickerField\"},{\"name\":\"JiraSingleLineTextField\"},{\"name\":\"JiraSingleSelectField\"},{\"name\":\"JiraSingleSelectUserPickerField\"},{\"name\":\"JiraSingleVersionPickerField\"},{\"name\":\"JiraSprintField\"},{\"name\":\"JiraStatusCategoryField\"},{\"name\":\"JiraStatusField\"},{\"name\":\"JiraSubtasksField\"},{\"name\":\"JiraTeamField\"},{\"name\":\"JiraTeamViewField\"},{\"name\":\"JiraTextFormulaField\"},{\"name\":\"JiraTimeTrackingField\"},{\"name\":\"JiraTimelineField\"},{\"name\":\"JiraTownsquareProjectField\"},{\"name\":\"JiraUrlField\"},{\"name\":\"JiraVotesField\"},{\"name\":\"JiraWatchesField\"},{\"name\":\"JiraWorkCategoryField\"},{\"name\":\"JiraWorkLogField\"},{\"name\":\"JsmMultipleSelectUserPickerField\"},{\"name\":\"JsmOrganizationField\"},{\"name\":\"JsmPeopleField\"},{\"name\":\"JsmRequestTypeField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueFieldCreateContextOption\",\"possibleTypes\":[{\"name\":\"JiraLabelsForCreateField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueFieldsByContainerTypesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldsByContainerTypes\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssuePillarContext\",\"possibleTypes\":[{\"name\":\"JiraJsmIssuePillarContextImpl\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueSearchBulkViewContexts\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchBulkViewGroupContexts\"},{\"name\":\"JiraIssueSearchBulkViewParentContexts\"},{\"name\":\"JiraIssueSearchBulkViewTopLevelContexts\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"},{\"name\":\"JiraJqlSearchRateLimitingError\"},{\"name\":\"JiraInvalidIssueSearchInputError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueSearchResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"JiraIssueSearchByHydration\"},{\"name\":\"JiraIssueSearchByJql\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueSearchResultContent\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchContextlessContent\"},{\"name\":\"JiraIssueSearchContextualContent\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueSearchViewContextMapping\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchViewContextMappingByGroup\"},{\"name\":\"JiraIssueSearchViewContextMappingByParent\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraIssueSearchViewMetadata\",\"possibleTypes\":[{\"name\":\"JiraDetailedView\"},{\"name\":\"JiraGroupedListView\"},{\"name\":\"JiraGroupedTimelineView\"},{\"name\":\"JiraIssueSearchView\"},{\"name\":\"JiraListView\"},{\"name\":\"JiraTimelineView\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraJourneyItemCommon\",\"possibleTypes\":[{\"name\":\"JiraJourneyStatusDependency\"},{\"name\":\"JiraJourneyWorkItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraJourneyStep\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItemStep\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraJqlFieldValue\",\"possibleTypes\":[{\"name\":\"JiraJqlAtlasProjectFieldValue\"},{\"name\":\"JiraJqlCascadingOptionFieldValue\"},{\"name\":\"JiraJqlComponentFieldValue\"},{\"name\":\"JiraJqlDateBucketFieldValue\"},{\"name\":\"JiraJqlEmptyFieldValue\"},{\"name\":\"JiraJqlFocusAreasFieldValue\"},{\"name\":\"JiraJqlFunctionFieldValue\"},{\"name\":\"JiraJqlGoalsFieldValue\"},{\"name\":\"JiraJqlGroupFieldValue\"},{\"name\":\"JiraJqlIssueFieldValue\"},{\"name\":\"JiraJqlIssueTypeFieldValue\"},{\"name\":\"JiraJqlJwmCategoryOptionFieldValue\"},{\"name\":\"JiraJqlLabelFieldValue\"},{\"name\":\"JiraJqlNumberFieldValue\"},{\"name\":\"JiraJqlOptionFieldValue\"},{\"name\":\"JiraJqlPlainTextFieldValue\"},{\"name\":\"JiraJqlPriorityFieldValue\"},{\"name\":\"JiraJqlProjectFieldValue\"},{\"name\":\"JiraJqlResolutionFieldValue\"},{\"name\":\"JiraJqlSprintFieldValue\"},{\"name\":\"JiraJqlStatusCategoryFieldValue\"},{\"name\":\"JiraJqlStatusFieldValue\"},{\"name\":\"JiraJqlTeamFieldValue\"},{\"name\":\"JiraJqlTownsquareProjectFieldValue\"},{\"name\":\"JiraJqlUserFieldValue\"},{\"name\":\"JiraJqlVersionFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryFieldsOnlyResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQueryFieldsOnly\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldsOnlyResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedFieldOnly\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRow\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"JiraIssueLinkList\"},{\"name\":\"JiraRemoteIssueLinkList\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowConnection\",\"possibleTypes\":[{\"name\":\"JiraIssueConnection\"},{\"name\":\"JiraLinkedIssueConnection\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowEdge\",\"possibleTypes\":[{\"name\":\"JiraIssueEdge\"},{\"name\":\"JiraIssueLinkListEdge\"},{\"name\":\"JiraRemoteIssueLinkListEdge\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowField\",\"possibleTypes\":[{\"name\":\"CalendarIssueField\"},{\"name\":\"GenericIssueField\"},{\"name\":\"JWMCategoryField\"},{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraAgentSessionsField\"},{\"name\":\"JiraAggregatedStatusField\"},{\"name\":\"JiraAggregatedTimelineField\"},{\"name\":\"JiraAssetField\"},{\"name\":\"JiraAtlasProjectField\"},{\"name\":\"JiraAtlassianTeamField\"},{\"name\":\"JiraAttachmentsField\"},{\"name\":\"JiraBoardCardCoverMediaField\"},{\"name\":\"JiraBooleanField\"},{\"name\":\"JiraCMDBField\"},{\"name\":\"JiraCascadingSelectField\"},{\"name\":\"JiraCheckboxesField\"},{\"name\":\"JiraColorField\"},{\"name\":\"JiraCommentSummaryField\"},{\"name\":\"JiraComponentsField\"},{\"name\":\"JiraConfluenceRemoteIssueLinksField\"},{\"name\":\"JiraConnectDateTimeField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraConnectNumberField\"},{\"name\":\"JiraConnectReadOnlyField\"},{\"name\":\"JiraConnectRichTextField\"},{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraConnectTextField\"},{\"name\":\"JiraCustomerServiceOrganizationField\"},{\"name\":\"JiraDataClassificationField\"},{\"name\":\"JiraDateFormulaField\"},{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateRangeField\"},{\"name\":\"JiraDateTimePickerField\"},{\"name\":\"JiraDevSummaryField\"},{\"name\":\"JiraDurationField\"},{\"name\":\"JiraEpicLinkField\"},{\"name\":\"JiraFallbackField\"},{\"name\":\"JiraFlagField\"},{\"name\":\"JiraForgeDateField\"},{\"name\":\"JiraForgeDatetimeField\"},{\"name\":\"JiraForgeGroupField\"},{\"name\":\"JiraForgeGroupsField\"},{\"name\":\"JiraForgeNumberField\"},{\"name\":\"JiraForgeObjectField\"},{\"name\":\"JiraForgeStringField\"},{\"name\":\"JiraForgeStringsField\"},{\"name\":\"JiraForgeUserField\"},{\"name\":\"JiraForgeUsersField\"},{\"name\":\"JiraGoalsField\"},{\"name\":\"JiraIssueCreatedProformaFormsField\"},{\"name\":\"JiraIssueLinkField\"},{\"name\":\"JiraIssueLinkRelationshipTypeField\"},{\"name\":\"JiraIssueRestrictionField\"},{\"name\":\"JiraIssueTypeField\"},{\"name\":\"JiraLabelsField\"},{\"name\":\"JiraMultipleGroupPickerField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleSelectUserPickerField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraNumberField\"},{\"name\":\"JiraNumberFormulaField\"},{\"name\":\"JiraOriginalTimeEstimateField\"},{\"name\":\"JiraParentIssueField\"},{\"name\":\"JiraPeopleField\"},{\"name\":\"JiraPriorityField\"},{\"name\":\"JiraProformaFormsField\"},{\"name\":\"JiraProjectField\"},{\"name\":\"JiraRadioSelectField\"},{\"name\":\"JiraRemainingTimeEstimateField\"},{\"name\":\"JiraRemoteGenericField\"},{\"name\":\"JiraRemoteIssueTypeField\"},{\"name\":\"JiraRemotePriorityField\"},{\"name\":\"JiraRemoteSingleLineTextField\"},{\"name\":\"JiraRemoteSingleSelectUserPickerField\"},{\"name\":\"JiraRemoteStatusField\"},{\"name\":\"JiraRequestTypeField\"},{\"name\":\"JiraResolutionField\"},{\"name\":\"JiraRichTextField\"},{\"name\":\"JiraSecurityLevelField\"},{\"name\":\"JiraServiceManagementApprovalField\"},{\"name\":\"JiraServiceManagementChannelSourceField\"},{\"name\":\"JiraServiceManagementDateTimeField\"},{\"name\":\"JiraServiceManagementEntitlementField\"},{\"name\":\"JiraServiceManagementIncidentLinkingField\"},{\"name\":\"JiraServiceManagementMajorIncidentField\"},{\"name\":\"JiraServiceManagementMultipleSelectUserPickerField\"},{\"name\":\"JiraServiceManagementOrganizationField\"},{\"name\":\"JiraServiceManagementPeopleField\"},{\"name\":\"JiraServiceManagementRequestFeedbackField\"},{\"name\":\"JiraServiceManagementRequestLanguageField\"},{\"name\":\"JiraServiceManagementRequestTypeField\"},{\"name\":\"JiraServiceManagementRespondersField\"},{\"name\":\"JiraServiceManagementSentimentField\"},{\"name\":\"JiraServiceManagementSlaField\"},{\"name\":\"JiraSingleGroupPickerField\"},{\"name\":\"JiraSingleLineTextField\"},{\"name\":\"JiraSingleSelectField\"},{\"name\":\"JiraSingleSelectUserPickerField\"},{\"name\":\"JiraSingleVersionPickerField\"},{\"name\":\"JiraSprintField\"},{\"name\":\"JiraStatusCategoryField\"},{\"name\":\"JiraStatusField\"},{\"name\":\"JiraSubtaskSummaryField\"},{\"name\":\"JiraSubtasksField\"},{\"name\":\"JiraTeamField\"},{\"name\":\"JiraTeamViewField\"},{\"name\":\"JiraTextFormulaField\"},{\"name\":\"JiraTimeTrackingField\"},{\"name\":\"JiraTimelineField\"},{\"name\":\"JiraTownsquareProjectField\"},{\"name\":\"JiraUrlField\"},{\"name\":\"JiraVotesField\"},{\"name\":\"JiraWatchesField\"},{\"name\":\"JiraWorkCategoryField\"},{\"name\":\"JiraWorkLogField\"},{\"name\":\"JsmMultipleSelectUserPickerField\"},{\"name\":\"JsmOrganizationField\"},{\"name\":\"JsmPeopleField\"},{\"name\":\"JsmRequestTypeField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowFieldConnection\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldConnection\"},{\"name\":\"JiraRemoteIssueFieldConnection\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowFieldEdge\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldEdge\"},{\"name\":\"JiraRemoteIssueFieldEdge\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowFieldSet\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldSet\"},{\"name\":\"JiraRemoteIssueFieldSet\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowFieldSetConnection\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldSetConnection\"},{\"name\":\"JiraRemoteIssueFieldSetConnection\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraListRowFieldSetEdge\",\"possibleTypes\":[{\"name\":\"JiraIssueFieldSetEdge\"},{\"name\":\"JiraRemoteIssueFieldSetEdge\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMergeIssuesOperationProgressResult\",\"possibleTypes\":[{\"name\":\"JiraMergeIssuesOperationProgress\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMyFilterFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraMyFilterFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraNavigationItem\",\"possibleTypes\":[{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraWorkManagementSavedView\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraNavigationItemType\",\"possibleTypes\":[{\"name\":\"JiraAppNavigationItemType\"},{\"name\":\"JiraSimpleNavigationItemType\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraNumberLikeField\",\"possibleTypes\":[{\"name\":\"JiraForgeNumberField\"},{\"name\":\"JiraNumberField\"},{\"name\":\"JiraNumberFormulaField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraProjectFieldAssociationInterface\",\"possibleTypes\":[{\"name\":\"JiraAvailableField\"},{\"name\":\"JiraFieldAssociationWithIssueTypes\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectLevelSidebarMenuCustomizationResult\",\"possibleTypes\":[{\"name\":\"JiraProjectLevelSidebarMenuCustomization\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraProjectRecommendationDetails\",\"possibleTypes\":[{\"name\":\"JiraInviterActivityRecommendation\"},{\"name\":\"JiraTenantActivityRecommendation\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraReleaseHistoryValue\",\"possibleTypes\":[{\"name\":\"JiraReleaseHistoryGenericFieldValue\"},{\"name\":\"JiraReleaseHistoryStatusFieldValue\"},{\"name\":\"JiraReleaseHistoryUserFieldValue\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraRemoteIssueField\",\"possibleTypes\":[{\"name\":\"JiraIssueLinkRelationshipTypeField\"},{\"name\":\"JiraRemoteGenericField\"},{\"name\":\"JiraRemoteIssueTypeField\"},{\"name\":\"JiraRemotePriorityField\"},{\"name\":\"JiraRemoteSingleLineTextField\"},{\"name\":\"JiraRemoteSingleSelectUserPickerField\"},{\"name\":\"JiraRemoteStatusField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraResourceUsageMetricV2\",\"possibleTypes\":[{\"name\":\"JiraCustomFieldOptionUsageMetric\"},{\"name\":\"JiraCustomFieldUsageMetric\"},{\"name\":\"JiraGenericResourceUsageMetric\"},{\"name\":\"JiraIssueSecurityLevelUsageMetric\"},{\"name\":\"JiraWorkTypeUsageMetric\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraScenarioIssueLike\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"JiraScenarioIssue\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraScenarioVersionLike\",\"possibleTypes\":[{\"name\":\"JiraScenarioVersion\"},{\"name\":\"JiraVersion\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraProductDiscoveryCollection\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraSelectableValue\",\"possibleTypes\":[{\"name\":\"JiraAffectedService\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraParentOption\"},{\"name\":\"JiraServiceManagementOrganization\"},{\"name\":\"JiraVersion\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraSelectedUsersField\",\"possibleTypes\":[{\"name\":\"JiraForgeUsersField\"},{\"name\":\"JiraMultipleSelectUserPickerField\"},{\"name\":\"JiraPeopleField\"},{\"name\":\"JiraServiceManagementMultipleSelectUserPickerField\"},{\"name\":\"JiraServiceManagementPeopleField\"},{\"name\":\"JiraVotesField\"},{\"name\":\"JiraWatchesField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraServiceManagementRequestTypeFieldCommon\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraSmartLink\",\"possibleTypes\":[{\"name\":\"JiraBlockSmartLink\"},{\"name\":\"JiraEmbedSmartLink\"},{\"name\":\"JiraInlineSmartLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraSpreadsheetView\",\"possibleTypes\":[{\"name\":\"JiraGroupedListView\"},{\"name\":\"JiraGroupedTimelineView\"},{\"name\":\"JiraListView\"},{\"name\":\"JiraTimelineView\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraSupportsUpdatedDependentFields\",\"possibleTypes\":[{\"name\":\"JiraDateFieldPayload\"},{\"name\":\"JiraDateTimeFieldPayload\"},{\"name\":\"JiraNumberFieldPayload\"},{\"name\":\"JiraSingleLineTextFieldPayload\"},{\"name\":\"JiraStoryPointEstimateFieldPayload\"},{\"name\":\"JiraUrlFieldPayload\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraTextLikeField\",\"possibleTypes\":[{\"name\":\"JiraSingleLineTextField\"},{\"name\":\"JiraTextFormulaField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraTimelineVirtualField\",\"possibleTypes\":[{\"name\":\"JiraAggregatedTimelineField\"},{\"name\":\"JiraTimelineField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraUserIssueFieldConfiguration\",\"possibleTypes\":[{\"name\":\"JWMCategoryField\"},{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraAgentSessionsField\"},{\"name\":\"JiraAssetField\"},{\"name\":\"JiraAtlasProjectField\"},{\"name\":\"JiraAtlassianTeamField\"},{\"name\":\"JiraAttachmentsField\"},{\"name\":\"JiraBooleanField\"},{\"name\":\"JiraCascadingSelectField\"},{\"name\":\"JiraCheckboxesField\"},{\"name\":\"JiraColorField\"},{\"name\":\"JiraComponentsField\"},{\"name\":\"JiraConnectDateTimeField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraConnectNumberField\"},{\"name\":\"JiraConnectReadOnlyField\"},{\"name\":\"JiraConnectRichTextField\"},{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraConnectTextField\"},{\"name\":\"JiraCustomerServiceOrganizationField\"},{\"name\":\"JiraDataClassificationField\"},{\"name\":\"JiraDateFormulaField\"},{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateRangeField\"},{\"name\":\"JiraDateTimePickerField\"},{\"name\":\"JiraDurationField\"},{\"name\":\"JiraEpicLinkField\"},{\"name\":\"JiraFlagField\"},{\"name\":\"JiraForgeDateField\"},{\"name\":\"JiraForgeDatetimeField\"},{\"name\":\"JiraForgeGroupField\"},{\"name\":\"JiraForgeGroupsField\"},{\"name\":\"JiraForgeNumberField\"},{\"name\":\"JiraForgeObjectField\"},{\"name\":\"JiraForgeStringField\"},{\"name\":\"JiraForgeStringsField\"},{\"name\":\"JiraForgeUserField\"},{\"name\":\"JiraForgeUsersField\"},{\"name\":\"JiraGoalsField\"},{\"name\":\"JiraIssueCreatedProformaFormsField\"},{\"name\":\"JiraIssueLinkField\"},{\"name\":\"JiraIssueRestrictionField\"},{\"name\":\"JiraLabelsField\"},{\"name\":\"JiraMultipleGroupPickerField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleSelectUserPickerField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraNumberField\"},{\"name\":\"JiraNumberFormulaField\"},{\"name\":\"JiraOriginalTimeEstimateField\"},{\"name\":\"JiraParentIssueField\"},{\"name\":\"JiraPeopleField\"},{\"name\":\"JiraPriorityField\"},{\"name\":\"JiraProformaFormsField\"},{\"name\":\"JiraProjectField\"},{\"name\":\"JiraRadioSelectField\"},{\"name\":\"JiraRemainingTimeEstimateField\"},{\"name\":\"JiraResolutionField\"},{\"name\":\"JiraRichTextField\"},{\"name\":\"JiraSecurityLevelField\"},{\"name\":\"JiraServiceManagementApprovalField\"},{\"name\":\"JiraServiceManagementChannelSourceField\"},{\"name\":\"JiraServiceManagementDateTimeField\"},{\"name\":\"JiraServiceManagementEntitlementField\"},{\"name\":\"JiraServiceManagementMajorIncidentField\"},{\"name\":\"JiraServiceManagementMultipleSelectUserPickerField\"},{\"name\":\"JiraServiceManagementOrganizationField\"},{\"name\":\"JiraServiceManagementPeopleField\"},{\"name\":\"JiraServiceManagementRequestFeedbackField\"},{\"name\":\"JiraServiceManagementRequestLanguageField\"},{\"name\":\"JiraServiceManagementSentimentField\"},{\"name\":\"JiraSingleGroupPickerField\"},{\"name\":\"JiraSingleLineTextField\"},{\"name\":\"JiraSingleSelectField\"},{\"name\":\"JiraSingleSelectUserPickerField\"},{\"name\":\"JiraSingleVersionPickerField\"},{\"name\":\"JiraSprintField\"},{\"name\":\"JiraStatusCategoryField\"},{\"name\":\"JiraStatusField\"},{\"name\":\"JiraTeamField\"},{\"name\":\"JiraTeamViewField\"},{\"name\":\"JiraTextFormulaField\"},{\"name\":\"JiraTimeTrackingField\"},{\"name\":\"JiraTownsquareProjectField\"},{\"name\":\"JiraUrlField\"},{\"name\":\"JiraVotesField\"},{\"name\":\"JiraWatchesField\"},{\"name\":\"JiraWorkLogField\"},{\"name\":\"JsmMultipleSelectUserPickerField\"},{\"name\":\"JsmOrganizationField\"},{\"name\":\"JsmPeopleField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraVersionRelatedWorkV2\",\"possibleTypes\":[{\"name\":\"JiraVersionRelatedWorkConfluenceReleaseNotes\"},{\"name\":\"JiraVersionRelatedWorkGenericLink\"},{\"name\":\"JiraVersionRelatedWorkNativeReleaseNotes\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraView\",\"possibleTypes\":[{\"name\":\"JiraBacklogView\"},{\"name\":\"JiraBoardView\"},{\"name\":\"JiraDetailedView\"},{\"name\":\"JiraGroupedListView\"},{\"name\":\"JiraGroupedTimelineView\"},{\"name\":\"JiraListView\"},{\"name\":\"JiraTimelineView\"}]},{\"kind\":\"UNION\",\"name\":\"JiraViewResult\",\"possibleTypes\":[{\"name\":\"JiraBoardView\"},{\"name\":\"JiraBacklogView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraWebItemTarget\",\"possibleTypes\":[{\"name\":\"JiraWebItemTargetDialog\"},{\"name\":\"JiraWebItemTargetDialogModule\"},{\"name\":\"JiraWebItemTargetInlineDialog\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JiraWorkManagementBackground\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JqlFieldValue\",\"possibleTypes\":[{\"name\":\"JqlCascadingOptionFieldValue\"},{\"name\":\"JqlComponentFieldValue\"},{\"name\":\"JqlGroupFieldValue\"},{\"name\":\"JqlIssueFieldValue\"},{\"name\":\"JqlIssueTypeFieldValue\"},{\"name\":\"JqlJwmCategoryOptionFieldValue\"},{\"name\":\"JqlLabelFieldValue\"},{\"name\":\"JqlOptionFieldValue\"},{\"name\":\"JqlPriorityFieldValue\"},{\"name\":\"JqlProjectFieldValue\"},{\"name\":\"JqlResolutionFieldValue\"},{\"name\":\"JqlSprintFieldValue\"},{\"name\":\"JqlStatusCategoryFieldValue\"},{\"name\":\"JqlStatusFieldValue\"},{\"name\":\"JqlUserFieldValue\"},{\"name\":\"JqlVersionFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"JswMutationResponse\",\"possibleTypes\":[{\"name\":\"AssignIssueOutput\"},{\"name\":\"CompleteSprintOutput\"},{\"name\":\"CreateSprintOutput\"},{\"name\":\"GenericMutationResponse\"},{\"name\":\"IssueParentCreateOutput\"},{\"name\":\"MoveSprintDownOutput\"},{\"name\":\"MoveSprintUpOutput\"},{\"name\":\"SetSwimlaneStrategyOutput\"},{\"name\":\"SprintOutput\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"INTERFACE\",\"name\":\"LocalizationContext\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MercuryOriginalProjectStatus\",\"possibleTypes\":[{\"name\":\"JiraStatus\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MercuryProjectStatus\",\"possibleTypes\":[{\"name\":\"JiraStatusCategory\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MercuryProjectType\",\"possibleTypes\":[{\"name\":\"JiraIssueType\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MutationErrorExtension\",\"possibleTypes\":[{\"name\":\"FieldValidationMutationErrorExtension\"},{\"name\":\"GenericMutationErrorExtension\"},{\"name\":\"JWMTransitionAndRankMutationErrorExtension\"},{\"name\":\"JiraFilterEditGrantMutationErrorExtension\"},{\"name\":\"JiraFilterNameMutationErrorExtension\"},{\"name\":\"JiraFilterShareGrantMutationErrorExtension\"},{\"name\":\"JiraIssueArchiveAsyncErrorExtension\"},{\"name\":\"JiraIssueArchiveErrorExtension\"},{\"name\":\"JiraIssueUnarchiveErrorExtension\"},{\"name\":\"JiraListSettingMigrationMutationErrorExtension\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MutationResponse\",\"possibleTypes\":[{\"name\":\"SetMyPreferenceOutput\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Node\",\"possibleTypes\":[{\"name\":\"ActivityFeedItem\"},{\"name\":\"ApprovalActivityItem\"},{\"name\":\"AvailableCardLayoutField\"},{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"BoardFeatureGroup\"},{\"name\":\"BoardScope\"},{\"name\":\"CalendarIssueField\"},{\"name\":\"CardColor\"},{\"name\":\"Comment\"},{\"name\":\"ConfluencePage\"},{\"name\":\"CurrentCardLayoutField\"},{\"name\":\"CustomFilter\"},{\"name\":\"CustomSwimlane\"},{\"name\":\"Dashboard\"},{\"name\":\"EstimationBoardFeatureView\"},{\"name\":\"FailedRemoteLink\"},{\"name\":\"FieldConfig\"},{\"name\":\"GadgetSpec\"},{\"name\":\"GenericIssueField\"},{\"name\":\"IncidentActivityItem\"},{\"name\":\"Issue\"},{\"name\":\"IssueParent\"},{\"name\":\"JWMCategoryField\"},{\"name\":\"JWMItemGroup\"},{\"name\":\"JiraAffectedServicesField\"},{\"name\":\"JiraAgentSessionsField\"},{\"name\":\"JiraAggregatedStatusField\"},{\"name\":\"JiraAggregatedTimelineField\"},{\"name\":\"JiraAnnouncementBanner\"},{\"name\":\"JiraAppConfigState\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraAppNavigationItemType\"},{\"name\":\"JiraApplicationProperty\"},{\"name\":\"JiraAssetField\"},{\"name\":\"JiraAtlasProject\"},{\"name\":\"JiraAtlasProjectField\"},{\"name\":\"JiraAtlassianTeamField\"},{\"name\":\"JiraAttachmentsField\"},{\"name\":\"JiraAutodevJob\"},{\"name\":\"JiraBacklogView\"},{\"name\":\"JiraBacklogViewColumnCardList\"},{\"name\":\"JiraBacklogViewSprintCardList\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraBoardCardCoverMediaField\"},{\"name\":\"JiraBoardView\"},{\"name\":\"JiraBoardViewAssigneeColumn\"},{\"name\":\"JiraBoardViewCategoryColumn\"},{\"name\":\"JiraBoardViewCell\"},{\"name\":\"JiraBoardViewColumnLayout\"},{\"name\":\"JiraBoardViewFieldSwimlane\"},{\"name\":\"JiraBoardViewPriorityColumn\"},{\"name\":\"JiraBoardViewStatusColumn\"},{\"name\":\"JiraBoardViewSwimlaneLayout\"},{\"name\":\"JiraBooleanField\"},{\"name\":\"JiraBulkEditField\"},{\"name\":\"JiraBulkTransition\"},{\"name\":\"JiraBulkTransitionScreenLayout\"},{\"name\":\"JiraBusinessAvailableFields\"},{\"name\":\"JiraBusinessFormConfiguration\"},{\"name\":\"JiraCMDBField\"},{\"name\":\"JiraCascadingSelectField\"},{\"name\":\"JiraCheckboxesField\"},{\"name\":\"JiraColorField\"},{\"name\":\"JiraCommentSummaryField\"},{\"name\":\"JiraComponent\"},{\"name\":\"JiraComponentsField\"},{\"name\":\"JiraConfluenceRemoteIssueLinksField\"},{\"name\":\"JiraConnectDateTimeField\"},{\"name\":\"JiraConnectMultipleSelectField\"},{\"name\":\"JiraConnectNumberField\"},{\"name\":\"JiraConnectReadOnlyField\"},{\"name\":\"JiraConnectRichTextField\"},{\"name\":\"JiraConnectSingleSelectField\"},{\"name\":\"JiraConnectTextField\"},{\"name\":\"JiraContainerNavigation\"},{\"name\":\"JiraContext\"},{\"name\":\"JiraCrossProjectVersion\"},{\"name\":\"JiraCustomFieldOptionUsageMetric\"},{\"name\":\"JiraCustomFieldUsageMetric\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraCustomerServiceOrganizationField\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraDataClassificationField\"},{\"name\":\"JiraDateFormulaField\"},{\"name\":\"JiraDatePickerField\"},{\"name\":\"JiraDateRangeField\"},{\"name\":\"JiraDateTimePickerField\"},{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraDetailedView\"},{\"name\":\"JiraDevSummaryField\"},{\"name\":\"JiraDurationField\"},{\"name\":\"JiraEntityPropertyBoolean\"},{\"name\":\"JiraEntityPropertyInt\"},{\"name\":\"JiraEntityPropertyJSON\"},{\"name\":\"JiraEntityPropertyLastDismissedAnnouncementBanner\"},{\"name\":\"JiraEntityPropertyString\"},{\"name\":\"JiraEpicLinkField\"},{\"name\":\"JiraFallbackField\"},{\"name\":\"JiraFavouriteValue\"},{\"name\":\"JiraFieldScheme\"},{\"name\":\"JiraFieldSetView\"},{\"name\":\"JiraFilterEmailSubscription\"},{\"name\":\"JiraFlagField\"},{\"name\":\"JiraFocusArea\"},{\"name\":\"JiraForgeDateField\"},{\"name\":\"JiraForgeDatetimeField\"},{\"name\":\"JiraForgeGroupField\"},{\"name\":\"JiraForgeGroupsField\"},{\"name\":\"JiraForgeNumberField\"},{\"name\":\"JiraForgeObjectField\"},{\"name\":\"JiraForgeStringField\"},{\"name\":\"JiraForgeStringsField\"},{\"name\":\"JiraForgeUserField\"},{\"name\":\"JiraForgeUsersField\"},{\"name\":\"JiraFormForPublicSubmissionConfiguration\"},{\"name\":\"JiraFormattingRule\"},{\"name\":\"JiraFormulaFieldExpressionConfig\"},{\"name\":\"JiraGenericResourceUsageMetric\"},{\"name\":\"JiraGoal\"},{\"name\":\"JiraGoalsField\"},{\"name\":\"JiraGroup\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraGroupedListView\"},{\"name\":\"JiraGroupedTimelineView\"},{\"name\":\"JiraGuest\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraIssueCommandPaletteUpdateFieldAction\"},{\"name\":\"JiraIssueCreatedProformaFormsField\"},{\"name\":\"JiraIssueFieldConfig\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"},{\"name\":\"JiraIssueGenericCommandPaletteAction\"},{\"name\":\"JiraIssueLinkField\"},{\"name\":\"JiraIssueLinkRelationshipTypeField\"},{\"name\":\"JiraIssueLinkType\"},{\"name\":\"JiraIssueLinkTypeRelation\"},{\"name\":\"JiraIssueRestrictionField\"},{\"name\":\"JiraIssueSearchView\"},{\"name\":\"JiraIssueSecurityLevelUsageMetric\"},{\"name\":\"JiraIssueType\"},{\"name\":\"JiraIssueTypeField\"},{\"name\":\"JiraJQLHistory\"},{\"name\":\"JiraJourney\"},{\"name\":\"JiraJourneyConfiguration\"},{\"name\":\"JiraJourneyWorkItemStep\"},{\"name\":\"JiraLabelsField\"},{\"name\":\"JiraLabelsForCreateField\"},{\"name\":\"JiraListView\"},{\"name\":\"JiraMultipleGroupPickerField\"},{\"name\":\"JiraMultipleSelectField\"},{\"name\":\"JiraMultipleSelectUserPickerField\"},{\"name\":\"JiraMultipleVersionPickerField\"},{\"name\":\"JiraNavigationUIStateUserProperty\"},{\"name\":\"JiraNumberField\"},{\"name\":\"JiraNumberFormulaField\"},{\"name\":\"JiraOpsgenieTeam\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraOriginalTimeEstimateField\"},{\"name\":\"JiraParentIssueField\"},{\"name\":\"JiraParentOption\"},{\"name\":\"JiraPeopleField\"},{\"name\":\"JiraPermissionScheme\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraPlatformAttachment\"},{\"name\":\"JiraPlatformComment\"},{\"name\":\"JiraPostIncidentReviewLink\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraPriorityField\"},{\"name\":\"JiraProductDiscoveryCollection\"},{\"name\":\"JiraProformaFormsField\"},{\"name\":\"JiraProject\"},{\"name\":\"JiraProjectAISummary\"},{\"name\":\"JiraProjectAccessRequestDetails\"},{\"name\":\"JiraProjectCategory\"},{\"name\":\"JiraProjectField\"},{\"name\":\"JiraProjectPolicy\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraProjectShortcut\"},{\"name\":\"JiraProjectTypeDetails\"},{\"name\":\"JiraRadioSelectField\"},{\"name\":\"JiraRemainingTimeEstimateField\"},{\"name\":\"JiraRequestType\"},{\"name\":\"JiraRequestTypeField\"},{\"name\":\"JiraResolution\"},{\"name\":\"JiraResolutionField\"},{\"name\":\"JiraResource\"},{\"name\":\"JiraResourceUsageMetric\"},{\"name\":\"JiraRichTextField\"},{\"name\":\"JiraRole\"},{\"name\":\"JiraScenario\"},{\"name\":\"JiraScenarioIssue\"},{\"name\":\"JiraScenarioVersion\"},{\"name\":\"JiraScreen\"},{\"name\":\"JiraSecurityLevel\"},{\"name\":\"JiraSecurityLevelField\"},{\"name\":\"JiraServiceManagementActiveApproval\"},{\"name\":\"JiraServiceManagementApprovalField\"},{\"name\":\"JiraServiceManagementAttachment\"},{\"name\":\"JiraServiceManagementChannelSourceField\"},{\"name\":\"JiraServiceManagementComment\"},{\"name\":\"JiraServiceManagementCompletedApproval\"},{\"name\":\"JiraServiceManagementDateTimeField\"},{\"name\":\"JiraServiceManagementEntitlement\"},{\"name\":\"JiraServiceManagementEntitlementField\"},{\"name\":\"JiraServiceManagementIncidentLinkingField\"},{\"name\":\"JiraServiceManagementMajorIncidentField\"},{\"name\":\"JiraServiceManagementMultipleSelectUserPickerField\"},{\"name\":\"JiraServiceManagementOrganizationField\"},{\"name\":\"JiraServiceManagementPeopleField\"},{\"name\":\"JiraServiceManagementProduct\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraServiceManagementRequestFeedbackField\"},{\"name\":\"JiraServiceManagementRequestLanguageField\"},{\"name\":\"JiraServiceManagementRequestType\"},{\"name\":\"JiraServiceManagementRequestTypeField\"},{\"name\":\"JiraServiceManagementRespondersField\"},{\"name\":\"JiraServiceManagementSentimentField\"},{\"name\":\"JiraServiceManagementSlaField\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"JiraSimpleNavigationItemType\"},{\"name\":\"JiraSingleGroupPickerField\"},{\"name\":\"JiraSingleLineTextField\"},{\"name\":\"JiraSingleSelectField\"},{\"name\":\"JiraSingleSelectUserPickerField\"},{\"name\":\"JiraSingleVersionPickerField\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraSoftwareCustomFilter\"},{\"name\":\"JiraSprint\"},{\"name\":\"JiraSprintField\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraStatusCategory\"},{\"name\":\"JiraStatusCategoryField\"},{\"name\":\"JiraStatusField\"},{\"name\":\"JiraSubmitBulkOperationProgress\"},{\"name\":\"JiraSubtaskSummaryField\"},{\"name\":\"JiraSubtasksField\"},{\"name\":\"JiraSuggestedIssueFieldValue\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraTeam\"},{\"name\":\"JiraTeamField\"},{\"name\":\"JiraTeamViewField\"},{\"name\":\"JiraTextFormulaField\"},{\"name\":\"JiraTimeTrackingField\"},{\"name\":\"JiraTimelineField\"},{\"name\":\"JiraTimelineView\"},{\"name\":\"JiraTownsquareProject\"},{\"name\":\"JiraTownsquareProjectField\"},{\"name\":\"JiraTransition\"},{\"name\":\"JiraUrlField\"},{\"name\":\"JiraUserBroadcastMessage\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraUserNavigationConfiguration\"},{\"name\":\"JiraVersion\"},{\"name\":\"JiraVersionApprover\"},{\"name\":\"JiraVotesField\"},{\"name\":\"JiraWatchesField\"},{\"name\":\"JiraWebItem\"},{\"name\":\"JiraWorkCategoryField\"},{\"name\":\"JiraWorkLogField\"},{\"name\":\"JiraWorkManagementFilter\"},{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraWorkManagementSavedViewType\"},{\"name\":\"JiraWorkManagementViewItem\"},{\"name\":\"JiraWorkTypeUsageMetric\"},{\"name\":\"JiraWorklog\"},{\"name\":\"JsmMultipleSelectUserPickerField\"},{\"name\":\"JsmOrganizationField\"},{\"name\":\"JsmPeopleField\"},{\"name\":\"JsmRequestType\"},{\"name\":\"JsmRequestTypeField\"},{\"name\":\"Project\"},{\"name\":\"Region\"},{\"name\":\"TimeZone\"},{\"name\":\"UserValue\"},{\"name\":\"ViewIssue\"},{\"name\":\"Worklog\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Payload\",\"possibleTypes\":[{\"name\":\"ActivitySortPreferencePayload\"},{\"name\":\"CopyIssueViewLayoutPayload\"},{\"name\":\"JWMConfluenceLinkPayload\"},{\"name\":\"JWMConfluenceUnlinkPayload\"},{\"name\":\"JWMCreateCategoryPayload\"},{\"name\":\"JWMDeleteCategoryPayload\"},{\"name\":\"JWMLinkItemsPayload\"},{\"name\":\"JWMScheduleTimelineItemPayload\"},{\"name\":\"JWMSetCollapsedStatusBoardColumnUserPreferencePayload\"},{\"name\":\"JWMTransitionAndRankItemPayload\"},{\"name\":\"JWMUnlinkItemsPayload\"},{\"name\":\"JWMUpdateCategoryPayload\"},{\"name\":\"JiraActivitySortOrderPayload\"},{\"name\":\"JiraAddAgentToBoardViewStatusColumnPayload\"},{\"name\":\"JiraAddAttachmentsPayload\"},{\"name\":\"JiraAddBoardViewStatusColumnPayload\"},{\"name\":\"JiraAddFieldsToFieldSchemePayload\"},{\"name\":\"JiraAddFieldsToProjectPayload\"},{\"name\":\"JiraAddIssuesToFixVersionPayload\"},{\"name\":\"JiraAddPostIncidentReviewLinkMutationPayload\"},{\"name\":\"JiraAddRelatedWorkToVersionPayload\"},{\"name\":\"JiraAffectedServicesFieldPayload\"},{\"name\":\"JiraAnswerApprovalDecisionPayload\"},{\"name\":\"JiraApproveJiraBitbucketWorkspaceAccessRequestPayload\"},{\"name\":\"JiraAssignRelatedWorkPayload\"},{\"name\":\"JiraAssociateProjectToFieldSchemePayload\"},{\"name\":\"JiraAttachmentFieldPayload\"},{\"name\":\"JiraAutodevBasicPayload\"},{\"name\":\"JiraAutodevCreateJobPayload\"},{\"name\":\"JiraAutodevDeletedPayload\"},{\"name\":\"JiraAutodevPlannedChangePayload\"},{\"name\":\"JiraAutodevTaskPayload\"},{\"name\":\"JiraBoardViewIssueCreatePayload\"},{\"name\":\"JiraBulkCleanupProjectsPayload\"},{\"name\":\"JiraBulkCreateIssueLinksPayload\"},{\"name\":\"JiraBulkLabelColorUpdatePayload\"},{\"name\":\"JiraBulkSetBoardViewColumnStatePayload\"},{\"name\":\"JiraBulkSetBoardViewSwimlaneStatePayload\"},{\"name\":\"JiraBusinessCreateFormPayload\"},{\"name\":\"JiraBusinessCreateIssuePayload\"},{\"name\":\"JiraBusinessDeleteFormPayload\"},{\"name\":\"JiraBusinessUpdateFormPayload\"},{\"name\":\"JiraCFOCreateRecommendationsPayload\"},{\"name\":\"JiraCascadingSelectFieldPayload\"},{\"name\":\"JiraCheckboxesFieldPayload\"},{\"name\":\"JiraClearBoardIssueCardCoverPayload\"},{\"name\":\"JiraCloneIssueResponse\"},{\"name\":\"JiraCmdbFieldPayload\"},{\"name\":\"JiraColorFieldPayload\"},{\"name\":\"JiraComponentsFieldPayload\"},{\"name\":\"JiraConnectTownsquareProjectPayload\"},{\"name\":\"JiraCreateApproverListFieldPayload\"},{\"name\":\"JiraCreateAttachmentBackgroundPayload\"},{\"name\":\"JiraCreateBoardPayload\"},{\"name\":\"JiraCreateBoardViewStatusColumnPayload\"},{\"name\":\"JiraCreateBoardViewsForWorkflowsPayload\"},{\"name\":\"JiraCreateCalendarIssuePayload\"},{\"name\":\"JiraCreateCategoryOptionPayload\"},{\"name\":\"JiraCreateCustomBackgroundPayload\"},{\"name\":\"JiraCreateCustomFieldPayload\"},{\"name\":\"JiraCreateCustomFilterPayload\"},{\"name\":\"JiraCreateFormattingRulePayload\"},{\"name\":\"JiraCreateGlobalCustomFieldPayload\"},{\"name\":\"JiraCreateIssueByPublicFormPayload\"},{\"name\":\"JiraCreateIssueSearchFormattingRulePayload\"},{\"name\":\"JiraCreateJourneyConfigurationPayload\"},{\"name\":\"JiraCreateNavigationItemPayload\"},{\"name\":\"JiraCreateProjectCleanupRecommendationsPayload\"},{\"name\":\"JiraCreateReleaseNoteConfluencePagePayload\"},{\"name\":\"JiraCreateTownsquareProjectAndConnectToSpacePayload\"},{\"name\":\"JiraCustomerServiceOrganizationFieldPayload\"},{\"name\":\"JiraDataClassificationFieldPayload\"},{\"name\":\"JiraDateFieldAssociationMessageMutationPayload\"},{\"name\":\"JiraDateFieldPayload\"},{\"name\":\"JiraDateTimeFieldPayload\"},{\"name\":\"JiraDeclineBoardViewsForWorkflowsPayload\"},{\"name\":\"JiraDeleteAllAttachmentsPayload\"},{\"name\":\"JiraDeleteAllIssueResourcesPayload\"},{\"name\":\"JiraDeleteAttachmentsPayload\"},{\"name\":\"JiraDeleteBoardViewStatusColumnPayload\"},{\"name\":\"JiraDeleteCustomBackgroundPayload\"},{\"name\":\"JiraDeleteCustomFieldPayload\"},{\"name\":\"JiraDeleteCustomFilterPayload\"},{\"name\":\"JiraDeleteFieldSchemePayload\"},{\"name\":\"JiraDeleteFormattingRulePayload\"},{\"name\":\"JiraDeleteIssueLinkPayload\"},{\"name\":\"JiraDeleteIssueSearchFormattingRulePayload\"},{\"name\":\"JiraDeleteIssueTypePayload\"},{\"name\":\"JiraDeleteNavigationItemPayload\"},{\"name\":\"JiraDeleteOnboardingConfigPayload\"},{\"name\":\"JiraDeleteProjectNotificationPreferencesPayload\"},{\"name\":\"JiraDeleteWorklogPayload\"},{\"name\":\"JiraDevOpsUpdateAssociationsPayload\"},{\"name\":\"JiraDevOpsUpdateVulnerabilityStatusPayload\"},{\"name\":\"JiraDiscardUserBoardViewConfigPayload\"},{\"name\":\"JiraDiscardUserTimelineViewConfigPayload\"},{\"name\":\"JiraDisconnectTownsquareProjectPayload\"},{\"name\":\"JiraDismissAiAgentSessionPayload\"},{\"name\":\"JiraDismissBitbucketPendingAccessRequestBannerPayload\"},{\"name\":\"JiraDismissDevOpsIssuePanelBannerPayload\"},{\"name\":\"JiraDismissForYouRecommendedActionPayload\"},{\"name\":\"JiraDismissInContextConfigPromptPayload\"},{\"name\":\"JiraDismissProjectGuestUserFlagPayload\"},{\"name\":\"JiraEditCustomFieldPayload\"},{\"name\":\"JiraEnablePlanFeaturePayloadGraphQL\"},{\"name\":\"JiraFieldSchemePayload\"},{\"name\":\"JiraFieldSetPreferencesUpdatePayload\"},{\"name\":\"JiraFieldSetsViewPayload\"},{\"name\":\"JiraFieldToFieldSchemeAssociationsPayload\"},{\"name\":\"JiraFieldWorkTypeConfigurationPayload\"},{\"name\":\"JiraFilterSearchModeMutationPayload\"},{\"name\":\"JiraForgeObjectFieldPayload\"},{\"name\":\"JiraForgeUpdatePanelPayload\"},{\"name\":\"JiraGlobalPermissionAddGroupGrantPayload\"},{\"name\":\"JiraGlobalPermissionDeleteGroupGrantPayload\"},{\"name\":\"JiraGlobalPermissionSetUserGroupsPayload\"},{\"name\":\"JiraInitializeProjectNotificationPreferencesPayload\"},{\"name\":\"JiraInlineIssueCreatePayload\"},{\"name\":\"JiraInlineIssuesCreatePayload\"},{\"name\":\"JiraIssueArchiveAsyncPayload\"},{\"name\":\"JiraIssueArchivePayload\"},{\"name\":\"JiraIssueCreatePayload\"},{\"name\":\"JiraIssueExportTaskCancellationResult\"},{\"name\":\"JiraIssueNavigatorJQLHistoryDeletePayload\"},{\"name\":\"JiraIssueNavigatorSearchLayoutMutationPayload\"},{\"name\":\"JiraIssueRemoteIssueLinkPayload\"},{\"name\":\"JiraIssueSearchGroupByFieldMutationPayload\"},{\"name\":\"JiraIssueSearchHideDonePreferenceMutationPayload\"},{\"name\":\"JiraIssueSearchHierarchyPreferenceMutationPayload\"},{\"name\":\"JiraIssueSearchViewPayload\"},{\"name\":\"JiraIssueTransitionResponse\"},{\"name\":\"JiraIssueTypeFieldPayload\"},{\"name\":\"JiraIssueUnarchivePayload\"},{\"name\":\"JiraJQLBuilderSearchModeMutationPayload\"},{\"name\":\"JiraJsmIssueViewAIPanelForServiceDeskEnabledMutationPayload\"},{\"name\":\"JiraJsmIssueViewAISummaryPanelForServiceDeskCollapsedMutationPayload\"},{\"name\":\"JiraLabelColorUpdatePayload\"},{\"name\":\"JiraLabelsFieldPayload\"},{\"name\":\"JiraLegacyTeamFieldPayload\"},{\"name\":\"JiraLinkIssueToVersionRelatedWorkPayload\"},{\"name\":\"JiraLinkIssuesToIncidentMutationPayload\"},{\"name\":\"JiraListSettingMigrationPayload\"},{\"name\":\"JiraMergeIssuesPayload\"},{\"name\":\"JiraMergeVersionPayload\"},{\"name\":\"JiraMoveBoardViewIssueToCellEndPayload\"},{\"name\":\"JiraMoveIssueToBacklogPayload\"},{\"name\":\"JiraMoveIssuesToFixVersionPayload\"},{\"name\":\"JiraMultipleGroupPickerFieldPayload\"},{\"name\":\"JiraMultipleSelectFieldPayload\"},{\"name\":\"JiraMultipleSelectUserPickerFieldPayload\"},{\"name\":\"JiraMultipleVersionPickerFieldPayload\"},{\"name\":\"JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload\"},{\"name\":\"JiraNumberFieldPayload\"},{\"name\":\"JiraOnboardingConfigPayload\"},{\"name\":\"JiraOptoutDevOpsIssuePanelNotConnectedPayload\"},{\"name\":\"JiraOrderFormattingRulePayload\"},{\"name\":\"JiraOrderIssueSearchFormattingRulePayload\"},{\"name\":\"JiraOriginalTimeEstimateFieldPayload\"},{\"name\":\"JiraParentFieldPayload\"},{\"name\":\"JiraPeopleFieldPayload\"},{\"name\":\"JiraPermissionSchemeAddGrantPayload\"},{\"name\":\"JiraPermissionSchemeRemoveGrantPayload\"},{\"name\":\"JiraPriorityFieldPayload\"},{\"name\":\"JiraProjectAccessRequestMutationPayload\"},{\"name\":\"JiraProjectCreateCustomBackgroundMutationPayload\"},{\"name\":\"JiraProjectDeleteCustomBackgroundMutationPayload\"},{\"name\":\"JiraProjectFieldPayload\"},{\"name\":\"JiraProjectListRightPanelStateMutationPayload\"},{\"name\":\"JiraProjectShortcutPayload\"},{\"name\":\"JiraProjectUpdateAvatarMutationPayload\"},{\"name\":\"JiraProjectUpdateBackgroundMutationPayload\"},{\"name\":\"JiraProjectUpdateNameMutationPayload\"},{\"name\":\"JiraPublishBoardViewConfigPayload\"},{\"name\":\"JiraPublishIssueSearchConfigPayload\"},{\"name\":\"JiraPublishTimelineViewConfigPayload\"},{\"name\":\"JiraRadioSelectFieldPayload\"},{\"name\":\"JiraRankNavigationItemPayload\"},{\"name\":\"JiraRemainingTimeEstimateFieldPayload\"},{\"name\":\"JiraRemoveActiveBackgroundPayload\"},{\"name\":\"JiraRemoveAgentFromBoardViewStatusColumnPayload\"},{\"name\":\"JiraRemoveCustomFieldPayload\"},{\"name\":\"JiraRemoveCustomFieldTranslationPayload\"},{\"name\":\"JiraRemoveFieldsFromFieldSchemePayload\"},{\"name\":\"JiraRemoveIssueFromSprintPayload\"},{\"name\":\"JiraRemoveIssuesFromAllFixVersionsPayload\"},{\"name\":\"JiraRemoveIssuesFromFixVersionPayload\"},{\"name\":\"JiraRemoveJiraBitbucketWorkspaceConnectionPayload\"},{\"name\":\"JiraRemovePostIncidentReviewLinkMutationPayload\"},{\"name\":\"JiraRemoveRelatedWorkFromVersionPayload\"},{\"name\":\"JiraRenameBoardViewStatusColumnPayload\"},{\"name\":\"JiraRenameNavigationItemPayload\"},{\"name\":\"JiraRenameProjectLevelSidebarMenuItemPayload\"},{\"name\":\"JiraReorderBoardViewColumnPayload\"},{\"name\":\"JiraResetFaviconPayload\"},{\"name\":\"JiraResetLogoPayload\"},{\"name\":\"JiraResolutionFieldPayload\"},{\"name\":\"JiraRestoreCustomFieldsPayload\"},{\"name\":\"JiraRestoreGlobalCustomFieldsPayload\"},{\"name\":\"JiraRichTextFieldPayload\"},{\"name\":\"JiraScheduleCalendarIssuePayload\"},{\"name\":\"JiraScheduleCalendarIssueWithScenarioPayload\"},{\"name\":\"JiraScheduleTimelineItemPayload\"},{\"name\":\"JiraSecurityLevelFieldPayload\"},{\"name\":\"JiraServiceManagementCreateAndAssociateWorkflowFromTemplatePayload\"},{\"name\":\"JiraServiceManagementCreateRequestTypeFromTemplatePayload\"},{\"name\":\"JiraServiceManagementCreateRequestTypeFromTemplateResult\"},{\"name\":\"JiraServiceManagementEntitlementFieldPayload\"},{\"name\":\"JiraServiceManagementRequestTypeCategoryDefaultPayload\"},{\"name\":\"JiraServiceManagementRequestTypeCategoryPayload\"},{\"name\":\"JiraServiceManagementSentimentFieldPayload\"},{\"name\":\"JiraSetAgentSessionIsPlanModeEnabledResponsePayload\"},{\"name\":\"JiraSetApplicationPropertiesPayload\"},{\"name\":\"JiraSetBacklogViewPayload\"},{\"name\":\"JiraSetBoardIssueCardCoverPayload\"},{\"name\":\"JiraSetBoardViewCardFieldSelectedPayload\"},{\"name\":\"JiraSetBoardViewCardOptionStatePayload\"},{\"name\":\"JiraSetBoardViewColumnStatePayload\"},{\"name\":\"JiraSetBoardViewColumnsOrderPayload\"},{\"name\":\"JiraSetBoardViewCompletedIssueSearchCutOffPayload\"},{\"name\":\"JiraSetBoardViewFilterPayload\"},{\"name\":\"JiraSetBoardViewGroupByPayload\"},{\"name\":\"JiraSetBoardViewStatusColumnIssueCountLimitPayload\"},{\"name\":\"JiraSetBoardViewStatusColumnMappingPayload\"},{\"name\":\"JiraSetBoardViewSwimlaneStatePayload\"},{\"name\":\"JiraSetBoardViewWorkflowSelectedPayload\"},{\"name\":\"JiraSetCapacityMostRecentSubRoutePayload\"},{\"name\":\"JiraSetCustomFieldTranslationPayload\"},{\"name\":\"JiraSetDefaultNavigationItemPayload\"},{\"name\":\"JiraSetFaviconPayload\"},{\"name\":\"JiraSetFieldAssociationWithIssueTypesPayload\"},{\"name\":\"JiraSetFieldSetsPreferencesPayload\"},{\"name\":\"JiraSetFormulaFieldExpressionConfigPayload\"},{\"name\":\"JiraSetIgnoreAgentContextPayload\"},{\"name\":\"JiraSetIsAgentAssignableResponsePayload\"},{\"name\":\"JiraSetIsFavouritePayload\"},{\"name\":\"JiraSetIssueSearchAggregationConfigPayload\"},{\"name\":\"JiraSetIssueSearchGroupByPayload\"},{\"name\":\"JiraSetIssueSearchHideDoneItemsPayload\"},{\"name\":\"JiraSetIssueSearchHideWarningsPayload\"},{\"name\":\"JiraSetIssueSearchHierarchyEnabledPayload\"},{\"name\":\"JiraSetIssueSearchJqlPayload\"},{\"name\":\"JiraSetIssueSearchViewLayoutPayload\"},{\"name\":\"JiraSetJswBoardViewSettingsPayload\"},{\"name\":\"JiraSetLogoPayload\"},{\"name\":\"JiraSetMostRecentlyViewedBoardPayload\"},{\"name\":\"JiraSetMyFilterFieldsPayload\"},{\"name\":\"JiraSetProjectPolicyAssociatedProjectsPayload\"},{\"name\":\"JiraSetProjectSelectedDeploymentAppsPropertyPayload\"},{\"name\":\"JiraSetTimelineBarColorModePayload\"},{\"name\":\"JiraSetTimelineChildIssuePlanningModePayload\"},{\"name\":\"JiraSetTimelineHighlightedReleasesPayload\"},{\"name\":\"JiraSetTimelineSearchFiltersPayload\"},{\"name\":\"JiraSetTimelineViewFieldSetsPayload\"},{\"name\":\"JiraSetTimelineViewHideDependenciesPayload\"},{\"name\":\"JiraSetTimelineViewHideReleasesPayload\"},{\"name\":\"JiraSetTimelineViewHideWarningsPayload\"},{\"name\":\"JiraSetTimelineViewRangeModePayload\"},{\"name\":\"JiraSetViewFilterPayload\"},{\"name\":\"JiraSetViewGroupByPayload\"},{\"name\":\"JiraShowUnscheduledIssuesCalendarMutationPayload\"},{\"name\":\"JiraSingleGroupPickerFieldPayload\"},{\"name\":\"JiraSingleLineTextFieldPayload\"},{\"name\":\"JiraSingleSelectFieldPayload\"},{\"name\":\"JiraSingleSelectUserPickerFieldPayload\"},{\"name\":\"JiraSingleVersionPickerFieldPayload\"},{\"name\":\"JiraSpreadsheetViewPayload\"},{\"name\":\"JiraSprintFieldPayload\"},{\"name\":\"JiraSprintMutationPayload\"},{\"name\":\"JiraStartAiAgentSessionPayload\"},{\"name\":\"JiraStatusFieldPayload\"},{\"name\":\"JiraStoryPointEstimateFieldPayload\"},{\"name\":\"JiraSubmitBulkOperationPayload\"},{\"name\":\"JiraTeamFieldPayload\"},{\"name\":\"JiraTimeTrackingFieldPayload\"},{\"name\":\"JiraTimelineIssueLinkOperationPayload\"},{\"name\":\"JiraTrackRecentIssuePayload\"},{\"name\":\"JiraTrackRecentProjectPayload\"},{\"name\":\"JiraTrashCustomFieldsPayload\"},{\"name\":\"JiraTrashGlobalCustomFieldsPayload\"},{\"name\":\"JiraUnlinkIssuesFromIncidentMutationPayload\"},{\"name\":\"JiraUnsplashAttributionPayload\"},{\"name\":\"JiraUpdateActiveBackgroundPayload\"},{\"name\":\"JiraUpdateBoardViewStatusColumnAgentPayload\"},{\"name\":\"JiraUpdateCalendarViewConfigPayload\"},{\"name\":\"JiraUpdateConfluenceRemoteIssueLinksFieldPayload\"},{\"name\":\"JiraUpdateCustomBackgroundPayload\"},{\"name\":\"JiraUpdateCustomFieldDefaultContextOptionsPayload\"},{\"name\":\"JiraUpdateCustomFieldPayload\"},{\"name\":\"JiraUpdateCustomFieldsPayload\"},{\"name\":\"JiraUpdateCustomFilterJqlPayload\"},{\"name\":\"JiraUpdateCustomFilterPayload\"},{\"name\":\"JiraUpdateFlagFieldPayload\"},{\"name\":\"JiraUpdateFormattingRulePayload\"},{\"name\":\"JiraUpdateGlobalCustomFieldPayload\"},{\"name\":\"JiraUpdateGlobalPreferencesPayload\"},{\"name\":\"JiraUpdateIssueLinkRelationshipTypeFieldPayload\"},{\"name\":\"JiraUpdateIssueSearchFormattingRulePayload\"},{\"name\":\"JiraUpdateJourneyConfigurationPayload\"},{\"name\":\"JiraUpdateNotificationOptionsPayload\"},{\"name\":\"JiraUpdateOverviewPlanMigrationChangeboardingPayload\"},{\"name\":\"JiraUpdateParentAndRankPayload\"},{\"name\":\"JiraUpdateProjectAdminAttributePayload\"},{\"name\":\"JiraUpdateProjectNotificationPreferencesPayload\"},{\"name\":\"JiraUpdateReleaseNotesConfigurationPayload\"},{\"name\":\"JiraUpdateTeamsFieldFilterPayload\"},{\"name\":\"JiraUpdateVersionPayload\"},{\"name\":\"JiraUpdateVersionRelatedWorkGenericLinkPayload\"},{\"name\":\"JiraUpdateVersionWarningConfigPayload\"},{\"name\":\"JiraUpdateViewConfigPayload\"},{\"name\":\"JiraUpsertIssueTypePayload\"},{\"name\":\"JiraUrlFieldPayload\"},{\"name\":\"JiraUserBroadcastMessageActionPayload\"},{\"name\":\"JiraUserNavigationConfigurationPayload\"},{\"name\":\"JiraVersionAddApproverPayload\"},{\"name\":\"JiraVersionDeleteApproverPayload\"},{\"name\":\"JiraVersionDetailsCollapsedUisPayload\"},{\"name\":\"JiraVersionIssueTableColumnHiddenStatePayload\"},{\"name\":\"JiraVersionUpdateApproverDeclineReasonPayload\"},{\"name\":\"JiraVersionUpdateApproverDescriptionPayload\"},{\"name\":\"JiraVersionUpdateApproverStatusPayload\"},{\"name\":\"JiraVersionUpdateReleaseNotesTypePreferencePayload\"},{\"name\":\"JiraVotesFieldPayload\"},{\"name\":\"JiraWatchesFieldPayload\"},{\"name\":\"JiraWorkManagementAssociateFieldPayload\"},{\"name\":\"JiraWorkManagementBoardSettingsPayload\"},{\"name\":\"JiraWorkManagementCreateCustomBackgroundPayload\"},{\"name\":\"JiraWorkManagementCreateFieldPayload\"},{\"name\":\"JiraWorkManagementCreateIssuePayload\"},{\"name\":\"JiraWorkManagementCreateSavedViewPayload\"},{\"name\":\"JiraWorkManagementDeleteAttachmentPayload\"},{\"name\":\"JiraWorkManagementDeleteCustomBackgroundPayload\"},{\"name\":\"JiraWorkManagementDeleteFieldPayload\"},{\"name\":\"JiraWorkManagementGiraCreateOverviewPayload\"},{\"name\":\"JiraWorkManagementGiraDeleteOverviewPayload\"},{\"name\":\"JiraWorkManagementGiraUpdateOverviewPayload\"},{\"name\":\"JiraWorkManagementRemoveActiveBackgroundPayload\"},{\"name\":\"JiraWorkManagementUpdateActiveBackgroundPayload\"},{\"name\":\"JiraWorkManagementUpdateCustomBackgroundPayload\"},{\"name\":\"JiraWorkManagementUpdateFieldPayload\"},{\"name\":\"JiraWorklogPayload\"},{\"name\":\"JsmOrganizationFieldPayload\"},{\"name\":\"JwmCreateFilterPayload\"},{\"name\":\"JwmUpdateFilterPayload\"},{\"name\":\"RankMutationPayload\"},{\"name\":\"ScheduleTimelineItemPayload\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"INTERFACE\",\"name\":\"QueryErrorExtension\",\"possibleTypes\":[{\"name\":\"DefaultQueryErrorExtension\"},{\"name\":\"JiraIssueFieldUnsupportedErrorExtension\"},{\"name\":\"JiraIssueFieldValueValidationErrorExtension\"},{\"name\":\"JiraIssueSearchErrorExtension\"},{\"name\":\"JiraVersionConnectionResultQueryErrorExtension\"},{\"name\":\"JiraWorkManagementQueryErrorExtension\"},{\"name\":\"JqlSyntaxQueryErrorExtension\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteJiraIssueLinkForJpdResult\",\"possibleTypes\":[{\"name\":\"RemoteJiraIssueLinkForJpdResultSuccess\"},{\"name\":\"RemoteJiraIssueLinkForJpdResultError\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteJiraIssueLinkResult\",\"possibleTypes\":[{\"name\":\"RemoteJiraIssueLinkResultSuccess\"},{\"name\":\"RemoteJiraIssueLinkResultError\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"INTERFACE\",\"name\":\"StatisticsParameters\",\"possibleTypes\":[{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"WorkloadPieChartParameters\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]},{\"kind\":\"INTERFACE\",\"name\":\"TimeSeriesParameters\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedGadgetParameters\"}]},{\"kind\":\"INTERFACE\",\"name\":\"User\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"}]}]}}");

});

parcelRegister("dEp2z", function(module, exports) {
$parcel$export(module.exports, "getErrorAnalyticsContext", () => $538129ece7c092f0$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $538129ece7c092f0$export$a78ebe1911f50d41);
/* eslint-disable jira/filename-case */ 
var $jJGWf = parcelRequire("jJGWf");

var $9Oiqw = parcelRequire("9Oiqw");

var $hFtK7 = parcelRequire("hFtK7");
const $538129ece7c092f0$export$15d632fe38832073 = 'giraErrorAnalytics';
const $538129ece7c092f0$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$538129ece7c092f0$export$15d632fe38832073]: errorAnalytics
    });
const $538129ece7c092f0$export$bd030713895ed5e2 = (context)=>{
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jJGWf)))(context, [
        $538129ece7c092f0$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $538129ece7c092f0$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $538129ece7c092f0$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $9Oiqw.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});



parcelRegister("iEXfT", function(module, exports) {
$parcel$export(module.exports, "getIssueCreateProjectForMount", () => $34acde4a47591c61$export$ce9d0b4bb614f329);
const $34acde4a47591c61$export$ce9d0b4bb614f329 = (projectContext)=>{
    if (projectContext?.projectId) return {
        label: projectContext.projectName,
        value: projectContext.projectId.toString(),
        iconUrl: '',
        projectKey: projectContext.projectKey,
        projectType: projectContext.projectType,
        isSimplified: projectContext.simplified
    };
    return null;
};

});

parcelRegister("7Xc3n", function(module, exports) {
$parcel$export(module.exports, "getQueryVariables", () => $5bc2d7c40c493298$export$8c3d6ce16880e58e);

var $i860n = parcelRequire("i860n");


var $3VQvs = parcelRequire("3VQvs");
const $5bc2d7c40c493298$export$8c3d6ce16880e58e = (selectedProject, selectedIssueType, defaultValues)=>{
    const projectId = selectedProject?.value || null;
    let issueTypeId = null;
    let requestTypeKey = null;
    if (selectedIssueType) {
        issueTypeId = selectedIssueType.type === (0, $2e5f0c6757041651$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        requestTypeKey = // @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
        selectedIssueType.requestTypeKey !== undefined ? // @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
        selectedIssueType.requestTypeKey : null;
    }
    return {
        project: projectId ? {
            projectId: projectId
        } : null,
        issueType: issueTypeId !== null ? {
            issueTypeId: issueTypeId
        } : null,
        requestType: requestTypeKey !== null ? {
            key: requestTypeKey
        } : null,
        // Normalise empty `defaultValues` ({}) to null so an issue type / project
        // revisited with no user input produces the same Apollo cache key as the
        // initial load, restoring cache hits instead of redundant network calls.
        defaultValues: (0, $i860n.fg)('nike_united_add_cache_and_network') ? (0, $3VQvs.normalizeDefaultValues)(defaultValues) : defaultValues || null,
        withNumberFormat: true
    };
};

});
/* eslint-disable jira/filename-case */ // error types
const $2e5f0c6757041651$export$6c8cb487d6ffc522 = 'QueryError';
const $2e5f0c6757041651$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $2e5f0c6757041651$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $2e5f0c6757041651$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $2e5f0c6757041651$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $2e5f0c6757041651$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $2e5f0c6757041651$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $2e5f0c6757041651$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $2e5f0c6757041651$export$7b20493af2e93ea0 = 'CASE_MANAGEMENT';
const $2e5f0c6757041651$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $2e5f0c6757041651$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $2e5f0c6757041651$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("3VQvs", function(module, exports) {
$parcel$export(module.exports, "normalizeDefaultValues", () => $2787c73bc83f9dbb$export$c07e00e0346b2363);
const $2787c73bc83f9dbb$export$c07e00e0346b2363 = (defaultValues)=>{
    if (defaultValues == null || Object.keys(defaultValues).length === 0) return null;
    return defaultValues;
};

});


parcelRegister("de86o", function(module, exports) {
$parcel$export(module.exports, "getConsolidatedCreateConfigQuery", () => $28ca85fa6b1691dd$export$a328fa075f14f3cc);

var $e0t6Q = parcelRequire("e0t6Q");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $aJDWs = parcelRequire("aJDWs");

var $ej0K9 = parcelRequire("ej0K9");
const $28ca85fa6b1691dd$var$getDataClassificationFragment = ()=>{
    if ((0, $i860n.fg)('enable_classification_control_on_issue_experiences')) return 0, $ej0K9.DATA_CLASSIFICATION_FIELD_FRAGMENT_WITH_CLASSIFICATION_CONTROL;
    return (0, $i860n.fg)('enable_classification_org_default') ? (0, $ej0K9.DATA_CLASSIFICATION_FIELD_FRAGMENT_WITH_ORG_DEFAULT) : (0, $ej0K9.DATA_CLASSIFICATION_FIELD_FRAGMENT);
};
const $28ca85fa6b1691dd$var$getDataClassificationInlineFragment = ()=>{
    if ((0, $i860n.fg)('enable_classification_control_on_issue_experiences')) return '...DataClassificationFieldFragmentWithClassificationControl';
    return (0, $i860n.fg)('enable_classification_org_default') ? '...DataClassificationFieldFragmentWithOrgDefault' : '...DataClassificationFieldFragment';
};
const $28ca85fa6b1691dd$export$a328fa075f14f3cc = ({ isInContext: isInContext, isSubtask: isSubtask = false, withML: withML, isCreateLinkedIssue: isCreateLinkedIssue, evaluateMiniMode: evaluateMiniMode = false, isModernised: isModernised = false })=>{
    // Determine the GraphQL operation name.
    // Standard and inContext share the same GIRA endpoints (with InContext suffix).
    // Subtask uses entirely different root fields on the schema.
    // oxlint-disable-next-line no-nested-ternary
    const operationName = isSubtask ? 'JiraGlobalSubtaskIssueCreateModalLoad' : isInContext ? `JiraGlobalIssueCreateInContext${isCreateLinkedIssue ? 'WithCLI' : ''}` : 'JiraGlobalIssueCreateModalLoad';
    // Root field names differ between subtask and standard/inContext modes.
    const layoutField = isSubtask ? `jiraSubtaskCreationLayout${withML ? 'WithML' : ''}` : `jiraIssueCreateLayout${isInContext ? 'InContext' : ''}${withML ? 'WithML' : ''}`;
    const fieldsField = isSubtask ? 'jiraSubtaskCreationFields' : `jiraIssueCreateFields${isInContext ? 'InContext' : ''}`;
    const servicesField = isSubtask ? 'jiraSubtaskCreationAdditionalServices' : 'jiraIssueCreateAdditionalServices';
    // IssueType fragment: subtask uses flat (no hierarchy, no search);
    // inContext uses hierarchy; standard uses search+hierarchy.
    // oxlint-disable-next-line no-nested-ternary
    const issueTypeInlineFragment = isSubtask ? '...IssueTypeFieldFragment' : isInContext ? '...IssueTypeFieldFragmentWithHierarchy' : '...IssueTypeFieldSearchFragmentWithHierarchy';
    // oxlint-disable-next-line no-nested-ternary
    const issueTypeFragment = isSubtask ? (0, $ej0K9.ISSUE_TYPE_FIELD_FRAGMENT) : isInContext ? (0, $ej0K9.ISSUE_TYPE_FIELD_FRAGMENT_WITH_HIERARCHY) : (0, $ej0K9.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT_WITH_HIERARCHY);
    // RequestType: standard uses search variant; inContext and subtask use basic variant.
    const requestTypeInlineFragment = isInContext || isSubtask ? '...RequestTypeFieldFragment' : '...RequestTypeFieldSearchFragment';
    const requestTypeFragment = isInContext || isSubtask ? (0, $ej0K9.REQUEST_TYPE_FIELD_FRAGMENT) : (0, $ej0K9.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT);
    // IssueLinks: inContext uses copy-links variant; all others use refined.
    const issueLinksInlineFragment = isInContext ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined' : '...IssueLinksFieldFragmentRefined';
    const issueLinksFragment = isInContext ? (0, $ej0K9.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED) : (0, $ej0K9.ISSUE_LINKS_FIELD_FRAGMENT_REFINED);
    // forceLegacyCreateExperience: for inContext and subtask it is gated behind the
    // experiment (needsForceLegacy below). For standard it is selected alongside
    // miniMode/fallbackReason when evaluateMiniMode is true (see the fields block),
    // matching the legacy standard query so the modernised modal can honour the
    // backend-driven legacy fallback (e.g. admin "simple create as default" off).
    const needsForceLegacy = (isInContext || isSubtask) && (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false);
    const layoutFragment = (0, $ej0K9.getLayoutFragment)(withML);
    return (0, $e0t6Q.default)`
	query ${operationName}(
		$project: JiraProjectInput
		$issueType: JiraIssueTypeInput
		$requestType: JiraRequestTypeInput
		$defaultValues: JiraIssueFieldsInput
		${!isInContext && !isSubtask ? '$issueTypes: String' : ''}
		${!isInContext && !isSubtask ? '$requestTypes: String' : ''}
		${isInContext ? '$additionalContext: JiraIssueCreateContextInput!' : ''}
		${isSubtask ? '$parentId: JiraParentIdInput!' : ''}
		${isInContext ? '$issueCreateType: IssueCreateTypeFilter' : ''}
		${!isInContext && !isSubtask && evaluateMiniMode ? '$evaluateMiniMode: Boolean' : ''}
		$withNumberFormat: Boolean!
		$cloudId: ID!
		$applicationKey: JiraApplicationKey!
		$shouldCheckForStorageLimit: Boolean!
	) {
		${layoutField}(
			layoutFilter: USER_CONFIGURED_LAYOUT
			project: $project
			issueType: $issueType
			${!isSubtask && !isInContext ? 'requestType: $requestType' : ''}
			${isSubtask ? 'parentId: $parentId' : ''}
			${isInContext ? 'additionalContext: $additionalContext' : ''}
			${isInContext ? 'issueCreateType: $issueCreateType' : ''}
		) {
			...${(0, $ej0K9.getLayoutFragmentName)(layoutFragment)}
		}
		${fieldsField}(
			fieldsFilter: USER_CONFIGURED_FIELDS
			project: $project
			issueType: $issueType
			requestType: $requestType
			defaultValues: $defaultValues
			${isSubtask ? 'parentId: $parentId' : ''}
			${isInContext ? 'additionalContext: $additionalContext' : ''}
			${isInContext ? 'issueCreateType: $issueCreateType' : ''}
			${!isInContext && !isSubtask && evaluateMiniMode ? 'evaluateMiniMode: $evaluateMiniMode' : ''}
		) {
			... on JiraIssueCreateFields {
				${!isInContext && !isSubtask && evaluateMiniMode ? 'miniMode fallbackReason forceLegacyCreateExperience' : ''}
				${needsForceLegacy ? 'forceLegacyCreateExperience' : ''}
				fields {
					nodes {
						${(0, $i860n.fg)('issue_create_reuse_labels_field_for_create') ? '...BaseFieldWithAriFragment' : '...BaseFieldFragment'}
						...ProjectFieldFragmentWithoutClassification
						${issueTypeInlineFragment}
						${requestTypeInlineFragment}
						...TextFieldFragment
						...RichTextFieldFragment
						${isModernised && (0, $i860n.fg)('jiv_22549_modern_wic_components_async_options') ? '...ComponentsFieldFragmentAsyncOptions' : '...ComponentsFieldFragment'}
						${isModernised && (0, $i860n.fg)('jiv_22550_modern_wic_versions_async_options') ? '...VersionFieldFragmentAsyncOptions' : '...VersionFieldFragment'}
						${isModernised && (0, $i860n.fg)('jiv_22550_modern_wic_versions_async_options') ? '...MultiVersionFieldFragmentAsyncOptions' : '...MultiVersionFieldFragment'}
						...PriorityFieldFragment
						...SprintFieldFragment
						...LabelFieldFragment
						...SingleUserPickerFieldFragment
						...MultiUserPickerFieldFragment
						...PeopleFieldFragment
						...SecurityFieldFragment
						...IssueRestrictionFieldFragment
						...ColorFieldFragment
						...ResolutionFieldFragment
						...SingleSelectFieldFragment
						...MultiSelectFieldFragment
						...NumberFieldFragment
						...UrlFieldFragment
						...EpicLinkFieldFragment
						...DatePickerFieldFragment
						...DateTimePickerFieldFragment
						...CascadingSelectFieldFragment
						...AttachmentsFieldFragment
						...CheckboxFieldFragment
						${issueLinksInlineFragment}
						...SingleGroupPickerFieldFragment
						...MultiGroupPickerFieldFragment
						...TeamFieldFragment
						...AtlassianTeamFieldFragment
						...RadioSelectFieldFragment
						...AffectedServicesFieldFragment
						...CMDBFieldFragment
						...OrganizationsFieldFragment
						...ConnectTextFieldFragment
						...ConnectNumberFieldFragment
						...ConnectSingleSelectFieldFragment
						...ConnectMultiSelectFieldFragment
						...ConnectRichTextFieldFragment
						...AssetFieldFragment
						...ForgeStringFieldFragment
						...ForgeNumberFieldFragment
						...ForgeSingleUserPickerFieldFragment
						...ForgeMultiUserPickerFieldFragment
						...ForgeGroupPickerFieldFragment
						...ForgeMultiGroupPickerFieldFragment
						...ForgeStringsFieldFragment
						...ForgeObjectFieldFragment
						...ForgeDateTimePickerFieldFragment
						...TimeTrackingFieldFragment
						...WorkLogFieldFragment
						...JsmMultiUserPickerFieldFragment
						...JsmPeopleFieldFragment
						...ParentLinkFieldFragment
						${!isInContext && !isSubtask ? $28ca85fa6b1691dd$var$getDataClassificationInlineFragment() : ''}
						...ParentFieldFragment
						...StatusFieldFragment
						${(0, $aJDWs.isProjectsInJiraM1Enabled)() ? '...AtlasProjectFieldFragment' : ''}
					}
				}
				errors {
					identifier
					extensions {
						... on JiraIssueFieldUnsupportedErrorExtension {
							fieldName
							fieldType
							isRequiredField
						}
						... on JiraIssueFieldValueValidationErrorExtension {
							errorType
							message
						}
					}
				}
			}
			... on QueryError {
				message
			}
		}
		${servicesField}(
			project: $project
			issueType: $issueType
			requestType: $requestType
			${isSubtask ? 'parentId: $parentId' : ''}
		) {
			... on JiraIssueCreateAdditionalServices {
				services {
					edges {
						node {
							...WatchersConfigFragment
							${!isSubtask ? '...ProformaConfigFragment' : ''}
						}
					}
				}
			}
			... on QueryError {
				message
			}
		}
		jira @include(if: $shouldCheckForStorageLimit) {
			...StorageLimitsFragment
		}
	}
	${layoutFragment}
	${(0, $i860n.fg)('issue_create_reuse_labels_field_for_create') ? (0, $ej0K9.BASE_FIELD_FRAGMENT_WITH_CREATE_CONTEXT_OPTION_ARI) : (0, $ej0K9.BASE_FIELD_FRAGMENT)}
	${0, $ej0K9.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
	${issueTypeFragment}
	${requestTypeFragment}
	${0, $ej0K9.TEXT_FIELD_FRAGMENT}
	${0, $ej0K9.RICH_TEXT_FIELD_FRAGMENT}
	${isModernised && (0, $i860n.fg)('jiv_22549_modern_wic_components_async_options') ? (0, $ej0K9.COMPONENTS_FIELD_FRAGMENT_ASYNC_OPTIONS) : (0, $ej0K9.COMPONENTS_FIELD_FRAGMENT)}
	${isModernised && (0, $i860n.fg)('jiv_22550_modern_wic_versions_async_options') ? (0, $ej0K9.VERSION_FIELD_FRAGMENT_ASYNC_OPTIONS) : (0, $ej0K9.VERSION_FIELD_FRAGMENT)}
	${isModernised && (0, $i860n.fg)('jiv_22550_modern_wic_versions_async_options') ? (0, $ej0K9.MULTI_VERSION_FIELD_FRAGMENT_ASYNC_OPTIONS) : (0, $ej0K9.MULTI_VERSION_FIELD_FRAGMENT)}
	${0, $ej0K9.PRIORITY_FIELD_FRAGMENT}
	${0, $ej0K9.SPRINT_FIELD_FRAGMENT}
	${0, $ej0K9.LABEL_FIELD_FRAGMENT}
	${0, $ej0K9.SINGLE_USER_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.MULTI_USER_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.SECURITY_FIELD_FRAGMENT}
	${0, $ej0K9.ISSUE_RESTRICTION_FIELD_FRAGMENT}
	${0, $ej0K9.COLOR_FIELD_FRAGMENT}
	${0, $ej0K9.RESOLUTION_FIELD_FRAGMENT}
	${0, $ej0K9.SINGLE_SELECT_FIELD_FRAGMENT}
	${0, $ej0K9.MULTI_SELECT_FIELD_FRAGMENT}
	${0, $ej0K9.NUMBER_FIELD_FRAGMENT}
	${0, $ej0K9.URL_FIELD_FRAGMENT}
	${0, $ej0K9.EPIC_LINK_FIELD_FRAGMENT}
	${0, $ej0K9.DATE_FIELD_FRAGMENT}
	${0, $ej0K9.DATE_TIME_FIELD_FRAGMENT}
	${0, $ej0K9.CASCADING_SELECT_FIELD_FRAGMENT}
	${0, $ej0K9.ATTACHMENTS_FIELD_FRAGMENT}
	${0, $ej0K9.CHECKBOX_FIELD_FRAGMENT}
	${issueLinksFragment}
	${0, $ej0K9.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.PEOPLE_FIELD_FRAGMENT}
	${0, $ej0K9.TEAM_FIELD_FRAGMENT}
	${0, $ej0K9.ATLASSIAN_TEAM_FIELD_FRAGMENT}
	${0, $ej0K9.RADIO_SELECT_FIELD_FRAGMENT}
	${0, $ej0K9.AFFECTED_SERVICES_FIELD_FRAGMENT}
	${0, $ej0K9.CMDB_FIELD_FRAGMENT}
	${0, $ej0K9.ORGANIZATIONS_FIELD_FRAGMENT}
	${0, $ej0K9.CONNECT_TEXT_FIELD_FRAGMENT}
	${0, $ej0K9.CONNECT_NUMBER_FIELD_FRAGMENT}
	${0, $ej0K9.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
	${0, $ej0K9.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
	${0, $ej0K9.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
	${0, $ej0K9.ASSET_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_STRING_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_NUMBER_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_STRINGS_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_DATETIME_FIELD_FRAGMENT}
	${0, $ej0K9.FORGE_OBJECT_FIELD_FRAGMENT}
	${0, $ej0K9.TIME_TRACKING_FIELD_FRAGMENT}
	${0, $ej0K9.WORK_LOG_FIELD_FRAGMENT}
	${0, $ej0K9.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
	${0, $ej0K9.JSM_PEOPLE_FIELD_FRAGMENT}
	${0, $ej0K9.PARENT_LINK_FIELD_FRAGMENT}
	${0, $ej0K9.PARENT_FIELD_FRAGMENT}
	${!isSubtask ? (0, $ej0K9.PROFORMA_CONFIG_FRAGMENT) : ''}
	${0, $ej0K9.STATUS_FIELD_FRAGMENT}
	${0, $ej0K9.WATCHERS_CONFIG_FRAGMENT}
	${!isInContext && !isSubtask ? $28ca85fa6b1691dd$var$getDataClassificationFragment() : ''}
	${0, $ej0K9.STORAGE_LIMITS_FRAGMENT}
	${(0, $aJDWs.isProjectsInJiraM1Enabled)() ? (0, $ej0K9.ATLAS_PROJECT_CONFIG_FRAGMENT) : ''}
`;
};

});
parcelRegister("e0t6Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $a327a54d3ddfdfcd$export$2e2bcd8739ae039);

var $9NQPN = parcelRequire("9NQPN");

var $7lpyQ = parcelRequire("7lpyQ");
var $a327a54d3ddfdfcd$var$docCache = new Map();
var $a327a54d3ddfdfcd$var$fragmentSourceMap = new Map();
var $a327a54d3ddfdfcd$var$printFragmentWarnings = true;
var $a327a54d3ddfdfcd$var$experimentalFragmentVariables = false;
function $a327a54d3ddfdfcd$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $a327a54d3ddfdfcd$var$cacheKeyFromLoc(loc) {
    return $a327a54d3ddfdfcd$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $a327a54d3ddfdfcd$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $a327a54d3ddfdfcd$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $a327a54d3ddfdfcd$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($a327a54d3ddfdfcd$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $a327a54d3ddfdfcd$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $9NQPN.__assign)((0, $9NQPN.__assign)({}, ast), {
        definitions: definitions
    });
}
function $a327a54d3ddfdfcd$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $a327a54d3ddfdfcd$var$parseDocument(source) {
    var cacheKey = $a327a54d3ddfdfcd$var$normalize(source);
    if (!$a327a54d3ddfdfcd$var$docCache.has(cacheKey)) {
        var parsed = (0, $7lpyQ.parse)(source, {
            experimentalFragmentVariables: $a327a54d3ddfdfcd$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $a327a54d3ddfdfcd$var$experimentalFragmentVariables,
            experimentalFragmentArguments: $a327a54d3ddfdfcd$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $a327a54d3ddfdfcd$var$docCache.set(cacheKey, $a327a54d3ddfdfcd$var$stripLoc($a327a54d3ddfdfcd$var$processFragments(parsed)));
    }
    return $a327a54d3ddfdfcd$var$docCache.get(cacheKey);
}
function $a327a54d3ddfdfcd$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $a327a54d3ddfdfcd$var$parseDocument(result);
}
function $a327a54d3ddfdfcd$export$657554ef4dc7ac2d() {
    $a327a54d3ddfdfcd$var$docCache.clear();
    $a327a54d3ddfdfcd$var$fragmentSourceMap.clear();
}
function $a327a54d3ddfdfcd$export$e4294e638636c6ab() {
    $a327a54d3ddfdfcd$var$printFragmentWarnings = false;
}
function $a327a54d3ddfdfcd$export$78cf889af350c840() {
    $a327a54d3ddfdfcd$var$experimentalFragmentVariables = true;
}
function $a327a54d3ddfdfcd$export$5290df9bbbd3cfa() {
    $a327a54d3ddfdfcd$var$experimentalFragmentVariables = false;
}
var $a327a54d3ddfdfcd$var$extras = {
    gql: $a327a54d3ddfdfcd$export$72e4926bf8358653,
    resetCaches: $a327a54d3ddfdfcd$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $a327a54d3ddfdfcd$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $a327a54d3ddfdfcd$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $a327a54d3ddfdfcd$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $a327a54d3ddfdfcd$var$extras.gql, gql_1.resetCaches = $a327a54d3ddfdfcd$var$extras.resetCaches, gql_1.disableFragmentWarnings = $a327a54d3ddfdfcd$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $a327a54d3ddfdfcd$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $a327a54d3ddfdfcd$var$extras.disableExperimentalFragmentVariables;
})($a327a54d3ddfdfcd$export$72e4926bf8358653 || ($a327a54d3ddfdfcd$export$72e4926bf8358653 = {}));
$a327a54d3ddfdfcd$export$72e4926bf8358653["default"] = $a327a54d3ddfdfcd$export$72e4926bf8358653;
var $a327a54d3ddfdfcd$export$2e2bcd8739ae039 = $a327a54d3ddfdfcd$export$72e4926bf8358653;

});
parcelRegister("7lpyQ", function(module, exports) {
$parcel$export(module.exports, "parse", () => $558e5276aea918fc$export$98e6a39c04603d36);

var $2sshc = parcelRequire("2sshc");

var $7tjYS = parcelRequire("7tjYS");

var $l8X7p = parcelRequire("l8X7p");

var $hv0g3 = parcelRequire("hv0g3");

var $cbOv1 = parcelRequire("cbOv1");

var $gvIhO = parcelRequire("gvIhO");

var $5xYGM = parcelRequire("5xYGM");
function $558e5276aea918fc$export$98e6a39c04603d36(source, options) {
    var parser = new $558e5276aea918fc$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $558e5276aea918fc$export$5303528d1070ff6f(source, options) {
    var parser = new $558e5276aea918fc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hv0g3.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hv0g3.TokenKind).EOF);
    return value;
}
function $558e5276aea918fc$export$28b8f402ccc88182(source, options) {
    var parser = new $558e5276aea918fc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hv0g3.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hv0g3.TokenKind).EOF);
    return type;
}
var $558e5276aea918fc$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $cbOv1.isSource)(source) ? source : new (0, $cbOv1.Source)(source);
        this._lexer = new (0, $5xYGM.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hv0g3.TokenKind).NAME);
        return {
            kind: (0, $7tjYS.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $7tjYS.Kind).DOCUMENT,
            definitions: this.many((0, $hv0g3.TokenKind).SOF, this.parseDefinition, (0, $hv0g3.TokenKind).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hv0g3.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hv0g3.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hv0g3.TokenKind).BRACE_L)) return {
            kind: (0, $7tjYS.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hv0g3.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $7tjYS.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hv0g3.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hv0g3.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hv0g3.TokenKind).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $7tjYS.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hv0g3.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hv0g3.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hv0g3.TokenKind).DOLLAR);
        return {
            kind: (0, $7tjYS.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $7tjYS.Kind).SELECTION_SET,
            selections: this.many((0, $hv0g3.TokenKind).BRACE_L, this.parseSelection, (0, $hv0g3.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hv0g3.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hv0g3.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $7tjYS.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hv0g3.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hv0g3.TokenKind).PAREN_L, item, (0, $hv0g3.TokenKind).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hv0g3.TokenKind).COLON);
        return {
            kind: (0, $7tjYS.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $7tjYS.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hv0g3.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hv0g3.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hv0g3.TokenKind).NAME)) return {
            kind: (0, $7tjYS.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $7tjYS.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $7tjYS.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $7tjYS.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hv0g3.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hv0g3.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hv0g3.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $7tjYS.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hv0g3.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $7tjYS.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hv0g3.TokenKind).STRING:
            case (0, $hv0g3.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hv0g3.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $7tjYS.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $7tjYS.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $7tjYS.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $7tjYS.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hv0g3.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $7tjYS.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hv0g3.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $7tjYS.Kind).LIST,
            values: this.any((0, $hv0g3.TokenKind).BRACKET_L, item, (0, $hv0g3.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $7tjYS.Kind).OBJECT,
            fields: this.any((0, $hv0g3.TokenKind).BRACE_L, item, (0, $hv0g3.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hv0g3.TokenKind).COLON);
        return {
            kind: (0, $7tjYS.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hv0g3.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hv0g3.TokenKind).AT);
        return {
            kind: (0, $7tjYS.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hv0g3.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hv0g3.TokenKind).BRACKET_R);
            type = {
                kind: (0, $7tjYS.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hv0g3.TokenKind).BANG)) return {
            kind: (0, $7tjYS.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $7tjYS.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hv0g3.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hv0g3.TokenKind).STRING) || this.peek((0, $hv0g3.TokenKind).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hv0g3.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hv0g3.TokenKind).BRACE_R);
        return {
            kind: (0, $7tjYS.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hv0g3.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $7tjYS.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $7tjYS.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $7tjYS.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hv0g3.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hv0g3.TokenKind).AMP) || this.peek((0, $hv0g3.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hv0g3.TokenKind).AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hv0g3.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hv0g3.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hv0g3.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hv0g3.TokenKind).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hv0g3.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $7tjYS.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hv0g3.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hv0g3.TokenKind).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hv0g3.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hv0g3.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $7tjYS.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $7tjYS.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $7tjYS.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hv0g3.TokenKind).EQUALS) ? this.delimitedMany((0, $hv0g3.TokenKind).PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $7tjYS.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hv0g3.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hv0g3.TokenKind).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $7tjYS.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $7tjYS.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hv0g3.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hv0g3.TokenKind).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hv0g3.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hv0g3.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hv0g3.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $7tjYS.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hv0g3.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $7tjYS.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hv0g3.TokenKind).PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $gvIhO.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $l8X7p.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $2sshc.syntaxError)(this._lexer.source, token.start, "Expected ".concat($558e5276aea918fc$var$getTokenKindDesc(kind), ", found ").concat($558e5276aea918fc$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hv0g3.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $2sshc.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($558e5276aea918fc$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hv0g3.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $2sshc.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($558e5276aea918fc$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $558e5276aea918fc$var$getTokenDesc(token) {
    var value = token.value;
    return $558e5276aea918fc$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $558e5276aea918fc$var$getTokenKindDesc(kind) {
    return (0, $5xYGM.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("2sshc", function(module, exports) {
$parcel$export(module.exports, "syntaxError", () => $1ca4216c1e26ba87$export$bbee0c6176c019d4);

var $dvTCL = parcelRequire("dvTCL");
function $1ca4216c1e26ba87$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $dvTCL.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("dvTCL", function(module, exports) {
$parcel$export(module.exports, "GraphQLError", () => $9d69516f2a33aba1$export$92d6ed0888e7cb7f);

var $aaofT = parcelRequire("aaofT");

var $3TZxj = parcelRequire("3TZxj");

var $gKl3L = parcelRequire("gKl3L");

var $dErSr = parcelRequire("dErSr");

var $gPlPf = parcelRequire("gPlPf");
function $9d69516f2a33aba1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9d69516f2a33aba1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9d69516f2a33aba1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9d69516f2a33aba1$var$_typeof(obj);
}
function $9d69516f2a33aba1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9d69516f2a33aba1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9d69516f2a33aba1$var$ownKeys(Object(source), true).forEach(function(key) {
            $9d69516f2a33aba1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9d69516f2a33aba1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9d69516f2a33aba1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9d69516f2a33aba1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9d69516f2a33aba1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9d69516f2a33aba1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9d69516f2a33aba1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9d69516f2a33aba1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9d69516f2a33aba1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9d69516f2a33aba1$var$_setPrototypeOf(subClass, superClass);
}
function $9d69516f2a33aba1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9d69516f2a33aba1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9d69516f2a33aba1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9d69516f2a33aba1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9d69516f2a33aba1$var$_possibleConstructorReturn(this, result);
    };
}
function $9d69516f2a33aba1$var$_possibleConstructorReturn(self, call) {
    if (call && ($9d69516f2a33aba1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9d69516f2a33aba1$var$_assertThisInitialized(self);
}
function $9d69516f2a33aba1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9d69516f2a33aba1$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9d69516f2a33aba1$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$9d69516f2a33aba1$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $9d69516f2a33aba1$var$_construct(Class, arguments, $9d69516f2a33aba1$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $9d69516f2a33aba1$var$_setPrototypeOf(Wrapper, Class);
    };
    return $9d69516f2a33aba1$var$_wrapNativeSuper(Class);
}
function $9d69516f2a33aba1$var$_construct(Parent, args, Class) {
    if ($9d69516f2a33aba1$var$_isNativeReflectConstruct()) $9d69516f2a33aba1$var$_construct = Reflect.construct;
    else $9d69516f2a33aba1$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $9d69516f2a33aba1$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $9d69516f2a33aba1$var$_construct.apply(null, arguments);
}
function $9d69516f2a33aba1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9d69516f2a33aba1$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $9d69516f2a33aba1$var$_setPrototypeOf(o, p) {
    $9d69516f2a33aba1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9d69516f2a33aba1$var$_setPrototypeOf(o, p);
}
function $9d69516f2a33aba1$var$_getPrototypeOf(o) {
    $9d69516f2a33aba1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9d69516f2a33aba1$var$_getPrototypeOf(o);
}
var $9d69516f2a33aba1$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $9d69516f2a33aba1$var$_inherits(GraphQLError, _Error);
    var _super = $9d69516f2a33aba1$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $9d69516f2a33aba1$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $9d69516f2a33aba1$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $9d69516f2a33aba1$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $dErSr.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $dErSr.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $3TZxj.default)(originalExtensions)) _this.extensions = $9d69516f2a33aba1$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($9d69516f2a33aba1$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($9d69516f2a33aba1$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $9d69516f2a33aba1$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($9d69516f2a33aba1$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($9d69516f2a33aba1$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $9d69516f2a33aba1$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $9d69516f2a33aba1$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $9d69516f2a33aba1$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gKl3L.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $9d69516f2a33aba1$var$_wrapNativeSuper(Error));
function $9d69516f2a33aba1$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $9d69516f2a33aba1$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $gPlPf.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $gPlPf.printSourceLocation)(error.source, location);
    }
    return output;
}
function $9d69516f2a33aba1$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $aaofT.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("aaofT", function(module, exports) {
$parcel$export(module.exports, "default", () => $766da72bef75ca45$export$2e2bcd8739ae039);
function $766da72bef75ca45$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("3TZxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d763dfd2ae59576$export$2e2bcd8739ae039);
function $2d763dfd2ae59576$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2d763dfd2ae59576$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2d763dfd2ae59576$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2d763dfd2ae59576$var$_typeof(obj);
}
function $2d763dfd2ae59576$export$2e2bcd8739ae039(value) {
    return $2d763dfd2ae59576$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gKl3L", function(module, exports) {
$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $c3114741238383cb$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $c3114741238383cb$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $c3114741238383cb$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $c3114741238383cb$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $c3114741238383cb$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $c3114741238383cb$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("dErSr", function(module, exports) {
$parcel$export(module.exports, "getLocation", () => $9f04a29dd0dd4099$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $9f04a29dd0dd4099$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("gPlPf", function(module, exports) {
$parcel$export(module.exports, "printLocation", () => $c40256dc6dc84b53$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $c40256dc6dc84b53$export$867940333fd9f869);

var $dErSr = parcelRequire("dErSr");
function $c40256dc6dc84b53$export$96a9681e539deed(location) {
    return $c40256dc6dc84b53$export$867940333fd9f869(location.source, (0, $dErSr.getLocation)(location.source, location.start));
}
function $c40256dc6dc84b53$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $c40256dc6dc84b53$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $c40256dc6dc84b53$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $c40256dc6dc84b53$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $c40256dc6dc84b53$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $c40256dc6dc84b53$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $c40256dc6dc84b53$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $c40256dc6dc84b53$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $c40256dc6dc84b53$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $c40256dc6dc84b53$var$leftPad(len, str) {
    return $c40256dc6dc84b53$var$whitespace(len - str.length) + str;
}

});



parcelRegister("7tjYS", function(module, exports) {
$parcel$export(module.exports, "Kind", () => $570abda3d784a65f$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $570abda3d784a65f$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hv0g3", function(module, exports) {
$parcel$export(module.exports, "TokenKind", () => $cbd588230149d42a$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $cbd588230149d42a$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("cbOv1", function(module, exports) {
$parcel$export(module.exports, "Source", () => $8dfdaf3ffc1e12cc$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $8dfdaf3ffc1e12cc$export$75135ee9ed6e435b);

var $gKl3L = parcelRequire("gKl3L");

var $9nV2v = parcelRequire("9nV2v");

var $aaofT = parcelRequire("aaofT");

var $2whS5 = parcelRequire("2whS5");
function $8dfdaf3ffc1e12cc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8dfdaf3ffc1e12cc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8dfdaf3ffc1e12cc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8dfdaf3ffc1e12cc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $8dfdaf3ffc1e12cc$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $aaofT.default)(0, "Body must be a string. Received: ".concat((0, $9nV2v.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $aaofT.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $aaofT.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $8dfdaf3ffc1e12cc$var$_createClass(Source, [
        {
            key: (0, $gKl3L.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $8dfdaf3ffc1e12cc$export$75135ee9ed6e435b(source) {
    return (0, $2whS5.default)(source, $8dfdaf3ffc1e12cc$export$1d2df86270c81ecb);
}

});
parcelRegister("2whS5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d5c6ec9a5ad0a19$export$2e2bcd8739ae039);

function $1d5c6ec9a5ad0a19$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1d5c6ec9a5ad0a19$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1d5c6ec9a5ad0a19$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1d5c6ec9a5ad0a19$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$1d5c6ec9a5ad0a19$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("gvIhO", function(module, exports) {
$parcel$export(module.exports, "DirectiveLocation", () => $c051e4eecf982e15$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $c051e4eecf982e15$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("5xYGM", function(module, exports) {
$parcel$export(module.exports, "Lexer", () => $010ad309e14a0a00$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $010ad309e14a0a00$export$59ac0f4da287406a);

var $2sshc = parcelRequire("2sshc");

var $l8X7p = parcelRequire("l8X7p");

var $hv0g3 = parcelRequire("hv0g3");

var $2EBvW = parcelRequire("2EBvW");
var $010ad309e14a0a00$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hv0g3.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $010ad309e14a0a00$var$readToken(this, token);
        }while (token.kind === (0, $hv0g3.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $010ad309e14a0a00$export$59ac0f4da287406a(kind) {
    return kind === (0, $hv0g3.TokenKind).BANG || kind === (0, $hv0g3.TokenKind).DOLLAR || kind === (0, $hv0g3.TokenKind).AMP || kind === (0, $hv0g3.TokenKind).PAREN_L || kind === (0, $hv0g3.TokenKind).PAREN_R || kind === (0, $hv0g3.TokenKind).SPREAD || kind === (0, $hv0g3.TokenKind).COLON || kind === (0, $hv0g3.TokenKind).EQUALS || kind === (0, $hv0g3.TokenKind).AT || kind === (0, $hv0g3.TokenKind).BRACKET_L || kind === (0, $hv0g3.TokenKind).BRACKET_R || kind === (0, $hv0g3.TokenKind).BRACE_L || kind === (0, $hv0g3.TokenKind).PIPE || kind === (0, $hv0g3.TokenKind).BRACE_R;
}
function $010ad309e14a0a00$var$printCharCode(code) {
    return isNaN(code) ? (0, $hv0g3.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $010ad309e14a0a00$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $010ad309e14a0a00$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $010ad309e14a0a00$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $010ad309e14a0a00$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $010ad309e14a0a00$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $010ad309e14a0a00$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $2sshc.syntaxError)(source, pos, $010ad309e14a0a00$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $010ad309e14a0a00$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($010ad309e14a0a00$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($010ad309e14a0a00$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $010ad309e14a0a00$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $010ad309e14a0a00$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $2sshc.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($010ad309e14a0a00$var$printCharCode(code), "."));
    } else {
        position = $010ad309e14a0a00$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $010ad309e14a0a00$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $010ad309e14a0a00$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $010ad309e14a0a00$var$isNameStart(code)) throw (0, $2sshc.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($010ad309e14a0a00$var$printCharCode(code), "."));
    return new (0, $l8X7p.Token)(isFloat ? (0, $hv0g3.TokenKind).FLOAT : (0, $hv0g3.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $010ad309e14a0a00$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $2sshc.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($010ad309e14a0a00$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $010ad309e14a0a00$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $2sshc.syntaxError)(source, position, "Invalid character within String: ".concat($010ad309e14a0a00$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $010ad309e14a0a00$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $2sshc.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $2sshc.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $2sshc.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $010ad309e14a0a00$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $2EBvW.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $2sshc.syntaxError)(source, position, "Invalid character within String: ".concat($010ad309e14a0a00$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $2sshc.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $010ad309e14a0a00$var$uniCharCode(a, b, c, d) {
    return $010ad309e14a0a00$var$char2hex(a) << 12 | $010ad309e14a0a00$var$char2hex(b) << 8 | $010ad309e14a0a00$var$char2hex(c) << 4 | $010ad309e14a0a00$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $010ad309e14a0a00$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $010ad309e14a0a00$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $l8X7p.Token)((0, $hv0g3.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $010ad309e14a0a00$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("ej0K9", function(module, exports) {
$parcel$export(module.exports, "getLayoutFragment", () => $bee71aa7fb34f807$export$e95015dcbe735de8);
$parcel$export(module.exports, "getLayoutFragmentName", () => $bee71aa7fb34f807$export$b986b980953c5bea);
$parcel$export(module.exports, "BASE_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$e61b49f54d551a76);
$parcel$export(module.exports, "BASE_FIELD_FRAGMENT_WITH_CREATE_CONTEXT_OPTION_ARI", () => $bee71aa7fb34f807$export$212eb1d8e6614c6b);
$parcel$export(module.exports, "PROJECT_WITHOUT_CLASSIFICATION", () => $bee71aa7fb34f807$export$c697769cce672aaf);
$parcel$export(module.exports, "PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION", () => $bee71aa7fb34f807$export$9594a6b1142bdd10);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$5b50a50ed83e9899);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_FRAGMENT_WITH_HIERARCHY", () => $bee71aa7fb34f807$export$391a5627b1d9ac75);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT_WITH_HIERARCHY", () => $bee71aa7fb34f807$export$10098ddb3ecbb1d7);
$parcel$export(module.exports, "TEXT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$636915305cba61ee);
$parcel$export(module.exports, "CONNECT_TEXT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$3cd5b2049171ec4c);
$parcel$export(module.exports, "FORGE_STRING_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$ebc024aa691e4d85);
$parcel$export(module.exports, "RICH_TEXT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$5b0963f21dba94f8);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$7f0a2ff1b7c9ca01);
$parcel$export(module.exports, "FORGE_OBJECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$689ca997bd170b37);
$parcel$export(module.exports, "COMPONENTS_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$ab0555e54f8994f9);
$parcel$export(module.exports, "COMPONENTS_FIELD_FRAGMENT_ASYNC_OPTIONS", () => $bee71aa7fb34f807$export$eb88d3e29426e7f3);
$parcel$export(module.exports, "SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$28f68e0bae1ee7f3);
$parcel$export(module.exports, "FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$1f16b392b8d9b666);
$parcel$export(module.exports, "MULTI_USER_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$b2adb4bd3df183ed);
$parcel$export(module.exports, "JSM_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$fffb689cf69ab0a2);
$parcel$export(module.exports, "FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$c43dfb9e201b83a2);
$parcel$export(module.exports, "PEOPLE_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$2b791aa6cca603ee);
$parcel$export(module.exports, "JSM_PEOPLE_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$b043dc06c0d2d4f8);
$parcel$export(module.exports, "NUMBER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$874202730a4f96be);
$parcel$export(module.exports, "CONNECT_NUMBER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$82ff38b10f06144a);
$parcel$export(module.exports, "FORGE_NUMBER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$87f4b71855b27f75);
$parcel$export(module.exports, "DATE_TIME_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$bbf5ba5f74471361);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED", () => $bee71aa7fb34f807$export$34262a4d713ee65e);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_REFINED", () => $bee71aa7fb34f807$export$94d9188aeb6b5618);
$parcel$export(module.exports, "FORGE_DATETIME_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$7009d41cc723dac);
$parcel$export(module.exports, "DATE_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$bb1ac816b515a7c);
$parcel$export(module.exports, "EPIC_LINK_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$47036e8bdf2c9326);
$parcel$export(module.exports, "LABEL_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$85cf307e24504b19);
$parcel$export(module.exports, "FORGE_STRINGS_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$9255ce322dbd4481);
$parcel$export(module.exports, "VERSION_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$37deee440fbd3c5);
$parcel$export(module.exports, "VERSION_FIELD_FRAGMENT_ASYNC_OPTIONS", () => $bee71aa7fb34f807$export$f0da1f9fc8380967);
$parcel$export(module.exports, "MULTI_VERSION_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$ffdfaa2ab8110c87);
$parcel$export(module.exports, "MULTI_VERSION_FIELD_FRAGMENT_ASYNC_OPTIONS", () => $bee71aa7fb34f807$export$f3e3753f83aea7e6);
$parcel$export(module.exports, "PRIORITY_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$63d6d00b6349a8fd);
$parcel$export(module.exports, "ATTACHMENTS_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$8ca944b20979f689);
$parcel$export(module.exports, "STORAGE_LIMITS_FRAGMENT", () => $bee71aa7fb34f807$export$faa49a05080716db);
$parcel$export(module.exports, "SECURITY_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$e0034adc460157a3);
$parcel$export(module.exports, "ISSUE_RESTRICTION_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$a4e0bff5a9855a6a);
$parcel$export(module.exports, "URL_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$55232ce79978fe60);
$parcel$export(module.exports, "CHECKBOX_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$2a0a6d36d97ce992);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$2bba3db49a112c62);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$f63043138eca54b8);
$parcel$export(module.exports, "MULTI_SELECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$494028c0baaef0a5);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$a5740cd9553dc3be);
$parcel$export(module.exports, "RADIO_SELECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$8a8492487a98fdaa);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$c525f571cbe1dcbb);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT_WITH_ORG_DEFAULT", () => $bee71aa7fb34f807$export$a8067ca2aedbcf48);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT_WITH_CLASSIFICATION_CONTROL", () => $bee71aa7fb34f807$export$206ec5fd5726be3d);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$1507bfa8951ee68d);
$parcel$export(module.exports, "FORGE_GROUP_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$51d039d4ec21f704);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$4c4a76b99fc5f54e);
$parcel$export(module.exports, "FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$ae231dc96d2638ab);
$parcel$export(module.exports, "SPRINT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$aba335b21420357f);
$parcel$export(module.exports, "COLOR_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$585571cdf68c55a1);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$201be0ff29129622);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $bee71aa7fb34f807$export$589a6183e9780424);
$parcel$export(module.exports, "RESOLUTION_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$31c88001934c2e15);
$parcel$export(module.exports, "CASCADING_SELECT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$2f9cfac026740bd3);
$parcel$export(module.exports, "TEAM_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$cb70b12f3de3f41c);
$parcel$export(module.exports, "ATLASSIAN_TEAM_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$1173888d99fd7ae6);
$parcel$export(module.exports, "ASSET_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$97cdf1e4b8832240);
$parcel$export(module.exports, "AFFECTED_SERVICES_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$3480d890dca64b9e);
$parcel$export(module.exports, "CMDB_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$c1864cedbeda248a);
$parcel$export(module.exports, "ORGANIZATIONS_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$e0f3793fd890e0);
$parcel$export(module.exports, "TIME_TRACKING_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$f9e6189fd786f6);
$parcel$export(module.exports, "WORK_LOG_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$c6c1a1f3d6f49ea4);
$parcel$export(module.exports, "PARENT_LINK_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$fa778835050523e6);
$parcel$export(module.exports, "PARENT_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$f75050611ceb9d35);
$parcel$export(module.exports, "STATUS_FIELD_FRAGMENT", () => $bee71aa7fb34f807$export$f89396a6b77b653f);
$parcel$export(module.exports, "PROFORMA_CONFIG_FRAGMENT", () => $bee71aa7fb34f807$export$5f06542accc83cb5);
$parcel$export(module.exports, "WATCHERS_CONFIG_FRAGMENT", () => $bee71aa7fb34f807$export$eda8fbd7533aaac1);
$parcel$export(module.exports, "ATLAS_PROJECT_CONFIG_FRAGMENT", () => $bee71aa7fb34f807$export$ddf4ac4d74647910);
/* eslint-disable jira/filename-case */ 
var $e0t6Q = parcelRequire("e0t6Q");

var $2700E = parcelRequire("2700E");
const $bee71aa7fb34f807$export$f625f330d228b694 = (0, $e0t6Q.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $bee71aa7fb34f807$export$c62f67b4f409a5c6 = (0, $e0t6Q.default)`
	fragment LayoutFragmentWithML on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					collapsedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $bee71aa7fb34f807$export$9a486723a2a1f86d = (0, $e0t6Q.default)`
	fragment LayoutFragmentWithRankedItems on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					collapsedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					rankedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $bee71aa7fb34f807$export$4df9fd5d55281538 = (0, $e0t6Q.default)`
	fragment LayoutFragmentWithRankedItemsNoML on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					rankedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
function $bee71aa7fb34f807$export$e95015dcbe735de8(withML) {
    if ((0, $2700E.expVal)('show-more-relevant-fields-in-quick-create-exp', 'isEnabled', false)) {
        if (withML) return $bee71aa7fb34f807$export$9a486723a2a1f86d;
        return $bee71aa7fb34f807$export$4df9fd5d55281538;
    }
    if (withML) return $bee71aa7fb34f807$export$c62f67b4f409a5c6;
    return $bee71aa7fb34f807$export$f625f330d228b694;
}
function $bee71aa7fb34f807$export$b986b980953c5bea(fragment) {
    const definition = fragment.definitions[0];
    if (definition?.kind !== 'FragmentDefinition') throw new Error('Expected a layout fragment definition');
    return definition.name.value;
}
const $bee71aa7fb34f807$export$e61b49f54d551a76 = (0, $e0t6Q.default)`
	fragment BaseFieldFragment on JiraIssueField {
		fieldId
		name
		type
		description
		... on JiraIssueFieldConfiguration {
			fieldConfig {
				isRequired
				isEditable
				nonEditableReason {
					message
				}
			}
		}
	}
`;
const $bee71aa7fb34f807$export$212eb1d8e6614c6b = (0, $e0t6Q.default)`
	fragment BaseFieldWithAriFragment on JiraIssueField {
		fieldId
		name
		type
		description
		issueFieldCreateContextOptionAri
		... on JiraIssueFieldConfiguration {
			fieldConfig {
				isRequired
				isEditable
				nonEditableReason {
					message
				}
			}
		}
	}
`;
const $bee71aa7fb34f807$export$c697769cce672aaf = (0, $e0t6Q.default)`
	fragment Project on JiraProject {
		id: projectId
		name
		avatar {
			large
		}
		projectType
		simplified
		key
		isAIEnabled
	}
`;
const $bee71aa7fb34f807$export$9594a6b1142bdd10 = (0, $e0t6Q.default)`
	fragment ProjectFieldFragmentWithoutClassification on JiraProjectField {
		project {
			...Project
		}
		searchUrl
	}
	${$bee71aa7fb34f807$export$c697769cce672aaf}
`;
/* issuetype field */ const $bee71aa7fb34f807$var$ISSUE_TYPE = (0, $e0t6Q.default)`
	fragment IssueType on JiraIssueType {
		id: issueTypeId
		name
		avatar {
			large
		}
	}
`;
const $bee71aa7fb34f807$var$ISSUE_TYPE_WITH_HIERARCHY = (0, $e0t6Q.default)`
	fragment IssueTypeWithHierarchy on JiraIssueType {
		id: issueTypeId
		name
		avatar {
			large
		}
		hierarchy {
			level
		}
	}
`;
const $bee71aa7fb34f807$export$5b50a50ed83e9899 = (0, $e0t6Q.default)`
	fragment IssueTypeFieldFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes {
			nodes {
				...IssueType
			}
		}
	}
	${$bee71aa7fb34f807$var$ISSUE_TYPE}
`;
const $bee71aa7fb34f807$export$391a5627b1d9ac75 = (0, $e0t6Q.default)`
	fragment IssueTypeFieldFragmentWithHierarchy on JiraIssueTypeField {
		issueType {
			...IssueTypeWithHierarchy
		}
		issueTypes {
			nodes {
				...IssueTypeWithHierarchy
			}
		}
	}
	${$bee71aa7fb34f807$var$ISSUE_TYPE_WITH_HIERARCHY}
`;
const $bee71aa7fb34f807$export$410d36690ebc2ef6 = (0, $e0t6Q.default)`
	fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes(searchBy: $issueTypes) {
			nodes {
				...IssueType
			}
		}
	}
	${$bee71aa7fb34f807$var$ISSUE_TYPE}
`;
const $bee71aa7fb34f807$export$10098ddb3ecbb1d7 = (0, $e0t6Q.default)`
	fragment IssueTypeFieldSearchFragmentWithHierarchy on JiraIssueTypeField {
		issueType {
			...IssueTypeWithHierarchy
		}
		issueTypes(searchBy: $issueTypes) {
			nodes {
				...IssueTypeWithHierarchy
			}
		}
	}
	${$bee71aa7fb34f807$var$ISSUE_TYPE_WITH_HIERARCHY}
`;
const $bee71aa7fb34f807$export$636915305cba61ee = (0, $e0t6Q.default)`
	fragment TextFieldFragment on JiraSingleLineTextField {
		text
	}
`;
const $bee71aa7fb34f807$export$3cd5b2049171ec4c = (0, $e0t6Q.default)`
	fragment ConnectTextFieldFragment on JiraConnectTextField {
		text
	}
`;
const $bee71aa7fb34f807$export$ebc024aa691e4d85 = (0, $e0t6Q.default)`
	fragment ForgeStringFieldFragment on JiraForgeStringField {
		text
	}
`;
const $bee71aa7fb34f807$var$MEDIA_CONTEXT_FRAGMENT = (0, $e0t6Q.default)`
	fragment JiraMediaContextFragment on JiraMediaContext {
		uploadToken {
			... on JiraMediaUploadToken {
				endpointUrl
				clientId
				targetCollection
				token
				tokenDurationInMin
			}
			... on QueryError {
				message
			}
		}
	}
`;
const $bee71aa7fb34f807$var$ADMIN_RICH_TEXT_FIELD_CONFIG_FRAGMENT = (0, $e0t6Q.default)`
	fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
		adminRichTextConfig {
			aiEnabledByProject
		}
	}
`;
const $bee71aa7fb34f807$export$5b0963f21dba94f8 = (0, $e0t6Q.default)`
	fragment RichTextFieldFragment on JiraRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
		...JiraAdminRichTextFieldConfigFragment
	}
	${$bee71aa7fb34f807$var$MEDIA_CONTEXT_FRAGMENT}
	${$bee71aa7fb34f807$var$ADMIN_RICH_TEXT_FIELD_CONFIG_FRAGMENT}
`;
const $bee71aa7fb34f807$export$7f0a2ff1b7c9ca01 = (0, $e0t6Q.default)`
	fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$bee71aa7fb34f807$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $bee71aa7fb34f807$export$689ca997bd170b37 = (0, $e0t6Q.default)`
	fragment ForgeObjectFieldFragment on JiraForgeObjectField {
		object
	}
`;
/* components field */ const $bee71aa7fb34f807$var$COMPONENT = (0, $e0t6Q.default)`
	fragment Component on JiraComponent {
		id: componentId
		name
	}
`;
const $bee71aa7fb34f807$export$ab0555e54f8994f9 = (0, $e0t6Q.default)`
	fragment ComponentsFieldFragment on JiraComponentsField {
		selectedComponents {
			...Component
		}
		components {
			nodes {
				...Component
			}
		}
	}
	${$bee71aa7fb34f807$var$COMPONENT}
`;
const $bee71aa7fb34f807$export$eb88d3e29426e7f3 = (0, $e0t6Q.default)`
	fragment ComponentsFieldFragmentAsyncOptions on JiraComponentsField {
		selectedComponents {
			...Component
		}
		components(first: 1) {
			nodes {
				...Component
			}
		}
	}
	${$bee71aa7fb34f807$var$COMPONENT}
`;
/* user picker */ const $bee71aa7fb34f807$var$USER = (0, $e0t6Q.default)`
	fragment UserFragment on User {
		accountId
		name
		picture
	}
`;
const $bee71aa7fb34f807$export$28f68e0bae1ee7f3 = (0, $e0t6Q.default)`
	fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$1f16b392b8d9b666 = (0, $e0t6Q.default)`
	fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$b2adb4bd3df183ed = (0, $e0t6Q.default)`
	fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$fffb689cf69ab0a2 = (0, $e0t6Q.default)`
	fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$c43dfb9e201b83a2 = (0, $e0t6Q.default)`
	fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$2b791aa6cca603ee = (0, $e0t6Q.default)`
	fragment PeopleFieldFragment on JiraPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$b043dc06c0d2d4f8 = (0, $e0t6Q.default)`
	fragment JsmPeopleFieldFragment on JsmPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$bee71aa7fb34f807$var$USER}
`;
const $bee71aa7fb34f807$export$874202730a4f96be = (0, $e0t6Q.default)`
	fragment NumberFieldFragment on JiraNumberField {
		number
		formatConfig @include(if: $withNumberFormat) {
			formatStyle
			formatUnit
			formatDecimals
		}
	}
`;
const $bee71aa7fb34f807$export$82ff38b10f06144a = (0, $e0t6Q.default)`
	fragment ConnectNumberFieldFragment on JiraConnectNumberField {
		number
	}
`;
const $bee71aa7fb34f807$export$87f4b71855b27f75 = (0, $e0t6Q.default)`
	fragment ForgeNumberFieldFragment on JiraForgeNumberField {
		number
	}
`;
const $bee71aa7fb34f807$export$bbf5ba5f74471361 = (0, $e0t6Q.default)`
	fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
		dateTime
	}
`;
const $bee71aa7fb34f807$export$34262a4d713ee65e = (0, $e0t6Q.default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
const $bee71aa7fb34f807$export$94d9188aeb6b5618 = (0, $e0t6Q.default)`
	fragment IssueLinksFieldFragmentRefined on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
const $bee71aa7fb34f807$export$7009d41cc723dac = (0, $e0t6Q.default)`
	fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
		dateTime
	}
`;
const $bee71aa7fb34f807$export$bb1ac816b515a7c = (0, $e0t6Q.default)`
	fragment DatePickerFieldFragment on JiraDatePickerField {
		date
	}
`;
/* epic-link field */ const $bee71aa7fb34f807$var$EPIC = (0, $e0t6Q.default)`
	fragment Epic on JiraEpic {
		name
		key
		summary
	}
`;
const $bee71aa7fb34f807$export$47036e8bdf2c9326 = (0, $e0t6Q.default)`
	fragment EpicLinkFieldFragment on JiraEpicLinkField {
		epic {
			...Epic
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$EPIC}
`;
/* labels field */ const $bee71aa7fb34f807$var$LABEL = (0, $e0t6Q.default)`
	fragment Label on JiraLabel {
		id: labelId
		name
	}
`;
const $bee71aa7fb34f807$var$LABEL_WITH_COLOR = (0, $e0t6Q.default)`
	fragment LabelWithColor on JiraLabel {
		id: labelId
		name
		color {
			colorKey
		}
	}
`;
const $bee71aa7fb34f807$export$85cf307e24504b19 = (0, $e0t6Q.default)`
	fragment LabelFieldFragment on JiraLabelsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$LABEL}
`;
const $bee71aa7fb34f807$export$73096e5a8439e28e = (0, $e0t6Q.default)`
	fragment LabelWithColorFieldFragment on JiraLabelsField {
		selectedLabels {
			...LabelWithColor
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$LABEL_WITH_COLOR}
`;
const $bee71aa7fb34f807$export$9255ce322dbd4481 = (0, $e0t6Q.default)`
	fragment ForgeStringsFieldFragment on JiraForgeStringsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$LABEL}
`;
/* versions field */ const $bee71aa7fb34f807$var$VERSION = (0, $e0t6Q.default)`
	fragment Version on JiraVersion {
		id: versionId
		name
		status
	}
`;
const $bee71aa7fb34f807$export$37deee440fbd3c5 = (0, $e0t6Q.default)`
	fragment VersionFieldFragment on JiraSingleVersionPickerField {
		version {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$bee71aa7fb34f807$var$VERSION}
`;
const $bee71aa7fb34f807$export$f0da1f9fc8380967 = (0, $e0t6Q.default)`
	fragment VersionFieldFragmentAsyncOptions on JiraSingleVersionPickerField {
		version {
			...Version
		}
		versions(first: 1) {
			nodes {
				...Version
			}
		}
	}
	${$bee71aa7fb34f807$var$VERSION}
`;
const $bee71aa7fb34f807$export$ffdfaa2ab8110c87 = (0, $e0t6Q.default)`
	fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
		selectedVersions {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$bee71aa7fb34f807$var$VERSION}
`;
const $bee71aa7fb34f807$export$f3e3753f83aea7e6 = (0, $e0t6Q.default)`
	fragment MultiVersionFieldFragmentAsyncOptions on JiraMultipleVersionPickerField {
		selectedVersions {
			...Version
		}
		versions(first: 1) {
			nodes {
				...Version
			}
		}
	}
	${$bee71aa7fb34f807$var$VERSION}
`;
/* priority field */ const $bee71aa7fb34f807$var$PRIORITY = (0, $e0t6Q.default)`
	fragment Priority on JiraPriority {
		name
		id: priorityId
		iconUrl
	}
`;
const $bee71aa7fb34f807$export$63d6d00b6349a8fd = (0, $e0t6Q.default)`
	fragment PriorityFieldFragment on JiraPriorityField {
		priority {
			...Priority
		}
		priorities {
			nodes {
				...Priority
			}
		}
	}
	${$bee71aa7fb34f807$var$PRIORITY}
`;
/* issue link field */ // schema needs to be updated
/* security field */ const $bee71aa7fb34f807$var$SECURITY_LEVEL = (0, $e0t6Q.default)`
	fragment SecurityLevel on JiraSecurityLevel {
		id: securityId
		name
		description
	}
`;
const $bee71aa7fb34f807$export$8ca944b20979f689 = (0, $e0t6Q.default)`
	fragment AttachmentsFieldFragment on JiraAttachmentsField {
		maxAllowedTotalAttachmentsSize
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$bee71aa7fb34f807$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $bee71aa7fb34f807$export$faa49a05080716db = (0, $e0t6Q.default)`
	fragment StorageLimitsFragment on JiraQuery {
		attachmentStorageAllowed(cloudId: $cloudId, applicationKey: $applicationKey)
		attachmentStorageUsed(cloudId: $cloudId, applicationKey: $applicationKey)
		attachmentStorageIsUnlimited(cloudId: $cloudId, applicationKey: $applicationKey)
	}
`;
const $bee71aa7fb34f807$export$e0034adc460157a3 = (0, $e0t6Q.default)`
	fragment SecurityFieldFragment on JiraSecurityLevelField {
		securityLevel {
			...SecurityLevel
		}
		securityLevels {
			nodes {
				...SecurityLevel
			}
		}
	}
	${$bee71aa7fb34f807$var$SECURITY_LEVEL}
`;
/* issue restriction field */ const $bee71aa7fb34f807$var$USER_ROLES = (0, $e0t6Q.default)`
	fragment UserRoles on JiraRole {
		roleId
	}
`;
const $bee71aa7fb34f807$export$a4e0bff5a9855a6a = (0, $e0t6Q.default)`
	fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
		selectedRoles {
			...UserRoles
		}
	}
	${$bee71aa7fb34f807$var$USER_ROLES}
`;
const $bee71aa7fb34f807$export$55232ce79978fe60 = (0, $e0t6Q.default)`
	fragment UrlFieldFragment on JiraUrlField {
		url
	}
`;
/* checkbox field */ const $bee71aa7fb34f807$var$OPTION = (0, $e0t6Q.default)`
	fragment Option on JiraOption {
		id: optionId
		value
	}
`;
const $bee71aa7fb34f807$export$2a0a6d36d97ce992 = (0, $e0t6Q.default)`
	fragment CheckboxFieldFragment on JiraCheckboxesField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
const $bee71aa7fb34f807$export$2bba3db49a112c62 = (0, $e0t6Q.default)`
	fragment SingleSelectFieldFragment on JiraSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
const $bee71aa7fb34f807$export$f63043138eca54b8 = (0, $e0t6Q.default)`
	fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
const $bee71aa7fb34f807$export$494028c0baaef0a5 = (0, $e0t6Q.default)`
	fragment MultiSelectFieldFragment on JiraMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
const $bee71aa7fb34f807$export$a5740cd9553dc3be = (0, $e0t6Q.default)`
	fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
const $bee71aa7fb34f807$export$8a8492487a98fdaa = (0, $e0t6Q.default)`
	fragment RadioSelectFieldFragment on JiraRadioSelectField {
		selectedOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
/* data classification field */ const $bee71aa7fb34f807$var$CLASSIFICATION_OPTION = (0, $e0t6Q.default)`
	fragment ClassificationLevel on JiraClassificationLevel {
		id
		name
		color {
			colorKey
		}
		definition
		status
	}
`;
const $bee71aa7fb34f807$export$c525f571cbe1dcbb = (0, $e0t6Q.default)`
	fragment DataClassificationFieldFragment on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
	}
	${$bee71aa7fb34f807$var$CLASSIFICATION_OPTION}
`;
const $bee71aa7fb34f807$export$a8067ca2aedbcf48 = (0, $e0t6Q.default)`
	fragment DataClassificationFieldFragmentWithOrgDefault on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		organizationClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
	}
	${$bee71aa7fb34f807$var$CLASSIFICATION_OPTION}
`;
const $bee71aa7fb34f807$export$206ec5fd5726be3d = (0, $e0t6Q.default)`
	fragment DataClassificationFieldFragmentWithClassificationControl on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		organizationClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
		classificationControl
		classificationLevelSource
		userOverride
		lowestLevelPermittedSource
	}
	${$bee71aa7fb34f807$var$CLASSIFICATION_OPTION}
`;
/* group picker field fragment */ const $bee71aa7fb34f807$var$GROUP = (0, $e0t6Q.default)`
	fragment Group on JiraGroup {
		groupId
		name
	}
`;
const $bee71aa7fb34f807$export$1507bfa8951ee68d = (0, $e0t6Q.default)`
	fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$GROUP}
`;
const $bee71aa7fb34f807$export$51d039d4ec21f704 = (0, $e0t6Q.default)`
	fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$GROUP}
`;
const $bee71aa7fb34f807$export$4c4a76b99fc5f54e = (0, $e0t6Q.default)`
	fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$GROUP}
`;
const $bee71aa7fb34f807$export$ae231dc96d2638ab = (0, $e0t6Q.default)`
	fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$GROUP}
`;
const $bee71aa7fb34f807$export$d9b12eb20c31129b = (0, $e0t6Q.default)`
	fragment MultiLineTextFieldFragment on JiraMultiLineTextField {
		text
	}
`;
/* sprint field */ const $bee71aa7fb34f807$var$SPRINT = (0, $e0t6Q.default)`
	fragment Sprint on JiraSprint {
		sprintId
		name
		state
	}
`;
const $bee71aa7fb34f807$export$aba335b21420357f = (0, $e0t6Q.default)`
	fragment SprintFieldFragment on JiraSprintField {
		selectedSprints {
			...Sprint
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$SPRINT}
`;
const $bee71aa7fb34f807$export$585571cdf68c55a1 = (0, $e0t6Q.default)`
	fragment ColorFieldFragment on JiraColorField {
		color {
			colorKey
		}
	}
`;
/* request type field */ const $bee71aa7fb34f807$var$REQUEST_TYPE = (0, $e0t6Q.default)`
	fragment RequestType on JsmRequestType {
		requestTypeId
		name
		description
		helpText
		key
		issueType {
			issueTypeId
		}
		avatar {
			large
		}
		practices {
			key
		}
	}
`;
const $bee71aa7fb34f807$export$201be0ff29129622 = (0, $e0t6Q.default)`
	fragment RequestTypeFieldFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes {
			nodes {
				...RequestType
			}
		}
	}
	${$bee71aa7fb34f807$var$REQUEST_TYPE}
`;
const $bee71aa7fb34f807$export$589a6183e9780424 = (0, $e0t6Q.default)`
	fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes(searchBy: $requestTypes) {
			nodes {
				...RequestType
			}
		}
	}
	${$bee71aa7fb34f807$var$REQUEST_TYPE}
`;
/* resolution field */ const $bee71aa7fb34f807$var$RESOLUTION = (0, $e0t6Q.default)`
	fragment Resolution on JiraResolution {
		name
		id: resolutionId
	}
`;
const $bee71aa7fb34f807$export$31c88001934c2e15 = (0, $e0t6Q.default)`
	fragment ResolutionFieldFragment on JiraResolutionField {
		resolution {
			...Resolution
		}
		resolutions {
			nodes {
				...Resolution
			}
		}
	}
	${$bee71aa7fb34f807$var$RESOLUTION}
`;
const $bee71aa7fb34f807$export$2f9cfac026740bd3 = (0, $e0t6Q.default)`
	fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
		cascadingOption {
			parentOptionValue {
				...Option
			}
			childOptionValue {
				...Option
			}
		}
		cascadingOptions {
			nodes {
				parentOptionValue {
					...Option
				}
				childOptionValues {
					...Option
				}
			}
		}
	}
	${$bee71aa7fb34f807$var$OPTION}
`;
/* team field */ const $bee71aa7fb34f807$var$TEAM = (0, $e0t6Q.default)`
	fragment Team on JiraTeam {
		name
		teamId
	}
`;
const $bee71aa7fb34f807$export$cb70b12f3de3f41c = (0, $e0t6Q.default)`
	fragment TeamFieldFragment on JiraTeamField {
		selectedTeam {
			...Team
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$TEAM}
`;
/* Atlassian Team field */ const $bee71aa7fb34f807$var$ATLASSIAN_TEAM = (0, $e0t6Q.default)`
	fragment AtlassianTeam on JiraAtlassianTeam {
		name
		teamId
		avatar {
			small
		}
	}
`;
const $bee71aa7fb34f807$export$1173888d99fd7ae6 = (0, $e0t6Q.default)`
	fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
		JiraAtlassianTeamField: selectedTeam {
			...AtlassianTeam
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$ATLASSIAN_TEAM}
`;
/* affected services field */ const $bee71aa7fb34f807$var$AFFECTED_SERVICE = (0, $e0t6Q.default)`
	fragment AffectedService on JiraAffectedService {
		serviceId
	}
`;
const $bee71aa7fb34f807$var$ASSET = (0, $e0t6Q.default)`
	fragment Asset on JiraAsset {
		serializedOrigin
		appKey
		originId
		value
	}
`;
const $bee71aa7fb34f807$export$97cdf1e4b8832240 = (0, $e0t6Q.default)`
	fragment AssetFieldFragment on JiraAssetField {
		selectedAssets {
			...Asset
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$ASSET}
`;
const $bee71aa7fb34f807$export$3480d890dca64b9e = (0, $e0t6Q.default)`
	fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
		selectedAffectedServices {
			...AffectedService
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$AFFECTED_SERVICE}
`;
const $bee71aa7fb34f807$export$c1864cedbeda248a = (0, $e0t6Q.default)`
	fragment CMDBFieldFragment on JiraCMDBField {
		searchUrl
		isMulti
		attributesIncludedInAutoCompleteSearch
		selectedCmdbObjects {
			id
			objectId
			workspaceId
			label
		}
	}
`;
/* organizations field */ const $bee71aa7fb34f807$var$ORGANIZATION = (0, $e0t6Q.default)`
	fragment Organization on JsmOrganization {
		organizationId
		organizationName
		domain
		__typename
	}
`;
const $bee71aa7fb34f807$export$e0f3793fd890e0 = (0, $e0t6Q.default)`
	fragment OrganizationsFieldFragment on JsmOrganizationField {
		selectedOrganizations {
			...Organization
		}
		searchUrl
	}
	${$bee71aa7fb34f807$var$ORGANIZATION}
`;
const $bee71aa7fb34f807$export$f9e6189fd786f6 = (0, $e0t6Q.default)`
	fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		originalEstimate {
			timeInSeconds
		}
	}
`;
const $bee71aa7fb34f807$export$c6c1a1f3d6f49ea4 = (0, $e0t6Q.default)`
	fragment WorkLogFieldFragment on JiraWorkLogField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$bee71aa7fb34f807$var$MEDIA_CONTEXT_FRAGMENT}
`;
// Parent link field
const $bee71aa7fb34f807$var$PARENT_LINK_ISSUE = (0, $e0t6Q.default)`
	fragment Issue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
	}
`;
const $bee71aa7fb34f807$export$fa778835050523e6 = (0, $e0t6Q.default)`
	fragment ParentLinkFieldFragment on JiraParentIssueField {
		searchUrl
		parentIssue {
			...Issue
		}
	}
	${$bee71aa7fb34f807$var$PARENT_LINK_ISSUE}
`;
// Hierarchy unification Parent issue
const $bee71aa7fb34f807$var$PARENT_ISSUE = (0, $e0t6Q.default)`
	fragment ParentIssue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
		issueColorField {
			color {
				colorKey
			}
		}
		fieldsById(ids: ["summary", "issuetype"]) {
			edges {
				node {
					... on JiraSingleLineTextField {
						text
					}
					... on JiraIssueTypeField {
						issueType {
							name
							avatar {
								xsmall
							}
						}
					}
				}
			}
		}
	}
`;
const $bee71aa7fb34f807$export$f75050611ceb9d35 = (0, $e0t6Q.default)`
	fragment ParentFieldFragment on JiraParentIssueField {
		parentIssue {
			...ParentIssue
		}
	}
	${$bee71aa7fb34f807$var$PARENT_ISSUE}
`;
const $bee71aa7fb34f807$export$f89396a6b77b653f = (0, $e0t6Q.default)`
	fragment StatusFieldFragment on JiraStatusField {
		name
		description
		aliasFieldId
		__typename
	}
`;
const $bee71aa7fb34f807$export$335dcd5b86a25a15 = (0, $e0t6Q.default)`
	fragment JiraServiceManagementRespondersFieldFragment on JiraServiceManagementRespondersField {
		searchUrl
	}
`;
const $bee71aa7fb34f807$export$5f06542accc83cb5 = (0, $e0t6Q.default)`
	fragment ProformaConfigFragment on JiraIssueCreateProformaConfiguration {
		serviceId
		proforma {
			portalLink
			hasProformaForm
		}
	}
`;
const $bee71aa7fb34f807$export$eda8fbd7533aaac1 = (0, $e0t6Q.default)`
	fragment WatchersConfigFragment on JiraIssueCreateWatchersConfiguration {
		serviceId
		permissions {
			canManageWatchers
			canViewWatchers
			isAutoWatchEnabled
			isWatchersEnabled
		}
		__typename
	}
`;
const $bee71aa7fb34f807$export$ddf4ac4d74647910 = (0, $e0t6Q.default)`
	fragment AtlasProjectFieldFragment on JiraTownsquareProjectField {
		atlasProject: project {
			id
			key
			name
			privateProject
			hasPermission
			isWorkspaceActive
			iconName
		}
	}
`;

});



parcelRegister("f6qor", function(module, exports) {
$parcel$export(module.exports, "useStorageVariables", () => $30e5acf9c0ef4471$export$36a06b8f251492a3);
$parcel$export(module.exports, "getFirstFieldIdWithError", () => $30e5acf9c0ef4471$export$f15841b83bf0d927);
$parcel$export(module.exports, "publishCreatedIssues", () => $30e5acf9c0ef4471$export$d46eb3aee2ce61a5);
$parcel$export(module.exports, "getTabIndexWithError", () => $30e5acf9c0ef4471$export$1d81ee131c803e88);
$parcel$export(module.exports, "getWatchersFlagConfigFromResponse", () => $30e5acf9c0ef4471$export$47ea475ac70a5697);

var $58tmX = parcelRequire("58tmX");

var $ka176 = parcelRequire("ka176");

var $eFPb2 = parcelRequire("eFPb2");

var $bS6BF = parcelRequire("bS6BF");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $1KydW = parcelRequire("1KydW");

var $kt86l = parcelRequire("kt86l");

var $4MOJ7 = parcelRequire("4MOJ7");

var $7IK6V = parcelRequire("7IK6V");

var $14CWj = parcelRequire("14CWj");

var $hJL79 = parcelRequire("hJL79");

var $d8LhJ = parcelRequire("d8LhJ");

var $pnnt0 = parcelRequire("pnnt0");

var $7RI9J = parcelRequire("7RI9J");

var $6bEm8 = parcelRequire("6bEm8");

var $hzlsM = parcelRequire("hzlsM");
const $30e5acf9c0ef4471$var$watchersWarningFlagTitle = (0, $7RI9J.defineMessage)({
    id: "issue-create.modal.watchers-warning-flag-title",
    defaultMessage: "Watchers not added to your issue"
});
const $30e5acf9c0ef4471$var$watchersErrorFlagTitle = (0, $7RI9J.defineMessage)({
    id: "issue-create.modal.watchers-error-flag-title",
    defaultMessage: "Something went wrong"
});
const $30e5acf9c0ef4471$var$watchersWarningFlagTitleIssueTermRefresh = (0, $7RI9J.defineMessage)({
    id: "issue-create.modal.watchers-warning-flag-title-issue-term-refresh",
    defaultMessage: "Watchers not added to your work item"
});
const $30e5acf9c0ef4471$var$watchersWarningFlagTitleIssueTerminologyRefreshM4 = (0, $7RI9J.defineMessage)({
    id: "issue-create.modal.watchers-warning-flag-title-issue-terminology-refresh-m4",
    defaultMessage: "Watchers not added to the {issueType} {issueKey}"
});
const $30e5acf9c0ef4471$export$8d7a103b266a4496 = '/rest/api/3/search/jql';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
let $30e5acf9c0ef4471$var$issueDataTillNow = {};
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $30e5acf9c0ef4471$var$issueIdsTillNow = {};
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
let $30e5acf9c0ef4471$var$activePromises = {};
const $30e5acf9c0ef4471$export$36a06b8f251492a3 = ()=>{
    const $ = (0, $58tmX.c)(5);
    const cloudId = (0, $kt86l.useCloudId)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $1KydW.useApplicationPermissions)();
    let t0;
    if ($[0] !== hasSoftwareAccess) {
        t0 = hasSoftwareAccess && (0, $bS6BF.default)((0, $6bEm8.default)).software === (0, $d8LhJ.FREE_EDITION);
        $[0] = hasSoftwareAccess;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== cloudId || $[3] !== t0) {
        t1 = {
            cloudId: cloudId,
            applicationKey: (0, $hJL79.JIRA_SOFTWARE),
            shouldCheckForStorageLimit: t0
        };
        $[2] = cloudId;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
const $30e5acf9c0ef4471$var$postMessageToConsumers = (createdIssues, triggerPointKey)=>{
    if (triggerPointKey === 'issue-create-embed-trigger') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.parent?.postMessage({
        event: 'jiraIssueCreate.sessionComplete',
        payload: createdIssues,
        triggerPointKey: triggerPointKey
    }, '*');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.postMessage({
        event: 'jiraIssueCreate.sessionComplete',
        payload: createdIssues,
        triggerPointKey: triggerPointKey
    }, '*');
};
const $30e5acf9c0ef4471$export$f15841b83bf0d927 = ({ fields: fields, emptyRequiredFields: emptyRequiredFields })=>{
    if (emptyRequiredFields) return fields.find((fieldId)=>{
        if (emptyRequiredFields.includes(fieldId)) return true;
        // handling multi input field errors separately because it contains different error keys
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
        if ((0, $7IK6V.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId]) return emptyRequiredFields.some((key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
            (0, $7IK6V.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId].includes(key));
        return false;
    });
    return undefined;
};
const $30e5acf9c0ef4471$var$fetchIssueListPromise = (jql, fieldsToAddInPublishedData, fetchAllFields, issueIdsToReconcileOn)=>{
    if ($30e5acf9c0ef4471$var$activePromises[jql] === undefined) {
        if (fetchAllFields) $30e5acf9c0ef4471$var$activePromises[jql] = (0, $h2wCv.performPostRequest)($30e5acf9c0ef4471$export$8d7a103b266a4496, {
            body: JSON.stringify({
                jql: jql,
                fields: [
                    ...new Set([
                        '*all'
                    ])
                ],
                reconcileIssues: issueIdsToReconcileOn
            })
        });
        else $30e5acf9c0ef4471$var$activePromises[jql] = (0, $h2wCv.performPostRequest)($30e5acf9c0ef4471$export$8d7a103b266a4496, {
            body: JSON.stringify({
                jql: jql,
                fields: [
                    ...new Set([
                        'summary',
                        'status',
                        'assignee',
                        'duedate',
                        'project',
                        'issuetype',
                        'priority',
                        'issuelinks',
                        ...fieldsToAddInPublishedData
                    ])
                ],
                reconcileIssues: issueIdsToReconcileOn
            })
        });
    }
    return $30e5acf9c0ef4471$var$activePromises[jql];
};
const $30e5acf9c0ef4471$var$getIssueList = async (createdIssues, fieldsToAddInPublishedData, fetchAllFields)=>{
    // Get list of issues that have not been fetched before
    const issuesToFetch = createdIssues.filter(({ issueKey: issueKey })=>!$30e5acf9c0ef4471$var$issueDataTillNow[issueKey]);
    const issueIdsToFetch = createdIssues.filter(({ issueId: issueId })=>!$30e5acf9c0ef4471$var$issueIdsTillNow[issueId]);
    let newIssueDetails = {
        issues: []
    };
    if (issuesToFetch.length) {
        // API call is made only if there are issues that needs to be fetched
        const jql = issuesToFetch.reduce((jqlQuery, { issueKey: issueKey }, index)=>`${jqlQuery}issuekey=${issueKey}${index !== issuesToFetch.length - 1 ? ' OR ' : ''}`, '');
        const issueIdsToReconcileOn = issueIdsToFetch.map(({ issueId: issueId })=>issueId) // Extract the issueId from each object
        .filter((issueId)=>Number.isInteger(issueId)); // Check if the issueId is an integer
        try {
            newIssueDetails = await $30e5acf9c0ef4471$var$fetchIssueListPromise(jql, fieldsToAddInPublishedData, fetchAllFields, issueIdsToReconcileOn);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $4MOJ7.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'getIssueList',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            $30e5acf9c0ef4471$var$activePromises[jql] = undefined;
        }
    }
    const prefetchedIssueDetails = createdIssues.filter(({ issueKey: issueKey })=>$30e5acf9c0ef4471$var$issueDataTillNow[issueKey]).map(({ issueKey: issueKey })=>$30e5acf9c0ef4471$var$issueDataTillNow[issueKey].createdIssueDetails);
    return {
        issues: [
            ...prefetchedIssueDetails,
            ...newIssueDetails.issues
        ]
    };
};
const $30e5acf9c0ef4471$var$merge = (obj, obj2)=>({
        ...obj,
        ...obj2
    });
const $30e5acf9c0ef4471$export$d46eb3aee2ce61a5 = async ({ createdIssues: createdIssues, globalEventNamespaces: globalEventNamespaces = [
    (0, $7IK6V.GLOBAL_EVENT_NAMESPACE)
], fieldsToAddInPublishedData: fieldsToAddInPublishedData = [], alertsToBeLinked: alertsToBeLinked = [], isSessionComplete: isSessionComplete = false, onIssueCreate: onIssueCreate, siteDomain: siteDomain, selectedCloudId: selectedCloudId, onClose: onClose, triggerPointKey: triggerPointKey, publishGICLifecycle: publishGICLifecycle, isIssueCreateSuccess: isIssueCreateSuccess, callbackPayload: callbackPayload, jqlSwimlaneId: jqlSwimlaneId, ecosystemCallback: ecosystemCallback }, fireErrorAnalytics = (0, $4MOJ7.fireIssueCreateErrorAnalytics))=>{
    let fetchAllFields = false;
    if (ecosystemCallback && ecosystemCallback.callbackFunction) fetchAllFields = true;
    if (createdIssues.length) {
        /**
     * We need to unregister the SPA global issue create event handlers so that new issue create can use its
     * default ones which render the success and error flag in a different place
     */ let oldFlagUnbindSuccess = false;
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.require('jira/common/header').unbind();
            oldFlagUnbindSuccess = true;
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            oldFlagUnbindSuccess = false;
        }
        try {
            const issueSearchRequest = $30e5acf9c0ef4471$var$getIssueList(createdIssues, fieldsToAddInPublishedData, fetchAllFields);
            const [issueList, Events] = await Promise.all([
                issueSearchRequest,
                (0, $pnnt0.apiReady)()
            ]);
            const issueData = (0, (/*@__PURE__*/$parcel$interopDefault($eFPb2)))(issueList.issues, 'key');
            const createdIssuesWithIssueData = createdIssues.map((createdIssue)=>{
                const createdIssueDetails = issueData[createdIssue.issueKey];
                const summary = createdIssueDetails?.fields?.summary;
                return {
                    ...createdIssue,
                    summary: summary,
                    createdIssueDetails: createdIssueDetails,
                    selectedCloudId: selectedCloudId,
                    jqlSwimlaneId: jqlSwimlaneId
                };
            });
            $30e5acf9c0ef4471$var$issueDataTillNow = $30e5acf9c0ef4471$var$merge($30e5acf9c0ef4471$var$issueDataTillNow, (0, (/*@__PURE__*/$parcel$interopDefault($eFPb2)))(createdIssuesWithIssueData, 'issueKey'));
            if (isIssueCreateSuccess) // ideally createdIssuesWithIssueData will contain a single element
            createdIssuesWithIssueData.forEach((createdIssue)=>{
                onIssueCreate?.(siteDomain ? {
                    ...createdIssue,
                    siteDomain: siteDomain
                } : createdIssue, alertsToBeLinked);
                publishGICLifecycle?.((0, $14CWj.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, {
                    createdIssueData: createdIssue,
                    callbackPayload: callbackPayload
                });
            });
            if (isSessionComplete) {
                if (fetchAllFields) (0, $hzlsM.executeEcosystemAPICallback)(ecosystemCallback, createdIssuesWithIssueData);
                $30e5acf9c0ef4471$var$postMessageToConsumers(createdIssuesWithIssueData, triggerPointKey);
                if ((0, $i860n.fg)('stop_polli_fails_due_to_load_bridge')) onClose?.(createdIssuesWithIssueData);
                globalEventNamespaces.forEach((namespace)=>{
                    if (triggerPointKey !== undefined) Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData,
                        triggerPointKey
                    ]);
                    else Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData
                    ]);
                });
                if (!(0, $i860n.fg)('stop_polli_fails_due_to_load_bridge')) onClose?.(createdIssuesWithIssueData);
            }
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireErrorAnalytics({
                meta: {
                    id: 'publishCreatedIssues',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (isSessionComplete) {
            $30e5acf9c0ef4471$var$issueDataTillNow = {};
            $30e5acf9c0ef4471$var$activePromises = {};
        }
        /**
     * On cleanup we need to re-register the legacy issue create event handlers which will override the
     * allow non-migrated triggers to show flag
     */ if (oldFlagUnbindSuccess && isSessionComplete) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.require('jira/common/header').initialize();
    } else if (isSessionComplete) {
        if (fetchAllFields) (0, $hzlsM.executeEcosystemAPICallback)(ecosystemCallback, []);
        onClose && onClose([]);
    }
};
const $30e5acf9c0ef4471$export$1d81ee131c803e88 = (fieldTabs, fieldValues, requiredFieldsData)=>{
    if (!fieldValues) return -1;
    const emptyRequiredField = Object.keys(fieldValues)?.find((id)=>requiredFieldsData[id] && Boolean(requiredFieldsData[id].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($ka176)))(fieldValues[id]));
    const tabIndex = fieldTabs?.findIndex((tab)=>tab.items.find((item)=>item === emptyRequiredField));
    return tabIndex > -1 ? tabIndex : -1;
};
const $30e5acf9c0ef4471$export$47ea475ac70a5697 = (response, issueKey, issueType)=>{
    if (response?.errorCollection && response.errorCollection.errorMessages[0]) return {
        type: 'error',
        title: $30e5acf9c0ef4471$var$watchersErrorFlagTitle,
        description: response.errorCollection.errorMessages[0],
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'issue-create.ui.modal.flag.error.error.watchers-error',
        messageType: 'transactional'
    };
    const getTitle = ()=>{
        if (issueType && (0, $2700E.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return $30e5acf9c0ef4471$var$watchersWarningFlagTitleIssueTerminologyRefreshM4;
        if ((0, $2700E.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return $30e5acf9c0ef4471$var$watchersWarningFlagTitleIssueTermRefresh;
        return $30e5acf9c0ef4471$var$watchersWarningFlagTitle;
    };
    if (response?.warningCollection && response?.warningCollection.warnings[0]) return {
        type: 'warning',
        title: [
            getTitle(),
            {
                issueKey: issueKey,
                issueType: issueType
            }
        ],
        description: response.warningCollection.warnings[0],
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'issue-create.ui.modal.flag.warning.warning.watchers-warning',
        messageType: 'transactional'
    };
    return undefined;
};

});
parcelRegister("eFPb2", function(module, exports) {

var $7WV3o = parcelRequire("7WV3o");

var $k6TkC = parcelRequire("k6TkC");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $aaec97bca4e6d37f$var$keyBy = $k6TkC(function(result, value, key) {
    $7WV3o(result, key, value);
});
module.exports = $aaec97bca4e6d37f$var$keyBy;

});

parcelRegister("4MOJ7", function(module, exports) {
$parcel$export(module.exports, "fireIssueCreateErrorAnalytics", () => $7c19b6949ea52add$export$fffbd8c0e67dbb84);
/* eslint-disable jira/filename-case */ 
var $9Oiqw = parcelRequire("9Oiqw");

var $bLUzn = parcelRequire("bLUzn");

var $1KMpZ = parcelRequire("1KMpZ");
const $7c19b6949ea52add$export$fffbd8c0e67dbb84 = (payload)=>{
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $bLUzn.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...error && (0, $9Oiqw.isApolloError)(error) ? {
                errorType: (0, $1KMpZ.handleApolloError)(error)
            } : {}
        },
        error: error
    });
};

});
parcelRegister("bLUzn", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $ccdb98b9fe4671c6$export$51f199f6846377f7);

var $hFtK7 = parcelRequire("hFtK7");

var $4CFYO = parcelRequire("4CFYO");
const $ccdb98b9fe4671c6$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $hFtK7.fireErrorAnalytics)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $4CFYO.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});
parcelRegister("4CFYO", function(module, exports) {
$parcel$export(module.exports, "getTenantAttributes", () => $e1d17022280fd753$export$bc31ff13a0bbe592);

var $l1vE2 = parcelRequire("l1vE2");

var $6bEm8 = parcelRequire("6bEm8");
const $e1d17022280fd753$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $6bEm8.default)('ajs-shard');
    const region = (0, $6bEm8.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $l1vE2.isFedRamp)()
    };
};

});


parcelRegister("1KMpZ", function(module, exports) {
$parcel$export(module.exports, "handleApolloError", () => $063c58a460d56e95$export$31b755cdc25616f2);
const $063c58a460d56e95$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});


parcelRegister("14CWj", function(module, exports) {
$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $e4153b0c47dc0bdb$export$876003a5b887f37e);
/* eslint-disable jira/filename-case */ const $e4153b0c47dc0bdb$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CREATE_FORM_FIELD_FOCUS: 'CREATE_FORM_FIELD_FOCUS',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("pnnt0", function(module, exports) {
$parcel$export(module.exports, "apiReady", () => $d946e41d58d23551$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6rVwb = parcelRequire("6rVwb");
let $d946e41d58d23551$var$currentBridge;
const $d946e41d58d23551$export$330fb1a04c974aad = async ()=>{
    if ($d946e41d58d23551$var$currentBridge) return $d946e41d58d23551$var$currentBridge;
    /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/wrm/no-load-bridge
    const Events = await (0, $6rVwb.loadBridge)({
        /* oxlint-enable typescript/consistent-type-assertions */ name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $d946e41d58d23551$var$currentBridge = Events;
    return Events;
};

});
parcelRegister("6rVwb", function(module, exports) {
$parcel$export(module.exports, "loadBridge", () => $48995096b3b8078a$export$df8409da353bde5a);

var $1fD9L = parcelRequire("1fD9L");
var $6uE4A = parcelRequire("6uE4A");
var $lzqod = parcelRequire("lzqod");
var $gO6uV = parcelRequire("gO6uV");

var $gO6uV = parcelRequire("gO6uV");
var $jiqJM = parcelRequire("jiqJM");
var $bok83 = parcelRequire("bok83");
var $eiY0v = parcelRequire("eiY0v");
var $fb524 = parcelRequire("fb524");
const $48995096b3b8078a$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $1fD9L.MAX_RETRIES), timeout: timeout = (0, $1fD9L.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $gO6uV.loadBridgeStrict)({
        name: name,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $6uE4A.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $lzqod.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("1fD9L", function(module, exports) {
$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $31c65cd7c39d7bf1$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $31c65cd7c39d7bf1$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $31c65cd7c39d7bf1$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $31c65cd7c39d7bf1$export$37f20f0ff732fcd7);
/* eslint-disable jira/filename-case */ 
var $6CfY5 = parcelRequire("6CfY5");
const $31c65cd7c39d7bf1$export$f19a2d31722e3428 = (0, $6CfY5.default).safeErrorWithoutCustomerData;
const $31c65cd7c39d7bf1$export$ea810ce67e3c8eac = (0, $6CfY5.default).safeInfoWithoutCustomerData;
const $31c65cd7c39d7bf1$export$1f86472c1374185a = 40;
const $31c65cd7c39d7bf1$export$7bd623b29ec8e1eb = 500;
const $31c65cd7c39d7bf1$export$37f20f0ff732fcd7 = true;

});

parcelRegister("6uE4A", function(module, exports) {
$parcel$export(module.exports, "loadBridgeBail", () => $74ab3760575edd11$export$a036f92c2465504e);

var $b3AOE = parcelRequire("b3AOE");

var $1fD9L = parcelRequire("1fD9L");
const $74ab3760575edd11$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>{
    try {
        /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    /* oxlint-enable typescript/consistent-type-assertions */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $1fD9L.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $b3AOE.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $b3AOE.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("b3AOE", function(module, exports) {
$parcel$export(module.exports, "safeStringify", () => $575c3794295cd43c$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $575c3794295cd43c$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("lzqod", function(module, exports) {
$parcel$export(module.exports, "loadBridgeRace", () => $3c47dcca8a60865f$export$20c32b4579d78b92);

var $6uE4A = parcelRequire("6uE4A");

var $jiqJM = parcelRequire("jiqJM");

var $1fD9L = parcelRequire("1fD9L");
const $3c47dcca8a60865f$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $1fD9L.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $jiqJM.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $6uE4A.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("jiqJM", function(module, exports) {
$parcel$export(module.exports, "loadBridgeWeak", () => $27e7fa08d02332e1$export$3cefda82396756a1);

var $Z0ggs = parcelRequire("Z0ggs");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
let $27e7fa08d02332e1$var$pollingSingleton = null;
const $27e7fa08d02332e1$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $27e7fa08d02332e1$var$pollingSingleton ?? (0, $Z0ggs.createPollingCollection)((v)=>window.require(v), 100);
    $27e7fa08d02332e1$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("Z0ggs", function(module, exports) {
$parcel$export(module.exports, "createPollingCollection", () => $d5b9dec420cdc257$export$f163446a982a8077);

var $4K6DP = parcelRequire("4K6DP");

var $aA3A5 = parcelRequire("aA3A5");
const $d5b9dec420cdc257$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $4K6DP.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aA3A5.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aA3A5.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aA3A5", function(module, exports) {
$parcel$export(module.exports, "default", () => $abfaf64ce8ef144a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $abfaf64ce8ef144a$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $abfaf64ce8ef144a$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $abfaf64ce8ef144a$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // oxlint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}
$abfaf64ce8ef144a$export$2e2bcd8739ae039.displayName = "Deferred";

});




parcelRegister("gO6uV", function(module, exports) {
$parcel$export(module.exports, "loadBridgeStrict", () => $3eaf52b3a5308c14$export$eba600d28decc4ac);

var $i860n = parcelRequire("i860n");

var $fEmTm = parcelRequire("fEmTm");

var $6bEm8 = parcelRequire("6bEm8");

var $4LdxJ = parcelRequire("4LdxJ");

var $lzqod = parcelRequire("lzqod");

var $eQBIW = parcelRequire("eQBIW");

var $1fD9L = parcelRequire("1fD9L");

var $bok83 = parcelRequire("bok83");
const $3eaf52b3a5308c14$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR), isolatedFromHeritage: isolatedFromHeritage = false })=>{
    (0, $4LdxJ.saveStats)(name, wrmKeys);
    if (// FIXME: remove fg after initial rollout
    // eslint-disable-next-line jira/ff/no-preconditioning
    !isolatedFromHeritage && (0, $i860n.fg)('jfp_magma_jira-report-early-strict-bridge') && (0, $6bEm8.default)('ajs-environment') === 'staging') {
        if (!(0, $bok83.isWRMHeritageLoaded)()) (0, $fEmTm.captureException)(`loadBridgeStrict:${name}`, new Error('Do not call loadBridgeStrict without waitForHeritage'));
    }
    try {
        /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    /* oxlint-enable typescript/consistent-type-assertions */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $eQBIW.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $lzqod.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("4LdxJ", function(module, exports) {
$parcel$export(module.exports, "saveStats", () => $6e002ee5b6839b4f$export$9ea3ff7978093559);
const $6e002ee5b6839b4f$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // oxlint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // oxlint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6e002ee5b6839b4f$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6e002ee5b6839b4f$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6e002ee5b6839b4f$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6e002ee5b6839b4f$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6e002ee5b6839b4f$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6e002ee5b6839b4f$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6e002ee5b6839b4f$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6e002ee5b6839b4f$var$isPageInteractive()) return;
        stats.requests += 1;
        $6e002ee5b6839b4f$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6e002ee5b6839b4f$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6e002ee5b6839b4f$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("eQBIW", function(module, exports) {
$parcel$export(module.exports, "loadWrmResources", () => $4ab948e8cb2ebd46$export$6cda16b6eff75f59);

var $b3AOE = parcelRequire("b3AOE");

var $f49LN = parcelRequire("f49LN");

var $jiqJM = parcelRequire("jiqJM");

var $1fD9L = parcelRequire("1fD9L");
const $4ab948e8cb2ebd46$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $jiqJM.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $f49LN.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $1fD9L.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $b3AOE.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("f49LN", function(module, exports) {
$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $dcfae4018197323a$export$93d9db5fbabad1b0);

var $6Z3wy = parcelRequire("6Z3wy");
let $dcfae4018197323a$var$isSuperBatchDependenciesLoaded = false;
const $dcfae4018197323a$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $dcfae4018197323a$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($dcfae4018197323a$var$isSuperBatchDependenciesLoaded || $dcfae4018197323a$var$isOnRapidBoardsPage()) return wrmKeys;
    $dcfae4018197323a$var$isSuperBatchDependenciesLoaded = true;
    return (0, $6Z3wy.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("6Z3wy", function(module, exports) {
$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $ca21c54a2634c804$export$f14a6b583ce9e077);
/* eslint-disable jira/filename-case */ const $ca21c54a2634c804$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});



parcelRegister("bok83", function(module, exports) {
$parcel$export(module.exports, "isWRMHeritageLoaded", () => $413a97ba4c420953$export$1a2b9c2d0a3d83ed);
$parcel$export(module.exports, "waitForHeritage", () => $413a97ba4c420953$export$c61060338d026f78);

var $4Ed6C = parcelRequire("4Ed6C");

var $aA3A5 = parcelRequire("aA3A5");
let $413a97ba4c420953$var$heritageIsLoaded = false;
const $413a97ba4c420953$export$1a2b9c2d0a3d83ed = ()=>$413a97ba4c420953$var$heritageIsLoaded;
const $413a97ba4c420953$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        $413a97ba4c420953$var$heritageIsLoaded = false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aA3A5.default)();
        (0, $4Ed6C.bootstrapWrmClient)().then(()=>{
            $413a97ba4c420953$var$heritageIsLoaded = true;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("4Ed6C", function(module, exports) {
$parcel$export(module.exports, "bootstrapWrmClient", () => $03eb6deeb21f88ea$export$d001f71dd306cb0c);

var $4fhEY = parcelRequire("4fhEY");

var $hFtK7 = parcelRequire("hFtK7");

var $b3AOE = parcelRequire("b3AOE");
const $03eb6deeb21f88ea$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $03eb6deeb21f88ea$var$fetchSpaWrmContext = async ()=>{
    return (0, $4fhEY.default)($03eb6deeb21f88ea$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $03eb6deeb21f88ea$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $03eb6deeb21f88ea$var$hasWrmInitialised;
const $03eb6deeb21f88ea$var$runBootstrap = ()=>{
    const spaWrmContext = $03eb6deeb21f88ea$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // oxlint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($03eb6deeb21f88ea$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                error: new Error((0, $b3AOE.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $03eb6deeb21f88ea$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($03eb6deeb21f88ea$var$hasWrmInitialised) return $03eb6deeb21f88ea$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $03eb6deeb21f88ea$var$hasWrmInitialised = Promise.resolve();
    else $03eb6deeb21f88ea$var$hasWrmInitialised = $03eb6deeb21f88ea$var$runBootstrap();
    return $03eb6deeb21f88ea$var$hasWrmInitialised;
};

});



parcelRegister("eiY0v", function(module, exports) {
$parcel$export(module.exports, "wrmRequire", () => $193010f5eb33da51$export$cc9d8f51375ef66a);

var $eQBIW = parcelRequire("eQBIW");

var $1fD9L = parcelRequire("1fD9L");
const $193010f5eb33da51$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR))=>(0, $eQBIW.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("fb524", function(module, exports) {
$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $ec0aeb328e8a9e35$export$e53a5db19a39ed2f);

var $eQBIW = parcelRequire("eQBIW");

var $1fD9L = parcelRequire("1fD9L");
const $ec0aeb328e8a9e35$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR))=>(0, $eQBIW.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});



parcelRegister("hzlsM", function(module, exports) {
$parcel$export(module.exports, "executeEcosystemAPICallback", () => $3cde9d09f1c14a25$export$352b0ab2ba913578);
/* eslint-disable jira/filename-case */ /* oxlint-disable typescript/consistent-type-assertions */ 
var $fjlMk = parcelRequire("fjlMk");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $3cde9d09f1c14a25$var$sanitizeIssues = (issuesData)=>{
    const sanitizedIssues = [];
    for (const issueData of issuesData){
        const sanitizedIssue = {
            id: '',
            key: '',
            self: '',
            fields: {}
        };
        const issue = issueData.createdIssueDetails;
        sanitizedIssue.id = issue.id;
        sanitizedIssue.key = issue.key;
        sanitizedIssue.self = issue.self;
        // Convert ADF to Text for all rich text fields
        sanitizedIssue.fields = issue.fields;
        for(const field in sanitizedIssue.fields)if ((0, $fjlMk.isAdfObject)(sanitizedIssue.fields[field])) // oxlint-disable-next-line typescript/consistent-type-assertions
        sanitizedIssue.fields[field] = (0, $fjlMk.convertAdfToWiki)(sanitizedIssue.fields[field]);
        sanitizedIssues.push(sanitizedIssue);
    }
    return sanitizedIssues;
};
const $3cde9d09f1c14a25$export$352b0ab2ba913578 = (ecosystemCallback, issuesData)=>{
    if (ecosystemCallback && ecosystemCallback.callbackFunction) {
        const sanitizedIssues = $3cde9d09f1c14a25$var$sanitizeIssues(issuesData);
        ecosystemCallback.callbackFunction.call({}, sanitizedIssues);
    }
};

});
parcelRegister("fjlMk", function(module, exports) {
$parcel$export(module.exports, "convertAdfToWiki", () => $57b72c646172a4b4$export$4aa84bff5b13655f);
$parcel$export(module.exports, "isAdfObject", () => $57b72c646172a4b4$export$9acea0de85f3957);
/* eslint-disable jira/filename-case */ 
var $aZsfy = parcelRequire("aZsfy");

var $OVmx5 = parcelRequire("OVmx5");

var $ku4jW = parcelRequire("ku4jW");
const $57b72c646172a4b4$export$4aa84bff5b13655f = (document)=>{
    try {
        const jsonTransformer = new (0, $OVmx5.JSONTransformer)();
        const wikiMarkupTransformer = new (0, $ku4jW.WikiMarkupTransformer)((0, $aZsfy.defaultSchema));
        if (document === null || document === undefined) return '';
        return wikiMarkupTransformer.encode(jsonTransformer.parse(document));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // We handle this state by disabling the option to export to markdown.
        return '';
    }
};
const $57b72c646172a4b4$export$9acea0de85f3957 = (field)=>{
    return field && field.type === 'doc' && Array.isArray(field.content);
};

});
parcelRegister("aZsfy", function(module, exports) {
$parcel$export(module.exports, "defaultSchemaConfig", () => $433f1ca85ba956d5$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $433f1ca85ba956d5$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $433f1ca85ba956d5$export$1db618b7b2275ea1);

var $hYOlI = parcelRequire("hYOlI");

var $iqfTZ = parcelRequire("iqfTZ");

var $b6kky = parcelRequire("b6kky");

var $k5JTK = parcelRequire("k5JTK");
var $b3Zoi = parcelRequire("b3Zoi");
var $dGNE8 = parcelRequire("dGNE8");
var $22R95 = parcelRequire("22R95");
var $fQBtT = parcelRequire("fQBtT");
var $4L22w = parcelRequire("4L22w");

var $a6aOH = parcelRequire("a6aOH");

var $goEAh = parcelRequire("goEAh");

var $ehkGa = parcelRequire("ehkGa");

var $22R95 = parcelRequire("22R95");

var $lT7kI = parcelRequire("lT7kI");
const $433f1ca85ba956d5$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $433f1ca85ba956d5$export$e4e3ac1fa64862db = $433f1ca85ba956d5$var$getDefaultSchemaConfig();
const $433f1ca85ba956d5$export$fd147e7d448dea03 = (0, $hYOlI.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $433f1ca85ba956d5$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $fQBtT.layoutSectionWithSingleColumn),
        extension: (0, $iqfTZ.fg)('cc_maui_annotations_on_extensions') ? (0, $22R95.extensionRootOnlyWithAnnotationStage0) : (0, $22R95.extensionRootOnlyStage0),
        bodiedExtension: (0, $k5JTK.bodiedExtensionRootOnlyStage0),
        multiBodiedExtension: (0, $dGNE8.multiBodiedExtensionRootOnlyStage0),
        extensionFrame: (0, $dGNE8.extensionFrame),
        expand: (0, $b3Zoi.expandWithNestedExpand),
        table: (0, $4L22w.tableWithNestedTable),
        tableRow: (0, $4L22w.tableRowWithNestedTable),
        tableCell: (0, $4L22w.tableCellWithNestedTableStage0),
        tableHeader: (0, $4L22w.tableHeaderWithNestedTableStage0),
        panel: (0, $ehkGa.extendedPanelRootOnlyStage0)(true),
        panel_c1: (0, $goEAh.extendedPanelC1RootOnlyStage0)(true),
        rule: (0, $lT7kI.ruleWithAttrsRootOnlyStage0),
        bodiedRule: (0, $a6aOH.bodiedRuleRootOnlyStage0)
    };
    return (0, $b6kky.createSchema)(defaultSchemaConfig);
});
const $433f1ca85ba956d5$export$1db618b7b2275ea1 = $433f1ca85ba956d5$export$fd147e7d448dea03();

});
parcelRegister("b6kky", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $0c2b4d2d93ee9fe3$export$5f4ce795563f4211);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $c3kt8 = parcelRequire("c3kt8");

var $5IbDB = parcelRequire("5IbDB");

var $9luPj = parcelRequire("9luPj");

var $gb4r4 = parcelRequire("gb4r4");

var $ekca7 = parcelRequire("ekca7");

var $iI7Jb = parcelRequire("iI7Jb");

function $0c2b4d2d93ee9fe3$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat((0, $9luPj.markGroupDeclarationsNames));
    let nodes = (0, $5IbDB.addItems)((0, $ekca7.nodesInOrder), nodesConfig, customNodeSpecs);
    const marks = (0, $5IbDB.addItems)((0, $gb4r4.marksInOrder), marksConfig, customMarkSpecs);
    nodes = (0, $iI7Jb.sanitizeNodes)(nodes, marks);
    return new (0, $c3kt8.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $0c2b4d2d93ee9fe3$export$c77b6d30da5276a1 = true;

});
parcelRegister("c3kt8", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $8c65a48aef09274f$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $8c65a48aef09274f$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $8c65a48aef09274f$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $8c65a48aef09274f$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $8c65a48aef09274f$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $8c65a48aef09274f$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $8c65a48aef09274f$export$85c928794f8d04d4);
$parcel$export(module.exports, "ContentMatch", () => $8c65a48aef09274f$export$364ed450558d7ec4);
$parcel$export(module.exports, "NodeType", () => $8c65a48aef09274f$export$f06e977173f1857c);
$parcel$export(module.exports, "MarkType", () => $8c65a48aef09274f$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $8c65a48aef09274f$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $8c65a48aef09274f$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $8c65a48aef09274f$export$3476b78f8f5a8b72);

var $8EaKU = parcelRequire("8EaKU");
function $8c65a48aef09274f$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $8c65a48aef09274f$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $8c65a48aef09274f$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $8c65a48aef09274f$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $8c65a48aef09274f$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $8c65a48aef09274f$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $8c65a48aef09274f$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $8c65a48aef09274f$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $8c65a48aef09274f$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $8c65a48aef09274f$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $8c65a48aef09274f$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $8c65a48aef09274f$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $8c65a48aef09274f$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $8c65a48aef09274f$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $8c65a48aef09274f$var$retIndex(0, pos);
        if (pos == this.size) return $8c65a48aef09274f$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $8c65a48aef09274f$var$retIndex(i + 1, end);
                return $8c65a48aef09274f$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $8c65a48aef09274f$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $8c65a48aef09274f$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $8c65a48aef09274f$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $8c65a48aef09274f$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $8c65a48aef09274f$export$ffb0004e005737fa.empty;
        if (nodes instanceof $8c65a48aef09274f$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $8c65a48aef09274f$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $8c65a48aef09274f$export$ffb0004e005737fa.empty = new $8c65a48aef09274f$export$ffb0004e005737fa([], 0);
const $8c65a48aef09274f$var$found = {
    index: 0,
    offset: 0
};
function $8c65a48aef09274f$var$retIndex(index, offset) {
    $8c65a48aef09274f$var$found.index = index;
    $8c65a48aef09274f$var$found.offset = offset;
    return $8c65a48aef09274f$var$found;
}
function $8c65a48aef09274f$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$8c65a48aef09274f$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$8c65a48aef09274f$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $8c65a48aef09274f$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $8c65a48aef09274f$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
        if (marks instanceof $8c65a48aef09274f$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $8c65a48aef09274f$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $8c65a48aef09274f$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $8c65a48aef09274f$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $8c65a48aef09274f$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $8c65a48aef09274f$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $8c65a48aef09274f$export$b3f2e2de3a8baa1e($8c65a48aef09274f$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $8c65a48aef09274f$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $8c65a48aef09274f$export$b3f2e2de3a8baa1e($8c65a48aef09274f$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $8c65a48aef09274f$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $8c65a48aef09274f$export$b3f2e2de3a8baa1e.empty = new $8c65a48aef09274f$export$b3f2e2de3a8baa1e($8c65a48aef09274f$export$ffb0004e005737fa.empty, 0, 0);
function $8c65a48aef09274f$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($8c65a48aef09274f$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $8c65a48aef09274f$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $8c65a48aef09274f$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $8c65a48aef09274f$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $8c65a48aef09274f$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $8c65a48aef09274f$export$6de0e778727af3f2("Inconsistent open depths");
    return $8c65a48aef09274f$var$replaceOuter($from, $to, slice, 0);
}
function $8c65a48aef09274f$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $8c65a48aef09274f$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $8c65a48aef09274f$var$close(node, $8c65a48aef09274f$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $8c65a48aef09274f$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $8c65a48aef09274f$var$prepareSliceForReplace(slice, $from);
        return $8c65a48aef09274f$var$close(node, $8c65a48aef09274f$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $8c65a48aef09274f$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $8c65a48aef09274f$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $8c65a48aef09274f$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $8c65a48aef09274f$var$checkJoin(node, $after.node(depth));
    return node;
}
function $8c65a48aef09274f$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $8c65a48aef09274f$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $8c65a48aef09274f$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$8c65a48aef09274f$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $8c65a48aef09274f$var$addNode($end.nodeBefore, target);
}
function $8c65a48aef09274f$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $8c65a48aef09274f$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $8c65a48aef09274f$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $8c65a48aef09274f$var$joinable($end, $to, depth + 1);
    let content = [];
    $8c65a48aef09274f$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $8c65a48aef09274f$var$checkJoin(openStart, openEnd);
        $8c65a48aef09274f$var$addNode($8c65a48aef09274f$var$close(openStart, $8c65a48aef09274f$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $8c65a48aef09274f$var$addNode($8c65a48aef09274f$var$close(openStart, $8c65a48aef09274f$var$replaceTwoWay($from, $start, depth + 1)), content);
        $8c65a48aef09274f$var$addRange($start, $end, depth, content);
        if (openEnd) $8c65a48aef09274f$var$addNode($8c65a48aef09274f$var$close(openEnd, $8c65a48aef09274f$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $8c65a48aef09274f$var$addRange($to, null, depth, content);
    return new $8c65a48aef09274f$export$ffb0004e005737fa(content);
}
function $8c65a48aef09274f$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $8c65a48aef09274f$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $8c65a48aef09274f$var$joinable($from, $to, depth + 1);
        $8c65a48aef09274f$var$addNode($8c65a48aef09274f$var$close(type, $8c65a48aef09274f$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $8c65a48aef09274f$var$addRange($to, null, depth, content);
    return new $8c65a48aef09274f$export$ffb0004e005737fa(content);
}
function $8c65a48aef09274f$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($8c65a48aef09274f$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $8c65a48aef09274f$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $8c65a48aef09274f$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $8c65a48aef09274f$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $8c65a48aef09274f$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $8c65a48aef09274f$var$resolveCache.set(doc, cache = new $8c65a48aef09274f$var$ResolveCache);
        let result = cache.elts[cache.i] = $8c65a48aef09274f$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $8c65a48aef09274f$var$resolveCacheSize;
        return result;
    }
}
class $8c65a48aef09274f$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $8c65a48aef09274f$var$resolveCacheSize = 12, $8c65a48aef09274f$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $8c65a48aef09274f$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $8c65a48aef09274f$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $8c65a48aef09274f$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $8c65a48aef09274f$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $8c65a48aef09274f$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $8c65a48aef09274f$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $8c65a48aef09274f$var$emptyAttrs) && $8c65a48aef09274f$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $8c65a48aef09274f$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $8c65a48aef09274f$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $8c65a48aef09274f$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $8c65a48aef09274f$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $8c65a48aef09274f$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $8c65a48aef09274f$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $8c65a48aef09274f$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $8c65a48aef09274f$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $8c65a48aef09274f$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $8c65a48aef09274f$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$8c65a48aef09274f$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $8c65a48aef09274f$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$8c65a48aef09274f$export$85c928794f8d04d4.prototype.text = undefined;
class $8c65a48aef09274f$var$TextNode extends $8c65a48aef09274f$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $8c65a48aef09274f$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $8c65a48aef09274f$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $8c65a48aef09274f$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $8c65a48aef09274f$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $8c65a48aef09274f$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $8c65a48aef09274f$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $8c65a48aef09274f$export$364ed450558d7ec4.empty;
        let expr = $8c65a48aef09274f$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $8c65a48aef09274f$var$dfa($8c65a48aef09274f$var$nfa(expr));
        $8c65a48aef09274f$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $8c65a48aef09274f$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $8c65a48aef09274f$export$364ed450558d7ec4.empty = new $8c65a48aef09274f$export$364ed450558d7ec4(true);
class $8c65a48aef09274f$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $8c65a48aef09274f$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($8c65a48aef09274f$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $8c65a48aef09274f$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($8c65a48aef09274f$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $8c65a48aef09274f$var$parseExprSubscript(stream) {
    let expr = $8c65a48aef09274f$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $8c65a48aef09274f$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $8c65a48aef09274f$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $8c65a48aef09274f$var$parseExprRange(stream, expr) {
    let min = $8c65a48aef09274f$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $8c65a48aef09274f$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $8c65a48aef09274f$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $8c65a48aef09274f$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $8c65a48aef09274f$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $8c65a48aef09274f$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $8c65a48aef09274f$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $8c65a48aef09274f$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $8c65a48aef09274f$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($8c65a48aef09274f$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $8c65a48aef09274f$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($8c65a48aef09274f$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $8c65a48aef09274f$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $8c65a48aef09274f$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($8c65a48aef09274f$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $8c65a48aef09274f$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $8c65a48aef09274f$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $8c65a48aef09274f$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $8c65a48aef09274f$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $8c65a48aef09274f$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $8c65a48aef09274f$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $8c65a48aef09274f$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $8c65a48aef09274f$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $8c65a48aef09274f$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $8c65a48aef09274f$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $8c65a48aef09274f$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $8c65a48aef09274f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $8c65a48aef09274f$export$ffb0004e005737fa.from(content), $8c65a48aef09274f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $8c65a48aef09274f$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $8c65a48aef09274f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $8c65a48aef09274f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $8c65a48aef09274f$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($8c65a48aef09274f$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $8c65a48aef09274f$export$85c928794f8d04d4(this, attrs, content.append(after), $8c65a48aef09274f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $8c65a48aef09274f$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $8c65a48aef09274f$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $8c65a48aef09274f$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $8c65a48aef09274f$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $8c65a48aef09274f$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $8c65a48aef09274f$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $8c65a48aef09274f$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $8c65a48aef09274f$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $8c65a48aef09274f$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $8c65a48aef09274f$export$c9d15bcfc6d42044(this, $8c65a48aef09274f$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $8c65a48aef09274f$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $8c65a48aef09274f$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $8c65a48aef09274f$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $8EaKU.default).from(spec.nodes), instanceSpec.marks = (0, $8EaKU.default).from(spec.marks || {}), this.nodes = $8c65a48aef09274f$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $8c65a48aef09274f$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $8c65a48aef09274f$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $8c65a48aef09274f$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $8c65a48aef09274f$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $8c65a48aef09274f$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $8c65a48aef09274f$var$TextNode(type, type.defaultAttrs, text, $8c65a48aef09274f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $8c65a48aef09274f$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $8c65a48aef09274f$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $8c65a48aef09274f$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $8c65a48aef09274f$var$isTagRule(rule) {
    return rule.tag != null;
}
function $8c65a48aef09274f$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $8c65a48aef09274f$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($8c65a48aef09274f$var$isTagRule(rule)) this.tags.push(rule);
            else if ($8c65a48aef09274f$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $8c65a48aef09274f$var$ParseContext(this, options, false);
        context.addAll(dom, $8c65a48aef09274f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $8c65a48aef09274f$var$ParseContext(this, options, true);
        context.addAll(dom, $8c65a48aef09274f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $8c65a48aef09274f$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($8c65a48aef09274f$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $8c65a48aef09274f$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $8c65a48aef09274f$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $8c65a48aef09274f$export$1059c6e7d2ce5669(schema, $8c65a48aef09274f$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $8c65a48aef09274f$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $8c65a48aef09274f$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $8c65a48aef09274f$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $8c65a48aef09274f$var$OPT_PRESERVE_WS = 1, $8c65a48aef09274f$var$OPT_PRESERVE_WS_FULL = 2, $8c65a48aef09274f$var$OPT_OPEN_LEFT = 4;
function $8c65a48aef09274f$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $8c65a48aef09274f$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $8c65a48aef09274f$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $8c65a48aef09274f$var$OPT_PRESERVE_WS | $8c65a48aef09274f$var$OPT_PRESERVE_WS_FULL : base & ~$8c65a48aef09274f$var$OPT_OPEN_LEFT;
}
class $8c65a48aef09274f$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $8c65a48aef09274f$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($8c65a48aef09274f$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $8c65a48aef09274f$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $8c65a48aef09274f$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($8c65a48aef09274f$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$8c65a48aef09274f$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $8c65a48aef09274f$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $8c65a48aef09274f$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $8c65a48aef09274f$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $8c65a48aef09274f$var$NodeContext(topNode.type, topNode.attrs, $8c65a48aef09274f$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $8c65a48aef09274f$var$NodeContext(null, null, $8c65a48aef09274f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $8c65a48aef09274f$var$NodeContext(parser.schema.topNodeType, null, $8c65a48aef09274f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $8c65a48aef09274f$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $8c65a48aef09274f$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($8c65a48aef09274f$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $8c65a48aef09274f$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $8c65a48aef09274f$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($8c65a48aef09274f$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $8c65a48aef09274f$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $8c65a48aef09274f$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $8c65a48aef09274f$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $8c65a48aef09274f$var$OPT_OPEN_LEFT;
        let applyMarks = $8c65a48aef09274f$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $8c65a48aef09274f$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $8c65a48aef09274f$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $8c65a48aef09274f$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $8c65a48aef09274f$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $8c65a48aef09274f$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $8c65a48aef09274f$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $8c65a48aef09274f$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $8c65a48aef09274f$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $8c65a48aef09274f$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $8c65a48aef09274f$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $8c65a48aef09274f$var$renderSpec($8c65a48aef09274f$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $8c65a48aef09274f$var$renderSpec($8c65a48aef09274f$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $8c65a48aef09274f$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $8c65a48aef09274f$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $8c65a48aef09274f$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $8c65a48aef09274f$var$gatherToDOM(schema.marks);
    }
}
function $8c65a48aef09274f$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $8c65a48aef09274f$var$doc(options) {
    return options.document || window.document;
}
const $8c65a48aef09274f$var$suspiciousAttributeCache = new WeakMap();
function $8c65a48aef09274f$var$suspiciousAttributes(attrs) {
    let value = $8c65a48aef09274f$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $8c65a48aef09274f$var$suspiciousAttributeCache.set(attrs, value = $8c65a48aef09274f$var$suspiciousAttributesInner(attrs));
    return value;
}
function $8c65a48aef09274f$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $8c65a48aef09274f$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $8c65a48aef09274f$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $8c65a48aef09274f$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("8EaKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ba66f94077f8e7$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $64ba66f94077f8e7$var$OrderedMap(content) {
    this.content = content;
}
$64ba66f94077f8e7$var$OrderedMap.prototype = {
    constructor: $64ba66f94077f8e7$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $64ba66f94077f8e7$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $64ba66f94077f8e7$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $64ba66f94077f8e7$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $64ba66f94077f8e7$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $64ba66f94077f8e7$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $64ba66f94077f8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $64ba66f94077f8e7$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $64ba66f94077f8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $64ba66f94077f8e7$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $64ba66f94077f8e7$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$64ba66f94077f8e7$var$OrderedMap.from = function(value) {
    if (value instanceof $64ba66f94077f8e7$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $64ba66f94077f8e7$var$OrderedMap(content);
};
var $64ba66f94077f8e7$export$2e2bcd8739ae039 = $64ba66f94077f8e7$var$OrderedMap;

});


parcelRegister("5IbDB", function(module, exports) {
$parcel$export(module.exports, "addItems", () => $b2de1af74cb86557$export$efa5595d3b524179);
function $b2de1af74cb86557$export$efa5595d3b524179(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
	 * Add built-in Node / Mark specs
	 */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
	 * Add Custom Node / Mark specs
	 */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}

});

parcelRegister("9luPj", function(module, exports) {
$parcel$export(module.exports, "markGroupDeclarations", () => $3bf57b8531f37960$export$78b27f3e8d09085f);
$parcel$export(module.exports, "markGroupDeclarationsNames", () => $3bf57b8531f37960$export$ee0d2ba599b1121f);

// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
function $3bf57b8531f37960$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $3bf57b8531f37960$export$78b27f3e8d09085f = [
    $3bf57b8531f37960$var$groupDeclaration((0, $8e46b016bb3cca28$export$9b982809044276a6)),
    $3bf57b8531f37960$var$groupDeclaration((0, $8e46b016bb3cca28$export$4498a6080fed604c)),
    $3bf57b8531f37960$var$groupDeclaration((0, $8e46b016bb3cca28$export$f8e8a5f34f6ea725)),
    $3bf57b8531f37960$var$groupDeclaration((0, $8e46b016bb3cca28$export$b395009ca7f092c7))
];
const $3bf57b8531f37960$export$ee0d2ba599b1121f = $3bf57b8531f37960$export$78b27f3e8d09085f.map((groupMark)=>groupMark.name);

});
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $8e46b016bb3cca28$export$4498a6080fed604c = 'fontStyle';
const $8e46b016bb3cca28$export$f8e8a5f34f6ea725 = 'searchQuery';
const $8e46b016bb3cca28$export$b395009ca7f092c7 = 'link';
const $8e46b016bb3cca28$export$9b982809044276a6 = 'color';
const $8e46b016bb3cca28$export$470d0905851e47a1 = 'alignment';
const $8e46b016bb3cca28$export$bacb7f4b06a06b22 = 'indentation';


parcelRegister("gb4r4", function(module, exports) {
$parcel$export(module.exports, "marksInOrder", () => $d7d6d88583b9f688$export$2a20daddecce6807);

var $9luPj = parcelRequire("9luPj");

var $j89ja = parcelRequire("j89ja");
var $cpFnz = parcelRequire("cpFnz");
var $2PrQh = parcelRequire("2PrQh");
var $cPeQR = parcelRequire("cPeQR");
var $dmrpa = parcelRequire("dmrpa");
var $dXxI2 = parcelRequire("dXxI2");
var $fQW41 = parcelRequire("fQW41");
var $gOaHA = parcelRequire("gOaHA");
var $gsmSv = parcelRequire("gsmSv");
var $eU5L8 = parcelRequire("eU5L8");
var $g7CDB = parcelRequire("g7CDB");
var $g8H7i = parcelRequire("g8H7i");
var $dwCff = parcelRequire("dwCff");
var $kIV7w = parcelRequire("kIV7w");
var $1JWP0 = parcelRequire("1JWP0");
var $hwzW2 = parcelRequire("hwzW2");
var $lTKZd = parcelRequire("lTKZd");
var $4WGnr = parcelRequire("4WGnr");
var $3JVbY = parcelRequire("3JVbY");
var $2WU8Y = parcelRequire("2WU8Y");
var $gLQW0 = parcelRequire("gLQW0");
const $d7d6d88583b9f688$export$2a20daddecce6807 = [
    {
        name: 'link',
        spec: (0, $dwCff.link)
    },
    {
        name: 'em',
        spec: (0, $gsmSv.em)
    },
    {
        name: 'strong',
        spec: (0, $1JWP0.strong)
    },
    {
        name: 'textColor',
        spec: (0, $lTKZd.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $2PrQh.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $kIV7w.strike)
    },
    {
        name: 'subsup',
        spec: (0, $hwzW2.subsup)
    },
    {
        name: 'underline',
        spec: (0, $3JVbY.underline)
    },
    {
        name: 'code',
        spec: (0, $dXxI2.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $4WGnr.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $j89ja.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $cpFnz.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $fQW41.confluenceInlineComment)
    },
    ...(0, $9luPj.markGroupDeclarations),
    {
        name: 'fontSize',
        spec: (0, $eU5L8.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $dmrpa.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $gOaHA.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $g7CDB.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $g8H7i.indentation)
    },
    {
        name: 'border',
        spec: (0, $cPeQR.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $2WU8Y.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $gLQW0.unsupportedNodeAttribute)
    }
];

});
parcelRegister("j89ja", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $edc7d556d0457eb8$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $edc7d556d0457eb8$export$8e53000a4ec837);

var $1Z6sX = parcelRequire("1Z6sX");
const $edc7d556d0457eb8$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $edc7d556d0457eb8$export$8e53000a4ec837 = (0, $1Z6sX.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("1Z6sX", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $2083559b6473b8d1$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $2083559b6473b8d1$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $2083559b6473b8d1$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $2083559b6473b8d1$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $2083559b6473b8d1$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $2083559b6473b8d1$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $2083559b6473b8d1$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $2083559b6473b8d1$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $2083559b6473b8d1$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $2083559b6473b8d1$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $2083559b6473b8d1$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $2083559b6473b8d1$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $2083559b6473b8d1$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $2083559b6473b8d1$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $2083559b6473b8d1$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $2083559b6473b8d1$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $2083559b6473b8d1$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $2083559b6473b8d1$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $2083559b6473b8d1$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $2083559b6473b8d1$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $2083559b6473b8d1$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $gFRiq = parcelRequire("gFRiq");
const $2083559b6473b8d1$export$8e53000a4ec837 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $2083559b6473b8d1$export$8512c9afa7b24c3b = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $2083559b6473b8d1$export$8c5a050822fd698c = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $2083559b6473b8d1$export$1edee58a52776cd9 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $2083559b6473b8d1$export$89015c65f1c75e3f = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $2083559b6473b8d1$export$6565f9f03506010b = (0, $gFRiq.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $2083559b6473b8d1$export$f3b72f8fc4684ecd = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $2083559b6473b8d1$export$3024f02c495408d6 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $2083559b6473b8d1$export$c63c6f932822f543 = (0, $gFRiq.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $2083559b6473b8d1$export$85e3c3ca0c6fb93 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $2083559b6473b8d1$export$f00aeb236b6f05af = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $2083559b6473b8d1$export$480c699bd4ec0d86 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $2083559b6473b8d1$export$9c30223ca0a664fb = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $2083559b6473b8d1$export$4899a95d70ec5056 = (0, $gFRiq.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $2083559b6473b8d1$export$59ae2c325a998f89 = (0, $gFRiq.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $2083559b6473b8d1$export$b3401ee80eb31041 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $2083559b6473b8d1$export$32f78bffcd82ff28 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $2083559b6473b8d1$export$20af3dabbb5538df = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $2083559b6473b8d1$export$425327af25286e5e = (0, $gFRiq.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $2083559b6473b8d1$export$30d78d5eb6719bb8 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $2083559b6473b8d1$export$a316dc07ff5182a2 = (0, $gFRiq.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});
parcelRegister("gFRiq", function(module, exports) {
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $d3d8ab02b9aaf27d$export$cf5823ed4e9f4c6f);
const $d3d8ab02b9aaf27d$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("cpFnz", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $e18855de16d67c52$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $e18855de16d67c52$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $e18855de16d67c52$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $e18855de16d67c52$export$8512c9afa7b24c3b);

var $1Z6sX = parcelRequire("1Z6sX");
var $e18855de16d67c52$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $e18855de16d67c52$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e18855de16d67c52$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $e18855de16d67c52$export$8512c9afa7b24c3b = (0, $1Z6sX.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$e18855de16d67c52$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("2PrQh", function(module, exports) {
$parcel$export(module.exports, "backgroundColorPalette", () => $9feb8e3f7a9e88d6$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColorPaletteNew", () => $9feb8e3f7a9e88d6$export$5e11ef3de07e2b1);
$parcel$export(module.exports, "backgroundColor", () => $9feb8e3f7a9e88d6$export$8c5a050822fd698c);

var $cn5fq = parcelRequire("cn5fq");

var $1Z6sX = parcelRequire("1Z6sX");

var $362O7 = parcelRequire("362O7");

var $4uPTe = parcelRequire("4uPTe");

var $g91p2 = parcelRequire("g91p2");

var $f7G3x = parcelRequire("f7G3x");

var $lTKZd = parcelRequire("lTKZd");
const $9feb8e3f7a9e88d6$var$colorArrayPalette = [
    [
        (0, $362O7.Neutral300),
        'Gray'
    ],
    [
        (0, $362O7.P200),
        'Purple'
    ],
    [
        (0, $362O7.M200),
        'Magenta'
    ],
    [
        (0, $362O7.O200),
        'Orange'
    ],
    [
        (0, $362O7.Yellow200),
        'Yellow'
    ],
    [
        (0, $362O7.L200),
        'Lime'
    ],
    [
        (0, $362O7.T200),
        'Teal'
    ]
];
const $9feb8e3f7a9e88d6$var$colorArrayPaletteNew = [
    [
        (0, $362O7.Neutral300),
        'Gray'
    ],
    [
        (0, $362O7.B75),
        'Blue'
    ],
    [
        (0, $362O7.T200),
        'Teal'
    ],
    [
        (0, $362O7.G75),
        'Green'
    ],
    [
        (0, $362O7.L200),
        'Lime'
    ],
    [
        (0, $362O7.Yellow200),
        'Yellow'
    ],
    [
        (0, $362O7.O200),
        'Orange'
    ],
    [
        (0, $362O7.R200),
        'Red'
    ],
    [
        (0, $362O7.M200),
        'Magenta'
    ],
    [
        (0, $362O7.P200),
        'Purple'
    ]
];
const $9feb8e3f7a9e88d6$export$14ec3f21a268e497 = new Map();
$9feb8e3f7a9e88d6$var$colorArrayPalette.forEach(([color, label])=>$9feb8e3f7a9e88d6$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $9feb8e3f7a9e88d6$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/iu;
const $9feb8e3f7a9e88d6$export$5e11ef3de07e2b1 = new Map();
$9feb8e3f7a9e88d6$var$colorArrayPaletteNew.forEach(([color, label])=>$9feb8e3f7a9e88d6$export$5e11ef3de07e2b1.set(color.toLowerCase(), label));
const $9feb8e3f7a9e88d6$var$isSupportedBackgroundColor = (hexColor)=>{
    if ($9feb8e3f7a9e88d6$export$14ec3f21a268e497.has(hexColor)) return true;
    return (0, $cn5fq.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $9feb8e3f7a9e88d6$export$5e11ef3de07e2b1.has(hexColor);
};
const $9feb8e3f7a9e88d6$export$8c5a050822fd698c = (0, $1Z6sX.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($9feb8e3f7a9e88d6$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $f7G3x.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $9feb8e3f7a9e88d6$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $9feb8e3f7a9e88d6$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
		 * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
		 *
		 * This behaviour predates the introduction of dark mode.
		 *
		 * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
		 *
		 * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
		 *
		 * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
		 * how we detect text colors copied from external editor sources. Where we load the background color from a
		 * separate attribute (data-text-custom-color), instead of the inline style.
		 *
		 * See the following document for more details on this behaviour
		 * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
		 */ const tokenColor = (0, $g91p2.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $lTKZd.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4uPTe.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("cn5fq", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $3d04ec5c231c88f6$export$63eebf86443a0a61);

var $3mK4j = parcelRequire("3mK4j");
function $3d04ec5c231c88f6$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $3mK4j.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});
parcelRegister("3mK4j", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $64bfc6a5e4c43e5f$export$58e581060588c6bb);

var $4LDqh = parcelRequire("4LDqh");

var $hbvZL = parcelRequire("hbvZL");

var $bzstt = parcelRequire("bzstt");

var $djzuo = parcelRequire("djzuo");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
const $64bfc6a5e4c43e5f$var$allowsProductKeys = [
    'cc-maui-experiment',
    'platform_use_unicode_emojis'
];
function $64bfc6a5e4c43e5f$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    if ((0, $djzuo._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $djzuo._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $4LDqh.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKeyName = $64bfc6a5e4c43e5f$var$allowsProductKeys.includes(experimentName) ? (0, $bzstt.editorExperimentsConfig)[experimentName]?.productKeys?.[0, $djzuo._product] ?? experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4LDqh.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $hbvZL.addFeatureFlagAccessed)(`${experimentKeyName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("bzstt", function(module, exports) {
$parcel$export(module.exports, "disallowsProductKeys", () => $6bb81e68681268a8$export$5c897d5297c5b7fd);
$parcel$export(module.exports, "editorExperimentsConfig", () => $6bb81e68681268a8$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dZgZK = parcelRequire("dZgZK");

var $61VLH = parcelRequire("61VLH");
const $6bb81e68681268a8$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness'
];
const $6bb81e68681268a8$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-08-08
    'example-boolean': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $dZgZK.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $61VLH.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("dZgZK", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $48cb66304653391d$export$456f1587c9c92021);

var $88IIA = parcelRequire("88IIA");
function $48cb66304653391d$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $88IIA.isBoolean),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("88IIA", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $4b3ec2f139cecaa6$export$f9ce7b637dfbe238);
function $4b3ec2f139cecaa6$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("61VLH", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $acdc1b9aa74c0dce$export$fb89e8a786694d1);

var $fRM1H = parcelRequire("fRM1H");
function $acdc1b9aa74c0dce$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $fRM1H.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("fRM1H", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $5f7bd354eb251353$export$a9a18ae5ba42aeab);

var $5tX2G = parcelRequire("5tX2G");
const $5f7bd354eb251353$var$IS_TESTING_ENV = typeof $5tX2G !== 'undefined' && ($5tX2G?.env?.NODE_ENV === 'test' || $5tX2G?.env?.JEST_WORKER_ID !== undefined);
function $5f7bd354eb251353$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($5f7bd354eb251353$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("djzuo", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $df480f4481daeefe$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $df480f4481daeefe$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $df480f4481daeefe$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $df480f4481daeefe$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $b5hzF = parcelRequire("b5hzF");

var $bzstt = parcelRequire("bzstt");
let $df480f4481daeefe$export$e5d73bf4f8e2ae96 = {};
let $df480f4481daeefe$export$4e849416bb5c5b52 = {};
let $df480f4481daeefe$export$cf7305fc65acbf0d;
function $df480f4481daeefe$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $bzstt.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $df480f4481daeefe$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $bzstt.editorExperimentsConfig)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $b5hzF.testMultivariateOverrides)[key] ?? (0, $b5hzF.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $df480f4481daeefe$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $df480f4481daeefe$export$cf7305fc65acbf0d = product;
    $df480f4481daeefe$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("b5hzF", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $e3e86bd5422ac116$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $e3e86bd5422ac116$export$54960937bb713f97);
const $e3e86bd5422ac116$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
const $e3e86bd5422ac116$export$54960937bb713f97 = {
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false
};

});




parcelRegister("362O7", function(module, exports) {
$parcel$export(module.exports, "R50", () => $1883c038767f98f7$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $1883c038767f98f7$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $1883c038767f98f7$export$be802dd0d8b57f35);
$parcel$export(module.exports, "RedBold", () => $1883c038767f98f7$export$8ce25cbf2e1e4328);
$parcel$export(module.exports, "R200", () => $1883c038767f98f7$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $1883c038767f98f7$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $1883c038767f98f7$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $1883c038767f98f7$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $1883c038767f98f7$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $1883c038767f98f7$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $1883c038767f98f7$export$5aae31392d72caaa);
$parcel$export(module.exports, "YellowBold", () => $1883c038767f98f7$export$b9aaaa578bb08b28);
$parcel$export(module.exports, "Yellow200", () => $1883c038767f98f7$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $1883c038767f98f7$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $1883c038767f98f7$export$874739ea9e379ab6);
$parcel$export(module.exports, "Y600", () => $1883c038767f98f7$export$8d067e56aec921ba);
$parcel$export(module.exports, "Y800", () => $1883c038767f98f7$export$880b9499608823af);
$parcel$export(module.exports, "G50", () => $1883c038767f98f7$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $1883c038767f98f7$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $1883c038767f98f7$export$747d86715d4175de);
$parcel$export(module.exports, "GreenBold", () => $1883c038767f98f7$export$4ba6949317382ac4);
$parcel$export(module.exports, "G300", () => $1883c038767f98f7$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $1883c038767f98f7$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $1883c038767f98f7$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $1883c038767f98f7$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $1883c038767f98f7$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $1883c038767f98f7$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "BlueBold", () => $1883c038767f98f7$export$7489d9dce51bb172);
$parcel$export(module.exports, "B400", () => $1883c038767f98f7$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $1883c038767f98f7$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L50", () => $1883c038767f98f7$export$f51762073d2bb381);
$parcel$export(module.exports, "L200", () => $1883c038767f98f7$export$f72948ef771f6f15);
$parcel$export(module.exports, "L400", () => $1883c038767f98f7$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L600", () => $1883c038767f98f7$export$b118f20869cce368);
$parcel$export(module.exports, "L800", () => $1883c038767f98f7$export$4d2dfdfde6a26b06);
$parcel$export(module.exports, "N0", () => $1883c038767f98f7$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $1883c038767f98f7$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $1883c038767f98f7$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $1883c038767f98f7$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $1883c038767f98f7$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $1883c038767f98f7$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "GrayBold", () => $1883c038767f98f7$export$a85cd17eb3a74576);
$parcel$export(module.exports, "N80", () => $1883c038767f98f7$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N90", () => $1883c038767f98f7$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N200", () => $1883c038767f98f7$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $1883c038767f98f7$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $1883c038767f98f7$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $1883c038767f98f7$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $1883c038767f98f7$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $1883c038767f98f7$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $1883c038767f98f7$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $1883c038767f98f7$export$f78789c8b01753cd);
$parcel$export(module.exports, "M50", () => $1883c038767f98f7$export$dce26b47982a2d83);
$parcel$export(module.exports, "M200", () => $1883c038767f98f7$export$a19f0c33186f7767);
$parcel$export(module.exports, "M400", () => $1883c038767f98f7$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M600", () => $1883c038767f98f7$export$3bff0a0c68537008);
$parcel$export(module.exports, "M800", () => $1883c038767f98f7$export$aedcf6658caf5ad6);
$parcel$export(module.exports, "O200", () => $1883c038767f98f7$export$51716a84e62e022c);
$parcel$export(module.exports, "Orange50", () => $1883c038767f98f7$export$8692a80ca6403e1e);
$parcel$export(module.exports, "Orange200", () => $1883c038767f98f7$export$a0fa9fa6bfbb29d1);
$parcel$export(module.exports, "Orange400", () => $1883c038767f98f7$export$e58d39c2a9e7b70e);
$parcel$export(module.exports, "O600", () => $1883c038767f98f7$export$65becf92d294645b);
$parcel$export(module.exports, "O800", () => $1883c038767f98f7$export$d50a5202329f668e);
$parcel$export(module.exports, "P50", () => $1883c038767f98f7$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $1883c038767f98f7$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $1883c038767f98f7$export$6011520a64d9a187);
$parcel$export(module.exports, "PurpleBold", () => $1883c038767f98f7$export$33050b411a4844fe);
$parcel$export(module.exports, "P200", () => $1883c038767f98f7$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $1883c038767f98f7$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $1883c038767f98f7$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $1883c038767f98f7$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $1883c038767f98f7$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $1883c038767f98f7$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $1883c038767f98f7$export$776c9c497ef08533);
$parcel$export(module.exports, "TealBold", () => $1883c038767f98f7$export$f4de2950886ae4c9);
$parcel$export(module.exports, "T200", () => $1883c038767f98f7$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $1883c038767f98f7$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $1883c038767f98f7$export$6036577f95c3877e);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * We're avoding importing these colors from @atlaskit/theme since we
 * do not want to have react as a dependency of this package.
 * TODO: Refactor this once tokenization by Core team is ready
 * https://product-fabric.atlassian.net/browse/CS-908
 */ 





const $1883c038767f98f7$export$4b84fd0e2c617bd = '#FFEBE6';
const $1883c038767f98f7$export$b34b069eff244586 = '#FFBDAD';
const $1883c038767f98f7$export$be802dd0d8b57f35 = '#FF8F73';
const $1883c038767f98f7$export$8ce25cbf2e1e4328 = '#FFB8B2';
const $1883c038767f98f7$export$60847d42f9da92a6 = '#FFD5D2';
const $1883c038767f98f7$export$4a7404f376229999 = '#FF5630';
const $1883c038767f98f7$export$2010d0fb4295b346 = '#DE350B';
const $1883c038767f98f7$export$2837b5a1a71d5c02 = '#BF2600';
const $1883c038767f98f7$export$8d9596b529bbb9cf = '#FFFAE6';
const $1883c038767f98f7$export$41060a744ab0b7ae = '#FFF0B3';
const $1883c038767f98f7$export$5aae31392d72caaa = '#FFC400';
const $1883c038767f98f7$export$b9aaaa578bb08b28 = '#EFDD4E';
const $1883c038767f98f7$export$fc857b6f8771648a = '#F8E6A0';
const $1883c038767f98f7$export$59619663aa6500fb = '#FF991F';
const $1883c038767f98f7$export$874739ea9e379ab6 = '#FF8B00';
const $1883c038767f98f7$export$8d067e56aec921ba = '#B38600';
const $1883c038767f98f7$export$880b9499608823af = '#7F5F01';
const $1883c038767f98f7$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $1883c038767f98f7$export$69a3bf21b9686c2b = '#ABF5D1';
const $1883c038767f98f7$export$747d86715d4175de = '#57D9A3';
const $1883c038767f98f7$export$4ba6949317382ac4 = '#97EDC9';
const $1883c038767f98f7$export$940e1f69e873f202 = '#36B37E';
const $1883c038767f98f7$export$a49394138f7b8e85 = '#00875A';
const $1883c038767f98f7$export$6fa04827ac68a4fb = '#006644';
const $1883c038767f98f7$export$226de0355ed012f8 = '#DEEBFF';
const $1883c038767f98f7$export$8c13c2ee36917869 = '#B3D4FF';
const $1883c038767f98f7$export$ecfc1dff386a3e7a = '#4C9AFF';
const $1883c038767f98f7$export$7489d9dce51bb172 = '#ADCBFB';
const $1883c038767f98f7$export$b3de0ae08da2ce64 = '#0052CC';
const $1883c038767f98f7$export$a6ee3d71bc067634 = '#0747A6';
const $1883c038767f98f7$export$f51762073d2bb381 = '#EFFFD6';
const $1883c038767f98f7$export$f72948ef771f6f15 = '#D3F1A7';
const $1883c038767f98f7$export$4b0a7cabffffd4f5 = '#BDE97C';
const $1883c038767f98f7$export$b118f20869cce368 = '#6A9A23';
const $1883c038767f98f7$export$4d2dfdfde6a26b06 = '#4C6B1F';
const $1883c038767f98f7$export$29a4f05edc054374 = '#FFFFFF';
const $1883c038767f98f7$export$9fdfb749e33cdf97 = '#F4F5F7';
const $1883c038767f98f7$export$3e51e8f1440314ba = '#EBECF0';
const $1883c038767f98f7$export$1ce2d1575d444ceb = '#DFE1E6';
const $1883c038767f98f7$export$8754fc7e6d8b3000 = '#C1C7D0';
const $1883c038767f98f7$export$c2e91cbeada39b8b = '#B3BAC5';
const $1883c038767f98f7$export$a85cd17eb3a74576 = '#B7B9BE';
const $1883c038767f98f7$export$eaa8c8a70ac22806 = '#97A0AF';
const $1883c038767f98f7$export$7c87d337fb91a97d = '#8993A4';
const $1883c038767f98f7$export$f563ee71e9ee74cd = '#6B778C';
const $1883c038767f98f7$export$e2ef2124cf4024b1 = '#5E6C84';
const $1883c038767f98f7$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $1883c038767f98f7$export$13609db0e6812ab8 = '#091E4224';
const $1883c038767f98f7$export$c39c0fe0f26207ae = '#42526E';
const $1883c038767f98f7$export$7090862dc3038a9f = '#758195';
const $1883c038767f98f7$export$7d61b15e0da132af = '#172B4D';
const $1883c038767f98f7$export$f78789c8b01753cd = '#172B4D';
const $1883c038767f98f7$export$dce26b47982a2d83 = '#FFECF8';
const $1883c038767f98f7$export$a19f0c33186f7767 = '#FDD0EC';
const $1883c038767f98f7$export$a1d4686c17e1cdef = '#FCB6E1';
const $1883c038767f98f7$export$3bff0a0c68537008 = '#CD519D';
const $1883c038767f98f7$export$aedcf6658caf5ad6 = '#943D73';
const $1883c038767f98f7$export$51716a84e62e022c = '#FEDEC8';
const $1883c038767f98f7$export$8692a80ca6403e1e = '#FFF5DB';
const $1883c038767f98f7$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
const $1883c038767f98f7$export$e58d39c2a9e7b70e = '#FBD779';
const $1883c038767f98f7$export$65becf92d294645b = '#E06C00';
const $1883c038767f98f7$export$d50a5202329f668e = '#9E4C00';
const $1883c038767f98f7$export$363e4475840015bb = '#EAE6FF';
const $1883c038767f98f7$export$4b0a4417ed59760f = '#C0B6F2';
const $1883c038767f98f7$export$6011520a64d9a187 = '#998DD9';
const $1883c038767f98f7$export$33050b411a4844fe = '#E3BDFA';
const $1883c038767f98f7$export$a7175d4e9206bc80 = '#DFD8FD';
const $1883c038767f98f7$export$b48405b95304b5a1 = '#6554C0';
const $1883c038767f98f7$export$c71e4279dd54a18d = '#5243AA';
const $1883c038767f98f7$export$147899de772240ec = '#403294';
const $1883c038767f98f7$export$2cf711fe14c66f06 = '#E6FCFF';
const $1883c038767f98f7$export$7a8f4d33f6f9772c = '#B3F5FF';
const $1883c038767f98f7$export$776c9c497ef08533 = '#79E2F2';
const $1883c038767f98f7$export$f4de2950886ae4c9 = '#B1E4F7';
const $1883c038767f98f7$export$69cb3ca10c1e330e = '#C6EDFB';
const $1883c038767f98f7$export$9dc1ef0f3f48059b = '#00B8D9';
const $1883c038767f98f7$export$6036577f95c3877e = '#008DA6';

});

parcelRegister("4uPTe", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $4d4e7e14b5bb7cc9$export$a5065c3b8aacaf99);

var $5MXpC = parcelRequire("5MXpC");

var $4VACd = parcelRequire("4VACd");

var $hYSEU = parcelRequire("hYSEU");
const $4d4e7e14b5bb7cc9$var$getLightness = (color)=>{
    const rgb = (0, $4VACd.rgbFromHex)(color);
    if (rgb === null) return 0;
    const lch = (0, $hYSEU.rgbToLch)(rgb);
    return lch.l;
};
const $4d4e7e14b5bb7cc9$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $4d4e7e14b5bb7cc9$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return (0, $5MXpC.clampLightness)(currentBackgroundColor, newLightness).toUpperCase();
};

});
parcelRegister("5MXpC", function(module, exports) {
$parcel$export(module.exports, "clampLightness", () => $2c9595752a6730e2$export$313b8a8fcb34c3b8);

var $4VACd = parcelRequire("4VACd");

var $hYSEU = parcelRequire("hYSEU");
const $2c9595752a6730e2$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $2c9595752a6730e2$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $2c9595752a6730e2$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $2c9595752a6730e2$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $2c9595752a6730e2$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $2c9595752a6730e2$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $2c9595752a6730e2$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $2c9595752a6730e2$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $2c9595752a6730e2$var$lchToRgb = (lch)=>$2c9595752a6730e2$var$xyzToRgb($2c9595752a6730e2$var$labToXyz($2c9595752a6730e2$var$lchToLab(lch)));
const $2c9595752a6730e2$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = (0, $4VACd.rgbFromHex)(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = (0, $hYSEU.rgbToLch)(rgb);
    lch.l = $2c9595752a6730e2$var$clamp(newPercent, 0, 100);
    return $2c9595752a6730e2$var$rgbToHex($2c9595752a6730e2$var$lchToRgb(lch));
};

});
parcelRegister("4VACd", function(module, exports) {
$parcel$export(module.exports, "rgbFromHex", () => $e8e19eb35fd3ec4f$export$d604f368c5212474);

var $7b4mN = parcelRequire("7b4mN");

var $35uZ1 = parcelRequire("35uZ1");
const $e8e19eb35fd3ec4f$export$d604f368c5212474 = (input)=>{
    const fullHex = (0, $7b4mN.expandShorthandHex)(input);
    const result = (0, $35uZ1.FULL_HEX_REGEX).exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};

});
parcelRegister("7b4mN", function(module, exports) {
$parcel$export(module.exports, "expandShorthandHex", () => $8c9f5cabeccebe02$export$f67f480c2f5dd62d);
const $8c9f5cabeccebe02$var$SHORTHAND_HEX_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/iu;
const $8c9f5cabeccebe02$export$f67f480c2f5dd62d = (input)=>input.replace($8c9f5cabeccebe02$var$SHORTHAND_HEX_REGEX, (_m, r, g, b)=>r + r + g + g + b + b);

});

parcelRegister("35uZ1", function(module, exports) {
$parcel$export(module.exports, "FULL_HEX_REGEX", () => $080c4342d7f2089e$export$c3a7521d0ffa04dc);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 







const $080c4342d7f2089e$export$c3a7521d0ffa04dc = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu;

});


parcelRegister("hYSEU", function(module, exports) {
$parcel$export(module.exports, "rgbToLch", () => $12cdf87f4045d348$export$60714bf90ef24e7b);

var $fkgmk = parcelRequire("fkgmk");

var $lsb6o = parcelRequire("lsb6o");

var $jPX2t = parcelRequire("jPX2t");
const $12cdf87f4045d348$export$60714bf90ef24e7b = (rgb)=>(0, $fkgmk.labToLch)((0, $jPX2t.xyzToLab)((0, $lsb6o.rgbToXyz)(rgb)));

});
parcelRegister("fkgmk", function(module, exports) {
$parcel$export(module.exports, "labToLch", () => $1732eec3550c31ff$export$21f398e7d277f911);
const $1732eec3550c31ff$export$21f398e7d277f911 = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};

});

parcelRegister("lsb6o", function(module, exports) {
$parcel$export(module.exports, "rgbToXyz", () => $d6bfd60aea669e0c$export$532d5190d94ac8d7);
const $d6bfd60aea669e0c$export$532d5190d94ac8d7 = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};

});

parcelRegister("jPX2t", function(module, exports) {
$parcel$export(module.exports, "xyzToLab", () => $0613f900065415f4$export$a7b197d2a22fcf09);
const $0613f900065415f4$export$a7b197d2a22fcf09 = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });

});




parcelRegister("g91p2", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $8c793e5bc7aa72a2$export$8b58ff1b36bb75e0);

var $cyXzf = parcelRequire("cyXzf");
function $8c793e5bc7aa72a2$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $cyXzf.textBackgroundColorPalette)[hexColor.toUpperCase()] : undefined;
}

});
parcelRegister("cyXzf", function(module, exports) {
$parcel$export(module.exports, "editorBorderPalette", () => $03ee56495a2c057c$export$aa000893c5e2b9c2);
$parcel$export(module.exports, "editorTextPalette", () => $03ee56495a2c057c$export$57fa5089caad992);
$parcel$export(module.exports, "textBackgroundColorPalette", () => $03ee56495a2c057c$export$12a518ff137dd389);
$parcel$export(module.exports, "editorBackgroundPalette", () => $03ee56495a2c057c$export$2462741d70e6a62f);

var $cn5fq = parcelRequire("cn5fq");
const $03ee56495a2c057c$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
const $03ee56495a2c057c$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)',
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $cn5fq.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? 'var(--ds-border-accent-yellow, #B38600)' : 'var(--ds-icon-accent-yellow, #B38600)';
    },
    /** yellow - strong */ '#7F5F01': 'var(--ds-text-accent-yellow, #7F5F01)'
};
const $03ee56495a2c057c$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Red - light */ '#FFD5D2': 'var(--ds-background-accent-red-subtler, #FFD5D2)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
const $03ee56495a2c057c$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    },
    /** lime - light */ '#EFFFD6': {
        getValue: ()=>'#EFFFD6',
        token: 'var(--ds-background-accent-lime-subtlest, #EFFFD6)'
    },
    /** lime - medium */ '#D3F1A7': {
        getValue: ()=>'#D3F1A7',
        token: 'var(--ds-background-accent-lime-subtler, #D3F1A7)'
    },
    /** lime - bold */ '#BDE97C': {
        getValue: ()=>'#BDE97C',
        token: 'var(--ds-background-accent-lime-subtler-hovered, #BDE97C)'
    },
    /** orange - light */ '#FFF5DB': {
        getValue: ()=>'#FFF5DB',
        token: 'var(--ds-background-accent-orange-subtlest, #FFF5DB)'
    },
    /** orange - medium */ '#FCE4A6': {
        getValue: ()=>'#FCE4A6',
        token: 'var(--ds-background-accent-orange-subtler, #FCE4A6)'
    },
    /** orange - bold */ '#FBD779': {
        getValue: ()=>'#FBD779',
        token: 'var(--ds-background-accent-orange-subtler-hovered, #FBD779)'
    },
    /** magenta - light */ '#FFECF8': {
        getValue: ()=>'#FFECF8',
        token: 'var(--ds-background-accent-magenta-subtlest, #FFECF8)'
    },
    /** magenta - medium */ '#FDD0EC': {
        getValue: ()=>'#FDD0EC',
        token: 'var(--ds-background-accent-magenta-subtler, #FDD0EC)'
    },
    /** magenta - bold */ '#FCB6E1': {
        getValue: ()=>'#FCB6E1',
        token: 'var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)'
    },
    // Bold row mappings using subtler.hovered tokens. These use new hex codes
    // so pre-existing documents keep their old subtle-token mappings above.
    /** blue - bold */ '#ADCBFB': {
        getValue: ()=>'#ADCBFB',
        token: 'var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)'
    },
    /** teal - bold */ '#B1E4F7': {
        getValue: ()=>'#B1E4F7',
        token: 'var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)'
    },
    /** green - bold */ '#97EDC9': {
        getValue: ()=>'#97EDC9',
        token: 'var(--ds-background-accent-green-subtler-hovered, #97EDC9)'
    },
    /** yellow - bold */ '#EFDD4E': {
        getValue: ()=>'#EFDD4E',
        token: 'var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)'
    },
    /** red - bold */ '#FFB8B2': {
        getValue: ()=>'#FFB8B2',
        token: 'var(--ds-background-accent-red-subtler-hovered, #FFB8B2)'
    },
    /** purple - bold */ '#E3BDFA': {
        getValue: ()=>'#E3BDFA',
        token: 'var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)'
    },
    /** gray - bold */ '#B7B9BE': {
        getValue: ()=>'#B7B9BE',
        token: 'var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)'
    }
};

});


parcelRegister("f7G3x", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $02758f02f3cd6b1b$export$34d09c4a771c46ef);
// eslint-disable-line import/no-namespace
function $02758f02f3cd6b1b$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}

});

parcelRegister("lTKZd", function(module, exports) {
$parcel$export(module.exports, "colorPalette", () => $a8b6327b058a5acd$export$569885e57444f84a);
$parcel$export(module.exports, "colorPaletteNew", () => $a8b6327b058a5acd$export$dee1d8a8cb3ab555);
$parcel$export(module.exports, "colorPaletteExtended", () => $a8b6327b058a5acd$export$81e5ed9e84fe2e28);
$parcel$export(module.exports, "getGlobalTheme", () => $a8b6327b058a5acd$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $a8b6327b058a5acd$export$32f78bffcd82ff28);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $cn5fq = parcelRequire("cn5fq");

var $1Z6sX = parcelRequire("1Z6sX");

var $362O7 = parcelRequire("362O7");

var $4uPTe = parcelRequire("4uPTe");

var $kO5ck = parcelRequire("kO5ck");

var $f7G3x = parcelRequire("f7G3x");
// used for extended palette in text color picker
const $a8b6327b058a5acd$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $362O7.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $362O7.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $362O7.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $362O7.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $362O7.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $362O7.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $362O7.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $362O7.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $362O7.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $362O7.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $362O7.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $362O7.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $362O7.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $362O7.N0),
        'White'
    ],
    [
        (0, $362O7.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $362O7.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $362O7.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $362O7.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $362O7.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $362O7.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
const $a8b6327b058a5acd$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $362O7.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $362O7.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $362O7.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $362O7.L800),
        'Dark lime'
    ],
    [
        (0, $362O7.Y800),
        'Dark yellow'
    ],
    [
        (0, $362O7.O800),
        'Dark orange'
    ],
    [
        (0, $362O7.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $362O7.M800),
        'Dark magenta'
    ],
    [
        (0, $362O7.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $362O7.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $362O7.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $362O7.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $362O7.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $362O7.L600),
        'Lime'
    ],
    [
        (0, $362O7.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $362O7.O600),
        'Orange'
    ],
    [
        (0, $362O7.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $362O7.M600),
        'Magenta'
    ],
    [
        (0, $362O7.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $362O7.N0),
        'White'
    ],
    [
        (0, $362O7.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $362O7.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $362O7.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $362O7.L200),
        'Light lime'
    ],
    [
        (0, $362O7.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $362O7.Orange200),
        'Light orange'
    ],
    [
        (0, $362O7.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $362O7.M200),
        'Light magenta'
    ],
    [
        (0, $362O7.P50),
        'Light purple'
    ] // Lavender secret
];
const $a8b6327b058a5acd$export$569885e57444f84a = new Map();
const $a8b6327b058a5acd$export$dee1d8a8cb3ab555 = new Map();
const $a8b6327b058a5acd$export$81e5ed9e84fe2e28 = $a8b6327b058a5acd$export$569885e57444f84a;
$a8b6327b058a5acd$var$colorArrayPalette.forEach(([color, label])=>$a8b6327b058a5acd$export$569885e57444f84a.set(color.toLowerCase(), label));
$a8b6327b058a5acd$var$colorArrayPaletteNew.forEach(([color, label])=>$a8b6327b058a5acd$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label));
const $a8b6327b058a5acd$var$isSupportedTextColor = (hexColor)=>{
    if ($a8b6327b058a5acd$export$569885e57444f84a.has(hexColor)) return true;
    return (0, $cn5fq.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $a8b6327b058a5acd$export$dee1d8a8cb3ab555.has(hexColor);
};
// these are for test only
let $a8b6327b058a5acd$var$testGlobalTheme;
const $a8b6327b058a5acd$export$fd7e0dd2b74807f7 = (theme)=>{
    $a8b6327b058a5acd$var$testGlobalTheme = theme;
};
const $a8b6327b058a5acd$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($a8b6327b058a5acd$var$testGlobalTheme) return {
        colorMode: $a8b6327b058a5acd$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $a8b6327b058a5acd$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/iu;
const $a8b6327b058a5acd$export$32f78bffcd82ff28 = (0, $1Z6sX.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($a8b6327b058a5acd$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $f7G3x.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $a8b6327b058a5acd$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $a8b6327b058a5acd$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $kO5ck.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($a8b6327b058a5acd$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4uPTe.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("kO5ck", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $69728dc5d9ec7b53$export$9c2f408d391feb93);

var $cyXzf = parcelRequire("cyXzf");
function $69728dc5d9ec7b53$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return normalizedHexColor ? (0, $cyXzf.editorTextPalette)[normalizedHexColor] : undefined;
}

});



parcelRegister("cPeQR", function(module, exports) {
$parcel$export(module.exports, "borderColorPalette", () => $dfb1bd958be1591a$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $dfb1bd958be1591a$export$1edee58a52776cd9);

var $1Z6sX = parcelRequire("1Z6sX");

var $362O7 = parcelRequire("362O7");

var $llVUB = parcelRequire("llVUB");
const $dfb1bd958be1591a$var$borderColorArrayPalette = [
    [
        (0, $362O7.N300A),
        'Subtle gray'
    ],
    [
        (0, $362O7.N600),
        'Gray'
    ],
    [
        (0, $362O7.N1000),
        'Bold gray'
    ]
];
const $dfb1bd958be1591a$export$e4e044c989c86ca7 = new Map();
$dfb1bd958be1591a$var$borderColorArrayPalette.forEach(([color, label])=>$dfb1bd958be1591a$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $dfb1bd958be1591a$export$1edee58a52776cd9 = (0, $1Z6sX.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $dfb1bd958be1591a$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $llVUB.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});
parcelRegister("llVUB", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $ec5128a7f99ddf0a$export$bad3c41dd33cb4bc);

var $cyXzf = parcelRequire("cyXzf");
function $ec5128a7f99ddf0a$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $cyXzf.editorBorderPalette)[hexColor.toUpperCase()] : undefined;
}

});


parcelRegister("dmrpa", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $34f2c30f7202d7e9$export$89015c65f1c75e3f);

var $1Z6sX = parcelRequire("1Z6sX");
const $34f2c30f7202d7e9$var$allowedTypes = [
    'wide',
    'full-width'
];
const $34f2c30f7202d7e9$export$89015c65f1c75e3f = (0, $1Z6sX.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $34f2c30f7202d7e9$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': mark.attrs?.width
            },
            0
        ];
    }
});

});

parcelRegister("dXxI2", function(module, exports) {
$parcel$export(module.exports, "code", () => $f969d87ff960fdd1$export$6565f9f03506010b);

var $1Z6sX = parcelRequire("1Z6sX");
const $f969d87ff960fdd1$export$6565f9f03506010b = (0, $1Z6sX.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("fQW41", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $beecf9839477fd75$export$f3b72f8fc4684ecd);

var $1Z6sX = parcelRequire("1Z6sX");
const $beecf9839477fd75$export$f3b72f8fc4684ecd = (0, $1Z6sX.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("gOaHA", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $efbfb47c49116380$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $efbfb47c49116380$export$54fd2c36b5cc6731);

var $1Z6sX = parcelRequire("1Z6sX");

var $kL8C9 = parcelRequire("kL8C9");
const $efbfb47c49116380$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $kL8C9.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $efbfb47c49116380$export$3024f02c495408d6 = (0, $1Z6sX.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$efbfb47c49116380$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $efbfb47c49116380$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("kL8C9", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $1db20bb9f0f8337e$export$c296e2d4365c37a5);
const $1db20bb9f0f8337e$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("gsmSv", function(module, exports) {
$parcel$export(module.exports, "em", () => $6e9f34c2dbc981b3$export$c63c6f932822f543);

var $1Z6sX = parcelRequire("1Z6sX");
const $6e9f34c2dbc981b3$var$emDOM = [
    'em'
];
const $6e9f34c2dbc981b3$export$c63c6f932822f543 = (0, $1Z6sX.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $6e9f34c2dbc981b3$var$emDOM;
    }
});

});

parcelRegister("eU5L8", function(module, exports) {
$parcel$export(module.exports, "fontSize", () => $271325d4fdd58322$export$85e3c3ca0c6fb93);

var $1Z6sX = parcelRequire("1Z6sX");
const $271325d4fdd58322$var$allowedSizes = [
    'small'
];
const $271325d4fdd58322$export$85e3c3ca0c6fb93 = (0, $1Z6sX.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $271325d4fdd58322$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});

});

parcelRegister("g7CDB", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $5d24c220f155976b$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $5d24c220f155976b$export$54fd2c36b5cc6731);

var $1Z6sX = parcelRequire("1Z6sX");

var $kL8C9 = parcelRequire("kL8C9");
const $5d24c220f155976b$var$parseFragment = (maybeValue)=>{
    if (!(0, $kL8C9.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $5d24c220f155976b$export$f00aeb236b6f05af = (0, $1Z6sX.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$5d24c220f155976b$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $5d24c220f155976b$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("g8H7i", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $7996dc9b421dde51$export$480c699bd4ec0d86);

var $1Z6sX = parcelRequire("1Z6sX");
const $7996dc9b421dde51$export$480c699bd4ec0d86 = (0, $1Z6sX.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("dwCff", function(module, exports) {
$parcel$export(module.exports, "link", () => $f3a187cb1a9cd220$export$9c30223ca0a664fb);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $1Z6sX = parcelRequire("1Z6sX");

var $2PNLJ = parcelRequire("2PNLJ");

var $aR7eZ = parcelRequire("aR7eZ");

const $f3a187cb1a9cd220$export$9c30223ca0a664fb = (0, $1Z6sX.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: (0, $aR7eZ.getLinkAttrs)('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: (0, $aR7eZ.getLinkAttrs)('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $2PNLJ.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});

});
parcelRegister("2PNLJ", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $55aad6ab75c4ffd5$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $55aad6ab75c4ffd5$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $55aad6ab75c4ffd5$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url?.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $55aad6ab75c4ffd5$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};

});

parcelRegister("aR7eZ", function(module, exports) {
$parcel$export(module.exports, "getLinkAttrs", () => $11c7acad4cc0d9a9$export$b5f67017585d1431);

var $lQSE3 = parcelRequire("lQSE3");

var $2PNLJ = parcelRequire("2PNLJ");

var $6hwun = parcelRequire("6hwun");
const $11c7acad4cc0d9a9$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $2PNLJ.isSafeUrl)(href)) return false;
        if ((0, $lQSE3.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $6hwun.normalizeUrl)(href);
        return attrs;
    };

});
parcelRegister("lQSE3", function(module, exports) {
$parcel$export(module.exports, "isRootRelative", () => $5111828705ccd4bb$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ /**
 * checks if root relative link
 */ function $5111828705ccd4bb$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});

parcelRegister("6hwun", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $1d17602c2c086db7$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $7bkJw = parcelRequire("7bkJw");
function $1d17602c2c086db7$export$6535eb414fa2c8b6(url) {
    const match = (0, $7bkJw.getLinkMatch)(url);
    return match && match.url || '';
}

});
parcelRegister("7bkJw", function(module, exports) {
$parcel$export(module.exports, "getLinkMatch", () => $f2d281d3f4ae34c3$export$ce9ae45aed3e4ec);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $eaVpm = parcelRequire("eaVpm");

var $kqkvJ = parcelRequire("kqkvJ");
function $f2d281d3f4ae34c3$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = (0, $eaVpm.linkifyMatch)(str);
    if (!match.length) match = (0, $kqkvJ.linkify).match(str);
    return match && match[0];
}

});
parcelRegister("eaVpm", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $998ee574a4a8ddb9$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $kqkvJ = parcelRequire("kqkvJ");
const $998ee574a4a8ddb9$export$6f7d7761b97f967 = (text)=>{
    if (!(0, $kqkvJ.LINK_REGEXP).test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match((0, $kqkvJ.LINK_REGEXP)) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search((0, $kqkvJ.LINK_REGEXP));
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};

});
parcelRegister("kqkvJ", function(module, exports) {
$parcel$export(module.exports, "linkify", () => $d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "LINK_REGEXP", () => $d7ecfd02b07e8ffd$export$746d02eae03c72e1);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $5OdXs = parcelRequire("5OdXs");

var $iqfTZ = parcelRequire("iqfTZ");





const $d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7 = new (0, $5OdXs.default)();
const $d7ecfd02b07e8ffd$var$URI_WITHOUT_SPACES = /[^\s]+/u;
const $d7ecfd02b07e8ffd$var$URI_WITHOUT_SPACES_ANCHORED = /^[^\s]+/u;
const $d7ecfd02b07e8ffd$var$urlWithoutSpacesValidator = {
    validate: (text, pos)=>{
        const tail = text.slice(pos);
        const pattern = (0, $iqfTZ.fg)('platform_bugfix_invalid_urls_parsing_in_editor') ? $d7ecfd02b07e8ffd$var$URI_WITHOUT_SPACES_ANCHORED : $d7ecfd02b07e8ffd$var$URI_WITHOUT_SPACES;
        const match = tail.match(pattern);
        return match ? match[0].length : 0;
    }
};
const $d7ecfd02b07e8ffd$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $d7ecfd02b07e8ffd$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $d7ecfd02b07e8ffd$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
$d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
$d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7.add('tel:', $d7ecfd02b07e8ffd$var$urlWithoutSpacesValidator);
$d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7.add('file:', $d7ecfd02b07e8ffd$var$urlWithoutSpacesValidator);
$d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
$d7ecfd02b07e8ffd$var$tlds.push($d7ecfd02b07e8ffd$var$tlds2Char);
$d7ecfd02b07e8ffd$export$8ccbde94d5c7f8e7.tlds($d7ecfd02b07e8ffd$var$tlds, false);

});
parcelRegister("5OdXs", function(module, exports) {
$parcel$export(module.exports, "default", () => $43ac730dad0c00d2$export$2e2bcd8739ae039);

var $8z1jO = parcelRequire("8z1jO");
//
// Helpers
//
// Merge objects
//
function $43ac730dad0c00d2$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $43ac730dad0c00d2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $43ac730dad0c00d2$var$isString(obj) {
    return $43ac730dad0c00d2$var$_class(obj) === '[object String]';
}
function $43ac730dad0c00d2$var$isObject(obj) {
    return $43ac730dad0c00d2$var$_class(obj) === '[object Object]';
}
function $43ac730dad0c00d2$var$isRegExp(obj) {
    return $43ac730dad0c00d2$var$_class(obj) === '[object RegExp]';
}
function $43ac730dad0c00d2$var$isFunction(obj) {
    return $43ac730dad0c00d2$var$_class(obj) === '[object Function]';
}
function $43ac730dad0c00d2$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $43ac730dad0c00d2$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $43ac730dad0c00d2$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $43ac730dad0c00d2$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $43ac730dad0c00d2$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp(`^\\/\\/${self.re.src_auth}${self.re.src_host_port_strict}${self.re.src_path}`, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            `(?:localhost|(?:(?:${self.re.src_domain})\\.)+${self.re.src_domain_root})` + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp(`^${self.re.src_email_name}@${self.re.src_host_strict}`, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
const $43ac730dad0c00d2$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $43ac730dad0c00d2$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $43ac730dad0c00d2$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $43ac730dad0c00d2$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $43ac730dad0c00d2$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $8z1jO.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($43ac730dad0c00d2$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.email_fuzzy_global = RegExp(untpl(re.tpl_email_fuzzy), 'ig');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_fuzzy_global = RegExp(untpl(re.tpl_link_fuzzy), 'ig');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.link_no_ip_fuzzy_global = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'ig');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error(`(LinkifyIt) Invalid schema "${name}": ${val}`);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($43ac730dad0c00d2$var$isObject(val)) {
            if ($43ac730dad0c00d2$var$isRegExp(val.validate)) compiled.validate = $43ac730dad0c00d2$var$createValidator(val.validate);
            else if ($43ac730dad0c00d2$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($43ac730dad0c00d2$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $43ac730dad0c00d2$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($43ac730dad0c00d2$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $43ac730dad0c00d2$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($43ac730dad0c00d2$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'i');
    self.re.schema_search = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'ig');
    self.re.schema_at_start = RegExp(`^${self.re.schema_search.source}`, 'i');
    self.re.pretest = RegExp(`(${self.re.schema_test.source})|(${self.re.host_fuzzy_test.source})|@`, 'i');
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $43ac730dad0c00d2$var$Match(text, schema, index, lastIndex) {
    const raw = text.slice(index, lastIndex);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = schema.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = index;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = lastIndex;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = raw;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = raw;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = raw;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $43ac730dad0c00d2$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $43ac730dad0c00d2$var$LinkifyIt)) return new $43ac730dad0c00d2$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($43ac730dad0c00d2$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $43ac730dad0c00d2$var$assign({}, $43ac730dad0c00d2$var$defaultOptions, options);
    this.__schemas__ = $43ac730dad0c00d2$var$assign({}, $43ac730dad0c00d2$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $43ac730dad0c00d2$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $43ac730dad0c00d2$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $43ac730dad0c00d2$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $43ac730dad0c00d2$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.test = function test(text) {
    if (!text.length) return false;
    let m, re;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            if (this.testSchemaAt(text, m[2], re.lastIndex)) return true;
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) // guess schemaless links
    {
        if (text.search(this.re.host_fuzzy_test) >= 0) {
            if (text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) return true;
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) // guess schemaless emails
    {
        if (text.indexOf('@') >= 0) {
            // We can't skip this check, because this cases are possible:
            // 192.168.1.1@gmail.com, my.in@example.com
            if (text.match(this.re.email_fuzzy) !== null) return true;
        }
    }
    return false;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    const type_schemed = [];
    const type_fuzzy_link = [];
    const type_fuzzy_email = [];
    let m, len, re;
    function choose(a, b) {
        if (!a) return b;
        if (!b) return a;
        if (a.index !== b.index) return a.index < b.index ? a : b;
        return a.lastIndex >= b.lastIndex ? a : b;
    }
    if (!text.length) return null;
    // scan for links with schema
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) type_schemed.push({
                schema: m[2],
                index: m.index + m[1].length,
                lastIndex: m.index + m[0].length + len
            });
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        re = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_link.push({
            schema: '',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        re = this.re.email_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_email.push({
            schema: 'mailto:',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    const indexes = [
        0,
        0,
        0
    ];
    let lastIndex = 0;
    for(;;){
        const candidates = [
            type_schemed[indexes[0]],
            type_fuzzy_email[indexes[1]],
            type_fuzzy_link[indexes[2]]
        ];
        const candidate = choose(choose(candidates[0], candidates[1]), candidates[2]);
        if (!candidate) break;
        if (candidate === candidates[0]) indexes[0]++;
        else if (candidate === candidates[1]) indexes[1]++;
        else indexes[2]++;
        if (candidate.index < lastIndex) continue;
        const match = new $43ac730dad0c00d2$var$Match(text, candidate.schema, candidate.index, candidate.lastIndex);
        this.__compiled__[match.schema].normalize(match, this);
        result.push(match);
        lastIndex = candidate.lastIndex;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    const match = new $43ac730dad0c00d2$var$Match(text, m[2], m.index + m[1].length, m.index + m[0].length + len);
    this.__compiled__[match.schema].normalize(match, this);
    return match;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $43ac730dad0c00d2$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $43ac730dad0c00d2$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = `http://${match.url}`;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = `mailto:${match.url}`;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $43ac730dad0c00d2$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $43ac730dad0c00d2$export$2e2bcd8739ae039 = $43ac730dad0c00d2$var$LinkifyIt;

});
parcelRegister("8z1jO", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c29d7828f5305c$export$2e2bcd8739ae039);
parcelRequire("elT2I");
var $lrWjP = parcelRequire("lrWjP");
var $1lqio = parcelRequire("1lqio");
var $iCYSh = parcelRequire("iCYSh");
var $la7EW = parcelRequire("la7EW");
function $63c29d7828f5305c$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $lrWjP.default).source;
    re.src_Cc = (0, $1lqio.default).source;
    re.src_Z = (0, $la7EW.default).source;
    re.src_P = (0, $iCYSh.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = `(?:(?!${text_separators}|${re.src_ZPCc})${re.src_Any})`;
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    // Length is capped to exclude possible rescans till the end and avoid O(n^2)
    // DoS. No standard limit, just take something reasonable.
    re.src_auth = `(?:(?:(?!${re.src_ZCc}|[@/\\[\\]()]).){1,50}@)?`;
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = `(?=$|${text_separators}|${re.src_ZPCc})` + `(?!${opts['---'] ? '-(?!--)|' : '-|'}_|:\\d|\\.-|\\.(?!$|${re.src_ZPCc}))`;
    re.src_path = "(?:[/?#](?:" + `(?!${re.src_ZCc}|${text_separators}|[()[\\]{}.,"'?!\\-;]).|` + `\\[(?:(?!${re.src_ZCc}|\\]).)*\\]|` + `\\((?:(?!${re.src_ZCc}|[)]).)*\\)|` + `\\{(?:(?!${re.src_ZCc}|[}]).)*\\}|` + `\\"(?:(?!${re.src_ZCc}|["]).)+\\"|` + `\\'(?:(?!${re.src_ZCc}|[']).)+\\'|` + // allow `I'm_king` if no pair found
    `\\'(?=${re.src_pseudo_letter}|[-])|` + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + `\\.(?!${re.src_ZCc}|[.]|$)|` + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    `,(?!${re.src_ZCc}|$)|` + // allow `;` if not followed by space-like char
    `;(?!${re.src_ZCc}|$)|` + // allow `!!!` in paths, but not at the end
    `\\!+(?!${re.src_ZCc}|[!]|$)|` + `\\?(?!${re.src_ZCc}|[?]|$)` + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    // Max name length capped to 64 chars (RFC 5321). This also prevents O(n^2)
    // rescans to the end on inputs like `mailto:mailto:...`
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]{0,63}';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + `${re.src_pseudo_letter}{1,63}` + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + `(?:${re.src_pseudo_letter})` + '|' + `(?:${re.src_pseudo_letter}(?:-|${re.src_pseudo_letter}){0,61}${re.src_pseudo_letter})` + ')';
    re.src_host = '(?:' + // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
    `(?:(?:(?:${re.src_domain})\\.)*${re.src_domain})` + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))` + ')';
    re.tpl_host_no_ip_fuzzy = `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))`;
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:${re.src_ZPCc}|>|$))`;
    re.tpl_email_fuzzy = `(^|${text_separators}|"|\\(|${re.src_ZCc})` + `(${re.src_email_name}@${re.tpl_host_fuzzy_strict})`;
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_fuzzy_strict}${re.src_path})`;
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_no_ip_fuzzy_strict}${re.src_path})`;
    return re;
}

});
parcelRegister("elT2I", function(module, exports) {
$parcel$export(module.exports, "Any", () => (parcelRequire("lrWjP")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("1lqio")).default);
$parcel$export(module.exports, "Cf", () => (parcelRequire("fsKot")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("iCYSh")).default);
$parcel$export(module.exports, "S", () => (parcelRequire("lhNsJ")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("la7EW")).default);

var $lrWjP = parcelRequire("lrWjP");

var $1lqio = parcelRequire("1lqio");

var $fsKot = parcelRequire("fsKot");

var $iCYSh = parcelRequire("iCYSh");

var $lhNsJ = parcelRequire("lhNsJ");

var $la7EW = parcelRequire("la7EW");

});
parcelRegister("lrWjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9d95b83391c8a2d$export$2e2bcd8739ae039);
var $f9d95b83391c8a2d$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("1lqio", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fac266018b5f2d2$export$2e2bcd8739ae039);
var $0fac266018b5f2d2$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("fsKot", function(module, exports) {
$parcel$export(module.exports, "default", () => $b41d755a4d6b8a6b$export$2e2bcd8739ae039);
var $b41d755a4d6b8a6b$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("iCYSh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8faff08a5835a57$export$2e2bcd8739ae039);
var $d8faff08a5835a57$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("lhNsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f18db96cd599b3$export$2e2bcd8739ae039);
var $f7f18db96cd599b3$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("la7EW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f680791c03497eb0$export$2e2bcd8739ae039);
var $f680791c03497eb0$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});










parcelRegister("kIV7w", function(module, exports) {
$parcel$export(module.exports, "strike", () => $63e2484740a10be4$export$4899a95d70ec5056);

var $1Z6sX = parcelRequire("1Z6sX");
const $63e2484740a10be4$export$4899a95d70ec5056 = (0, $1Z6sX.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("1JWP0", function(module, exports) {
$parcel$export(module.exports, "strong", () => $5470e1bc6981756f$export$59ae2c325a998f89);

var $1Z6sX = parcelRequire("1Z6sX");
const $5470e1bc6981756f$var$strongDOM = [
    'strong'
];
const $5470e1bc6981756f$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9]\d{2,})$/u;
const $5470e1bc6981756f$export$59ae2c325a998f89 = (0, $1Z6sX.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $5470e1bc6981756f$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $5470e1bc6981756f$var$strongDOM;
    }
});

});

parcelRegister("hwzW2", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $6b95625fbfc297d8$export$b3401ee80eb31041);

var $1Z6sX = parcelRequire("1Z6sX");
function $6b95625fbfc297d8$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $6b95625fbfc297d8$export$b3401ee80eb31041 = (0, $1Z6sX.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$6b95625fbfc297d8$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$6b95625fbfc297d8$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("4WGnr", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $a7193aaf24b064ca$export$20af3dabbb5538df);

var $1Z6sX = parcelRequire("1Z6sX");

var $362O7 = parcelRequire("362O7");
const $a7193aaf24b064ca$export$20af3dabbb5538df = (0, $1Z6sX.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $362O7.B400)}`
            }
        ];
    }
});

});

parcelRegister("3JVbY", function(module, exports) {
$parcel$export(module.exports, "underline", () => $f62aaa695d7789f4$export$425327af25286e5e);

var $1Z6sX = parcelRequire("1Z6sX");
const $f62aaa695d7789f4$export$425327af25286e5e = (0, $1Z6sX.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("2WU8Y", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $b907663ec44f0c24$export$30d78d5eb6719bb8);

var $1Z6sX = parcelRequire("1Z6sX");
const $b907663ec44f0c24$export$30d78d5eb6719bb8 = (0, $1Z6sX.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("gLQW0", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $15d6fba02f77eed7$export$a316dc07ff5182a2);

var $1Z6sX = parcelRequire("1Z6sX");
const $15d6fba02f77eed7$export$a316dc07ff5182a2 = (0, $1Z6sX.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});


parcelRegister("ekca7", function(module, exports) {
$parcel$export(module.exports, "nodesInOrder", () => $ad7b761ce4fc2f09$export$77d2c0ec1ddbfa6c);

var $gdRl1 = parcelRequire("gdRl1");
var $jeJW3 = parcelRequire("jeJW3");
var $k5JTK = parcelRequire("k5JTK");
var $3WThI = parcelRequire("3WThI");
var $9R6do = parcelRequire("9R6do");
var $04yOa = parcelRequire("04yOa");
var $lklwG = parcelRequire("lklwG");
var $gbJ5m = parcelRequire("gbJ5m");
var $Ey7SE = parcelRequire("Ey7SE");
var $bU4hE = parcelRequire("bU4hE");
var $8sjT8 = parcelRequire("8sjT8");
var $4a5W3 = parcelRequire("4a5W3");
var $6Ay0J = parcelRequire("6Ay0J");
var $5Wu5o = parcelRequire("5Wu5o");
var $aJRkQ = parcelRequire("aJRkQ");
var $jR4g0 = parcelRequire("jR4g0");
var $b3Zoi = parcelRequire("b3Zoi");
var $7n5Be = parcelRequire("7n5Be");
var $drQo7 = parcelRequire("drQo7");
var $9aBD1 = parcelRequire("9aBD1");
var $22R95 = parcelRequire("22R95");
var $dGNE8 = parcelRequire("dGNE8");
var $1rlZ6 = parcelRequire("1rlZ6");
var $3jP3u = parcelRequire("3jP3u");
var $aFQVV = parcelRequire("aFQVV");
var $hGMiA = parcelRequire("hGMiA");
var $jfvyT = parcelRequire("jfvyT");
var $ZTMwP = parcelRequire("ZTMwP");
var $fQBtT = parcelRequire("fQBtT");
var $cL7eE = parcelRequire("cL7eE");
var $k6DLS = parcelRequire("k6DLS");
var $35VDH = parcelRequire("35VDH");
var $3zde7 = parcelRequire("3zde7");
var $5L24F = parcelRequire("5L24F");
var $cDeo1 = parcelRequire("cDeo1");
var $lfuSq = parcelRequire("lfuSq");
var $lWPov = parcelRequire("lWPov");
var $4SrYU = parcelRequire("4SrYU");
var $iK3hE = parcelRequire("iK3hE");
var $lT7kI = parcelRequire("lT7kI");
var $itzC4 = parcelRequire("itzC4");
var $dNMPP = parcelRequire("dNMPP");
var $4L22w = parcelRequire("4L22w");
var $4TQA2 = parcelRequire("4TQA2");
var $aeONV = parcelRequire("aeONV");
var $1Zvzi = parcelRequire("1Zvzi");
var $fHe1g = parcelRequire("fHe1g");
var $avjHo = parcelRequire("avjHo");

var $a6aOH = parcelRequire("a6aOH");
const $ad7b761ce4fc2f09$export$77d2c0ec1ddbfa6c = [
    {
        name: 'doc',
        spec: (0, $5Wu5o.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $4SrYU.paragraph)
    },
    {
        name: 'text',
        spec: (0, $aeONV.text)
    },
    {
        name: 'bulletList',
        spec: (0, $9R6do.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $lWPov.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $cL7eE.listItem)
    },
    {
        name: 'heading',
        spec: (0, $3jP3u.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $7n5Be.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $lklwG.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $drQo7.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $9aBD1.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $lT7kI.rule)
    },
    {
        name: 'bodiedRule',
        spec: (0, $a6aOH.bodiedRule)
    },
    {
        name: 'image',
        spec: (0, $aFQVV.image)
    },
    {
        name: 'mention',
        spec: (0, $cDeo1.mention)
    },
    {
        name: 'caption',
        spec: (0, $04yOa.caption)
    },
    {
        name: 'media',
        spec: (0, $k6DLS.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $35VDH.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $5L24F.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $3zde7.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $iK3hE.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $fQBtT.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $ZTMwP.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $1rlZ6.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $jR4g0.emoji)
    },
    {
        name: 'table',
        spec: (0, $4L22w.table)
    },
    {
        name: 'tableCell',
        spec: (0, $4L22w.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $4L22w.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $4L22w.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $gbJ5m.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bU4hE.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $Ey7SE.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $6Ay0J.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $4a5W3.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $4TQA2.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $jeJW3.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $jeJW3.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $8sjT8.date)
    },
    {
        name: 'status',
        spec: (0, $itzC4.status)
    },
    {
        name: 'expand',
        spec: (0, $b3Zoi.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $lfuSq.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $22R95.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $jfvyT.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $k5JTK.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $dGNE8.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $dGNE8.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $hGMiA.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $gdRl1.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $aJRkQ.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $dNMPP.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $3WThI.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $1Zvzi.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $fHe1g.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $avjHo.unsupportedInline)
    }
];

});
parcelRegister("gdRl1", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $b2d7fcde9a1bf2af$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $b2d7fcde9a1bf2af$export$9894f24949f094e5);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $b2d7fcde9a1bf2af$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $b2d7fcde9a1bf2af$export$c4c2f833baaebdb8 = (0, $blgFF.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$b2d7fcde9a1bf2af$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$b2d7fcde9a1bf2af$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
const $b2d7fcde9a1bf2af$export$9894f24949f094e5 = (0, $blgFF.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$b2d7fcde9a1bf2af$var$getCommonAttributesFromDom(dom),
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$b2d7fcde9a1bf2af$var$getCommonAttributesFromDom(dom),
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});

});
parcelRegister("blgFF", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $10bbba9f0890e37a$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $10bbba9f0890e37a$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $10bbba9f0890e37a$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $10bbba9f0890e37a$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $10bbba9f0890e37a$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedRuleStage0", () => $10bbba9f0890e37a$export$fedbe6c839176437);
$parcel$export(module.exports, "bodiedSyncBlock", () => $10bbba9f0890e37a$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $10bbba9f0890e37a$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $10bbba9f0890e37a$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $10bbba9f0890e37a$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $10bbba9f0890e37a$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $10bbba9f0890e37a$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $10bbba9f0890e37a$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $10bbba9f0890e37a$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $10bbba9f0890e37a$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $10bbba9f0890e37a$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $10bbba9f0890e37a$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $10bbba9f0890e37a$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $10bbba9f0890e37a$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $10bbba9f0890e37a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $10bbba9f0890e37a$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $10bbba9f0890e37a$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $10bbba9f0890e37a$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $10bbba9f0890e37a$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $10bbba9f0890e37a$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $10bbba9f0890e37a$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $10bbba9f0890e37a$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $10bbba9f0890e37a$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $10bbba9f0890e37a$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $10bbba9f0890e37a$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $10bbba9f0890e37a$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $10bbba9f0890e37a$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $10bbba9f0890e37a$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $10bbba9f0890e37a$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $10bbba9f0890e37a$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $10bbba9f0890e37a$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $10bbba9f0890e37a$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $10bbba9f0890e37a$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $10bbba9f0890e37a$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $10bbba9f0890e37a$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $10bbba9f0890e37a$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $10bbba9f0890e37a$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $10bbba9f0890e37a$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $10bbba9f0890e37a$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelC1Stage0", () => $10bbba9f0890e37a$export$6f6742e395e02fdc);
$parcel$export(module.exports, "paragraph", () => $10bbba9f0890e37a$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $10bbba9f0890e37a$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $10bbba9f0890e37a$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $10bbba9f0890e37a$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $10bbba9f0890e37a$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $10bbba9f0890e37a$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $10bbba9f0890e37a$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $10bbba9f0890e37a$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $10bbba9f0890e37a$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $10bbba9f0890e37a$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $10bbba9f0890e37a$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $10bbba9f0890e37a$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $10bbba9f0890e37a$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $10bbba9f0890e37a$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $10bbba9f0890e37a$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $10bbba9f0890e37a$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $10bbba9f0890e37a$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $10bbba9f0890e37a$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $lxG6u = parcelRequire("lxG6u");
const $10bbba9f0890e37a$export$c4c2f833baaebdb8 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $10bbba9f0890e37a$export$67dc04e652a298ca = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $10bbba9f0890e37a$export$199922e5af8e9a6 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $10bbba9f0890e37a$export$16018c61064a18df = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$27903d543b563e39 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $10bbba9f0890e37a$export$8bbe5aa5bba36cc1 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $10bbba9f0890e37a$export$e7320d153c538837 = (0, $lxG6u.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $10bbba9f0890e37a$export$208411233915368e = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$fedbe6c839176437 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$e92c7e4302dd4371 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel_c1 | panel | rule | bodiedRule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $10bbba9f0890e37a$export$a140c94e5ea26bee = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$8e3c2dfdc4f0453d = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $10bbba9f0890e37a$export$7bb0d5c671655cc4 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $10bbba9f0890e37a$export$e4f1c66d84049f8b = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $10bbba9f0890e37a$export$daf889beb5092f95 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$e6e4878f43c27cab = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$3e6d667072febc87 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$324d90190a8b822a = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$47988d68fe575725 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$6959e16eeff859b4 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $10bbba9f0890e37a$export$62d45a65fb43d95e = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$2a111da947c407d2 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | codeBlock | panel | panel_c1_root_only | rule | bodiedRule | extension | bodiedExtension | multiBodiedExtension | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation breakout'
});
const $10bbba9f0890e37a$export$be4283d9a1cb1ff6 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$a19185d1233fc4b2 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$f5574b5d45fc2112 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$9f77e0932fb78f72 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $10bbba9f0890e37a$export$7e3788972005cc72 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $10bbba9f0890e37a$export$1b45514b112dd749 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$ad06037362b3c3b3 = (0, $lxG6u.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$243bc54b0560ecc = (0, $lxG6u.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$3e3366ebd634cc62 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$a8baf338431a691 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$b555be60c7703afb = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $10bbba9f0890e37a$export$371da9dd35aba193 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $10bbba9f0890e37a$export$46e4a324ac90507f = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$1b0c1557b234fa00 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$85461f751c457cc2 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$2b380a0f7e250af1 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$5c452ff88e35e47d = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $10bbba9f0890e37a$export$cbf8224b64e0d942 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $10bbba9f0890e37a$export$2f4e72b9459914ad = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $10bbba9f0890e37a$export$16b353b2649bd8d9 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$b3b1e36c2105006d = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$ab76e7c03cd6f650 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $10bbba9f0890e37a$export$b3b6a70a7fa4a5be = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $10bbba9f0890e37a$export$cdae19acb0a520fd = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $10bbba9f0890e37a$export$206007566ca0aca5 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $10bbba9f0890e37a$export$76c7e83ecc9cdf05 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$987d49ffe1b0900f = (0, $lxG6u.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$2855e964765eac9 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $10bbba9f0890e37a$export$38bab695e3f720f1 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$969fe3781ca15058 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $10bbba9f0890e37a$export$8d067f22dc2d1254 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$7e767666f2ce108a = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$4bd9a38995f6bf50 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$db83999c14438df4 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$46f790bd65f760d0 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$6f4c18ddc3950a66 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $10bbba9f0890e37a$export$750e45819f66d9d0 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $10bbba9f0890e37a$export$63cadbf5f4296627 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | bodiedRule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $10bbba9f0890e37a$export$f03786aa6312d1e4 = (0, $lxG6u.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $10bbba9f0890e37a$export$a5dc81035676e7a = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$21f42ab9b6679f44 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$862432e0a10d1bc1 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$6f6742e395e02fdc = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$7eb9416336a42c2b = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$9c206ddddb32a9b = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$4f98472e6dc14293 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$b0710a201beac6b2 = (0, $lxG6u.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$ea332b61641b0588 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$a1f41dc4901771f8 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$c7187bbd1a7a9244 = (0, $lxG6u.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $10bbba9f0890e37a$export$fbeb3a3956e8a3c7 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$1d53b70195c9c417 = (0, $lxG6u.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$78cca5eef2450890 = (0, $lxG6u.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$17f7139bf40eed49 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $10bbba9f0890e37a$export$471f7ae5c4103ae1 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$b6ce52be8d7a261 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$faab0ca9701d7048 = (0, $lxG6u.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$9852986a3ec5f6a0 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $10bbba9f0890e37a$export$ce086a560a1d05f5 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $10bbba9f0890e37a$export$e1e720e5f4603e6a = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $10bbba9f0890e37a$export$abf39ca178940ff3 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $10bbba9f0890e37a$export$48884d2a5190dc73 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $10bbba9f0890e37a$export$2a5a518232fa1a97 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $10bbba9f0890e37a$export$ce666bf02318c957 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $10bbba9f0890e37a$export$7d657479499397 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $10bbba9f0890e37a$export$6d8b0ef52e2e6390 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$375b6afcc5f4d291 = (0, $lxG6u.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $10bbba9f0890e37a$export$6f093cfa640b7166 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline'
});
const $10bbba9f0890e37a$export$5ea06bc686c59dc2 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline'
});
const $10bbba9f0890e37a$export$93256a4c17b33a82 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline'
});
const $10bbba9f0890e37a$export$a12828d0f14a2762 = (0, $lxG6u.createPMNodeSpecFactory)({});
const $10bbba9f0890e37a$export$44b79b0979d0f0f7 = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $10bbba9f0890e37a$export$310ebe0d80122e9b = (0, $lxG6u.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("lxG6u", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $68a84dc213148cce$export$bf0a80f00e2b8ff6);
const $68a84dc213148cce$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});


parcelRegister("cJBwX", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $e8662a4caf118c6a$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $e8662a4caf118c6a$export$31b40729666a4ae0);
const $e8662a4caf118c6a$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $e8662a4caf118c6a$var$staticValue = false;
const $e8662a4caf118c6a$export$31b40729666a4ae0 = {
    setStatic (value) {
        $e8662a4caf118c6a$var$staticValue = value;
    },
    generate () {
        return $e8662a4caf118c6a$var$staticValue || $e8662a4caf118c6a$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("jeJW3", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $a8b537470196d616$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $a8b537470196d616$export$16018c61064a18df);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $a8b537470196d616$export$6d8b0ef52e2e6390 = (0, $blgFF.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $cJBwX.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a8b537470196d616$export$16018c61064a18df = (0, $blgFF.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $cJBwX.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("k5JTK", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $e9a2dffed3be90df$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtensionRootOnlyStage0", () => $e9a2dffed3be90df$export$8bbe5aa5bba36cc1);

var $blgFF = parcelRequire("blgFF");

var $d5mjZ = parcelRequire("d5mjZ");
const $e9a2dffed3be90df$export$27903d543b563e39 = (0, $blgFF.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $d5mjZ.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e9a2dffed3be90df$export$8bbe5aa5bba36cc1 = {
    ...$e9a2dffed3be90df$export$27903d543b563e39,
    marks: `breakout ${$e9a2dffed3be90df$export$27903d543b563e39.marks}`
};

});
parcelRegister("d5mjZ", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $d5482d7d3ac8057e$export$1765e2758fc47004);

var $kSiCy = parcelRequire("kSiCy");
const $d5482d7d3ac8057e$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = (0, $kSiCy.isValidLayout)(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});
parcelRegister("kSiCy", function(module, exports) {
$parcel$export(module.exports, "isValidLayout", () => $12992cf5bb95070f$export$d5f21755dc782a4a);
const $12992cf5bb95070f$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};

});



parcelRegister("3WThI", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $004b7fd0ec0d3289$export$e92c7e4302dd4371);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $004b7fd0ec0d3289$export$e92c7e4302dd4371 = (0, $blgFF.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $cJBwX.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("9R6do", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $e2719dc480e60359$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $e2719dc480e60359$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $e2719dc480e60359$export$dfd406053b2bab40);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $e2719dc480e60359$export$5f25a39efab3b58b = '.ak-ul';
const $e2719dc480e60359$export$a140c94e5ea26bee = (0, $blgFF.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $e2719dc480e60359$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $e2719dc480e60359$export$dfd406053b2bab40 = (0, $blgFF.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $e2719dc480e60359$export$5f25a39efab3b58b.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("04yOa", function(module, exports) {
$parcel$export(module.exports, "caption", () => $eb37e67d4eef5d59$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $eb37e67d4eef5d59$export$b5d01ee303c467aa);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $eb37e67d4eef5d59$export$8e3c2dfdc4f0453d = (0, $blgFF.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $eb37e67d4eef5d59$export$b5d01ee303c467aa = (0, $blgFF.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-caption': 'true'
        };
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("lklwG", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $714860238f4f0e4f$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $714860238f4f0e4f$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $714860238f4f0e4f$export$3f75de798a0b5356);

var $c3kt8 = parcelRequire("c3kt8");

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $714860238f4f0e4f$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $714860238f4f0e4f$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $714860238f4f0e4f$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $714860238f4f0e4f$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $714860238f4f0e4f$var$LANGUAGE_CLASS_REGEX = /(?:^|\s)language-([^\s]+)/u;
const $714860238f4f0e4f$var$TRAILING_NEWLINE_REGEX = /\n$/u;
const $714860238f4f0e4f$var$extractLanguageFromClass = (className)=>{
    const result = $714860238f4f0e4f$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $714860238f4f0e4f$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($714860238f4f0e4f$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $714860238f4f0e4f$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $714860238f4f0e4f$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $714860238f4f0e4f$export$7bb0d5c671655cc4 = (0, $blgFF.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $714860238f4f0e4f$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $714860238f4f0e4f$var$getLanguageFromEditorStyle(dom.parentElement) || $714860238f4f0e4f$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $714860238f4f0e4f$var$removeLastNewLine(dom);
                const wrapAttr = dom.getAttribute('data-wrap');
                const isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                const wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                const hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $714860238f4f0e4f$var$parseCodeFromHtml(domNode);
                return code ? (0, $c3kt8.Fragment).from(schema.text(code)) : (0, $c3kt8.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $714860238f4f0e4f$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $714860238f4f0e4f$export$3f75de798a0b5356 = (0, $blgFF.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $714860238f4f0e4f$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $714860238f4f0e4f$var$getLanguageFromEditorStyle(dom.parentElement) || $714860238f4f0e4f$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $714860238f4f0e4f$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $714860238f4f0e4f$var$parseCodeFromHtml(domNode);
                return code ? (0, $c3kt8.Fragment).from(schema.text(code)) : (0, $c3kt8.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("gbJ5m", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $453b5a1e56d4b324$export$daf889beb5092f95);

var $blgFF = parcelRequire("blgFF");
const $453b5a1e56d4b324$var$name = 'confluenceJiraIssue';
const $453b5a1e56d4b324$export$daf889beb5092f95 = (0, $blgFF.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$453b5a1e56d4b324$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $453b5a1e56d4b324$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("Ey7SE", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $d7b5a4879557b5b9$export$e6e4878f43c27cab);

var $blgFF = parcelRequire("blgFF");
const $d7b5a4879557b5b9$var$name = 'confluenceUnsupportedBlock';
const $d7b5a4879557b5b9$export$e6e4878f43c27cab = (0, $blgFF.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $d7b5a4879557b5b9$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$d7b5a4879557b5b9$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bU4hE", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $c7f2a130bd8c3e5f$export$3e6d667072febc87);

var $blgFF = parcelRequire("blgFF");
const $c7f2a130bd8c3e5f$var$name = 'confluenceUnsupportedInline';
const $c7f2a130bd8c3e5f$export$3e6d667072febc87 = (0, $blgFF.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $c7f2a130bd8c3e5f$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$c7f2a130bd8c3e5f$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("8sjT8", function(module, exports) {
$parcel$export(module.exports, "date", () => $34f978be7b3f57dc$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $34f978be7b3f57dc$export$a6a035390e3921b2);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $34f978be7b3f57dc$export$324d90190a8b822a = (0, $blgFF.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $34f978be7b3f57dc$export$a6a035390e3921b2 = (0, $blgFF.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4a5W3", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $d2394a79941c0d34$export$6959e16eeff859b4);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $d2394a79941c0d34$export$6959e16eeff859b4 = (0, $blgFF.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $cJBwX.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6Ay0J", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $d785e98310cda980$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $d785e98310cda980$export$62d45a65fb43d95e);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $d785e98310cda980$var$name = 'decisionList';
const $d785e98310cda980$export$a5393ce68c2ff601 = `[data-node-type="${$d785e98310cda980$var$name}"]`;
const $d785e98310cda980$export$62d45a65fb43d95e = (0, $blgFF.decisionList)({
    parseDOM: [
        {
            tag: `ol${$d785e98310cda980$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $d785e98310cda980$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5Wu5o", function(module, exports) {
$parcel$export(module.exports, "doc", () => $dc7504ffa0ba65f7$export$2a111da947c407d2);

var $blgFF = parcelRequire("blgFF");
const $dc7504ffa0ba65f7$export$2a111da947c407d2 = (0, $blgFF.doc)({});

});

parcelRegister("aJRkQ", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $b18283c04a2380aa$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $b18283c04a2380aa$export$36734475a7f6fd3e);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $b18283c04a2380aa$export$be4283d9a1cb1ff6 = (0, $blgFF.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $b18283c04a2380aa$export$36734475a7f6fd3e = (0, $blgFF.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jR4g0", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $d7a8f9a2383d3ecb$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $d7a8f9a2383d3ecb$export$ebb3b3c7a0ac9936);

var $blgFF = parcelRequire("blgFF");

var $1fFSz = parcelRequire("1fFSz");

var $9TnPh = parcelRequire("9TnPh");

var $cJBwX = parcelRequire("cJBwX");
const $d7a8f9a2383d3ecb$export$a19185d1233fc4b2 = (0, $blgFF.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $1fFSz.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $9TnPh.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $d7a8f9a2383d3ecb$export$ebb3b3c7a0ac9936 = (0, $blgFF.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $1fFSz.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $9TnPh.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $d7a8f9a2383d3ecb$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("1fFSz", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $d61ea42f9a1fd975$export$f61e93bda2a8b420);

var $49fDj = parcelRequire("49fDj");

var $gDGGC = parcelRequire("gDGGC");
function $d61ea42f9a1fd975$export$f61e93bda2a8b420(acName) {
    const emojiData = (0, $49fDj.acNameToEmojiMap)[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: (0, $gDGGC.DEFAULT_EMOJI_ID),
        shortName: `:${acName}:`,
        text: ''
    };
}

});
parcelRegister("49fDj", function(module, exports) {
$parcel$export(module.exports, "acNameToEmojiMap", () => $a6fe537c69e3925d$export$7962498ea8ccffac);
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $a6fe537c69e3925d$export$7962498ea8ccffac = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};

});

parcelRegister("gDGGC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_EMOJI_ID", () => $820a4d5963e776ea$export$936e67708ade64a9);
$parcel$export(module.exports, "DEFAULT_EMOJI_ACNAME", () => $820a4d5963e776ea$export$209b328f48821d5f);
$parcel$export(module.exports, "HC_EMOTICON_PREFIX", () => $820a4d5963e776ea$export$1c102a772ecd912c);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 




const $820a4d5963e776ea$export$936e67708ade64a9 = '2b50';
const $820a4d5963e776ea$export$209b328f48821d5f = 'blue-star';
const $820a4d5963e776ea$export$1c102a772ecd912c = 'atlassian-';

});


parcelRegister("9TnPh", function(module, exports) {
$parcel$export(module.exports, "acShortcutToEmoji", () => $e92f48f4badfa14c$export$441f8b58f5790a68);

var $gDGGC = parcelRequire("gDGGC");
function $e92f48f4badfa14c$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${0, $gDGGC.HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}

});


parcelRegister("b3Zoi", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $2d51439a56c34244$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $2d51439a56c34244$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $2d51439a56c34244$export$54fd2c36b5cc6731);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
function $2d51439a56c34244$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $2d51439a56c34244$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $2d51439a56c34244$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $2d51439a56c34244$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $2d51439a56c34244$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $2d51439a56c34244$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $2d51439a56c34244$export$7b80cba28d10b2c1 = (0, $blgFF.expand)($2d51439a56c34244$var$nodeSpecOptions);
const $2d51439a56c34244$export$2ae5e7565ff9ffa6 = (0, $blgFF.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $2d51439a56c34244$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $2d51439a56c34244$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $2d51439a56c34244$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $2d51439a56c34244$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2d51439a56c34244$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("7n5Be", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $c5fefe4a28590e8d$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $c5fefe4a28590e8d$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $c5fefe4a28590e8d$export$950ebf43f3364a0f);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $c5fefe4a28590e8d$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $c5fefe4a28590e8d$export$67dc04e652a298ca = (0, $blgFF.blockquoteLegacy)($c5fefe4a28590e8d$var$nodeSpecOptions);
const $c5fefe4a28590e8d$export$70a64939da3e8455 = (0, $blgFF.blockquote)($c5fefe4a28590e8d$var$nodeSpecOptions);
const $c5fefe4a28590e8d$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'blockquote',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $c5fefe4a28590e8d$export$950ebf43f3364a0f = (0, $blgFF.blockquote)($c5fefe4a28590e8d$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("drQo7", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", () => $5fbf44b65dae1e4b$export$ce20b13564211141);

var $blgFF = parcelRequire("blgFF");

var $aQFmP = parcelRequire("aQFmP");
const $5fbf44b65dae1e4b$export$ce20b13564211141 = (allowCustomPanel)=>(0, $blgFF.panel)((0, $aQFmP.createPanelNodeSpecOptions)(allowCustomPanel));

});
parcelRegister("aQFmP", function(module, exports) {
$parcel$export(module.exports, "createPanelNodeSpecOptions", () => $d846b1292edb0714$export$1f22c1e22ac5e390);

var $6ujCu = parcelRequire("6ujCu");

var $cdiYQ = parcelRequire("cdiYQ");
const $d846b1292edb0714$export$1f22c1e22ac5e390 = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>(0, $cdiYQ.getParseDOMAttrs)(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = (0, $6ujCu.getDomAttrs)(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });

});
parcelRegister("6ujCu", function(module, exports) {
$parcel$export(module.exports, "getDomAttrs", () => $a9c0c6fb7d111800$export$573b838ca5694549);
const $a9c0c6fb7d111800$export$573b838ca5694549 = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': nodeAttrs?.localId || undefined
    };
    return attrs;
};

});

parcelRegister("cdiYQ", function(module, exports) {
$parcel$export(module.exports, "getParseDOMAttrs", () => $29cfc867fcafd4b8$export$f5f376335f9d8c6b);

var $cJBwX = parcelRequire("cJBwX");

var $2HY1z = parcelRequire("2HY1z");
const $29cfc867fcafd4b8$export$f5f376335f9d8c6b = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $cJBwX.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === (0, $2HY1z.PanelType).CUSTOM ? (0, $2HY1z.PanelType).INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};

});
parcelRegister("2HY1z", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $5077f846ede9d6a7$export$969277cf61e5a7aa);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 








var $5077f846ede9d6a7$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});

});




parcelRegister("9aBD1", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1", () => $beda89222cb2eb4f$export$c158ac2988d2f011);

var $blgFF = parcelRequire("blgFF");

var $aQFmP = parcelRequire("aQFmP");
const $beda89222cb2eb4f$export$c158ac2988d2f011 = (allowCustomPanel)=>(0, $blgFF.panelC1Stage0)((0, $aQFmP.createPanelNodeSpecOptions)(allowCustomPanel));

});

parcelRegister("22R95", function(module, exports) {
$parcel$export(module.exports, "extension", () => $5932b488c00e2078$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionRootOnlyStage0", () => $5932b488c00e2078$export$ad06037362b3c3b3);
$parcel$export(module.exports, "extensionWithAnnotationStage0", () => $5932b488c00e2078$export$3e3366ebd634cc62);
$parcel$export(module.exports, "extensionRootOnlyWithAnnotationStage0", () => $5932b488c00e2078$export$243bc54b0560ecc);

var $blgFF = parcelRequire("blgFF");

var $d5mjZ = parcelRequire("d5mjZ");
const $5932b488c00e2078$export$1b45514b112dd749 = (0, $blgFF.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $d5mjZ.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
const $5932b488c00e2078$export$ad06037362b3c3b3 = {
    ...$5932b488c00e2078$export$1b45514b112dd749,
    marks: 'breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $5932b488c00e2078$export$3e3366ebd634cc62 = {
    ...$5932b488c00e2078$export$1b45514b112dd749,
    marks: 'annotation dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $5932b488c00e2078$export$243bc54b0560ecc = {
    ...$5932b488c00e2078$export$1b45514b112dd749,
    marks: 'annotation breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("dGNE8", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $8ce2caac4f910df3$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $8ce2caac4f910df3$export$c3c04d555a8b9013);
$parcel$export(module.exports, "multiBodiedExtensionRootOnlyStage0", () => $8ce2caac4f910df3$export$6f4c18ddc3950a66);

var $blgFF = parcelRequire("blgFF");

var $d5mjZ = parcelRequire("d5mjZ");
const $8ce2caac4f910df3$export$4fdcae991fd743e7 = (0, $blgFF.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $8ce2caac4f910df3$export$c3c04d555a8b9013 = (0, $blgFF.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $d5mjZ.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $8ce2caac4f910df3$export$6f4c18ddc3950a66 = {
    ...$8ce2caac4f910df3$export$c3c04d555a8b9013,
    marks: `breakout ${$8ce2caac4f910df3$export$c3c04d555a8b9013.marks}`
};

});

parcelRegister("1rlZ6", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $01768354b512b412$export$371da9dd35aba193);

var $blgFF = parcelRequire("blgFF");
const $01768354b512b412$export$371da9dd35aba193 = (0, $blgFF.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("3jP3u", function(module, exports) {
$parcel$export(module.exports, "heading", () => $d2b78185a5dddaa4$export$46e4a324ac90507f);

var $blgFF = parcelRequire("blgFF");
const $d2b78185a5dddaa4$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $d2b78185a5dddaa4$export$46e4a324ac90507f = (0, $blgFF.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $d2b78185a5dddaa4$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $d2b78185a5dddaa4$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $d2b78185a5dddaa4$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $d2b78185a5dddaa4$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $d2b78185a5dddaa4$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $d2b78185a5dddaa4$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("aFQVV", function(module, exports) {
$parcel$export(module.exports, "image", () => $744a7d6b03ac5d2b$export$5c452ff88e35e47d);

var $blgFF = parcelRequire("blgFF");
const $744a7d6b03ac5d2b$export$5c452ff88e35e47d = (0, $blgFF.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("hGMiA", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $36991e9306dbdb0a$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $36991e9306dbdb0a$export$7ed775fc743eadd1);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $36991e9306dbdb0a$export$cbf8224b64e0d942 = (0, $blgFF.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $36991e9306dbdb0a$export$7ed775fc743eadd1 = (0, $blgFF.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $cJBwX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': node?.attrs?.localId || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("jfvyT", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $e138207d79d1d076$export$16b353b2649bd8d9);

var $blgFF = parcelRequire("blgFF");

var $d5mjZ = parcelRequire("d5mjZ");
const $e138207d79d1d076$export$16b353b2649bd8d9 = (0, $blgFF.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $d5mjZ.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("ZTMwP", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $8ff4590b29f5ec24$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $8ff4590b29f5ec24$export$b2e27d292505bac2);
$parcel$export(module.exports, "layoutColumnStage0", () => $8ff4590b29f5ec24$export$f8cda4c28dab3f58);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");

var $kkS86 = parcelRequire("kkS86");
const $8ff4590b29f5ec24$var$setColumnAttributes = (node, { withLocalId: withLocalId = false } = {})=>{
    const attrs = {
        'data-layout-column': 'true'
    };
    const { width: width, valign: valign, localId: localId } = node.attrs;
    if (width) {
        const baseStyle = `flex-basis: ${width}%`;
        attrs['style'] = `${baseStyle}; --column-width: ${width}%`;
        attrs['data-column-width'] = `${width}`;
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
const $8ff4590b29f5ec24$var$getColumnAttrs = ({ withLocalId: withLocalId = false } = {})=>(domNode)=>{
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = domNode;
        const base = {
            width: Number(dom.getAttribute('data-column-width')) || undefined,
            ...withLocalId && {
                localId: (0, $cJBwX.uuid).generate()
            }
        };
        const valign = (0, $kkS86.parseValign)(dom.getAttribute('data-valign'));
        return valign ? {
            ...base,
            valign: valign
        } : base;
    };
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
const $8ff4590b29f5ec24$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
const $8ff4590b29f5ec24$export$ab76e7c03cd6f650 = (0, $blgFF.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $8ff4590b29f5ec24$var$getColumnAttrs()
        }
    ],
    toDOM (node) {
        return [
            'div',
            $8ff4590b29f5ec24$var$setColumnAttributes(node),
            [
                'div',
                $8ff4590b29f5ec24$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $8ff4590b29f5ec24$export$b2e27d292505bac2 = (0, $blgFF.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $8ff4590b29f5ec24$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM (node) {
        return [
            'div',
            $8ff4590b29f5ec24$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $8ff4590b29f5ec24$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $8ff4590b29f5ec24$export$f8cda4c28dab3f58 = $8ff4590b29f5ec24$export$b2e27d292505bac2;

});
parcelRegister("kkS86", function(module, exports) {
$parcel$export(module.exports, "parseValign", () => $2d3154f71163d97f$export$80408efb85c33a7a);
const $2d3154f71163d97f$export$80408efb85c33a7a = (raw)=>{
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};

});


parcelRegister("fQBtT", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $4573531dc03d06eb$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $4573531dc03d06eb$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $4573531dc03d06eb$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $4573531dc03d06eb$export$64facded20dfd85c);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $4573531dc03d06eb$export$b3b6a70a7fa4a5be = (0, $blgFF.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4573531dc03d06eb$export$cdae19acb0a520fd = (0, $blgFF.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4573531dc03d06eb$export$4f9d8f623ff17117 = (0, $blgFF.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4573531dc03d06eb$export$d9d3c69a64270b13 = (0, $blgFF.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $cJBwX.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4573531dc03d06eb$export$64facded20dfd85c = (0, $blgFF.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $cJBwX.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("cL7eE", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $7e67839ff3cf6e96$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $7e67839ff3cf6e96$export$483d52f09158e61c);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $7e67839ff3cf6e96$export$76c7e83ecc9cdf05 = (0, $blgFF.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $7e67839ff3cf6e96$export$483d52f09158e61c = (0, $blgFF.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'li',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
});

});

parcelRegister("k6DLS", function(module, exports) {
$parcel$export(module.exports, "media", () => $6138f9a7d0761aca$export$987d49ffe1b0900f);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");

var $4XUZl = parcelRequire("4XUZl");



const $6138f9a7d0761aca$export$bb3fe706be61f640 = {
    ...(0, $blgFF.media)({}).attrs
};
const $6138f9a7d0761aca$export$987d49ffe1b0900f = (0, $4XUZl.createMediaSpec)($6138f9a7d0761aca$export$bb3fe706be61f640, false, false);
const $6138f9a7d0761aca$export$8446e47a4c7fd000 = (0, $4XUZl.createMediaSpec)({
    ...$6138f9a7d0761aca$export$bb3fe706be61f640,
    localId: {
        default: (0, $cJBwX.uuid).generate()
    }
}, false, true);

});
parcelRegister("4XUZl", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", () => $dfe8ee49f29ea1da$export$35bdbf5bc8caa677);

var $blgFF = parcelRequire("blgFF");

var $362O7 = parcelRequire("362O7");

var $cJBwX = parcelRequire("cJBwX");

var $eyWOv = parcelRequire("eyWOv");

var $k1P4h = parcelRequire("k1P4h");
const $dfe8ee49f29ea1da$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/u;
const $dfe8ee49f29ea1da$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = (0, $eyWOv.camelCaseToKebabCase)(k).replace($dfe8ee49f29ea1da$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    const value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $cJBwX.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $362O7.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        (0, $k1P4h.copyPrivateAttributes)(node.attrs, attrs, attributes, (key)=>`data-${(0, $eyWOv.camelCaseToKebabCase)(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $blgFF.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $blgFF.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $cJBwX.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};

});
parcelRegister("eyWOv", function(module, exports) {
$parcel$export(module.exports, "camelCaseToKebabCase", () => $a53d2de26ee1ba7d$export$f84fdfb973c05bd8);
const $a53d2de26ee1ba7d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);

});

parcelRegister("k1P4h", function(module, exports) {
$parcel$export(module.exports, "copyPrivateAttributes", () => $4d9c2cc6ae640755$export$111130fa8968d741);
const $4d9c2cc6ae640755$export$111130fa8968d741 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
from, // eslint-disable-next-line @typescript-eslint/no-explicit-any
to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};

});



parcelRegister("35VDH", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $7090a6b8237e9fc8$export$2855e964765eac9);

var $blgFF = parcelRequire("blgFF");
const $7090a6b8237e9fc8$export$2855e964765eac9 = (0, $blgFF.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("3zde7", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $68dad10faa980206$export$38bab695e3f720f1);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");

var $4XUZl = parcelRequire("4XUZl");
const $68dad10faa980206$export$38bab695e3f720f1 = (0, $4XUZl.createMediaSpec)((0, $blgFF.mediaInline)({}).attrs, true);
const $68dad10faa980206$export$aea8e9c496505c61 = (0, $4XUZl.createMediaSpec)({
    ...(0, $blgFF.mediaInline)({}).attrs,
    localId: {
        default: (0, $cJBwX.uuid).generate()
    }
}, true, true);

});

parcelRegister("5L24F", function(module, exports) {
$parcel$export(module.exports, "mediaSingle", () => $ff207caf5b5c67e5$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $ff207caf5b5c67e5$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $ff207caf5b5c67e5$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $ff207caf5b5c67e5$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $ff207caf5b5c67e5$export$75376a385837c942);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $iuevC = parcelRequire("iuevC");

const $ff207caf5b5c67e5$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    layout: {
        default: 'center'
    }
};
const $ff207caf5b5c67e5$export$969fe3781ca15058 = (0, $iuevC.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $ff207caf5b5c67e5$export$d35e6c006d4abdfb = (0, $iuevC.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $ff207caf5b5c67e5$export$9c58e19811ce4cf5 = (0, $iuevC.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $ff207caf5b5c67e5$export$7e767666f2ce108a = (0, $iuevC.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $ff207caf5b5c67e5$export$75376a385837c942 = (0, $iuevC.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});

});
parcelRegister("iuevC", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $116e5a71082a4db1$export$5a1e124099b60c6b);

var $blgFF = parcelRequire("blgFF");

var $kL8C9 = parcelRequire("kL8C9");

var $cJBwX = parcelRequire("cJBwX");

var $eEtFQ = parcelRequire("eEtFQ");
const $116e5a71082a4db1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $kL8C9.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $cJBwX.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $eEtFQ.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) attrs['data-local-id'] = node?.attrs?.localId || undefined;
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $eEtFQ.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $blgFF.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $blgFF.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $blgFF.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $blgFF.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};

});
parcelRegister("eEtFQ", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $a6f39557a1fc4bfa$export$4d41558722ac7eed);
var $a6f39557a1fc4bfa$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});



parcelRegister("cDeo1", function(module, exports) {
$parcel$export(module.exports, "mention", () => $61ad3f2dc5af0bae$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $61ad3f2dc5af0bae$export$54fd2c36b5cc6731);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
var $61ad3f2dc5af0bae$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $61ad3f2dc5af0bae$export$db83999c14438df4 = (0, $blgFF.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $61ad3f2dc5af0bae$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $61ad3f2dc5af0bae$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $61ad3f2dc5af0bae$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $cJBwX.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($61ad3f2dc5af0bae$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $61ad3f2dc5af0bae$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $61ad3f2dc5af0bae$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($61ad3f2dc5af0bae$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("lfuSq", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $b2b9f264a71274de$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $b2b9f264a71274de$export$b854197485aa1fa0);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
function $b2b9f264a71274de$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $cJBwX.uuid).generate() : undefined
    };
}
const $b2b9f264a71274de$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$b2b9f264a71274de$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$b2b9f264a71274de$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $b2b9f264a71274de$export$63cadbf5f4296627 = (0, $blgFF.nestedExpand)($b2b9f264a71274de$var$nestedExpandFactoryOptions);
const $b2b9f264a71274de$export$b854197485aa1fa0 = (0, $blgFF.nestedExpand)({
    ...$b2b9f264a71274de$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$b2b9f264a71274de$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$b2b9f264a71274de$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$b2b9f264a71274de$var$getExpandAttrs(domNode, true)
        }
    ]
});

});

parcelRegister("lWPov", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $11881baef39be057$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $11881baef39be057$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $11881baef39be057$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $11881baef39be057$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $11881baef39be057$export$2ea3505d41d7525d);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $11881baef39be057$export$4e7125c7ff595be5 = '.ak-ol';
const $11881baef39be057$export$a5dc81035676e7a = (0, $blgFF.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $11881baef39be057$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $11881baef39be057$export$8157adc5747ec436 = (0, $blgFF.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $11881baef39be057$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $11881baef39be057$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $11881baef39be057$export$b9ab759e8298198f = (0, $blgFF.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $11881baef39be057$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        const start = $11881baef39be057$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $11881baef39be057$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $11881baef39be057$export$2ea3505d41d7525d = (0, $blgFF.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $cJBwX.uuid).generate();
                if (startDOMAttr) {
                    const start = $11881baef39be057$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const start = $11881baef39be057$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $11881baef39be057$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("4SrYU", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $35b87cee0b385bd2$export$9c206ddddb32a9b);

var $blgFF = parcelRequire("blgFF");
const $35b87cee0b385bd2$export$9c206ddddb32a9b = (0, $blgFF.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || $35b87cee0b385bd2$export$9c206ddddb32a9b.attrs?.localId?.default
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("iK3hE", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $aebfa939d30ed091$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $aebfa939d30ed091$export$6205248609a8f7a0);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $aebfa939d30ed091$export$c7187bbd1a7a9244 = (0, $blgFF.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $aebfa939d30ed091$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $aebfa939d30ed091$export$6205248609a8f7a0 = (0, $blgFF.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $aebfa939d30ed091$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("lT7kI", function(module, exports) {
$parcel$export(module.exports, "rule", () => $d761d9c17879d8de$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $d761d9c17879d8de$export$bf3ef6fb6ad90e7);
$parcel$export(module.exports, "ruleWithAttrs", () => $d761d9c17879d8de$export$ef9ec4ed8a654d7f);
$parcel$export(module.exports, "ruleRootOnlyStage0", () => $d761d9c17879d8de$export$1d53b70195c9c417);
$parcel$export(module.exports, "ruleWithAttrsRootOnlyStage0", () => $d761d9c17879d8de$export$78cca5eef2450890);

var $blgFF = parcelRequire("blgFF");

var $kO5ck = parcelRequire("kO5ck");

var $cJBwX = parcelRequire("cJBwX");
const $d761d9c17879d8de$var$hrDOM = [
    'hr'
];
const $d761d9c17879d8de$export$fbeb3a3956e8a3c7 = (0, $blgFF.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $d761d9c17879d8de$var$hrDOM;
    }
});
const $d761d9c17879d8de$export$bf3ef6fb6ad90e7 = (0, $blgFF.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'hr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            }
        ];
    }
});
const $d761d9c17879d8de$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || undefined,
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $d761d9c17879d8de$export$ef9ec4ed8a654d7f = {
    ...$d761d9c17879d8de$export$bf3ef6fb6ad90e7,
    attrs: {
        ...$d761d9c17879d8de$export$bf3ef6fb6ad90e7.attrs,
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: $d761d9c17879d8de$var$getAttrs
        }
    ],
    toDOM (node) {
        const { color: color, localId: localId, style: style, weight: weight } = node.attrs;
        const paletteColorValue = color && ((0, $kO5ck.hexToEditorTextPaletteColor)(color) ?? color);
        return [
            'hr',
            {
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined,
                style: paletteColorValue ? `--custom-palette-color: ${paletteColorValue}` : undefined
            }
        ];
    }
};
const $d761d9c17879d8de$export$1d53b70195c9c417 = {
    ...$d761d9c17879d8de$export$bf3ef6fb6ad90e7,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
const $d761d9c17879d8de$export$78cca5eef2450890 = {
    ...$d761d9c17879d8de$export$ef9ec4ed8a654d7f,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("itzC4", function(module, exports) {
$parcel$export(module.exports, "status", () => $60d75f02f47ac426$export$471f7ae5c4103ae1);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $60d75f02f47ac426$var$NEWLINE_REGEX = /\n/u;
const $60d75f02f47ac426$export$471f7ae5c4103ae1 = (0, $blgFF.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace($60d75f02f47ac426$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $cJBwX.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("dNMPP", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $85ebb58d2cde7d2a$export$faab0ca9701d7048);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $85ebb58d2cde7d2a$export$faab0ca9701d7048 = (0, $blgFF.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $cJBwX.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("4L22w", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $ed8b77ce3e9782f2$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $ed8b77ce3e9782f2$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $ed8b77ce3e9782f2$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $ed8b77ce3e9782f2$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $ed8b77ce3e9782f2$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $ed8b77ce3e9782f2$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $ed8b77ce3e9782f2$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $ed8b77ce3e9782f2$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorNameByHex", () => $ed8b77ce3e9782f2$export$87db0bca041942ef);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $ed8b77ce3e9782f2$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundColorPaletteNew", () => $ed8b77ce3e9782f2$export$f26b9114878cba41);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $ed8b77ce3e9782f2$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $ed8b77ce3e9782f2$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $ed8b77ce3e9782f2$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $ed8b77ce3e9782f2$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $ed8b77ce3e9782f2$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $ed8b77ce3e9782f2$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $ed8b77ce3e9782f2$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $ed8b77ce3e9782f2$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $ed8b77ce3e9782f2$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $ed8b77ce3e9782f2$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $ed8b77ce3e9782f2$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $ed8b77ce3e9782f2$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $ed8b77ce3e9782f2$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $ed8b77ce3e9782f2$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $ed8b77ce3e9782f2$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $ed8b77ce3e9782f2$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $ed8b77ce3e9782f2$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $ed8b77ce3e9782f2$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $ed8b77ce3e9782f2$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $ed8b77ce3e9782f2$export$7928c3aeb4cd2213);
$parcel$export(module.exports, "tableCellStage0", () => $ed8b77ce3e9782f2$export$7ffdb7030e2f2223);
$parcel$export(module.exports, "tableHeaderStage0", () => $ed8b77ce3e9782f2$export$53c69bb0cddd9750);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => $ed8b77ce3e9782f2$export$10671ff6b5f3bd84);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => $ed8b77ce3e9782f2$export$69bdb7ac5d810d92);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $blgFF = parcelRequire("blgFF");

var $362O7 = parcelRequire("362O7");

var $4uPTe = parcelRequire("4uPTe");

var $21y9s = parcelRequire("21y9s");

var $dnvFz = parcelRequire("dnvFz");

var $fAkYC = parcelRequire("fAkYC");

var $gMhwf = parcelRequire("gMhwf");

var $f7G3x = parcelRequire("f7G3x");

var $cJBwX = parcelRequire("cJBwX");

var $kkS86 = parcelRequire("kkS86");
const $ed8b77ce3e9782f2$export$9cfceb893b24742a = 'pm-table';
const $ed8b77ce3e9782f2$var$COL_WIDTH_ATTR_REGEX = /^\d+(,\d+)*$/u;
const $ed8b77ce3e9782f2$export$69cb4c3f80383763 = `${$ed8b77ce3e9782f2$export$9cfceb893b24742a}-cell-content-wrap`;
const $ed8b77ce3e9782f2$export$7b07d37d879c957f = `${$ed8b77ce3e9782f2$export$9cfceb893b24742a}-header-content-wrap`;
const $ed8b77ce3e9782f2$export$8dd42a84cd52da07 = `${$ed8b77ce3e9782f2$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $ed8b77ce3e9782f2$export$5e26a5c19f0865d8 = `${$ed8b77ce3e9782f2$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $ed8b77ce3e9782f2$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $362O7.N20).toLocaleLowerCase();
const $ed8b77ce3e9782f2$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && $ed8b77ce3e9782f2$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $fAkYC.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $gMhwf.isRgb)(backgroundColor)) {
        const result = (0, $f7G3x.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues?.localId;
    const valign = (0, $kkS86.parseValign)(dom.getAttribute('data-valign'));
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        },
        ...valign && {
            valign: valign
        }
    };
};
// these are for test only
let $ed8b77ce3e9782f2$var$testGlobalTheme;
const $ed8b77ce3e9782f2$export$fd7e0dd2b74807f7 = (theme)=>{
    $ed8b77ce3e9782f2$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $ed8b77ce3e9782f2$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($ed8b77ce3e9782f2$var$testGlobalTheme) return {
        colorMode: $ed8b77ce3e9782f2$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $ed8b77ce3e9782f2$var$cssVariablePattern = /^var\(--.*\)$/u;
const $ed8b77ce3e9782f2$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $ed8b77ce3e9782f2$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $ed8b77ce3e9782f2$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $gMhwf.isRgb)(background) && (0, $f7G3x.rgbToHex)(background) ? (0, $f7G3x.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $21y9s.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $ed8b77ce3e9782f2$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($ed8b77ce3e9782f2$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $4uPTe.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $ed8b77ce3e9782f2$export$87db0bca041942ef.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $ed8b77ce3e9782f2$export$7b07d37d879c957f;
    else attrs.class = $ed8b77ce3e9782f2$export$69cb4c3f80383763;
    if (node?.attrs?.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
const $ed8b77ce3e9782f2$export$219b7f492ad209f8 = new Map();
const $ed8b77ce3e9782f2$export$f26b9114878cba41 = new Map();
const $ed8b77ce3e9782f2$export$95e9c925fbf01d1c = (0, $dnvFz.hexToRgba)((0, $362O7.N800), 0.12) || (0, $362O7.N0);
const $ed8b77ce3e9782f2$export$8cc2833b5b349a1e = new Map();
const $ed8b77ce3e9782f2$export$87db0bca041942ef = new Map();
// Original 7-column palette — kept as the default export so external consumers
// are not broken. When cleaning up the platform_editor_lovability_text_bg_color experiment, check if this can be removed
[
    [
        (0, $362O7.N0),
        'White'
    ],
    [
        (0, $362O7.B50),
        'Light blue'
    ],
    [
        (0, $362O7.T50),
        'Light teal'
    ],
    [
        (0, $362O7.G50),
        'Light green'
    ],
    [
        (0, $362O7.Y50),
        'Light yellow'
    ],
    [
        (0, $362O7.R50),
        'Light red'
    ],
    [
        (0, $362O7.P50),
        'Light purple'
    ],
    [
        (0, $362O7.N20),
        'Light gray'
    ],
    [
        (0, $362O7.B75),
        'Blue'
    ],
    [
        (0, $362O7.T75),
        'Teal'
    ],
    [
        (0, $362O7.G75),
        'Green'
    ],
    [
        (0, $362O7.Y75),
        'Yellow'
    ],
    [
        (0, $362O7.R75),
        'Red'
    ],
    [
        (0, $362O7.P75),
        'Purple'
    ],
    [
        (0, $362O7.N60),
        'Gray'
    ],
    [
        (0, $362O7.B100),
        'Dark blue'
    ],
    [
        (0, $362O7.T100),
        'Dark teal'
    ],
    [
        (0, $362O7.G200),
        'Dark green'
    ],
    [
        (0, $362O7.Y200),
        'Dark yellow'
    ],
    [
        (0, $362O7.R100),
        'Dark red'
    ],
    [
        (0, $362O7.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $ed8b77ce3e9782f2$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $ed8b77ce3e9782f2$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $ed8b77ce3e9782f2$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
[
    [
        (0, $362O7.N0),
        'White'
    ],
    [
        (0, $362O7.B50),
        'Light blue'
    ],
    [
        (0, $362O7.T50),
        'Light teal'
    ],
    [
        (0, $362O7.G50),
        'Light green'
    ],
    [
        (0, $362O7.L50),
        'Subtle lime'
    ],
    [
        (0, $362O7.Y50),
        'Light yellow'
    ],
    [
        (0, $362O7.Orange50),
        'Subtle orange'
    ],
    [
        (0, $362O7.R50),
        'Light red'
    ],
    [
        (0, $362O7.M50),
        'Subtle magenta'
    ],
    [
        (0, $362O7.P50),
        'Light purple'
    ],
    [
        (0, $362O7.N20),
        'Light gray'
    ],
    [
        (0, $362O7.B75),
        'Blue'
    ],
    [
        (0, $362O7.T75),
        'Teal'
    ],
    [
        (0, $362O7.G75),
        'Green'
    ],
    [
        (0, $362O7.L200),
        'Lime'
    ],
    [
        (0, $362O7.Y75),
        'Yellow'
    ],
    [
        (0, $362O7.Orange200),
        'Orange'
    ],
    [
        (0, $362O7.R75),
        'Red'
    ],
    [
        (0, $362O7.M200),
        'Magenta'
    ],
    [
        (0, $362O7.P75),
        'Purple'
    ],
    [
        (0, $362O7.GrayBold),
        'Bold gray'
    ],
    [
        (0, $362O7.BlueBold),
        'Bold blue'
    ],
    [
        (0, $362O7.TealBold),
        'Bold teal'
    ],
    [
        (0, $362O7.GreenBold),
        'Bold green'
    ],
    [
        (0, $362O7.L400),
        'Bold lime'
    ],
    [
        (0, $362O7.YellowBold),
        'Bold yellow'
    ],
    [
        (0, $362O7.Orange400),
        'Bold orange'
    ],
    [
        (0, $362O7.RedBold),
        'Bold red'
    ],
    [
        (0, $362O7.M400),
        'Bold magenta'
    ],
    [
        (0, $362O7.PurpleBold),
        'Bold purple'
    ]
].forEach(([colorValue, colorName])=>{
    $ed8b77ce3e9782f2$export$f26b9114878cba41.set(colorValue.toLowerCase(), colorName);
    $ed8b77ce3e9782f2$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $ed8b77ce3e9782f2$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
const $ed8b77ce3e9782f2$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = dom.parentElement?.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || // copying from renderer
                    breakoutWrapper?.getAttribute('data-layout') || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $cJBwX.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $ed8b77ce3e9782f2$var$createTableSpec = ()=>(0, $blgFF.table)($ed8b77ce3e9782f2$var$tableNodeSpecOptions);
const $ed8b77ce3e9782f2$export$9852986a3ec5f6a0 = $ed8b77ce3e9782f2$var$createTableSpec();
const $ed8b77ce3e9782f2$export$90e634fbace1f0c4 = $ed8b77ce3e9782f2$var$createTableSpec();
const $ed8b77ce3e9782f2$export$3862de5c8c9098cf = $ed8b77ce3e9782f2$var$createTableSpec();
const $ed8b77ce3e9782f2$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $ed8b77ce3e9782f2$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$ed8b77ce3e9782f2$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $ed8b77ce3e9782f2$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $ed8b77ce3e9782f2$export$ce666bf02318c957 = (0, $blgFF.tableRow)($ed8b77ce3e9782f2$var$tableRowNodeSpecOptions);
const $ed8b77ce3e9782f2$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
const $ed8b77ce3e9782f2$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$ed8b77ce3e9782f2$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $ed8b77ce3e9782f2$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ed8b77ce3e9782f2$export$e1e720e5f4603e6a = (0, $blgFF.tableCell)($ed8b77ce3e9782f2$var$tableCellNodeSpecOptions);
const $ed8b77ce3e9782f2$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($ed8b77ce3e9782f2$var$cellAttrs[key] && $ed8b77ce3e9782f2$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $ed8b77ce3e9782f2$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ed8b77ce3e9782f2$export$43977bde391e007(dom, {
                    background: $ed8b77ce3e9782f2$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $ed8b77ce3e9782f2$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ed8b77ce3e9782f2$export$48884d2a5190dc73 = (0, $blgFF.tableHeader)($ed8b77ce3e9782f2$var$tableHeaderNodeSpecOptions);
const $ed8b77ce3e9782f2$export$2af48797a1010bb1 = $ed8b77ce3e9782f2$export$2ac34c099660f1a8;
const $ed8b77ce3e9782f2$export$ce086a560a1d05f5 = (0, $blgFF.tableWithNestedTable)($ed8b77ce3e9782f2$var$tableNodeSpecOptions);
const $ed8b77ce3e9782f2$export$7d657479499397 = (0, $blgFF.tableRowWithNestedTable)($ed8b77ce3e9782f2$var$tableRowNodeSpecOptions);
const $ed8b77ce3e9782f2$export$abf39ca178940ff3 = (0, $blgFF.tableCellWithNestedTable)($ed8b77ce3e9782f2$var$tableCellNodeSpecOptions);
const $ed8b77ce3e9782f2$export$2a5a518232fa1a97 = (0, $blgFF.tableHeaderWithNestedTable)($ed8b77ce3e9782f2$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $ed8b77ce3e9782f2$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'tr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $ed8b77ce3e9782f2$export$c8f0853ac97552c9 = (0, $blgFF.tableRow)($ed8b77ce3e9782f2$var$tableRowNodeSpecOptionsWithLocalId);
const $ed8b77ce3e9782f2$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ed8b77ce3e9782f2$export$43977bde391e007(dom, {
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $ed8b77ce3e9782f2$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $ed8b77ce3e9782f2$export$db76cfd28a574029 = (0, $blgFF.tableCell)($ed8b77ce3e9782f2$var$tableCellNodeSpecOptionsWithLocalId);
const $ed8b77ce3e9782f2$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ed8b77ce3e9782f2$export$43977bde391e007(dom, {
                    background: $ed8b77ce3e9782f2$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $ed8b77ce3e9782f2$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ed8b77ce3e9782f2$export$b82d2b1d8824143d = (0, $blgFF.tableHeader)($ed8b77ce3e9782f2$var$tableHeaderNodeSpecOptionsWithLocalId);
const $ed8b77ce3e9782f2$export$27926e30c8a74147 = (0, $blgFF.tableRowWithNestedTable)($ed8b77ce3e9782f2$var$tableRowNodeSpecOptionsWithLocalId);
const $ed8b77ce3e9782f2$export$e9fd700fafee293a = (0, $blgFF.tableCellWithNestedTable)($ed8b77ce3e9782f2$var$tableCellNodeSpecOptionsWithLocalId);
const $ed8b77ce3e9782f2$export$7928c3aeb4cd2213 = (0, $blgFF.tableHeaderWithNestedTable)($ed8b77ce3e9782f2$var$tableHeaderNodeSpecOptionsWithLocalId);
const $ed8b77ce3e9782f2$export$7ffdb7030e2f2223 = $ed8b77ce3e9782f2$export$db76cfd28a574029;
const $ed8b77ce3e9782f2$export$53c69bb0cddd9750 = $ed8b77ce3e9782f2$export$b82d2b1d8824143d;
const $ed8b77ce3e9782f2$export$10671ff6b5f3bd84 = $ed8b77ce3e9782f2$export$e9fd700fafee293a;
const $ed8b77ce3e9782f2$export$69bdb7ac5d810d92 = $ed8b77ce3e9782f2$export$7928c3aeb4cd2213;

});
parcelRegister("21y9s", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $2ceaad011ed1b98a$export$a270511a0e7fd61a);

var $cyXzf = parcelRequire("cyXzf");
function $2ceaad011ed1b98a$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? (0, $cyXzf.editorBackgroundPalette)[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}

});

parcelRegister("dnvFz", function(module, exports) {
$parcel$export(module.exports, "hexToRgba", () => $bde145e49382c25b$export$9665a07d9187b414);
// eslint-disable-line import/no-namespace

var $6jVvE = parcelRequire("6jVvE");
function $bde145e49382c25b$export$9665a07d9187b414(rawColor, alpha) {
    const color = (0, $6jVvE.normalizeHexColor)(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}

});
parcelRegister("6jVvE", function(module, exports) {
$parcel$export(module.exports, "normalizeHexColor", () => $6e41d033f2e94cd8$export$b61655071712e690);

var $6fm5p = parcelRequire("6fm5p");

var $fAkYC = parcelRequire("fAkYC");

var $gMhwf = parcelRequire("gMhwf");

var $f7G3x = parcelRequire("f7G3x");
function $6e41d033f2e94cd8$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ((0, $fAkYC.isHex)(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ((0, $gMhwf.isRgb)(color)) return (0, $f7G3x.rgbToHex)(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $6fm5p.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $6fm5p.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $6fm5p.default[color];
        else if ($6fm5p && $6fm5p[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $6fm5p[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}

});
parcelRegister("6fm5p", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});

parcelRegister("fAkYC", function(module, exports) {
$parcel$export(module.exports, "isHex", () => $ca45ad0ccb963688$export$8a9b6341a7c96bc);
// eslint-disable-line import/no-namespace
const $ca45ad0ccb963688$var$IS_HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/u;
function $ca45ad0ccb963688$export$8a9b6341a7c96bc(color) {
    return $ca45ad0ccb963688$var$IS_HEX_REGEX.test(color);
}

});

parcelRegister("gMhwf", function(module, exports) {
$parcel$export(module.exports, "isRgb", () => $5cf3bef2bb3c0261$export$e698776ec826343);
// eslint-disable-line import/no-namespace
const $5cf3bef2bb3c0261$var$IS_RGB_REGEX = /rgba?\(/u;
function $5cf3bef2bb3c0261$export$e698776ec826343(color) {
    return $5cf3bef2bb3c0261$var$IS_RGB_REGEX.test(color);
}

});




parcelRegister("4TQA2", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $352860a52d7436c6$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $352860a52d7436c6$export$375b6afcc5f4d291);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $352860a52d7436c6$var$name = 'actionList';
const $352860a52d7436c6$export$c0ec71adb7a18fb2 = `[data-node-type="${$352860a52d7436c6$var$name}"]`;
const $352860a52d7436c6$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$352860a52d7436c6$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $cJBwX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $352860a52d7436c6$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $352860a52d7436c6$export$375b6afcc5f4d291 = (0, $blgFF.taskList)($352860a52d7436c6$var$taskListParseDOMAndToDOM);

});

parcelRegister("aeONV", function(module, exports) {
$parcel$export(module.exports, "text", () => $3561ce67c8ccb71c$export$6f093cfa640b7166);

var $blgFF = parcelRequire("blgFF");
const $3561ce67c8ccb71c$export$6f093cfa640b7166 = (0, $blgFF.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("1Zvzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfe049a265b07ec8$export$2e2bcd8739ae039);
const $cfe049a265b07ec8$var$name = 'unknownBlock';
const $cfe049a265b07ec8$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $cfe049a265b07ec8$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type=\"${$cfe049a265b07ec8$var$name}\"]`
        }
    ]
};

});

parcelRegister("fHe1g", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $9d7996618116ed77$export$44b79b0979d0f0f7);

var $blgFF = parcelRequire("blgFF");
const $9d7996618116ed77$export$44b79b0979d0f0f7 = (0, $blgFF.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("avjHo", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $7e708941c983eb1f$export$310ebe0d80122e9b);

var $blgFF = parcelRequire("blgFF");
const $7e708941c983eb1f$export$310ebe0d80122e9b = (0, $blgFF.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("a6aOH", function(module, exports) {
$parcel$export(module.exports, "bodiedRule", () => $6319b4d34a496c42$export$2069efcbff2f0292);
$parcel$export(module.exports, "bodiedRuleRootOnlyStage0", () => $6319b4d34a496c42$export$208411233915368e);

var $blgFF = parcelRequire("blgFF");

var $cJBwX = parcelRequire("cJBwX");
const $6319b4d34a496c42$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        alignment: dom.getAttribute('data-alignment') || undefined,
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || (0, $cJBwX.uuid).generate(),
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $6319b4d34a496c42$export$2069efcbff2f0292 = (0, $blgFF.bodiedRuleStage0)({
    parseDOM: [
        {
            tag: 'div[data-node-type="bodied-rule"]',
            getAttrs: $6319b4d34a496c42$var$getAttrs
        }
    ],
    toDOM (node) {
        const { alignment: alignment, color: color, localId: localId, style: style, weight: weight } = node.attrs;
        return [
            'div',
            {
                'data-node-type': 'bodied-rule',
                'data-alignment': alignment || undefined,
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined
            },
            0
        ];
    }
});
const $6319b4d34a496c42$export$208411233915368e = {
    ...$6319b4d34a496c42$export$2069efcbff2f0292,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};

});


parcelRegister("iI7Jb", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $4a81e3c5296c8b72$export$daf54fed04c8fb77);
function $4a81e3c5296c8b72$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $4a81e3c5296c8b72$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $4a81e3c5296c8b72$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = Array.from(new Set(contentKeys.filter((contentKey)=>!$4a81e3c5296c8b72$var$isContentSupported(nodes, contentKey)))).sort((a, b)=>b.length - a.length);
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$4a81e3c5296c8b72$var$sanitizedContent(newContent, nodeName), rawContent);
}
const $4a81e3c5296c8b72$var$WORD_CHAR_REGEX = /\w/u;
function $4a81e3c5296c8b72$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($4a81e3c5296c8b72$var$WORD_CHAR_REGEX)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $4a81e3c5296c8b72$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});


parcelRegister("goEAh", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1RootOnlyStage0", () => $448d2177217bb830$export$9ef8544aba133962);

var $cBh5Y = parcelRequire("cBh5Y");
const $448d2177217bb830$export$9ef8544aba133962 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $cBh5Y.extendedPanelC1WithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};

});
parcelRegister("cBh5Y", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => $453b39629c914f90$export$9c65e35ecb68f683);

var $blgFF = parcelRequire("blgFF");

var $aQFmP = parcelRequire("aQFmP");
const $453b39629c914f90$export$9c65e35ecb68f683 = (allowCustomPanel)=>(0, $blgFF.panelC1Stage0)((0, $aQFmP.createPanelNodeSpecOptions)(allowCustomPanel, true));

});


parcelRegister("ehkGa", function(module, exports) {
$parcel$export(module.exports, "extendedPanelRootOnlyStage0", () => $fd43000638d381fc$export$71123ea8f73a7fb);

var $jHqZN = parcelRequire("jHqZN");
const $fd43000638d381fc$export$71123ea8f73a7fb = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $jHqZN.extendedPanelWithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};

});
parcelRegister("jHqZN", function(module, exports) {
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $597b765666016328$export$855c3c67c9c9ebaf);

var $blgFF = parcelRequire("blgFF");

var $aQFmP = parcelRequire("aQFmP");
const $597b765666016328$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $blgFF.panel)((0, $aQFmP.createPanelNodeSpecOptions)(allowCustomPanel, true));

});



parcelRegister("OVmx5", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", () => $0c3ce5f4beb20cf8$export$98cb1d9308d0944d);

var $1nqqd = parcelRequire("1nqqd");

var $aZsfy = parcelRequire("aZsfy");

var $6YJXB = parcelRequire("6YJXB");

var $aw9OM = parcelRequire("aw9OM");
const $0c3ce5f4beb20cf8$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $0c3ce5f4beb20cf8$var$emptyDoc = $0c3ce5f4beb20cf8$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
class $0c3ce5f4beb20cf8$export$98cb1d9308d0944d {
    /**
	 * Creates a new JSONTransformer instance.
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $aZsfy.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $6YJXB.sanitizeNode)((0, $aw9OM.toJSON)(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($1nqqd)))(content, $0c3ce5f4beb20cf8$var$emptyDoc.content)) return $0c3ce5f4beb20cf8$var$createDocFromContent([]);
        return $0c3ce5f4beb20cf8$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $aZsfy.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($0c3ce5f4beb20cf8$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node, options = {}) {
        return (0, $6YJXB.sanitizeNode)((0, $aw9OM.toJSON)(node, this.mentionMap), options);
    }
}

});
parcelRegister("6YJXB", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $029c976f2472bdac$export$48b382180baf8e88);

var $6L2Y6 = parcelRequire("6L2Y6");

var $e0DQG = parcelRequire("e0DQG");

var $uNoz0 = parcelRequire("uNoz0");

var $5alrF = parcelRequire("5alrF");
const $029c976f2472bdac$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $029c976f2472bdac$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $e0DQG.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $5alrF.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($029c976f2472bdac$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $6L2Y6.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($029c976f2472bdac$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $6L2Y6.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: (node)=>({
                ...node,
                type: 'panel'
            }),
        emoji: (0, $5alrF.removeNonAnnotationMarks),
        mention: (0, $5alrF.removeNonAnnotationMarks),
        date: (0, $5alrF.removeNonAnnotationMarks),
        hardBreak: (0, $uNoz0.removeMarks),
        inlineCard: (0, $5alrF.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("6L2Y6", function(module, exports) {
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $d510569b1194886c$export$8a334a7d9fe120ec);

var $cN9cD = parcelRequire("cN9cD");

var $kwbWU = parcelRequire("kwbWU");

var $jwDjF = parcelRequire("jwDjF");
const $d510569b1194886c$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $cN9cD.extension)({
                    extensionType: (0, $jwDjF.NESTED_TABLE_EXTENSION_TYPE),
                    extensionKey: (0, $jwDjF.NESTED_TABLE_EXTENSION_KEY),
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $kwbWU.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("cN9cD", function(module, exports) {
$parcel$export(module.exports, "extension", () => $9d391ae85fcf63e4$export$1b45514b112dd749);
const $9d391ae85fcf63e4$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("kwbWU", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $a8511843fd292141$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $a8511843fd292141$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});

parcelRegister("jwDjF", function(module, exports) {
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_TYPE", () => $4acd12f831a04aed$export$3b760d14ce8127a2);
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_KEY", () => $4acd12f831a04aed$export$f45f8b42c24922c1);



var $6L2Y6 = parcelRequire("6L2Y6");
const $4acd12f831a04aed$export$3b760d14ce8127a2 = 'com.atlassian.confluence.migration', $4acd12f831a04aed$export$f45f8b42c24922c1 = 'nested-table';

});


parcelRegister("e0DQG", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $a834bed4dfbe6098$export$df3f009e3d155b20);

var $5wH64 = parcelRequire("5wH64");
function $a834bed4dfbe6098$export$df3f009e3d155b20(adf, visitors) {
    if (!(0, $5wH64.validateVisitors)(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $a834bed4dfbe6098$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a834bed4dfbe6098$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $a834bed4dfbe6098$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});
parcelRegister("5wH64", function(module, exports) {
$parcel$export(module.exports, "validateVisitors", () => $5125b149f9efa8cc$export$735cfea22ce30f58);
function $5125b149f9efa8cc$export$735cfea22ce30f58(_visitors) {
    return true;
}

});


parcelRegister("uNoz0", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $8ff637e863648c78$export$9bf001d8ef76e497);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ function $8ff637e863648c78$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}

});

parcelRegister("5alrF", function(module, exports) {
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $a3505d3ea4a32e02$export$8cae9126fc577085);
function $a3505d3ea4a32e02$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});


parcelRegister("aw9OM", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $5de411ce7acd32b4$export$54fd2c36b5cc6731);

var $bmTE8 = parcelRequire("bmTE8");

var $lklwG = parcelRequire("lklwG");

var $gOaHA = parcelRequire("gOaHA");

var $b3Zoi = parcelRequire("b3Zoi");

var $g7CDB = parcelRequire("g7CDB");

var $cDeo1 = parcelRequire("cDeo1");

var $4L22w = parcelRequire("4L22w");

var $6TqRc = parcelRequire("6TqRc");

var $d2ivN = parcelRequire("d2ivN");

var $jjkUc = parcelRequire("jjkUc");
const $5de411ce7acd32b4$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $5de411ce7acd32b4$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $5de411ce7acd32b4$var$isCodeBlock = $5de411ce7acd32b4$var$isType('codeBlock');
const $5de411ce7acd32b4$var$isMediaNode = $5de411ce7acd32b4$var$isType('media');
const $5de411ce7acd32b4$var$isMediaInline = $5de411ce7acd32b4$var$isType('mediaInline');
const $5de411ce7acd32b4$var$isMediaSingleNode = $5de411ce7acd32b4$var$isType('mediaSingle');
const $5de411ce7acd32b4$var$isMentionNode = $5de411ce7acd32b4$var$isType('mention');
const $5de411ce7acd32b4$var$isParagraph = $5de411ce7acd32b4$var$isType('paragraph');
const $5de411ce7acd32b4$var$isHeading = $5de411ce7acd32b4$var$isType('heading');
const $5de411ce7acd32b4$var$isTable = $5de411ce7acd32b4$var$isType('table');
const $5de411ce7acd32b4$var$isTableCell = $5de411ce7acd32b4$var$isType('tableCell');
const $5de411ce7acd32b4$var$isTableHeader = $5de411ce7acd32b4$var$isType('tableHeader');
const $5de411ce7acd32b4$var$isLinkMark = $5de411ce7acd32b4$var$isType('link');
const $5de411ce7acd32b4$var$isUnsupportedMark = $5de411ce7acd32b4$var$isType('unsupportedMark');
const $5de411ce7acd32b4$var$isUnsupportedNodeAttributeMark = $5de411ce7acd32b4$var$isType('unsupportedNodeAttribute');
const $5de411ce7acd32b4$var$isExpand = $5de411ce7acd32b4$var$isType('expand');
const $5de411ce7acd32b4$var$isNestedExpand = $5de411ce7acd32b4$var$isType('nestedExpand');
const $5de411ce7acd32b4$var$isExtensionNode = $5de411ce7acd32b4$var$isType('extension');
const $5de411ce7acd32b4$var$isUnsupportedNode = (node)=>$5de411ce7acd32b4$var$isType('unsupportedBlock')(node) || $5de411ce7acd32b4$var$isType('unsupportedInline')(node);
const $5de411ce7acd32b4$var$isDataConsumer = $5de411ce7acd32b4$var$isType('dataConsumer');
const $5de411ce7acd32b4$var$isFragmentMark = $5de411ce7acd32b4$var$isType('fragment');
const $5de411ce7acd32b4$var$isAnnotationMark = $5de411ce7acd32b4$var$isType('annotation');
const $5de411ce7acd32b4$var$isAllowedNodeForAnnotation = (node)=>!node.type.isBlock || $5de411ce7acd32b4$var$isMediaNode(node) || $5de411ce7acd32b4$var$isExtensionNode(node);
const $5de411ce7acd32b4$var$isHardBreak = $5de411ce7acd32b4$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5de411ce7acd32b4$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $5de411ce7acd32b4$var$filterNull(current);
    }
    return output;
};
const $5de411ce7acd32b4$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $jjkUc.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $5de411ce7acd32b4$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
const $5de411ce7acd32b4$export$54fd2c36b5cc6731 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($5de411ce7acd32b4$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($5de411ce7acd32b4$var$isMediaNode(node)) obj.attrs = (0, $d2ivN.toJSON)(node).attrs;
    else if ($5de411ce7acd32b4$var$isMediaSingleNode(node)) obj.attrs = (0, $6TqRc.toJSON)(node).attrs;
    else if ($5de411ce7acd32b4$var$isMediaInline(node)) obj.attrs = (0, $d2ivN.toJSON)(node).attrs;
    else if ($5de411ce7acd32b4$var$isMentionNode(node)) obj.attrs = (0, $cDeo1.toJSON)(node).attrs;
    else if ($5de411ce7acd32b4$var$isCodeBlock(node)) obj.attrs = (0, $lklwG.toJSON)(node).attrs;
    else if ($5de411ce7acd32b4$var$isTable(node)) obj.attrs = (0, $4L22w.tableToJSON)(node).attrs;
    else if ($5de411ce7acd32b4$var$isTableCell(node)) obj.attrs = (0, $4L22w.toJSONTableCell)(node).attrs;
    else if ($5de411ce7acd32b4$var$isTableHeader(node)) obj.attrs = (0, $4L22w.toJSONTableHeader)(node).attrs;
    else if ($5de411ce7acd32b4$var$isExpand(node) || $5de411ce7acd32b4$var$isNestedExpand(node)) obj.attrs = (0, $b3Zoi.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $5de411ce7acd32b4$var$filterNull(obj.attrs);
    if ($5de411ce7acd32b4$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($5de411ce7acd32b4$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $5de411ce7acd32b4$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($5de411ce7acd32b4$export$54fd2c36b5cc6731(child, mentionMap));
    });
    if ($5de411ce7acd32b4$var$isParagraph(node) || $5de411ce7acd32b4$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($5de411ce7acd32b4$var$isAnnotationMark(mark) && !$5de411ce7acd32b4$var$isAllowedNodeForAnnotation(node)) return null;
            else if ($5de411ce7acd32b4$var$isUnsupportedMark(mark)) return $5de411ce7acd32b4$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($5de411ce7acd32b4$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($5de411ce7acd32b4$var$isLinkMark(mark)) return (0, $bmTE8.toJSON)(mark);
            else if ($5de411ce7acd32b4$var$isDataConsumer(mark)) {
                const serialised = (0, $gOaHA.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($5de411ce7acd32b4$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $g7CDB.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($5de411ce7acd32b4$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$5de411ce7acd32b4$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};

});
parcelRegister("bmTE8", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $d0fdf4ba468d4676$export$54fd2c36b5cc6731);
const $d0fdf4ba468d4676$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $d0fdf4ba468d4676$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($d0fdf4ba468d4676$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});

parcelRegister("6TqRc", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $ea96887b1dcfc213$export$54fd2c36b5cc6731);
const $ea96887b1dcfc213$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("d2ivN", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $3f95f632e93717f0$export$54fd2c36b5cc6731);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $3f95f632e93717f0$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $3f95f632e93717f0$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $3f95f632e93717f0$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $3f95f632e93717f0$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($3f95f632e93717f0$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("jjkUc", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $2d6ac36612e45eaa$export$28e4e3c024cce988);
const $2d6ac36612e45eaa$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $2d6ac36612e45eaa$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $2d6ac36612e45eaa$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $2d6ac36612e45eaa$var$defaultAllowOverrideBehaviour;
        default:
            return $2d6ac36612e45eaa$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});



parcelRegister("ku4jW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "WikiMarkupTransformer", () => $b9ddc5586b85304b$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $b9ddc5586b85304b$export$2e2bcd8739ae039);

var $aZsfy = parcelRequire("aZsfy");

var $4heNR = parcelRequire("4heNR");

var $h6GAR = parcelRequire("h6GAR");

var $kFWx8 = parcelRequire("kFWx8");
class $b9ddc5586b85304b$export$caaa00407b56b900 {
    constructor(schema = (0, $aZsfy.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $4heNR.encode)(node, $b9ddc5586b85304b$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $h6GAR.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($b9ddc5586b85304b$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $kFWx8.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $b9ddc5586b85304b$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $b9ddc5586b85304b$export$2e2bcd8739ae039 = $b9ddc5586b85304b$export$caaa00407b56b900;

});
parcelRegister("4heNR", function(module, exports) {
$parcel$export(module.exports, "encode", () => $aefaa01728fd3645$export$c564cdbbe6da493);

var $g5Vfk = parcelRequire("g5Vfk");

var $eQpR0 = parcelRequire("eQpR0");

var $fkr5Y = parcelRequire("fkr5Y");

var $eRmvB = parcelRequire("eRmvB");

var $2kbXb = parcelRequire("2kbXb");

var $fxHB9 = parcelRequire("fxHB9");

var $eqlfj = parcelRequire("eqlfj");

var $4Zezn = parcelRequire("4Zezn");

var $7G36w = parcelRequire("7G36w");

var $lxpJp = parcelRequire("lxpJp");

var $1I3Wv = parcelRequire("1I3Wv");

var $4vpP4 = parcelRequire("4vpP4");

var $5H8zP = parcelRequire("5H8zP");

var $5TUib = parcelRequire("5TUib");

var $1GFUD = parcelRequire("1GFUD");

var $74oFm = parcelRequire("74oFm");

var $7lvUV = parcelRequire("7lvUV");

var $3ag3B = parcelRequire("3ag3B");

var $kaIWu = parcelRequire("kaIWu");

var $8DVoS = parcelRequire("8DVoS");
const $aefaa01728fd3645$var$nodeEncoderMapping = {
    blockquote: $eQpR0.blockquote,
    bulletList: $eRmvB.bulletList,
    taskList: $kaIWu.taskList,
    decisionList: $eqlfj.decisionList,
    codeBlock: $fxHB9.codeBlock,
    doc: $4Zezn.doc,
    heading: $1I3Wv.heading,
    caption: $2kbXb.caption,
    mediaGroup: $4vpP4.mediaGroup,
    mediaInline: $5H8zP.mediaInline,
    mediaSingle: (0, $4vpP4.mediaGroup),
    orderedList: $5TUib.orderedList,
    panel: $1GFUD.panel,
    paragraph: $74oFm.paragraph,
    rule: $7lvUV.rule,
    table: $3ag3B.table,
    blockCard: $g5Vfk.blockCard,
    embedCard: $7G36w.embedCard,
    expand: $lxpJp.expand,
    bodiedSyncBlock: $fkr5Y.bodiedSyncBlock
};
function $aefaa01728fd3645$export$c564cdbbe6da493(node, context) {
    const encoder = $aefaa01728fd3645$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $8DVoS.unknown)(node);
    } catch (err) {
        return (0, $8DVoS.unknown)(node);
    }
}

});
parcelRegister("g5Vfk", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $8c1303c1bd817336$export$c4c2f833baaebdb8);

var $8DVoS = parcelRequire("8DVoS");
const $8c1303c1bd817336$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $8DVoS.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});
parcelRegister("8DVoS", function(module, exports) {
$parcel$export(module.exports, "unknown", () => $6660a10c42c9ba0a$export$19282c40b967aec6);

var $OVmx5 = parcelRequire("OVmx5");
const $6660a10c42c9ba0a$var$jsonTransformer = new (0, $OVmx5.JSONTransformer)();
const $6660a10c42c9ba0a$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($6660a10c42c9ba0a$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("eQpR0", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $6488c2885c41c0e7$export$67dc04e652a298ca);

var $4heNR = parcelRequire("4heNR");
const $6488c2885c41c0e7$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $4heNR.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("fkr5Y", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $c7880badfd69abc4$export$e92c7e4302dd4371);

var $4heNR = parcelRequire("4heNR");
const $c7880badfd69abc4$export$e92c7e4302dd4371 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $4heNR.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("eRmvB", function(module, exports) {
$parcel$export(module.exports, "bulletList", () => $19e26b2e59c407c3$export$a140c94e5ea26bee);

var $69KIz = parcelRequire("69KIz");
const $19e26b2e59c407c3$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $69KIz.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("69KIz", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $4920e7fe4006235c$export$76c7e83ecc9cdf05);

var $4heNR = parcelRequire("4heNR");

var $fxHB9 = parcelRequire("fxHB9");

var $4vpP4 = parcelRequire("4vpP4");

var $5H8zP = parcelRequire("5H8zP");

var $74oFm = parcelRequire("74oFm");

var $8DVoS = parcelRequire("8DVoS");
const $4920e7fe4006235c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $74oFm.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
            case 'taskList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const nestedList = (0, $4heNR.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $fxHB9.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $5H8zP.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $4vpP4.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $8DVoS.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("fxHB9", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $f010d3d11d6113a6$export$7bb0d5c671655cc4);

var $5j3bO = parcelRequire("5j3bO");
const $f010d3d11d6113a6$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $f010d3d11d6113a6$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $5j3bO.inlines)(n, {
            parent: node
        });
    });
    if ($f010d3d11d6113a6$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});
parcelRegister("5j3bO", function(module, exports) {
$parcel$export(module.exports, "inlines", () => $89b73e05f18f78db$export$96c94bfc00b85760);

var $5EVbj = parcelRequire("5EVbj");

var $5qkz8 = parcelRequire("5qkz8");

var $19JC2 = parcelRequire("19JC2");

var $1QiGu = parcelRequire("1QiGu");

var $5H8zP = parcelRequire("5H8zP");

var $gLT1m = parcelRequire("gLT1m");

var $54XkG = parcelRequire("54XkG");

var $jm8Or = parcelRequire("jm8Or");

var $8DVoS = parcelRequire("8DVoS");
const $89b73e05f18f78db$var$inlinesEncoderMapping = {
    emoji: $5qkz8.emoji,
    hardBreak: $19JC2.hardBreak,
    mediaInline: $5H8zP.mediaInline,
    mention: $gLT1m.mention,
    text: $jm8Or.text,
    inlineCard: $1QiGu.inlineCard,
    status: $54XkG.status,
    date: $5EVbj.date
};
const $89b73e05f18f78db$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $89b73e05f18f78db$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $8DVoS.unknown)(node);
};

});
parcelRegister("5EVbj", function(module, exports) {
$parcel$export(module.exports, "date", () => $c4bf75d42c4769d3$export$324d90190a8b822a);
const $c4bf75d42c4769d3$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});

parcelRegister("5qkz8", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $61e9dc143455275f$export$a19185d1233fc4b2);

var $8DPp2 = parcelRequire("8DPp2");

var $8DVoS = parcelRequire("8DVoS");
const $61e9dc143455275f$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $8DPp2.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $8DVoS.unknown)(node);
};

});
parcelRegister("8DPp2", function(module, exports) {
$parcel$export(module.exports, "mapping", () => $8e8483240c1795ba$export$83e1f26587c4acd2);
const $8e8483240c1795ba$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});


parcelRegister("19JC2", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $6a74fa378117a9fe$export$371da9dd35aba193);
const $6a74fa378117a9fe$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("1QiGu", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $f8f772e8e5d7b982$export$cbf8224b64e0d942);

var $kFWx8 = parcelRequire("kFWx8");

var $8DVoS = parcelRequire("8DVoS");
const $f8f772e8e5d7b982$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $8DVoS.unknown)(node);
    const match = node.attrs.url.match((0, $kFWx8.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});
parcelRegister("kFWx8", function(module, exports) {
$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $59d49eb1d6f87e97$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $59d49eb1d6f87e97$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $59d49eb1d6f87e97$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $59d49eb1d6f87e97$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $59d49eb1d6f87e97$export$cd8701ad7512efee);

var $fNfI6 = parcelRequire("fNfI6");
const $59d49eb1d6f87e97$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $59d49eb1d6f87e97$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $59d49eb1d6f87e97$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $59d49eb1d6f87e97$var$fallback(input, position);
    const issue = $59d49eb1d6f87e97$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $59d49eb1d6f87e97$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $fNfI6.isNotBlank)(charBefore) && $59d49eb1d6f87e97$var$isNotAllowedChars(charBefore) || (0, $fNfI6.isNotBlank)(charAfter) && $59d49eb1d6f87e97$var$isNotAllowedChars(charAfter)) return $59d49eb1d6f87e97$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $59d49eb1d6f87e97$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $59d49eb1d6f87e97$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $59d49eb1d6f87e97$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $59d49eb1d6f87e97$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $59d49eb1d6f87e97$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $59d49eb1d6f87e97$var$withInlineCardFromTextStamp = (issue)=>$59d49eb1d6f87e97$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $59d49eb1d6f87e97$var$ALLOWED_CHARS_REGEX = /\s|\(|\)|!|\.|\,|\/|\:/;
const $59d49eb1d6f87e97$var$isNotAllowedChars = (char)=>!$59d49eb1d6f87e97$var$ALLOWED_CHARS_REGEX.test(char);
const $59d49eb1d6f87e97$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});
parcelRegister("fNfI6", function(module, exports) {
$parcel$export(module.exports, "hasAnyOfMarks", () => $6c9349c5c8084799$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $6c9349c5c8084799$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $6c9349c5c8084799$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $6c9349c5c8084799$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $6c9349c5c8084799$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $6c9349c5c8084799$export$83347051c3437dc9);
function $6c9349c5c8084799$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6c9349c5c8084799$var$DIGIT_REGEX = /^\d$/;
function $6c9349c5c8084799$export$727d9dbc4fbb948f(value) {
    return !!value.match($6c9349c5c8084799$var$DIGIT_REGEX);
}
function $6c9349c5c8084799$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $6c9349c5c8084799$export$4d9e7a1c098df5e2(value) {
    return !$6c9349c5c8084799$export$7ee701e290d9865(value);
}
const $6c9349c5c8084799$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $6c9349c5c8084799$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});



parcelRegister("5H8zP", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $bab2ee631372cf21$export$38bab695e3f720f1);
const $bab2ee631372cf21$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    const fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("gLT1m", function(module, exports) {
$parcel$export(module.exports, "mention", () => $0b829cc172cd7872$export$db83999c14438df4);
const $0b829cc172cd7872$var$PREFIX = 'accountid:';
const $0b829cc172cd7872$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $0b829cc172cd7872$var$addPrefix = (content)=>content.toLowerCase().startsWith($0b829cc172cd7872$var$PREFIX) ? content : `${$0b829cc172cd7872$var$PREFIX}${content}`;
const $0b829cc172cd7872$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $0b829cc172cd7872$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $0b829cc172cd7872$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("54XkG", function(module, exports) {
$parcel$export(module.exports, "status", () => $4089c2a12df3173f$export$471f7ae5c4103ae1);

var $2G1AL = parcelRequire("2G1AL");
const $4089c2a12df3173f$var$color = {
    grey: '#97A0AF',
    purple: '#6554C0',
    blue: '#00B8D9',
    red: '#FF5630',
    yellow: '#FF991F',
    green: '#36B37E',
    // Teal — color.text.accent.teal.bolder
    '#B3F5FF': '#164555',
    // Green — reuses the legacy `green` value rather than emitting a second, near-identical green
    '#ABF5D1': '#36B37E',
    // Lime — a hue with no legacy name, so it takes its own color.text.accent.lime.bolder
    '#D3F1A7': '#37471F',
    // Yellow — takes its own color.text.accent.yellow.bolder. It cannot reuse the legacy `yellow`
    // value the way #ABF5D1 reuses `green`, because that value is `Y400` #FF991F, which is
    // orange-hued (33°) despite the name.
    '#FFF0B3': '#533F04',
    // Orange — reuses the legacy `yellow` value, which is the orange-hued one, rather than emitting
    // a second, near-identical orange
    '#FCE4A6': '#FF991F',
    // Magenta — color.text.accent.magenta.bolder
    '#FDD0EC': '#50253F'
};
const $4089c2a12df3173f$var$normalizeColor = (value)=>value.startsWith('#') ? value.toUpperCase() : value;
const $4089c2a12df3173f$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    const key = $4089c2a12df3173f$var$normalizeColor(node.attrs.color ?? '');
    newAttrs.color = $4089c2a12df3173f$var$color[key] ?? $4089c2a12df3173f$var$color['grey'];
    return (0, $2G1AL.textColor)(text, newAttrs);
};

});
parcelRegister("2G1AL", function(module, exports) {
$parcel$export(module.exports, "textColor", () => $62646961f5a04883$export$32f78bffcd82ff28);
const $62646961f5a04883$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});


parcelRegister("jm8Or", function(module, exports) {
$parcel$export(module.exports, "text", () => $996e0f7ad9d5d078$export$6f093cfa640b7166);

var $2AB5a = parcelRequire("2AB5a");

var $fj89e = parcelRequire("fj89e");

var $2G1AL = parcelRequire("2G1AL");

var $eaI6L = parcelRequire("eaI6L");

var $5vqGE = parcelRequire("5vqGE");

var $kJGxH = parcelRequire("kJGxH");

var $7wlXx = parcelRequire("7wlXx");

var $fsoDu = parcelRequire("fsoDu");

var $jnXZO = parcelRequire("jnXZO");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $996e0f7ad9d5d078$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $eaI6L.em)
    ],
    [
        'strike',
        (0, $kJGxH.strike)
    ],
    [
        'strong',
        (0, $7wlXx.strong)
    ],
    [
        'subsup',
        (0, $fsoDu.subsup)
    ],
    [
        'underline',
        (0, $jnXZO.underline)
    ],
    [
        'textColor',
        (0, $2G1AL.textColor)
    ],
    [
        'link',
        (0, $5vqGE.link)
    ],
    [
        'code',
        (0, $fj89e.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $996e0f7ad9d5d078$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $996e0f7ad9d5d078$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $996e0f7ad9d5d078$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $996e0f7ad9d5d078$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $996e0f7ad9d5d078$var$escapingWikiFormatter(text) {
    const pattern = [
        $996e0f7ad9d5d078$var$MENTION_ESCAPE_PATTERN,
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        ...(0, $2AB5a.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($996e0f7ad9d5d078$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($996e0f7ad9d5d078$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $996e0f7ad9d5d078$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $996e0f7ad9d5d078$var$isEscapeNeeded(node, parent) ? $996e0f7ad9d5d078$var$escapingWikiFormatter(node.text) : node.text;
    $996e0f7ad9d5d078$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("2AB5a", function(module, exports) {
$parcel$export(module.exports, "macroKeywordTokenMap", () => $aa8f7aa7f3591885$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $aa8f7aa7f3591885$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $aa8f7aa7f3591885$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $aa8f7aa7f3591885$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $aa8f7aa7f3591885$export$bcec6d03770b152c);

var $1APmx = parcelRequire("1APmx");

var $91WMw = parcelRequire("91WMw");
const $aa8f7aa7f3591885$export$afcd7edeca61ca93 = [
    {
        type: (0, $1APmx.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $1APmx.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $1APmx.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $1APmx.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $1APmx.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $1APmx.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $1APmx.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $1APmx.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $aa8f7aa7f3591885$var$keywordTokenMap = {
    '[': (0, $1APmx.TokenType).LINK_FORMAT,
    http: (0, $1APmx.TokenType).LINK_TEXT,
    ftp: (0, $1APmx.TokenType).LINK_TEXT,
    jamfselfservice: (0, $1APmx.TokenType).LINK_TEXT,
    irc: (0, $1APmx.TokenType).LINK_TEXT,
    mailto: (0, $1APmx.TokenType).LINK_TEXT,
    '\\\\': (0, $1APmx.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $1APmx.TokenType).HARD_BREAK,
    '\n': (0, $1APmx.TokenType).HARD_BREAK,
    '\r\n': (0, $1APmx.TokenType).HARD_BREAK,
    '!': (0, $1APmx.TokenType).MEDIA,
    '----': (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $1APmx.TokenType).DELETED,
    '{+}': (0, $1APmx.TokenType).INSERTED,
    '{*}': (0, $1APmx.TokenType).STRONG,
    '{^}': (0, $1APmx.TokenType).SUPERSCRIPT,
    '{~}': (0, $1APmx.TokenType).SUBSCRIPT,
    '{_}': (0, $1APmx.TokenType).EMPHASIS,
    '{{{}': (0, $1APmx.TokenType).MONOSPACE,
    '{??}': (0, $1APmx.TokenType).CITATION,
    '-': (0, $1APmx.TokenType).DELETED,
    '+': (0, $1APmx.TokenType).INSERTED,
    '*': (0, $1APmx.TokenType).STRONG,
    '^': (0, $1APmx.TokenType).SUPERSCRIPT,
    '~': (0, $1APmx.TokenType).SUBSCRIPT,
    _: (0, $1APmx.TokenType).EMPHASIS,
    '{{': (0, $1APmx.TokenType).MONOSPACE,
    '??': (0, $1APmx.TokenType).CITATION
};
const $aa8f7aa7f3591885$var$keywordTokenMapKeys = Object.keys($aa8f7aa7f3591885$var$keywordTokenMap);
function $aa8f7aa7f3591885$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $aa8f7aa7f3591885$export$afcd7edeca61ca93.length; i++){
        const keyword = $aa8f7aa7f3591885$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $aa8f7aa7f3591885$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $aa8f7aa7f3591885$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($aa8f7aa7f3591885$var$keywordTokenMapKeys[i])) return {
            type: $aa8f7aa7f3591885$var$keywordTokenMap[$aa8f7aa7f3591885$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $1APmx.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $aa8f7aa7f3591885$var$leadingKeywordTokenMap = [
    {
        type: (0, $1APmx.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $1APmx.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $1APmx.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $1APmx.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $91WMw.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $1APmx.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $aa8f7aa7f3591885$export$68162fc57528b560(input) {
    for(let i = 0; i < $aa8f7aa7f3591885$var$leadingKeywordTokenMap.length; i++){
        const keyword = $aa8f7aa7f3591885$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $aa8f7aa7f3591885$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $1APmx.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("1APmx", function(module, exports) {
$parcel$export(module.exports, "TokenType", () => $2a5a6ef886ae7fd0$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $2a5a6ef886ae7fd0$export$af8f4e8328578827);

var $4AqSL = parcelRequire("4AqSL");

var $a7LOR = parcelRequire("a7LOR");

var $h2Z1g = parcelRequire("h2Z1g");

var $choiT = parcelRequire("choiT");

var $eg4DI = parcelRequire("eg4DI");

var $huA1O = parcelRequire("huA1O");

var $jmmxf = parcelRequire("jmmxf");

var $8lvqH = parcelRequire("8lvqH");

var $1rCZj = parcelRequire("1rCZj");

var $2DGLe = parcelRequire("2DGLe");

var $155x4 = parcelRequire("155x4");

var $13yHz = parcelRequire("13yHz");

var $1Wl0c = parcelRequire("1Wl0c");

var $eOIm2 = parcelRequire("eOIm2");

var $kFWx8 = parcelRequire("kFWx8");

var $aGLf7 = parcelRequire("aGLf7");

var $60dci = parcelRequire("60dci");

var $91WMw = parcelRequire("91WMw");

var $9bbxW = parcelRequire("9bbxW");

var $28zSC = parcelRequire("28zSC");

var $kcQWJ = parcelRequire("kcQWJ");

var $cIK79 = parcelRequire("cIK79");

var $7myNQ = parcelRequire("7myNQ");

var $hC2d9 = parcelRequire("hC2d9");

var $9waO1 = parcelRequire("9waO1");

var $7iTrv = parcelRequire("7iTrv");

var $86tkG = parcelRequire("86tkG");

var $7IrRU = parcelRequire("7IrRU");

var $aKthg = parcelRequire("aKthg");

var $72O3j = parcelRequire("72O3j");
var $2a5a6ef886ae7fd0$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $2a5a6ef886ae7fd0$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $8lvqH.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $72O3j.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $7myNQ.quadrupleDashSymbol),
    ["RULER"]: (0, $9waO1.ruler),
    ["STRONG"]: (0, $7iTrv.strong),
    ["MONOSPACE"]: (0, $28zSC.monospace),
    ["SUPERSCRIPT"]: (0, $7IrRU.superscript),
    ["SUBSCRIPT"]: (0, $86tkG.subscript),
    ["EMPHASIS"]: (0, $2DGLe.emphasis),
    ["CITATION"]: (0, $choiT.citation),
    ["DELETED"]: (0, $jmmxf.deleted),
    ["INSERTED"]: (0, $eOIm2.inserted),
    ["HARD_BREAK"]: (0, $13yHz.hardbreak),
    ["LINK_FORMAT"]: (0, $60dci.linkFormat),
    ["LINK_TEXT"]: (0, $aGLf7.linkText),
    ["HEADING"]: (0, $1Wl0c.heading),
    ["MEDIA"]: (0, $9bbxW.media),
    ["LIST"]: (0, $91WMw.list),
    ["QUOTE"]: (0, $h2Z1g.blockquote),
    ["TABLE"]: (0, $aKthg.table),
    ["EMOJI"]: (0, $1rCZj.emoji),
    ["ADF_MACRO"]: (0, $4AqSL.adfMacro),
    ["ANCHOR_MACRO"]: (0, $a7LOR.anchorMacro),
    ["CODE_MACRO"]: (0, $eg4DI.codeMacro),
    ["QUOTE_MACRO"]: (0, $hC2d9.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $kcQWJ.noformatMacro),
    ["PANEL_MACRO"]: (0, $cIK79.panelMacro),
    ["COLOR_MACRO"]: (0, $huA1O.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $155x4.forceLineBreak),
    ["ISSUE_KEY"]: (0, $kFWx8.issueKey)
};
function $2a5a6ef886ae7fd0$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $2a5a6ef886ae7fd0$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $2a5a6ef886ae7fd0$var$fallback(input, position);
    }
    return $2a5a6ef886ae7fd0$var$fallback(input, position);
}
function $2a5a6ef886ae7fd0$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4AqSL", function(module, exports) {
$parcel$export(module.exports, "adfMacro", () => $2cb246b259649d18$export$8fb4b58db8f664fb);

var $eksg7 = parcelRequire("eksg7");
const $2cb246b259649d18$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $2cb246b259649d18$var$rawContentProcessor
    });
};
const $2cb246b259649d18$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});
parcelRegister("eksg7", function(module, exports) {
$parcel$export(module.exports, "commonMacro", () => $f70927e89171dad8$export$b6a12943ac1bb1ba);
function $f70927e89171dad8$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $f70927e89171dad8$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $f70927e89171dad8$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});


parcelRegister("a7LOR", function(module, exports) {
$parcel$export(module.exports, "anchorMacro", () => $de6c920eba3b0000$export$e660dadc21580fa2);

var $eksg7 = parcelRequire("eksg7");
const $de6c920eba3b0000$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $de6c920eba3b0000$var$rawContentProcessor
    });
};
const $de6c920eba3b0000$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("h2Z1g", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $64ab2e5ec9e4dc5f$export$67dc04e652a298ca);

var $hC2d9 = parcelRequire("hC2d9");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $64ab2e5ec9e4dc5f$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $64ab2e5ec9e4dc5f$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($64ab2e5ec9e4dc5f$var$BLOCKQUOTE_REGEXP);
    if (!match) return $64ab2e5ec9e4dc5f$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $hC2d9.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $64ab2e5ec9e4dc5f$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("hC2d9", function(module, exports) {
$parcel$export(module.exports, "quoteMacro", () => $997d2a26cb643078$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $997d2a26cb643078$export$c2a5e4612254bfa);

var $kCcFA = parcelRequire("kCcFA");

var $7wD7c = parcelRequire("7wD7c");

var $fNfI6 = parcelRequire("fNfI6");

var $eksg7 = parcelRequire("eksg7");
const $997d2a26cb643078$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $997d2a26cb643078$export$c2a5e4612254bfa,
        context: context
    });
};
const $997d2a26cb643078$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $997d2a26cb643078$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $kCcFA.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $7wD7c.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $997d2a26cb643078$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $997d2a26cb643078$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $997d2a26cb643078$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($997d2a26cb643078$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $997d2a26cb643078$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $fNfI6.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $fNfI6.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $fNfI6.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("kCcFA", function(module, exports) {
$parcel$export(module.exports, "parseString", () => $020c7f4aa21f3b80$export$960addfb9e5a0cde);

var $fc1xS = parcelRequire("fc1xS");

var $1APmx = parcelRequire("1APmx");

var $2AB5a = parcelRequire("2AB5a");

var $6Hzju = parcelRequire("6Hzju");

var $mBuw8 = parcelRequire("mBuw8");

var $7wD7c = parcelRequire("7wD7c");
const $020c7f4aa21f3b80$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $020c7f4aa21f3b80$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $020c7f4aa21f3b80$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $1APmx.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $020c7f4aa21f3b80$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $6Hzju.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $2AB5a.parseLeadingKeyword)(substring) || (0, $2AB5a.parseMacroKeyword)(substring) || (0, $2AB5a.parseOtherKeyword)(substring) || (0, $2AB5a.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $020c7f4aa21f3b80$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $020c7f4aa21f3b80$var$processState.BUFFER;
                        continue;
                    }
                }
            case $020c7f4aa21f3b80$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $2AB5a.parseOtherKeyword)(substring);
                    else match = (0, $2AB5a.parseMacroKeyword)(substring) || (0, $2AB5a.parseOtherKeyword)(substring) || (0, $2AB5a.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $020c7f4aa21f3b80$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $020c7f4aa21f3b80$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $020c7f4aa21f3b80$var$processState.TOKEN:
                {
                    const token = (0, $1APmx.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $1APmx.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $7wD7c.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $020c7f4aa21f3b80$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $020c7f4aa21f3b80$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $fc1xS.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $1APmx.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $1APmx.TokenType).HARD_BREAK) state = $020c7f4aa21f3b80$var$processState.NEWLINE;
                    else state = $020c7f4aa21f3b80$var$processState.BUFFER;
                    continue;
                }
            case $020c7f4aa21f3b80$var$processState.ESCAPE:
                {
                    const token = (0, $mBuw8.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $020c7f4aa21f3b80$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $7wD7c.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $fc1xS.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $020c7f4aa21f3b80$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $020c7f4aa21f3b80$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("fc1xS", function(module, exports) {
$parcel$export(module.exports, "createTextNode", () => $a62ab7a38280b965$export$b2ce9ad90858ed7a);
function $a62ab7a38280b965$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("6Hzju", function(module, exports) {
$parcel$export(module.exports, "parseNewlineOnly", () => $c49ff8b35e9647f2$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $c49ff8b35e9647f2$export$9c597b035e16623b);
function $c49ff8b35e9647f2$export$877995a80ec11782(input) {
    const newlineLength = $c49ff8b35e9647f2$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $c49ff8b35e9647f2$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $c49ff8b35e9647f2$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $c49ff8b35e9647f2$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("mBuw8", function(module, exports) {
$parcel$export(module.exports, "escapeHandler", () => $4d1b6ae0384f0d3b$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $4d1b6ae0384f0d3b$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $4d1b6ae0384f0d3b$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($4d1b6ae0384f0d3b$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("7wD7c", function(module, exports) {
$parcel$export(module.exports, "normalizePMNodes", () => $60bf6ec87b4e7e76$export$e21f6b7efdaf8b5d);

var $50uJP = parcelRequire("50uJP");
function $60bf6ec87b4e7e76$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $60bf6ec87b4e7e76$var$normalizeMediaGroups,
        $60bf6ec87b4e7e76$export$2cef2a4c047f9887,
        $60bf6ec87b4e7e76$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $60bf6ec87b4e7e76$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($60bf6ec87b4e7e76$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $60bf6ec87b4e7e76$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $50uJP.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $50uJP.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $50uJP.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $60bf6ec87b4e7e76$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($60bf6ec87b4e7e76$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($60bf6ec87b4e7e76$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($60bf6ec87b4e7e76$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $60bf6ec87b4e7e76$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $60bf6ec87b4e7e76$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $60bf6ec87b4e7e76$var$isHardBreak(n, separatorBuffer) || !$60bf6ec87b4e7e76$var$isEmptyTextNode(n) || $60bf6ec87b4e7e76$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $60bf6ec87b4e7e76$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $60bf6ec87b4e7e76$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $60bf6ec87b4e7e76$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $60bf6ec87b4e7e76$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $60bf6ec87b4e7e76$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("50uJP", function(module, exports) {
$parcel$export(module.exports, "createEmptyParagraphNode", () => $cef7c3b0c40f01be$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $cef7c3b0c40f01be$export$f0eaed48ea684567);
function $cef7c3b0c40f01be$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $cef7c3b0c40f01be$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});





parcelRegister("choiT", function(module, exports) {
$parcel$export(module.exports, "citation", () => $2d07fff0f57aa8f4$export$258632c953c109e9);


var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $2d07fff0f57aa8f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $2fad6ada9ec9331e$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $2fad6ada9ec9331e$export$3bca9fae3002bd9b = "\u2014";

parcelRegister("col2M", function(module, exports) {
$parcel$export(module.exports, "commonFormatter", () => $b241c0112a824a2d$export$a71d57024d3da1c5);

var $mBuw8 = parcelRequire("mBuw8");

var $1APmx = parcelRequire("1APmx");

var $2AB5a = parcelRequire("2AB5a");

var $60dci = parcelRequire("60dci");

var $6Hzju = parcelRequire("6Hzju");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b241c0112a824a2d$var$ALPHANUMERIC_OR_NON_ASCII_REGEX = /[a-zA-Z0-9]|[^\u0000-\u007F]/;
const $b241c0112a824a2d$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $b241c0112a824a2d$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $b241c0112a824a2d$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $b241c0112a824a2d$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && $b241c0112a824a2d$var$ALPHANUMERIC_OR_NON_ASCII_REGEX.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $b241c0112a824a2d$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
                    state = $b241c0112a824a2d$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $b241c0112a824a2d$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $6Hzju.parseNewlineOnly)(input.substring(index));
                    if (length) return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $b241c0112a824a2d$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $b241c0112a824a2d$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $b241c0112a824a2d$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $b241c0112a824a2d$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $b241c0112a824a2d$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && $b241c0112a824a2d$var$ALPHANUMERIC_OR_NON_ASCII_REGEX.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $b241c0112a824a2d$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $b241c0112a824a2d$var$processState.INLINE_MACRO:
                {
                    const match = (0, $2AB5a.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $b241c0112a824a2d$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $1APmx.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $b241c0112a824a2d$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $1APmx.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $b241c0112a824a2d$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
                }
            case $b241c0112a824a2d$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $60dci.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $b241c0112a824a2d$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $b241c0112a824a2d$var$processState.BUFFER;
                        continue;
                    }
                    return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
                }
            case $b241c0112a824a2d$var$processState.ESCAPE:
                {
                    const token = (0, $mBuw8.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $b241c0112a824a2d$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $b241c0112a824a2d$var$fallback(input, position, openingSymbolLength);
}
function $b241c0112a824a2d$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("60dci", function(module, exports) {
$parcel$export(module.exports, "linkFormat", () => $0fdb7f4112995684$export$e1f888a4b6f2ee53);

var $1APmx = parcelRequire("1APmx");

var $kCcFA = parcelRequire("kCcFA");

var $g6fag = parcelRequire("g6fag");

var $dZZ7F = parcelRequire("dZZ7F");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0fdb7f4112995684$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $0fdb7f4112995684$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0fdb7f4112995684$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TABLE,
        (0, $1APmx.TokenType).RULER,
        // We want to avoid recursion
        (0, $1APmx.TokenType).LINK_TEXT,
        (0, $1APmx.TokenType).LINK_FORMAT
    ];
    if (!match) return $0fdb7f4112995684$var$fallback();
    const content = (0, $g6fag.parseContentLink)(match[1]);
    const resolvedLink = (0, $dZZ7F.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $kCcFA.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $0fdb7f4112995684$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("g6fag", function(module, exports) {
$parcel$export(module.exports, "parseContentLink", () => $0824a178c17bdb7d$export$3a250a08d37b0eae);

var $fNfI6 = parcelRequire("fNfI6");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $0824a178c17bdb7d$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $0824a178c17bdb7d$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $0824a178c17bdb7d$var$divideOn(buffer, '|');
    const body = new (0, $fNfI6.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $0824a178c17bdb7d$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $0824a178c17bdb7d$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $0824a178c17bdb7d$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $0824a178c17bdb7d$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $0824a178c17bdb7d$var$extractNumber(buf) {
    const digits = new (0, $fNfI6.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $fNfI6.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $0824a178c17bdb7d$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $fNfI6.StringBuffer)(linkText);
    const linkBody = $0824a178c17bdb7d$var$extractLinkBody(buf);
    const linkTitle = $0824a178c17bdb7d$var$trimIfPossible($0824a178c17bdb7d$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $0824a178c17bdb7d$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $0824a178c17bdb7d$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $fNfI6.StringBuffer)(notLinkBody);
        shortcutName = $0824a178c17bdb7d$var$trimIfPossible($0824a178c17bdb7d$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $fNfI6.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $fNfI6.StringBuffer)(notLinkBody);
    if ((0, $fNfI6.isBlank)(shortcutName)) {
        spaceKey = $0824a178c17bdb7d$var$trimIfPossible($0824a178c17bdb7d$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $0824a178c17bdb7d$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $0824a178c17bdb7d$var$trimIfPossible($0824a178c17bdb7d$var$divideAfter(buf, '^'));
        anchor = $0824a178c17bdb7d$var$trimIfPossible($0824a178c17bdb7d$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});

parcelRegister("dZZ7F", function(module, exports) {
$parcel$export(module.exports, "resolveLink", () => $750dac6e4d3f21e1$export$c2baa561eb017101);

var $2L4mp = parcelRequire("2L4mp");

var $dACUd = parcelRequire("dACUd");

var $6NIUu = parcelRequire("6NIUu");

var $4ZyZH = parcelRequire("4ZyZH");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $750dac6e4d3f21e1$var$linkResolverStrategies = [
    (0, $2L4mp.attachmentLinkResolver),
    (0, $6NIUu.mentionLinkResolver),
    (0, $dACUd.issueLinkResolver),
    (0, $4ZyZH.urlLinkResolver)
];
function $750dac6e4d3f21e1$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $750dac6e4d3f21e1$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("2L4mp", function(module, exports) {
$parcel$export(module.exports, "attachmentLinkResolver", () => $38794481a8f08c47$export$ce918f41a76b8445);

var $bfp31 = parcelRequire("bfp31");
function $38794481a8f08c47$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $bfp31.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("bfp31", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ec3d66e6fdaff83$export$2e2bcd8739ae039);
function $9ec3d66e6fdaff83$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("dACUd", function(module, exports) {
$parcel$export(module.exports, "issueLinkResolver", () => $23f6404f809a96eb$export$f40ed0efa65d4e8);

var $kFWx8 = parcelRequire("kFWx8");
function $23f6404f809a96eb$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Depricated should be removed in the next major release
    linkTitle === 'block-link') return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $kFWx8.getIssue)(context, originalLinkText);
    if (issue) return (0, $kFWx8.buildInlineCard)(schema, issue);
    return undefined;
}

});

parcelRegister("6NIUu", function(module, exports) {
$parcel$export(module.exports, "mentionLinkResolver", () => $9b654a0fbdd089a2$export$1da3b34e38fc6ca8);
function $9b654a0fbdd089a2$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("4ZyZH", function(module, exports) {
$parcel$export(module.exports, "urlLinkResolver", () => $cac99c930a3f3375$export$b737d556d2167f9);

var $2PNLJ = parcelRequire("2PNLJ");

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cac99c930a3f3375$var$MAILTO_PREFIX_REGEX = /^mailto:/;
function $cac99c930a3f3375$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $2PNLJ.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).LINK_TEXT,
        (0, $1APmx.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $kCcFA.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: textRepresentation.replace($cac99c930a3f3375$var$MAILTO_PREFIX_REGEX, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$cac99c930a3f3375$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $cac99c930a3f3375$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});





parcelRegister("eg4DI", function(module, exports) {
$parcel$export(module.exports, "codeMacro", () => $59841b999d854fe1$export$db6c131ac26c7700);

var $4uhDE = parcelRequire("4uhDE");

var $4qF1d = parcelRequire("4qF1d");

var $eksg7 = parcelRequire("eksg7");
const $59841b999d854fe1$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $59841b999d854fe1$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $59841b999d854fe1$var$rawContentProcessor
    });
};
const $59841b999d854fe1$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4uhDE.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $4qF1d.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $59841b999d854fe1$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $59841b999d854fe1$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $59841b999d854fe1$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});
parcelRegister("4uhDE", function(module, exports) {
$parcel$export(module.exports, "parseAttrs", () => $213e7efc79e9ef2c$export$e1a9355cfd8f6c64);
function $213e7efc79e9ef2c$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("4qF1d", function(module, exports) {
$parcel$export(module.exports, "title", () => $73d6ba22b6efb4c5$export$fb184b623420d9be);
function $73d6ba22b6efb4c5$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("huA1O", function(module, exports) {
$parcel$export(module.exports, "colorMacro", () => $9762df613650f48c$export$b557be495948d995);

var $1APmx = parcelRequire("1APmx");

var $8MUAp = parcelRequire("8MUAp");

var $kCcFA = parcelRequire("kCcFA");

var $4uhDE = parcelRequire("4uhDE");

var $fNfI6 = parcelRequire("fNfI6");

var $eksg7 = parcelRequire("eksg7");
const $9762df613650f48c$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $9762df613650f48c$var$rawContentProcessor
    });
};
const $9762df613650f48c$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TABLE
    ];
    const parsedAttrs = (0, $4uhDE.parseAttrs)(rawAttrs);
    const content = (0, $kCcFA.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $8MUAp.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("8MUAp", function(module, exports) {
$parcel$export(module.exports, "getEditorColor", () => $ced6d8c66d14c87f$export$c0cfc6f23e0b7578);

var $6jVvE = parcelRequire("6jVvE");
function $ced6d8c66d14c87f$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $6jVvE.normalizeHexColor)(keys[0]);
}

});


parcelRegister("jmmxf", function(module, exports) {
$parcel$export(module.exports, "deleted", () => $6741743692148f54$export$bccbf0c716f226f4);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $6741743692148f54$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("8lvqH", function(module, exports) {
$parcel$export(module.exports, "doubleDashSymbol", () => $6b73f2a40e2e8ad4$export$65e3ca7c95899a2d);

var $baxbC = parcelRequire("baxbC");
const $6b73f2a40e2e8ad4$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $6b73f2a40e2e8ad4$var$fallback = {
    ...$6b73f2a40e2e8ad4$var$token,
    text: '--'
};
const $6b73f2a40e2e8ad4$export$65e3ca7c95899a2d = (0, $baxbC.createDashTokenParser)($6b73f2a40e2e8ad4$var$token, $6b73f2a40e2e8ad4$var$fallback);

});
parcelRegister("baxbC", function(module, exports) {
$parcel$export(module.exports, "createDashTokenParser", () => $3589bb0639b61b27$export$d43b58865d429e3c);
const $3589bb0639b61b27$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$3589bb0639b61b27$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$3589bb0639b61b27$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3589bb0639b61b27$var$WHITESPACE_REGEX = /\s/;
const $3589bb0639b61b27$var$isSpace = (char)=>{
    return $3589bb0639b61b27$var$WHITESPACE_REGEX.test(char);
};

});


parcelRegister("1rCZj", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $41c459e75d106d9c$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $41c459e75d106d9c$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $41c459e75d106d9c$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $41c459e75d106d9c$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $41c459e75d106d9c$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($41c459e75d106d9c$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $41c459e75d106d9c$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $41c459e75d106d9c$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("2DGLe", function(module, exports) {
$parcel$export(module.exports, "emphasis", () => $9a39a99476273193$export$bef81ba411953b51);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $9a39a99476273193$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("155x4", function(module, exports) {
$parcel$export(module.exports, "forceLineBreak", () => $cd88c19d32f92280$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cd88c19d32f92280$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $cd88c19d32f92280$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $cd88c19d32f92280$var$fallback(input, position);
    }
    const match = input.substring(position).match($cd88c19d32f92280$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $cd88c19d32f92280$var$fallback(input, position);
};
function $cd88c19d32f92280$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});

parcelRegister("13yHz", function(module, exports) {
$parcel$export(module.exports, "hardbreak", () => $3f40c931dc60b246$export$ac55bb44695749c1);

var $6Hzju = parcelRequire("6Hzju");
const $3f40c931dc60b246$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $6Hzju.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("1Wl0c", function(module, exports) {
$parcel$export(module.exports, "heading", () => $2a5dd5b446d5d4f2$export$46e4a324ac90507f);

var $kCcFA = parcelRequire("kCcFA");

var $1APmx = parcelRequire("1APmx");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2a5dd5b446d5d4f2$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $2a5dd5b446d5d4f2$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($2a5dd5b446d5d4f2$var$HEADING_REGEXP);
    if (!match) return $2a5dd5b446d5d4f2$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $kCcFA.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $2a5dd5b446d5d4f2$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("eOIm2", function(module, exports) {
$parcel$export(module.exports, "inserted", () => $77c95b1b2c68e108$export$744ba74fb86b8ca7);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $77c95b1b2c68e108$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("aGLf7", function(module, exports) {
$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $a3a2c122c14a74b3$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $a3a2c122c14a74b3$export$cb7bcf09a05b7705);

var $2PNLJ = parcelRequire("2PNLJ");

var $1Bexq = parcelRequire("1Bexq");
const $a3a2c122c14a74b3$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $a3a2c122c14a74b3$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($a3a2c122c14a74b3$export$f69d1dce349473aa);
    if (!matches) return $a3a2c122c14a74b3$var$fallback(input, position);
    const match = $a3a2c122c14a74b3$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $1Bexq.decode)($a3a2c122c14a74b3$var$unescape(match[0]));
    if (!(0, $2PNLJ.isSafeUrl)(url)) return $a3a2c122c14a74b3$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $a3a2c122c14a74b3$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $a3a2c122c14a74b3$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a3a2c122c14a74b3$var$BAD_END_CHARS_REGEX = /[.,>)\];}"\'!]*$/;
// removes bad characters from the end of regex match
function $a3a2c122c14a74b3$var$trimBadEndChar(input) {
    return [
        input[0].replace($a3a2c122c14a74b3$var$BAD_END_CHARS_REGEX, ''),
        input[1],
        input[2].replace($a3a2c122c14a74b3$var$BAD_END_CHARS_REGEX, '')
    ];
}

});
parcelRegister("1Bexq", function(module, exports) {
$parcel$export(module.exports, "decode", () => $2ff55fe9818b76e0$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $2ff55fe9818b76e0$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});


parcelRegister("91WMw", function(module, exports) {
$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $f6c64ca127258bad$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $f6c64ca127258bad$export$8837f4fc672e936d);

var $fzso2 = parcelRequire("fzso2");

var $kCcFA = parcelRequire("kCcFA");

var $7wD7c = parcelRequire("7wD7c");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $2AB5a = parcelRequire("2AB5a");

var $6Hzju = parcelRequire("6Hzju");
const $f6c64ca127258bad$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f6c64ca127258bad$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$f6c64ca127258bad$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f6c64ca127258bad$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f6c64ca127258bad$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $f6c64ca127258bad$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $f6c64ca127258bad$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).LIST,
        (0, $1APmx.TokenType).TABLE
    ];
    let index = position;
    let state = $f6c64ca127258bad$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $f6c64ca127258bad$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($f6c64ca127258bad$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($f6c64ca127258bad$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($f6c64ca127258bad$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $f6c64ca127258bad$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $fzso2.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $kCcFA.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $f6c64ca127258bad$var$sanitize((0, $7wD7c.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $fzso2.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $fzso2.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($f6c64ca127258bad$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $f6c64ca127258bad$var$processState.END;
                        continue;
                    }
                    state = $f6c64ca127258bad$var$processState.BUFFER;
                    continue;
                }
            case $f6c64ca127258bad$var$processState.BUFFER:
                {
                    const length = (0, $6Hzju.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $f6c64ca127258bad$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $f6c64ca127258bad$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $f6c64ca127258bad$var$processState.MACRO:
                {
                    const match = (0, $2AB5a.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $f6c64ca127258bad$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $1APmx.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $f6c64ca127258bad$var$processState.BUFFER;
                    continue;
                }
            case $f6c64ca127258bad$var$processState.END:
                if (!builder) // Something is really wrong here
                return $f6c64ca127258bad$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $kCcFA.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $f6c64ca127258bad$var$sanitize((0, $7wD7c.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $kCcFA.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $f6c64ca127258bad$var$sanitize((0, $7wD7c.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $f6c64ca127258bad$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $f6c64ca127258bad$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("fzso2", function(module, exports) {
$parcel$export(module.exports, "getType", () => $b5bf1992ef200449$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $b5bf1992ef200449$export$876cfa3161bef296);
const $b5bf1992ef200449$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b5bf1992ef200449$var$ORDERED_LIST_REGEX = /#$/;
function $b5bf1992ef200449$export$e2b5c5db9e2009fd(bullets) {
    return $b5bf1992ef200449$var$ORDERED_LIST_REGEX.test(bullets) ? 'orderedList' : 'bulletList';
}
class $b5bf1992ef200449$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($b5bf1992ef200449$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $b5bf1992ef200449$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $b5bf1992ef200449$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) {
            // If the first element is a list node, try to create a wrapper listItem
            // (list as first child, no paragraph) for flexible list indentation.
            // If the schema doesn't support this variant, fall back to prepending
            // an empty paragraph.
            const listTypes = [
                'bulletList',
                'orderedList',
                'taskList'
            ];
            if (content.length > 0 && listTypes.indexOf(content[0].type.name) !== -1) try {
                return schema.nodes.listItem.createChecked({}, content);
            } catch  {
            // Schema doesn't support list as first child of listItem,
            // fall back to prepending an empty paragraph
            }
            // If the content is empty or the first element is not paragraph or mediaSingle,
            // this is likely a nested list where the top-level list item has no text content.
            // For example: *# item 1
            // In this case we create an empty paragraph for the top level listNode.
            content.unshift(this.schema.nodes.paragraph.createChecked());
        }
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("9bbxW", function(module, exports) {
$parcel$export(module.exports, "media", () => $51873a8e09ba75d2$export$987d49ffe1b0900f);

var $bXrmX = parcelRequire("bXrmX");

var $4uhDE = parcelRequire("4uhDE");

var $col2M = parcelRequire("col2M");
const $51873a8e09ba75d2$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $bXrmX.default)(schema, rawContent, (0, $4uhDE.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("bXrmX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba1ed5b7a36086f4$export$2e2bcd8739ae039);

var $aGLf7 = parcelRequire("aGLf7");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ba1ed5b7a36086f4$var$WRAPPING_QUOTES_REGEX = /^"(.+)"$/;
const $ba1ed5b7a36086f4$var$defaultWidth = 200;
const $ba1ed5b7a36086f4$var$defaultHeight = 183;
const $ba1ed5b7a36086f4$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $ba1ed5b7a36086f4$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $ba1ed5b7a36086f4$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $ba1ed5b7a36086f4$var$defaultHeight;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $ba1ed5b7a36086f4$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        const href = attrs.href.replace($ba1ed5b7a36086f4$var$WRAPPING_QUOTES_REGEX, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        const altText = attrs.alt.replace($ba1ed5b7a36086f4$var$WRAPPING_QUOTES_REGEX, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $aGLf7.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});


parcelRegister("28zSC", function(module, exports) {
$parcel$export(module.exports, "monospace", () => $80682f627a599147$export$2b90969bbc9ff4c9);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $80682f627a599147$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).ADF_MACRO,
        (0, $1APmx.TokenType).ANCHOR_MACRO,
        (0, $1APmx.TokenType).CODE_MACRO,
        (0, $1APmx.TokenType).QUOTE_MACRO,
        (0, $1APmx.TokenType).NOFORMAT_MACRO,
        (0, $1APmx.TokenType).PANEL_MACRO,
        (0, $1APmx.TokenType).COLOR_MACRO,
        (0, $1APmx.TokenType).LOREM_MACRO,
        (0, $1APmx.TokenType).QUOTE,
        (0, $1APmx.TokenType).STRING,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).LINK_FORMAT,
        (0, $1APmx.TokenType).LINK_TEXT,
        (0, $1APmx.TokenType).MEDIA,
        (0, $1APmx.TokenType).HEADING,
        (0, $1APmx.TokenType).LIST,
        (0, $1APmx.TokenType).TABLE,
        (0, $1APmx.TokenType).RULER,
        (0, $1APmx.TokenType).HARD_BREAK,
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).STRONG,
        (0, $1APmx.TokenType).MONOSPACE,
        (0, $1APmx.TokenType).SUPERSCRIPT,
        (0, $1APmx.TokenType).SUBSCRIPT,
        (0, $1APmx.TokenType).EMPHASIS,
        (0, $1APmx.TokenType).CITATION,
        (0, $1APmx.TokenType).DELETED,
        (0, $1APmx.TokenType).INSERTED,
        (0, $1APmx.TokenType).EMOJI,
        (0, $1APmx.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("kcQWJ", function(module, exports) {
$parcel$export(module.exports, "noformatMacro", () => $4f20869f85685a0f$export$9199752eb9b2d5b4);

var $4uhDE = parcelRequire("4uhDE");

var $4qF1d = parcelRequire("4qF1d");

var $eksg7 = parcelRequire("eksg7");
const $4f20869f85685a0f$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $4f20869f85685a0f$var$rawContentProcessor
    });
};
const $4f20869f85685a0f$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4uhDE.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $4qF1d.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("cIK79", function(module, exports) {
$parcel$export(module.exports, "panelMacro", () => $9f58e9bc36bbd4a4$export$5d7bf7e31a674541);

var $kCcFA = parcelRequire("kCcFA");

var $4uhDE = parcelRequire("4uhDE");

var $7wD7c = parcelRequire("7wD7c");

var $1aGph = parcelRequire("1aGph");

var $4qF1d = parcelRequire("4qF1d");

var $eksg7 = parcelRequire("eksg7");
const $9f58e9bc36bbd4a4$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $9f58e9bc36bbd4a4$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $eksg7.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $9f58e9bc36bbd4a4$var$rawContentProcessor
    });
};
const $9f58e9bc36bbd4a4$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $4uhDE.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $1aGph.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $kCcFA.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $7wD7c.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $4qF1d.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($9f58e9bc36bbd4a4$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $9f58e9bc36bbd4a4$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $9f58e9bc36bbd4a4$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("1aGph", function(module, exports) {
$parcel$export(module.exports, "getPanelType", () => $849f0753bba4bc88$export$fa00fa3d6c22a747);

var $84PMf = parcelRequire("84PMf");
const $849f0753bba4bc88$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $849f0753bba4bc88$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $849f0753bba4bc88$export$fa00fa3d6c22a747(attrs) {
    const rgb = $849f0753bba4bc88$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($849f0753bba4bc88$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $849f0753bba4bc88$var$distanceOfRgb($849f0753bba4bc88$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $849f0753bba4bc88$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $849f0753bba4bc88$var$generateRgb(color) {
    switch(true){
        case $849f0753bba4bc88$var$COLOR_TYPE_REGEX.hexShort.test(color) || $849f0753bba4bc88$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $849f0753bba4bc88$var$parseHex(color);
        case $849f0753bba4bc88$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $849f0753bba4bc88$var$parseRgb(color);
        case $849f0753bba4bc88$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $849f0753bba4bc88$var$parsePrgb(color);
        default:
            return $849f0753bba4bc88$var$parseColorName(color);
    }
}
function $849f0753bba4bc88$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($849f0753bba4bc88$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $849f0753bba4bc88$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $849f0753bba4bc88$var$parseRgb(rgb) {
    const result = rgb.match($849f0753bba4bc88$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $849f0753bba4bc88$var$parsePrgb(prgb) {
    const result = prgb.match($849f0753bba4bc88$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $849f0753bba4bc88$var$parseColorName(color) {
    return (0, $84PMf.default)[color];
}

});
parcelRegister("84PMf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eb457d8ca968ebc$export$2e2bcd8739ae039);
const $5eb457d8ca968ebc$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $5eb457d8ca968ebc$export$2e2bcd8739ae039 = $5eb457d8ca968ebc$var$mapping;

});



parcelRegister("7myNQ", function(module, exports) {
$parcel$export(module.exports, "quadrupleDashSymbol", () => $6868f01d93f1db44$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6868f01d93f1db44$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $6868f01d93f1db44$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($6868f01d93f1db44$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("9waO1", function(module, exports) {
$parcel$export(module.exports, "ruler", () => $ccbbd83137e1b227$export$f9adada2013e846e);

var $dkOnL = parcelRequire("dkOnL");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ccbbd83137e1b227$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $ccbbd83137e1b227$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($ccbbd83137e1b227$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $dkOnL.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("dkOnL", function(module, exports) {
$parcel$export(module.exports, "createRuleNode", () => $d016958d2b00499a$export$4267f2e5716b018a);
const $d016958d2b00499a$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $d016958d2b00499a$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($d016958d2b00499a$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $d016958d2b00499a$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("7iTrv", function(module, exports) {
$parcel$export(module.exports, "strong", () => $e5b618c7e57e9144$export$59ae2c325a998f89);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $e5b618c7e57e9144$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("86tkG", function(module, exports) {
$parcel$export(module.exports, "subscript", () => $774f8a62b3ac8bc3$export$bc5390e4688d2822);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $774f8a62b3ac8bc3$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("7IrRU", function(module, exports) {
$parcel$export(module.exports, "superscript", () => $51ca0a4cccce66ed$export$b4aab94a5fcfcead);

var $kCcFA = parcelRequire("kCcFA");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $col2M = parcelRequire("col2M");
const $51ca0a4cccce66ed$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).ISSUE_KEY,
        (0, $1APmx.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $kCcFA.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $fNfI6.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $col2M.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("aKthg", function(module, exports) {
$parcel$export(module.exports, "table", () => $db342ad4199c8031$export$9852986a3ec5f6a0);

var $kTxMh = parcelRequire("kTxMh");

var $kCcFA = parcelRequire("kCcFA");

var $7wD7c = parcelRequire("7wD7c");

var $fNfI6 = parcelRequire("fNfI6");

var $1APmx = parcelRequire("1APmx");

var $1rCZj = parcelRequire("1rCZj");

var $2AB5a = parcelRequire("2AB5a");

var $60dci = parcelRequire("60dci");

var $9bbxW = parcelRequire("9bbxW");

var $6Hzju = parcelRequire("6Hzju");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $db342ad4199c8031$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $db342ad4199c8031$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $db342ad4199c8031$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $db342ad4199c8031$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $1APmx.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $1APmx.TokenType).TABLE,
        (0, $1APmx.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $db342ad4199c8031$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $db342ad4199c8031$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($db342ad4199c8031$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $kTxMh.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $db342ad4199c8031$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $db342ad4199c8031$var$processState.END_TABLE;
                    continue;
                }
            case $db342ad4199c8031$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($db342ad4199c8031$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $db342ad4199c8031$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $db342ad4199c8031$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($db342ad4199c8031$var$CELL_REGEXP);
                    if (cellMatch) currentState = $db342ad4199c8031$var$processState.CLOSE_ROW;
                    else currentState = $db342ad4199c8031$var$processState.BUFFER;
                    continue;
                }
            case $db342ad4199c8031$var$processState.BUFFER:
                {
                    const length = (0, $6Hzju.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($db342ad4199c8031$var$EMPTY_LINE_REGEXP)) currentState = $db342ad4199c8031$var$processState.CLOSE_ROW;
                        else {
                            currentState = $db342ad4199c8031$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $db342ad4199c8031$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($db342ad4199c8031$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $db342ad4199c8031$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $db342ad4199c8031$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $db342ad4199c8031$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $db342ad4199c8031$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $db342ad4199c8031$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $db342ad4199c8031$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $db342ad4199c8031$var$processState.NEW_ROW;
                    continue;
                }
            case $db342ad4199c8031$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $db342ad4199c8031$var$processState.MEDIA:
                {
                    const token = (0, $9bbxW.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $db342ad4199c8031$var$processState.BUFFER;
                    continue;
                }
            case $db342ad4199c8031$var$processState.EMOJI:
                {
                    const token = (0, $1rCZj.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $db342ad4199c8031$var$processState.BUFFER;
                    continue;
                }
            case $db342ad4199c8031$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $60dci.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $db342ad4199c8031$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $db342ad4199c8031$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $db342ad4199c8031$var$processState.MACRO:
                {
                    const match = (0, $2AB5a.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $db342ad4199c8031$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $1APmx.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $db342ad4199c8031$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $db342ad4199c8031$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $db342ad4199c8031$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $kCcFA.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $db342ad4199c8031$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $7wD7c.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $db342ad4199c8031$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $db342ad4199c8031$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $db342ad4199c8031$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $db342ad4199c8031$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $db342ad4199c8031$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $fNfI6.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $db342ad4199c8031$var$traverseContent(node, mark, schema);
}

});
parcelRegister("kTxMh", function(module, exports) {
$parcel$export(module.exports, "TableBuilder", () => $d395db562522c7da$export$9e18c07f56f31a89);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $d395db562522c7da$var$TABLE_HEADER_REGEX = /\|\|/;
/**
 * Return the cell type based on the delimeter
 */ function $d395db562522c7da$var$getType(style) {
    return $d395db562522c7da$var$TABLE_HEADER_REGEX.test(style) ? 'tableHeader' : 'tableCell';
}
class $d395db562522c7da$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $d395db562522c7da$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("72O3j", function(module, exports) {
$parcel$export(module.exports, "tripleDashSymbol", () => $8ffc6cae435a5389$export$edbcd749367de060);

var $baxbC = parcelRequire("baxbC");
const $8ffc6cae435a5389$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $8ffc6cae435a5389$var$fallback = {
    ...$8ffc6cae435a5389$var$token,
    text: '---'
};
const $8ffc6cae435a5389$export$edbcd749367de060 = (0, $baxbC.createDashTokenParser)($8ffc6cae435a5389$var$token, $8ffc6cae435a5389$var$fallback);

});



parcelRegister("fj89e", function(module, exports) {
$parcel$export(module.exports, "code", () => $946bc07726c029c6$export$6565f9f03506010b);
const $946bc07726c029c6$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("eaI6L", function(module, exports) {
$parcel$export(module.exports, "em", () => $97b1cac723ea1ca2$export$c63c6f932822f543);

var $fNtyE = parcelRequire("fNtyE");
const $97b1cac723ea1ca2$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $fNtyE.baseMarkPattern)(text.substring(2), '??');
    return (0, $fNtyE.baseMarkPattern)(text, '_');
};

});
parcelRegister("fNtyE", function(module, exports) {
$parcel$export(module.exports, "baseMarkPattern", () => $defe08c4e9b78244$export$3d8aed7830783c75);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $defe08c4e9b78244$var$ONLY_WHITESPACE_REGEX = /^\s*$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $defe08c4e9b78244$var$LEADING_WHITESPACE_REGEX = /^\s*/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $defe08c4e9b78244$var$TRAILING_WHITESPACE_REGEX = /\s*$/;
const $defe08c4e9b78244$export$3d8aed7830783c75 = (text, token)=>{
    if ($defe08c4e9b78244$var$ONLY_WHITESPACE_REGEX.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    return text.replace($defe08c4e9b78244$var$LEADING_WHITESPACE_REGEX, `$&${token}`).replace($defe08c4e9b78244$var$TRAILING_WHITESPACE_REGEX, `${token}$&`);
};

});


parcelRegister("5vqGE", function(module, exports) {
$parcel$export(module.exports, "link", () => $ef9a65ae107f3fa2$export$9c30223ca0a664fb);
const $ef9a65ae107f3fa2$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("kJGxH", function(module, exports) {
$parcel$export(module.exports, "strike", () => $57cede2105194bea$export$4899a95d70ec5056);

var $fNtyE = parcelRequire("fNtyE");
const $57cede2105194bea$export$4899a95d70ec5056 = (text)=>{
    return (0, $fNtyE.baseMarkPattern)(text, '-');
};

});

parcelRegister("7wlXx", function(module, exports) {
$parcel$export(module.exports, "strong", () => $3b6a9481313d208d$export$59ae2c325a998f89);

var $fNtyE = parcelRequire("fNtyE");
const $3b6a9481313d208d$export$59ae2c325a998f89 = (text)=>{
    return (0, $fNtyE.baseMarkPattern)(text, '*');
};

});

parcelRegister("fsoDu", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $68d8e66899f110f9$export$b3401ee80eb31041);

var $fNtyE = parcelRequire("fNtyE");
const $68d8e66899f110f9$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $fNtyE.baseMarkPattern)(text, '~');
    else return (0, $fNtyE.baseMarkPattern)(text, '^');
};

});

parcelRegister("jnXZO", function(module, exports) {
$parcel$export(module.exports, "underline", () => $f5eb08d000d19b3d$export$425327af25286e5e);

var $fNtyE = parcelRequire("fNtyE");
const $f5eb08d000d19b3d$export$425327af25286e5e = (text)=>{
    return (0, $fNtyE.baseMarkPattern)(text, '+');
};

});




parcelRegister("4vpP4", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $a0887e7f7268a1ea$export$2855e964765eac9);

var $2kbXb = parcelRequire("2kbXb");

var $8hvGT = parcelRequire("8hvGT");

var $8DVoS = parcelRequire("8DVoS");
const $a0887e7f7268a1ea$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $8hvGT.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $2kbXb.caption)(n, opts));
                break;
            default:
                result.push((0, $8DVoS.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("2kbXb", function(module, exports) {
$parcel$export(module.exports, "caption", () => $a637dc3c52e14520$export$8e3c2dfdc4f0453d);

var $5j3bO = parcelRequire("5j3bO");
const $a637dc3c52e14520$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $5j3bO.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("8hvGT", function(module, exports) {
$parcel$export(module.exports, "media", () => $19653a68a2726696$export$987d49ffe1b0900f);
const $19653a68a2726696$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});


parcelRegister("74oFm", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $6d224d74f234b8c4$export$9c206ddddb32a9b);

var $5j3bO = parcelRequire("5j3bO");
const $6d224d74f234b8c4$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $5j3bO.inlines)(n, {
            context: context
        });
    });
    return result;
};

});



parcelRegister("eqlfj", function(module, exports) {
$parcel$export(module.exports, "decisionList", () => $750524d2114b4de6$export$62d45a65fb43d95e);

var $kgprp = parcelRequire("kgprp");
const $750524d2114b4de6$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $kgprp.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("kgprp", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $8be44a86e95d62dc$export$6959e16eeff859b4);

var $5j3bO = parcelRequire("5j3bO");
const $8be44a86e95d62dc$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $5j3bO.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("4Zezn", function(module, exports) {
$parcel$export(module.exports, "doc", () => $07d0607d60614344$export$2a111da947c407d2);

var $4heNR = parcelRequire("4heNR");
const $07d0607d60614344$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $4heNR.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("7G36w", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $967a3865cd5fac70$export$be4283d9a1cb1ff6);

var $8DVoS = parcelRequire("8DVoS");
const $967a3865cd5fac70$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $8DVoS.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});

parcelRegister("lxpJp", function(module, exports) {
$parcel$export(module.exports, "expand", () => $557c1bf52de9bb6f$export$9f77e0932fb78f72);

var $4heNR = parcelRequire("4heNR");
const $557c1bf52de9bb6f$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $4heNR.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("1I3Wv", function(module, exports) {
$parcel$export(module.exports, "heading", () => $0866f7c04778ffed$export$46e4a324ac90507f);

var $5j3bO = parcelRequire("5j3bO");
const $0866f7c04778ffed$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $5j3bO.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("5TUib", function(module, exports) {
$parcel$export(module.exports, "orderedList", () => $2f3976cb06b2795e$export$a5dc81035676e7a);

var $69KIz = parcelRequire("69KIz");
const $2f3976cb06b2795e$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $69KIz.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("1GFUD", function(module, exports) {
$parcel$export(module.exports, "panel", () => $2d341fa5c2d1dff1$export$21f42ab9b6679f44);

var $4heNR = parcelRequire("4heNR");
const $2d341fa5c2d1dff1$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $2d341fa5c2d1dff1$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $4heNR.encode)(n, context));
    });
    return `{panel:bgColor=${$2d341fa5c2d1dff1$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("7lvUV", function(module, exports) {
$parcel$export(module.exports, "rule", () => $680bfaf5fcaec4fc$export$fbeb3a3956e8a3c7);
const $680bfaf5fcaec4fc$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("3ag3B", function(module, exports) {
$parcel$export(module.exports, "table", () => $dd43d2a7a84b59c1$export$9852986a3ec5f6a0);

var $4heNR = parcelRequire("4heNR");

var $8DVoS = parcelRequire("8DVoS");
const $dd43d2a7a84b59c1$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($dd43d2a7a84b59c1$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $8DVoS.unknown)(node);
    }
};
const $dd43d2a7a84b59c1$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$dd43d2a7a84b59c1$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $dd43d2a7a84b59c1$var$tableCell = (node, { context: context } = {})=>{
    if ($dd43d2a7a84b59c1$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $4heNR.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $dd43d2a7a84b59c1$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("kaIWu", function(module, exports) {
$parcel$export(module.exports, "taskList", () => $bf3df6461d2af7c4$export$375b6afcc5f4d291);

var $97YsR = parcelRequire("97YsR");
const $bf3df6461d2af7c4$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($bf3df6461d2af7c4$var$nestedNode(item, depth + 1));
        else result.push((0, $97YsR.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $bf3df6461d2af7c4$export$375b6afcc5f4d291 = (node)=>{
    return $bf3df6461d2af7c4$var$nestedNode(node);
};

});
parcelRegister("97YsR", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $c0d0014f1b9cd1e3$export$6d8b0ef52e2e6390);

var $5j3bO = parcelRequire("5j3bO");
const $c0d0014f1b9cd1e3$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $5j3bO.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $5j3bO.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});



parcelRegister("h6GAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d71e685d2a10fbe6$export$2e2bcd8739ae039);

var $kCcFA = parcelRequire("kCcFA");

var $7wD7c = parcelRequire("7wD7c");
class $d71e685d2a10fbe6$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $kCcFA.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $7wD7c.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});





parcelRegister("fAVtN", function(module, exports) {
$parcel$export(module.exports, "preloadIssueCreateModernisedModal", () => $06bcfb2ddb186fdc$export$64dffb3661427b35);
$parcel$export(module.exports, "AsyncIssueCreateModal", () => $06bcfb2ddb186fdc$export$2eb2fdb04fff9db3);

var $3yzOx = parcelRequire("3yzOx");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $9c2wt = parcelRequire("9c2wt");

var $anXdQ = parcelRequire("anXdQ");

var $7JeLK = parcelRequire("7JeLK");

var $jepRN = parcelRequire("jepRN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $06bcfb2ddb186fdc$var$JiraGicInviteNudgeListenerLazy = (0, $l8G1z.lazy)(()=>(parcelRequire("1qfXv")).then((module)=>({
            default: module.JiraGicInviteNudgeListener
        })), {
    ssr: false,
    moduleId: "./src/packages/growth/twcg-2043-jira-gic-invite-nudge/src/JiraGicInviteNudgeListener.tsx"
});
const $06bcfb2ddb186fdc$var$JiraGicInviteNudgeListenerLazyWithFG = (0, $jepRN.componentWithFG)('jira-gic-invite-nudge-killswitch', $06bcfb2ddb186fdc$var$JiraGicInviteNudgeListenerLazy, ()=>null);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $06bcfb2ddb186fdc$var$CaptureBugContextIssueCreatedListenerLazy = (0, $l8G1z.lazy)(()=>(parcelRequire("jBrIx")).then(({ CaptureBugContextIssueCreatedListener: CaptureBugContextIssueCreatedListener })=>({
            default: CaptureBugContextIssueCreatedListener
        })), {
    ssr: false,
    moduleId: "./src/packages/growth/twcg-2199-capture-bug-context/src/CaptureBugContextIssueCreatedListener.tsx"
});
const $06bcfb2ddb186fdc$var$CaptureBugContextIssueCreatedListenerLazyWithFG = (0, $jepRN.componentWithFG)('capture-bug-context-killswitch', $06bcfb2ddb186fdc$var$CaptureBugContextIssueCreatedListenerLazy, ()=>null);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $06bcfb2ddb186fdc$var$IssueCreateModernisedModalLazy = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gW9EX")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-modernised/src/ui/modal/IssueCreateModal.tsx"
});
const $06bcfb2ddb186fdc$export$64dffb3661427b35 = ()=>{
    $06bcfb2ddb186fdc$var$IssueCreateModernisedModalLazy.preload();
    (0, $anXdQ.preloadableAsyncRichTextEditEntryPoint).preload();
};
const $06bcfb2ddb186fdc$var$IssueCreateModernisedModalWithPriority = ({ onResetApolloCache: onResetApolloCache, alwaysShowFullForm: alwaysShowFullForm })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $7JeLK.BackgroundPriority), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($06bcfb2ddb186fdc$var$IssueCreateModernisedModalLazy, {
        onResetApolloCache: onResetApolloCache,
        alwaysShowFullForm: alwaysShowFullForm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($06bcfb2ddb186fdc$var$JiraGicInviteNudgeListenerLazyWithFG, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($06bcfb2ddb186fdc$var$CaptureBugContextIssueCreatedListenerLazyWithFG, null));
$06bcfb2ddb186fdc$var$IssueCreateModernisedModalWithPriority.displayName = "IssueCreateModernisedModalWithPriority";
const $06bcfb2ddb186fdc$export$2eb2fdb04fff9db3 = ({ onResetApolloCache: onResetApolloCache, alwaysShowFullForm: alwaysShowFullForm, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $9c2wt.JiraIssueCreateErrorBoundary), {
        id: "async.jira.issue-create-modernised-modal",
        packageName: "jiraIssueCreateModernised",
        sendToPrivacyUnsafeSplunk: true,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $a8EUd.default), {
        name: "issue-create-modernised-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($06bcfb2ddb186fdc$var$IssueCreateModernisedModalWithPriority, {
        onResetApolloCache: onResetApolloCache,
        alwaysShowFullForm: alwaysShowFullForm
    })));
$06bcfb2ddb186fdc$export$2eb2fdb04fff9db3.displayName = "AsyncIssueCreateModal";

});
parcelRegister("9c2wt", function(module, exports) {
$parcel$export(module.exports, "JiraIssueCreateErrorBoundary", () => $572865789d1a9afe$export$fe891cbe61d9bf7b);
// eslint-disable-next-line jira/filename-case

var $3yzOx = parcelRequire("3yzOx");

var $4BBh0 = parcelRequire("4BBh0");
var $inMxE = parcelRequire("inMxE");

var $cRIqG = parcelRequire("cRIqG");
const $572865789d1a9afe$export$fe891cbe61d9bf7b = (props)=>{
    const { children: children, attributes: attributes, onError: onError, taskName: taskName, ...otherProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const getAttributes = (0, $3yzOx.useCallback)((error)=>{
        // TODO: add additional attributes in that we need for issue create.
        const attributesPassed = typeof attributes === 'function' ? attributes(error) : attributes;
        return {
            ...attributesPassed
        };
    }, [
        attributes
    ]);
    const handleOnError = (0, $3yzOx.useCallback)((location, error, errorAttributes)=>{
        if (taskName) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $4BBh0.fireOperationalAnalyticsDeferred)(analyticsEvent, 'ui taskFail', {
                task: taskName
            });
        }
        onError?.(location, error, errorAttributes);
    }, [
        createAnalyticsEvent,
        onError,
        taskName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $cRIqG.IssueCommonErrorBoundary), {
        ...otherProps,
        attributes: getAttributes,
        onError: handleOnError
    }, children);
};
$572865789d1a9afe$export$fe891cbe61d9bf7b.displayName = "JiraIssueCreateErrorBoundary";

});
parcelRegister("4BBh0", function(module, exports) {
$parcel$export(module.exports, "fireTrackAnalyticsDeferred", () => $5a3d746c864ddc29$export$b6c00a2e59d74c5e);
$parcel$export(module.exports, "fireOperationalAnalyticsDeferred", () => $5a3d746c864ddc29$export$6bb7ef8f82969e8f);
$parcel$export(module.exports, "fireScreenAnalyticsDeferred", () => $5a3d746c864ddc29$export$59b89d5a711a4fa);
$parcel$export(module.exports, "MountEvent", () => $5a3d746c864ddc29$export$2c6963927dbc68f1);
/* eslint-disable jira/filename-case */ // code-reaper-ignore-file -- Analytics implementations for the browser.

var $3yzOx = parcelRequire("3yzOx");

var $klSsw = parcelRequire("klSsw");

var $aJ81Y = parcelRequire("aJ81Y");

var $jdKJF = parcelRequire("jdKJF");

var $aJ81Y = parcelRequire("aJ81Y");

var $7RK6D = parcelRequire("7RK6D");

var $inMxE = parcelRequire("inMxE");


var $aZMdt = parcelRequire("aZMdt");

var $7YsQW = parcelRequire("7YsQW");

var $aqPkH = parcelRequire("aqPkH");
const $5a3d746c864ddc29$export$b6c00a2e59d74c5e = (event, ...rest)=>{
    if (false) return;
    return (0, $aJ81Y.fireTrackAnalyticsDeferred)(event, ...rest);
};
const $5a3d746c864ddc29$export$6bb7ef8f82969e8f = (event, ...rest)=>{
    if (false) return;
    return (0, $aJ81Y.fireOperationalAnalyticsDeferred)(event, ...rest);
};
const $5a3d746c864ddc29$export$59b89d5a711a4fa = (...args)=>{
    if (false) return;
    return (0, $aJ81Y.fireScreenAnalyticsDeferred)(...args);
};
const $5a3d746c864ddc29$export$2c6963927dbc68f1 = (props)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $klSsw.MountEvent), {
        onMount: props.onMount
    });
    // Note: This is a workaround to avoid type errors. The type of the props is not the same as the type of the BrowserMountEvent.
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $jdKJF.MountEvent), props);
};
$5a3d746c864ddc29$export$2c6963927dbc68f1.displayName = "MountEvent";
// Preserve the original displayName so snapshot tests that serialise the element tree continue to match.
$5a3d746c864ddc29$export$2c6963927dbc68f1.displayName = (0, $jdKJF.MountEvent).displayName;

});
parcelRegister("klSsw", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $ef629069b3a57875$export$5bf35293e545f20c);
$parcel$export(module.exports, "MountEvent", () => $ef629069b3a57875$export$2c6963927dbc68f1);
// eslint-disable-next-line jira/filename-case

var $3yzOx = parcelRequire("3yzOx");

var $aZMdt = parcelRequire("aZMdt");

const $ef629069b3a57875$var$AnalyticsContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).Fragment, null, props.children);
$ef629069b3a57875$var$AnalyticsContext.displayName = "AnalyticsContext";
const $ef629069b3a57875$export$198470770171c65 = /*#__PURE__*/ (0, $3yzOx.memo)((props)=>{
    const data = (0, $aZMdt.extractContextualData)(props);
    // @ts-expect-error - TS2741 - Property 'children' is missing in type 'Dictionary<string | string[] | { [containerName: string]: Container; } | { [key: string]: any; } | undefined>' but required in type 'AnalyticsContextData'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($ef629069b3a57875$var$AnalyticsContext, {
        data: data
    }, props.children);
});
const $ef629069b3a57875$export$64eb47d7b94ba089 = ()=>null;
const $ef629069b3a57875$export$5a67e7291fd4569e = (_props)=>null;
const $ef629069b3a57875$export$5f0d7aae8dfa8b86 = (_props)=>null;
const $ef629069b3a57875$export$b71c3ada5d4ec5da = (_props)=>null;
const $ef629069b3a57875$export$2ccf161b817b43b = (_props)=>null;
const $ef629069b3a57875$export$34ac71ce24cddec2 = (_event, _type, _payload = {})=>undefined;
const $ef629069b3a57875$export$79f423cc3fd39762 = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$6bb7ef8f82969e8f = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$6f46fb37ad7d962b = (_event, _attributes)=>undefined;
const $ef629069b3a57875$export$59b89d5a711a4fa = (_event, _attributes)=>undefined;
const $ef629069b3a57875$export$13990ad4625571ed = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$b6c00a2e59d74c5e = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$5d00cd31b1bf8e94 = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$ee2085e97a04e027 = (_event)=>({
        type: undefined,
        payload: {}
    });
class $ef629069b3a57875$var$UIAnalyticsEventServer {
    constructor(){
        this.payload = {};
        this.context = [];
        this.handlers = [];
        this.hasFired = false;
        // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
        this.clone = ()=>new $ef629069b3a57875$var$UIAnalyticsEventServer();
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        this.fire = (_channel)=>{};
        // @ts-expect-error TS2416: Property 'update' in type 'UIAnalyticsEventServer' is not assignable to the same property in base type 'UIAnalyticsEvent'. Type 'UIAnalyticsEventServer' is not assignable to type 'this'. 'UIAnalyticsEventServer' is assignable to the constraint of type 'this', but 'this' could be instantiated with a different subtype of constraint 'UIAnalyticsEventServer'.
        this.update = ()=>new $ef629069b3a57875$var$UIAnalyticsEventServer();
    }
}
$ef629069b3a57875$var$UIAnalyticsEventServer.displayName = "UIAnalyticsEventServer";
const $ef629069b3a57875$var$createAnalyticsEvent = (_payload)=>// @ts-expect-error - Type 'UIAnalyticsEventServer' is not assignable to type 'UIAnalyticsEvent'.
    new $ef629069b3a57875$var$UIAnalyticsEventServer();
const $ef629069b3a57875$export$5bf35293e545f20c = ()=>(0, $3yzOx.useMemo)(()=>({
            createAnalyticsEvent: $ef629069b3a57875$var$createAnalyticsEvent
        }), []);
const $ef629069b3a57875$var$withAnalyticsEvents = ()=>(WrappedComponent)=>{
        // @ts-expect-error: Argument of type '(props: Config, ref: ForwardedRef<unknown>) => Element' is not assignable to parameter of type 'ForwardRefRenderFunction<unknown, PropsWithoutRef<Config>>'.
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $3yzOx.forwardRef)((props, ref)=>// @ts-expect-error Spread types may only be created from object types.ts(2698)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(WrappedComponent, {
                ...props,
                ref: ref,
                createAnalyticsEvent: $ef629069b3a57875$var$createAnalyticsEvent
            }));
        WithAnalyticsEvents.displayName = 'WithAnalyticsEvents('.concat(WrappedComponent.displayName != null ? WrappedComponent.displayName : WrappedComponent.name || '', ')');
        // @ts-expect-error: Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'AbstractComponent<Config, any>'.
        return WithAnalyticsEvents;
    };
const $ef629069b3a57875$export$3e9ef96ba97ea9dc = (_componentName, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
_eventActions)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>$ef629069b3a57875$var$withAnalyticsEvents()(component);
const $ef629069b3a57875$var$MountEventComponent = ({ onMount: onMount })=>{
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    (0, $3yzOx.useLayoutEffect)(()=>onMount(new $ef629069b3a57875$var$UIAnalyticsEventServer()), [
        onMount
    ]);
    return null;
};
$ef629069b3a57875$var$MountEventComponent.displayName = "MountEventComponent";
const $ef629069b3a57875$export$2c6963927dbc68f1 = $ef629069b3a57875$var$withAnalyticsEvents()($ef629069b3a57875$var$MountEventComponent);

});

parcelRegister("jdKJF", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $fab3069e3f594b66$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $3yzOx = parcelRequire("3yzOx");

var $kTviw = parcelRequire("kTviw");
// oxlint-disable-next-line react/prefer-function-component
class $fab3069e3f594b66$var$MountEventComponent extends (0, $3yzOx.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
$fab3069e3f594b66$var$MountEventComponent.displayName = "MountEventComponent";
const $fab3069e3f594b66$export$2c6963927dbc68f1 = (0, $kTviw.default)()($fab3069e3f594b66$var$MountEventComponent);

});

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("7YsQW", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventToProps", () => $2b18d9474fbe6700$export$3e9ef96ba97ea9dc);

var $kTviw = parcelRequire("kTviw");
const $2b18d9474fbe6700$export$871de8747c9eaa88 = (props, componentName)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // oxlint-disable-next-line oxc/no-accumulating-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $2b18d9474fbe6700$export$3e9ef96ba97ea9dc = (componentName, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
eventActions)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $kTviw.default)($2b18d9474fbe6700$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});


parcelRegister("cRIqG", function(module, exports) {
$parcel$export(module.exports, "IssueCommonErrorBoundary", () => $070396f2cc4605c2$export$eda988af1aea453d);

var $58tmX = parcelRequire("58tmX");

var $3yzOx = parcelRequire("3yzOx");

var $i860n = parcelRequire("i860n");

var $3GN2r = parcelRequire("3GN2r");

var $eefAt = parcelRequire("eefAt");

var $8AO0r = parcelRequire("8AO0r");

var $hFtK7 = parcelRequire("hFtK7");

var $h8QGu = parcelRequire("h8QGu");

var $4CFYO = parcelRequire("4CFYO");
const $070396f2cc4605c2$export$eda988af1aea453d = (t0)=>{
    const $ = (0, $58tmX.c)(21);
    let attributes;
    let children;
    let fallback;
    let fireErrorEventWhenNetworkError;
    let getErrorAttributes;
    let otherProps;
    if ($[0] !== t0) {
        ({ children: children, fallback: fallback, fireErrorEventWhenNetworkError: fireErrorEventWhenNetworkError, getErrorAttributes: getErrorAttributes, attributes: attributes, ...otherProps } = t0);
        $[0] = t0;
        $[1] = attributes;
        $[2] = children;
        $[3] = fallback;
        $[4] = fireErrorEventWhenNetworkError;
        $[5] = getErrorAttributes;
        $[6] = otherProps;
    } else {
        attributes = $[1];
        children = $[2];
        fallback = $[3];
        fireErrorEventWhenNetworkError = $[4];
        getErrorAttributes = $[5];
        otherProps = $[6];
    }
    const accountIdLoggedInUser = (0, $3GN2r.useAccountId)();
    let t1;
    if ($[7] !== accountIdLoggedInUser || $[8] !== attributes) {
        t1 = (error)=>{
            const attributesPassed = typeof attributes === "function" ? attributes(error) : attributes;
            const tenantAttributes = (0, $4CFYO.getTenantAttributes)();
            const { errorAttributes: errorAttributes } = (0, $eefAt.getIssueErrorAttributes)(error, accountIdLoggedInUser);
            return {
                ...attributesPassed,
                ...tenantAttributes,
                ...errorAttributes
            };
        };
        $[7] = accountIdLoggedInUser;
        $[8] = attributes;
        $[9] = t1;
    } else t1 = $[9];
    const getAttributes = t1;
    const isFallbackString = typeof fallback === "string";
    let t2;
    if ($[10] !== accountIdLoggedInUser || $[11] !== attributes || $[12] !== fallback || $[13] !== getErrorAttributes || $[14] !== isFallbackString) {
        t2 = (errorProps)=>{
            const { errorAttributes: errorAttributes_0 } = (0, $eefAt.getIssueErrorAttributes)(errorProps.error, accountIdLoggedInUser);
            if (errorAttributes_0.statusCode && errorAttributes_0.statusCode >= 400 && errorAttributes_0.statusCode < 500) {
                (0, $hFtK7.fireErrorAnalytics)({
                    error: errorProps.error,
                    meta: {
                        id: "issue.issue-view.viewIssue",
                        teamName: "Bento"
                    },
                    attributes: {
                        ...attributes,
                        ...getErrorAttributes?.(errorProps.error),
                        statusCode: errorAttributes_0.statusCode,
                        traceId: errorAttributes_0.traceId || undefined,
                        ...(0, $i860n.fg)("bento-1705-add-stack-trace") && {
                            errorStack: errorAttributes_0.errorStack || (0, $8AO0r.truncateStackTrace)(errorProps.error.stack) || undefined
                        }
                    }
                });
                return !isFallbackString && fallback?.(errorProps);
            }
        };
        $[10] = accountIdLoggedInUser;
        $[11] = attributes;
        $[12] = fallback;
        $[13] = getErrorAttributes;
        $[14] = isFallbackString;
        $[15] = t2;
    } else t2 = $[15];
    const fallbackMethod = t2;
    const fallbackAbstracted = fireErrorEventWhenNetworkError && !isFallbackString ? fallbackMethod : fallback;
    let t3;
    if ($[16] !== children || $[17] !== fallbackAbstracted || $[18] !== getAttributes || $[19] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $h8QGu.JSErrorBoundary), {
            ...otherProps,
            attributes: getAttributes,
            fallback: fallbackAbstracted
        }, children);
        $[16] = children;
        $[17] = fallbackAbstracted;
        $[18] = getAttributes;
        $[19] = otherProps;
        $[20] = t3;
    } else t3 = $[20];
    return t3;
};
$070396f2cc4605c2$export$eda988af1aea453d.displayName = "IssueCommonErrorBoundary";

});
parcelRegister("eefAt", function(module, exports) {
$parcel$export(module.exports, "statusCodesNotImpactingReliability", () => $ba0b0d00c5d6ba8b$export$501df64f0fda1d63);
$parcel$export(module.exports, "getIssueErrorAttributes", () => $ba0b0d00c5d6ba8b$export$23bbdbaa14274cfd);
$parcel$export(module.exports, "loginViaRedirectUrl", () => $ba0b0d00c5d6ba8b$export$796a2c2756dc1f12);
$parcel$export(module.exports, "getIssueLimitErrorField", () => $ba0b0d00c5d6ba8b$export$aba25149bb9fdf05);

var $i860n = parcelRequire("i860n");

var $75sVW = parcelRequire("75sVW");

var $lCetP = parcelRequire("lCetP");

var $djrlm = parcelRequire("djrlm");


var $kH0tF = parcelRequire("kH0tF");

var $8AO0r = parcelRequire("8AO0r");
const $ba0b0d00c5d6ba8b$var$COMMENTS_PER_ISSUE_LIMIT_EXCEEDED = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $ba0b0d00c5d6ba8b$var$ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $ba0b0d00c5d6ba8b$var$ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $ba0b0d00c5d6ba8b$var$WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $ba0b0d00c5d6ba8b$var$ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $ba0b0d00c5d6ba8b$var$COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $ba0b0d00c5d6ba8b$var$REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $ba0b0d00c5d6ba8b$var$WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $ba0b0d00c5d6ba8b$var$ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST = [
    $ba0b0d00c5d6ba8b$var$ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE,
    $ba0b0d00c5d6ba8b$var$COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE,
    $ba0b0d00c5d6ba8b$var$WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE,
    $ba0b0d00c5d6ba8b$var$REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE
];
const $ba0b0d00c5d6ba8b$var$isIssueNetworkError = (error)=>(0, $lCetP.isClientFetchError)(error) || (0, $lCetP.isHttpClientErrorResponse)(error) || error instanceof (0, $75sVW.default) || error instanceof (0, $kH0tF.IssueViewFetchError);
const $ba0b0d00c5d6ba8b$export$d3ca0619504206aa = new Set([
    (0, $djrlm.AUTHENTICATION_ERROR),
    (0, $djrlm.CONNECTIVITY_ERROR),
    (0, $djrlm.NOT_FOUND_OR_NO_PERMISSION_ERROR),
    (0, $djrlm.UNKNOWN_ERROR)
]);
const $ba0b0d00c5d6ba8b$export$501df64f0fda1d63 = [
    (0, $8f860a533cc71fca$export$9de493bcd9b1d977),
    (0, $8f860a533cc71fca$export$4a3cb39801694eee),
    (0, $8f860a533cc71fca$export$fa405bbf47d510e2),
    (0, $8f860a533cc71fca$export$3b48aba8957000cd),
    (0, $8f860a533cc71fca$export$6763168a631449a2)
];
const $ba0b0d00c5d6ba8b$var$isPreCalculatedErrorType = (error)=>// oxlint-disable-next-line typescript/consistent-type-assertions
    $ba0b0d00c5d6ba8b$export$d3ca0619504206aa.has(error.message);
const $ba0b0d00c5d6ba8b$export$23bbdbaa14274cfd = (error, accountIdLoggedInUser)=>{
    // TODO Cleanup with JIV-14818
    if ($ba0b0d00c5d6ba8b$var$isPreCalculatedErrorType(error)) return {
        errorType: error.message,
        errorAttributes: error.errorAttributes
    };
    const errorType = (0, $djrlm.UNKNOWN_ERROR);
    const errorStack = (0, $i860n.fg)('bento-1705-add-stack-trace') ? (0, $8AO0r.truncateStackTrace)(error.stack) : undefined;
    const errorAttributes = {
        errorMessage: error.message,
        ...(0, $i860n.fg)('bento-1705-add-stack-trace') && {
            errorStack: errorStack
        }
    };
    if ($ba0b0d00c5d6ba8b$var$isIssueNetworkError(error)) {
        const { statusCode: statusCode, traceId: traceId } = error;
        Object.assign(errorAttributes, {
            statusCode: statusCode,
            traceId: traceId
        });
        if (!accountIdLoggedInUser || statusCode === (0, $8f860a533cc71fca$export$67d19e9a991baa07)) return {
            errorType: (0, $djrlm.AUTHENTICATION_ERROR),
            errorAttributes: errorAttributes
        };
        if (statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef) || statusCode === (0, $8f860a533cc71fca$export$a3269a3914b007e3)) return {
            errorType: (0, $djrlm.NOT_FOUND_OR_NO_PERMISSION_ERROR),
            errorAttributes: errorAttributes
        };
        // Relay Error - could be mainIssueAggQuery
        if (error instanceof (0, $kH0tF.IssueViewFetchError) && error?.getIsRelayError()) {
            if ((0, $lCetP.isClientFetchError)(error) || statusCode && $ba0b0d00c5d6ba8b$export$501df64f0fda1d63.includes(statusCode)) return {
                errorType: (0, $djrlm.CONNECTIVITY_ERROR),
                errorAttributes: errorAttributes
            };
            Object.assign(errorAttributes, {
                userExperience: error.userExperience || 'unknownExperience'
            });
            Object.assign(errorAttributes, {
                errorMessage: `${error.message}, endpoint: ${error.endpoint || 'unknown'}`,
                endpoint: error.endpoint || 'unknown'
            });
            Object.assign(errorAttributes, {
                additionalErrors: error.additionalErrors
            });
            // If the statusCode is undefine for Relay Error we want to set it as UNKNOWN_ERROR to (taskFail)
            return {
                errorType: (0, $djrlm.UNKNOWN_ERROR),
                errorAttributes: errorAttributes
            };
        }
        // Return CONNECTIVITY_ERROR if the statusCode is undefined for un-relay error
        if (!statusCode || $ba0b0d00c5d6ba8b$export$501df64f0fda1d63.includes(statusCode)) return {
            errorType: (0, $djrlm.CONNECTIVITY_ERROR),
            errorAttributes: errorAttributes
        };
    }
    return {
        errorType: errorType,
        errorAttributes: errorAttributes
    };
};
const $ba0b0d00c5d6ba8b$export$796a2c2756dc1f12 = async (loginRedirectUrl)=>{
    if (!loginRedirectUrl) return;
    const encodedRedirectUrl = encodeURIComponent(loginRedirectUrl);
    const logInUrl = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(logInUrl, '_blank');
};
const $ba0b0d00c5d6ba8b$export$aba25149bb9fdf05 = (error)=>{
    const errorMessagesList = error?.message?.split('; ');
    if (errorMessagesList?.length === 0) return undefined;
    const fieldLimitErrorList = $ba0b0d00c5d6ba8b$var$ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST.filter((fieldLimitErrorMessage)=>errorMessagesList.some((message)=>message.includes(fieldLimitErrorMessage)));
    // we prioritise comments/worklogs, if there are limits for both comments/worklogs and attachments.
    if (fieldLimitErrorList.includes($ba0b0d00c5d6ba8b$var$COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE)) return $ba0b0d00c5d6ba8b$var$COMMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes($ba0b0d00c5d6ba8b$var$WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE)) return $ba0b0d00c5d6ba8b$var$WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes($ba0b0d00c5d6ba8b$var$ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE)) return $ba0b0d00c5d6ba8b$var$ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes($ba0b0d00c5d6ba8b$var$REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE)) return $ba0b0d00c5d6ba8b$var$ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED;
    return undefined;
};

});
parcelRegister("djrlm", function(module, exports) {
$parcel$export(module.exports, "AUTHENTICATION_ERROR", () => $a91f95fb3a7acfab$export$99405616af30f11f);
$parcel$export(module.exports, "CONNECTIVITY_ERROR", () => $a91f95fb3a7acfab$export$683dbe11f74cd161);
$parcel$export(module.exports, "NOT_FOUND_OR_NO_PERMISSION_ERROR", () => $a91f95fb3a7acfab$export$4e094d34a5cb1872);
$parcel$export(module.exports, "UNKNOWN_ERROR", () => $a91f95fb3a7acfab$export$f10b32dfda12e96e);
/* eslint-disable jira/filename-case */ const $a91f95fb3a7acfab$export$99405616af30f11f = 'AUTHENTICATION_ERROR';
const $a91f95fb3a7acfab$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
const $a91f95fb3a7acfab$export$4e094d34a5cb1872 = 'NOT_FOUND_OR_NO_PERMISSION_ERROR';
const $a91f95fb3a7acfab$export$f10b32dfda12e96e = 'UNKNOWN_ERROR';

});

/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

parcelRegister("kH0tF", function(module, exports) {
$parcel$export(module.exports, "IssueViewFetchError", () => $5be2b25bf96224a1$export$4802e881d6c7820d);

var $75sVW = parcelRequire("75sVW");

var $2KgJI = parcelRequire("2KgJI");
class $5be2b25bf96224a1$export$4802e881d6c7820d extends (0, $2KgJI.default) {
    constructor(error, endpoint, traceId, isRelayError, userExperience, additionalErrors){
        super(error.message), this.error = error, this.endpoint = endpoint, this.traceId = traceId, this.isRelayError = isRelayError, this.userExperience = userExperience, this.additionalErrors = additionalErrors;
        this.endpoint = endpoint;
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $75sVW.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        if (error instanceof $5be2b25bf96224a1$export$4802e881d6c7820d) {
            this.error = error.error;
            this.statusCode = error.statusCode;
            this.traceId = error.traceId;
        }
        // set traceId from AGG, only if not set already
        if (!this.traceId && traceId && traceId !== '') this.traceId = traceId;
    }
    getIsRelayError() {
        return this.isRelayError === true;
    }
}
$5be2b25bf96224a1$export$4802e881d6c7820d.displayName = "IssueViewFetchError";

});

parcelRegister("8AO0r", function(module, exports) {
$parcel$export(module.exports, "truncateStackTrace", () => $119eda47cf0fabc5$export$320e9bc1c3d6f023);
const $119eda47cf0fabc5$var$MAX_STACK_TRACE_LENGTH = 1000;
const $119eda47cf0fabc5$export$320e9bc1c3d6f023 = (stack)=>{
    if (!stack) return undefined;
    if (stack.length <= $119eda47cf0fabc5$var$MAX_STACK_TRACE_LENGTH) return stack;
    return `${stack.substring(0, $119eda47cf0fabc5$var$MAX_STACK_TRACE_LENGTH)}\u{2026}`;
};

});




parcelRegister("anXdQ", function(module, exports) {
$parcel$export(module.exports, "preloadableAsyncRichTextEditEntryPoint", () => $76b0ac6e60623dd0$export$48e6e3bc974a51b6);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $76b0ac6e60623dd0$var$asyncRichTextEditRoot = (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cq49U")), {
    moduleId: "44d4add7",
    moduleName: "EntryPointContent",
    priority: "interaction"
});
const $76b0ac6e60623dd0$var$baseEntryPoint = (0, $fiVog.createEntryPoint)({
    root: $76b0ac6e60623dd0$var$asyncRichTextEditRoot,
    getPreloadProps: ()=>({})
});
const $76b0ac6e60623dd0$export$48e6e3bc974a51b6 = Object.assign($76b0ac6e60623dd0$var$baseEntryPoint, {
    preload: ()=>$76b0ac6e60623dd0$var$asyncRichTextEditRoot.preload()
});

});
parcelRegister("cq49U", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("iZe2c"),
    $dk4lR("faPKS"),
    $dk4lR("1aRRK"),
    $dk4lR("ay8Nt"),
    $dk4lR("hc93Z"),
    $dk4lR("4Smn9"),
    $dk4lR("hQm1v")
]).then(()=>parcelRequire('1P35g'));

});


parcelRegister("7JeLK", function(module, exports) {
$parcel$export(module.exports, "BackgroundPriority", () => $419b8588f5ef9617$export$ae957da140356154);
$parcel$export(module.exports, "renderInBackgroundPriority", () => $419b8588f5ef9617$export$92ab163f92594a98);

var $3yzOx = parcelRequire("3yzOx");

var $5dfRu = parcelRequire("5dfRu");
const $419b8588f5ef9617$export$ae957da140356154 = ({ children: children, forceRender: forceRender })=>{
    const tier = (0, $5dfRu.useCurrentPriority)();
    if (!forceRender && tier < (0, $5dfRu.loadingPriority).background) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).Fragment, null, children);
};
$419b8588f5ef9617$export$ae957da140356154.displayName = "BackgroundPriority";
const $419b8588f5ef9617$export$92ab163f92594a98 = (Component, bypassCondition)=>{
    const wrappedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($419b8588f5ef9617$export$ae957da140356154, {
            forceRender: bypassCondition ? bypassCondition() : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(Component, null));
    wrappedComponent.displayName = `BackgroundPriority(${Component.displayName || Component.name})`;
    return wrappedComponent;
};

});
parcelRegister("5dfRu", function(module, exports) {
$parcel$export(module.exports, "useCurrentPriority", () => $76dcb30860d81647$export$ea2f0151c2177b4c);
$parcel$export(module.exports, "loadingPriority", () => $76dcb30860d81647$export$9d1e6d89fa244199);
$parcel$export(module.exports, "PriorityManager", () => $76dcb30860d81647$export$7099b16a7996ef6c);

var $3yzOx = parcelRequire("3yzOx");

var $7fzie = parcelRequire("7fzie");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $62Xqf = parcelRequire("62Xqf");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $76dcb30860d81647$var$store = (0, $5QDqc.createStore)({
    name: 'priority-manager',
    initialState: {
        tier: 1
    },
    actions: {
        setTier: (tier)=>({ setState: setState, getState: getState })=>setState({
                    tier: Math.max(getState().tier, tier)
                })
    }
});
const $76dcb30860d81647$export$5761757a15d758a = (0, $3h1FP.createActionsHook)($76dcb30860d81647$var$store);
const $76dcb30860d81647$export$ea2f0151c2177b4c = (0, $3h1FP.createStateHook)($76dcb30860d81647$var$store, {
    selector: (state)=>state.tier
});
const $76dcb30860d81647$export$9d1e6d89fa244199 = {
    // tier 0 - "early scripts" is outside of this component reach and responsibility
    /**
	 * Tier 1 - initial loading phase, everything is critical
	 */ critical: 1,
    /**
	 * Tier 2 - app is ready, but some work is still in progress
	 * This is the phase where we can start loading non-critical resources
	 */ nonCritical: 2,
    /**
	 * Tier 3 - background phase, all work is done, we can load background resources
	 * This is the phase where we can start loading background resources
	 */ background: 3
};
function $76dcb30860d81647$export$7099b16a7996ef6c() {
    const isReady = (0, $62Xqf.useSpaStatePageReady)();
    const { setTier: setTier } = $76dcb30860d81647$export$5761757a15d758a();
    const interactionContext = (0, $7fzie.useInteractionContext)();
    const { addCustomData: addCustomData } = interactionContext ?? {};
    (0, $3yzOx.useEffect)(()=>{
        if (isReady) {
            performance.mark('priority:non-critical-phase');
            setTier($76dcb30860d81647$export$9d1e6d89fa244199.nonCritical);
            const tm = setTimeout(()=>{
                if ((0, $i860n.fg)('hot_301836_bg_task_timeout_info')) addCustomData?.({
                    bgTaskTimeout: performance.now()
                });
                setTier($76dcb30860d81647$export$9d1e6d89fa244199.background);
            }, (0, $2700E.expVal)('hot_301836_dynamic_bg_task_timeout', 'value', 5000));
            return ()=>{
                clearTimeout(tm);
            };
        }
    }, [
        isReady,
        setTier,
        addCustomData
    ]);
    (0, $3yzOx.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                performance.mark('priority:background-phase');
                setTier($76dcb30860d81647$export$9d1e6d89fa244199.background);
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, [
        setTier
    ]);
    return null;
}
$76dcb30860d81647$export$7099b16a7996ef6c.displayName = "PriorityManager";

});


parcelRegister("1qfXv", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fuvqe").then(()=>parcelRequire('3lgEv'));

});

parcelRegister("jBrIx", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("axhj4").then(()=>parcelRequire('gKkZg'));

});

parcelRegister("gW9EX", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("faPKS"),
    $dk4lR("1aRRK"),
    $dk4lR("iZe2c"),
    $dk4lR("5geQX"),
    $dk4lR("ay8Nt"),
    $dk4lR("hc93Z"),
    $dk4lR("4Smn9"),
    $dk4lR("dfOyD")
]).then(()=>parcelRequire('axaB5'));

});


parcelRegister("5fpxV", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateModernisedModalEntryPoint", () => $4955053f10f1e64e$export$4803b75cf956038a);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4955053f10f1e64e$export$4803b75cf956038a = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("gTfHZ")), {
        moduleId: "a2568b8e",
        moduleName: "IssueCreateModalEntryPoint",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gTfHZ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("faPKS"),
    $dk4lR("1aRRK"),
    $dk4lR("iZe2c"),
    $dk4lR("5geQX"),
    $dk4lR("ay8Nt"),
    $dk4lR("hc93Z"),
    $dk4lR("4Smn9"),
    $dk4lR("eGoBr")
]).then(()=>parcelRequire('jSewF'));

});


parcelRegister("9Oo0T", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $dcd926d39f5bb8db$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "noopActions", () => $dcd926d39f5bb8db$export$6b9306855551af21);
$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $dcd926d39f5bb8db$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $dcd926d39f5bb8db$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $dcd926d39f5bb8db$export$558a195c5bfe3787);
// eslint-disable-next-line jira/filename-case

var $3yzOx = parcelRequire("3yzOx");

var $B4kk2 = parcelRequire("B4kk2");

var $21Wjy = parcelRequire("21Wjy");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $4BBh0 = parcelRequire("4BBh0");
var $inMxE = parcelRequire("inMxE");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $jaJSD = parcelRequire("jaJSD");

var $7IK6V = parcelRequire("7IK6V");

var $14CWj = parcelRequire("14CWj");

var $cIX5T = parcelRequire("cIX5T");

var $1OTgk = parcelRequire("1OTgk");

var $jwOsd = parcelRequire("jwOsd");

var $kTMHb = parcelRequire("kTMHb");

var $k2847 = parcelRequire("k2847");
const $dcd926d39f5bb8db$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $7IK6V.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1OTgk.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null,
    // reference to the element to focus when the modal is closed
    returnFocusRef: undefined,
    // when true, indicates the user was redirected from the modern modal to the old modal (e.g., for unsupported project types)
    isRedirectedFromModernModal: false,
    // when true, a transition between old and new modal is in progress
    isTransitioningBetweenOldAndNewModal: false,
    shouldUseLegacyCreateExperience: false,
    // controls whether GIC creates an issue on submit or fires onSaveEditsWithoutIssueCreation.
    submitBehaviour: (0, $kTMHb.ISSUE_CREATE_SUBMIT_BEHAVIOUR).CREATE_ISSUE,
    // called with the full form field payload when submitBehaviour is 'saveEditsWithoutIssueCreation' and the user clicks the submit button. No issue is created in this case.
    onSaveEditsWithoutIssueCreation: undefined
};
const $dcd926d39f5bb8db$export$e324594224ef24da = {
    setShouldUseLegacyCreateExperience: (shouldUseLegacyCreateExperience)=>({ setState: setState })=>{
            setState({
                shouldUseLegacyCreateExperience: shouldUseLegacyCreateExperience
            });
        },
    restoreState: (stateToRestore, isTransitioningBetweenExistingAndNewModal)=>({ setState: setState, getState: getState })=>{
            // During modal transitions (switchToModernModal / triggerFallbackToOldModal),
            // skip restore entirely to prevent stale draft data from overwriting the transition state.
            if (isTransitioningBetweenExistingAndNewModal && (0, $i860n.fg)('create_work_item_modernization')) return;
            // If the user just discarded the existing GIC (wasModalRetriggered was reset to false),
            // skip restoring stale IndexedDB state that still has wasModalRetriggered: true.
            // This prevents the discard modal and docked view from reopening after discard.
            const currentState = getState();
            if (!currentState.wasModalRetriggered && stateToRestore.wasModalRetriggered && (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false)) return;
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) {
                const isModernisedTrigger = Boolean(stateToRestore.triggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(stateToRestore.triggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(isSubsequentLoad, isModernisedTrigger);
            }
            // Don't let stale persisted state close a modal that was just opened.
            // The openIssueCreateModal action sets isModalOpen inside a setTimeout(0),
            // and restoreState from IndexedDB can race and overwrite it.
            if (isModalOpen && !stateToRestore.isModalOpen) return;
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                const isModernisedTrigger = Boolean(nextState?.triggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(nextState.triggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad, isModernisedTrigger);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts && !(0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false);
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $k2847.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $k2847.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $dcd926d39f5bb8db$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                /*
				 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
				 * so that we can store the reference of this
				 * and use that to re-focus the button whenever the modal is closed
				 */ let triggerButton;
                const handleButtonClick = (event)=>{
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    const triggerButtonTarget = event.target;
                    triggerButton = triggerButtonTarget?.closest('button');
                    triggerButton?.focus();
                };
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.addEventListener('click', handleButtonClick);
                setTimeout(()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.removeEventListener('click', handleButtonClick);
                }, 0);
                setTimeout(()=>{
                    setState({
                        ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                        ...(0, $i860n.fg)('jac_fix_gic_flicker') && {
                            shouldUseLegacyCreateExperience: currentState.shouldUseLegacyCreateExperience
                        },
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, $k2847.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, $21Wjy.default)(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey,
                        ...nextState,
                        /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        triggerButtonRef: triggerButton || document.activeElement
                    });
                }, 0);
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $k2847.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                ...(0, $i860n.fg)('jac_fix_gic_flicker') && {
                    shouldUseLegacyCreateExperience: currentState.shouldUseLegacyCreateExperience
                },
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $jaJSD.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    triggerFallbackToOldModal: (project, options)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            // The rest of the payload (parentId, issueType, defaultValues) only describes the project
            // the modal was triggered with. Keep it when we hand back to the old modal for that same
            // project — otherwise context-carrying trigger points such as create subtask lose their
            // parent and issue type and degrade into a blank create form. When the fallback is caused
            // by the user picking a different project, the payload no longer applies and is dropped.
            const isFallbackForTriggeringProject = currentState.payload?.project?.projectId !== undefined && currentState.payload.project.projectId === project.value;
            const shouldRetainLinkedIssueContextOnly = currentState.isCreateLinkedIssue && (0, $i860n.fg)('fix_linked_issue_on_project_switch_gic');
            const payloadForLinkedIssueContextOnly = {
                project: {
                    projectId: project.value,
                    projectType: project.projectType
                },
                ...currentState.payload?.defaultValues?.issueLinks !== undefined && {
                    defaultValues: {
                        issueLinks: currentState.payload.defaultValues.issueLinks
                    }
                },
                ...currentState.payload?.additionalContext?.linkedIssue && {
                    additionalContext: {
                        linkedIssue: currentState.payload.additionalContext.linkedIssue
                    }
                }
            };
            let payload = {
                project: {
                    projectId: project.value,
                    projectType: project.projectType
                }
            };
            if (options?.forceLegacyCreateExperience || isFallbackForTriggeringProject) payload = {
                ...currentState.payload,
                project: {
                    projectId: project.value,
                    projectType: project.projectType
                }
            };
            else if (shouldRetainLinkedIssueContextOnly) payload = payloadForLinkedIssueContextOnly;
            setState({
                ...currentState,
                isTransitioningBetweenOldAndNewModal: true,
                ...options?.forceLegacyCreateExperience && {
                    shouldUseLegacyCreateExperience: true
                },
                payload: payload
            });
        },
    /**
	 * Switches from the old modal to the modern modal by closing and reopening.
	 * Uses a single setState to avoid intermediate renders where payload is cleared.
	 * Publishes MODAL_CLOSED to clean up the old in-progress issue from IndexedDB
	 * so stale draft data isn't restored after the transition.
	 */ switchToModernModal: (project)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            // Clean up the old in-progress issue from IndexedDB before switching
            const { publish: publish } = (0, $cIX5T.getGICLifeCycleEvents)();
            publish((0, $14CWj.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
                inProgressIssueID: currentState.inProgressIssueID ?? '',
                createdIssues: []
            });
            (0, $k2847.startGlobalIssueCreateMetrics)(true, true);
            // Reset to initial state but immediately set the new modal state in a single setState
            // to avoid intermediate renders where payload is cleared
            setState({
                ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                ...(0, $i860n.fg)('jac_fix_gic_flicker') && {
                    shouldUseLegacyCreateExperience: currentState.shouldUseLegacyCreateExperience
                },
                isModalOpen: true,
                isSubsequentLoad: true,
                isTransitioningBetweenOldAndNewModal: true,
                shouldInitFetchConfig: true,
                triggerPointKey: currentState.triggerPointKey,
                payload: {
                    project: {
                        projectId: project.value,
                        projectType: project.projectType,
                        isSimplified: project.isSimplified
                    }
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                const nextTriggerPointKey = currentState.openIssueCreateModalNextState?.triggerPointKey ?? currentState.triggerPointKey;
                const isModernisedTrigger = Boolean(nextTriggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(nextTriggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad, isModernisedTrigger);
                setState({
                    ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                    ...(0, $i860n.fg)('jac_fix_gic_flicker') && {
                        shouldUseLegacyCreateExperience: currentState.shouldUseLegacyCreateExperience
                    },
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $dcd926d39f5bb8db$export$6b9306855551af21 = {
    setShouldUseLegacyCreateExperience: (_shouldUseLegacyCreateExperience)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    restoreState: (_stateToRestore, _isTransitioningBetweenExistingAndNewModal)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    openIssueCreateModal: (_nextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    closeIssueCreateModal: (_hasIssueCreated)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    triggerFallbackToOldModal: (_project, _options)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    switchToModernModal: (_project)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    clearSectionMessage: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    setDisplayOnlyRequiredFields: (_nextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    setMinimizableModalView: (_minimizableModalView)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    resetWasModalRetriggered: (_applyNextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    resetShouldInitFetchConfig: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    setCallbackPayload: (_callbackPayload)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    setShouldPushMiniModalDiscoverability: (_shouldPushMiniModalDiscoverability)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    dismissModalSpotlight: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    setPersistentModalView: (_persistentModalView)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    removeAlertFromAlertsToBeLinked: (_alertId)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))(),
    setSessionId: (_sessionId)=>(0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))()
};
const $dcd926d39f5bb8db$var$store = (0, $5QDqc.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
    actions: $dcd926d39f5bb8db$export$e324594224ef24da
});
const $dcd926d39f5bb8db$var$useTriggerIssueCreateModalState = (0, $3h1FP.createStateHook)($dcd926d39f5bb8db$var$store);
const $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions = (0, $3h1FP.createActionsHook)($dcd926d39f5bb8db$var$store);
const $dcd926d39f5bb8db$export$71e0eb7b8a91a156 = ()=>{
    const createState = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalState();
    const createActions = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $3yzOx.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {},
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $4BBh0.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $dcd926d39f5bb8db$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $jwOsd.useSitePickerContext)();
    return (0, $3yzOx.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {},
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {}
        };
        (0, $4BBh0.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $dcd926d39f5bb8db$export$4c674fe824b8f278 = (0, $iGu4q.createSubscriber)($dcd926d39f5bb8db$var$store);
function $dcd926d39f5bb8db$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $dcd926d39f5bb8db$export$71e0eb7b8a91a156();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: true,
            ...props
        });
    };
}

});
parcelRegister("jaJSD", function(module, exports) {
$parcel$export(module.exports, "CreateIssueUFOExperience", () => $b158ee0e69f56076$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $b158ee0e69f56076$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $b158ee0e69f56076$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $b158ee0e69f56076$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $b158ee0e69f56076$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $b158ee0e69f56076$export$b2d8f8edec75f571);
/* eslint-disable jira/filename-case */ 
var $jkqqC = parcelRequire("jkqqC");

var $ipvkO = parcelRequire("ipvkO");
const $b158ee0e69f56076$export$cd75c112ac11a83b = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $b158ee0e69f56076$export$7d25d25bed94d6e2 = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $b158ee0e69f56076$export$fda88e8e14acb615 = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $b158ee0e69f56076$export$e890e797a25e655c = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
});
const $b158ee0e69f56076$export$70208657c8d471a7 = new (0, $jkqqC.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $b158ee0e69f56076$export$b2d8f8edec75f571 = new (0, $jkqqC.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("cIX5T", function(module, exports) {
$parcel$export(module.exports, "getGICLifeCycleEvents", () => $8858188c1840e961$export$28a4bbe8d482a171);
$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8858188c1840e961$export$e3ff72f196296fcc);
/* eslint-disable jira/filename-case */ 
var $1kmhL = parcelRequire("1kmhL");
const $8858188c1840e961$var$GICLifeCycleEventsService = new (0, $1kmhL.PubSubHub)();
const $8858188c1840e961$export$28a4bbe8d482a171 = ()=>({
        ...$8858188c1840e961$var$GICLifeCycleEventsService
    });
const $8858188c1840e961$export$e3ff72f196296fcc = ()=>({
        ...$8858188c1840e961$var$GICLifeCycleEventsService
    });

});
parcelRegister("1kmhL", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $6c1c7aebb5a6ab60$export$e3607828f8f2c01e);
class $6c1c7aebb5a6ab60$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}
$6c1c7aebb5a6ab60$export$e3607828f8f2c01e.displayName = "PubSubHub";

});


parcelRegister("1OTgk", function(module, exports) {
$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $cd15ee075658be2b$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $cd15ee075658be2b$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $cd15ee075658be2b$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $cd15ee075658be2b$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $cd15ee075658be2b$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $cd15ee075658be2b$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $cd15ee075658be2b$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $cd15ee075658be2b$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $cd15ee075658be2b$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $cd15ee075658be2b$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $cd15ee075658be2b$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $cd15ee075658be2b$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $cd15ee075658be2b$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $cd15ee075658be2b$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_OPS_XFLOW_ONBOARDING_CREATE", () => $cd15ee075658be2b$export$3ce1e5f0e10cb8ea);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $cd15ee075658be2b$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $cd15ee075658be2b$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $cd15ee075658be2b$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $cd15ee075658be2b$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $cd15ee075658be2b$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $cd15ee075658be2b$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $cd15ee075658be2b$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $cd15ee075658be2b$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $cd15ee075658be2b$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $cd15ee075658be2b$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $cd15ee075658be2b$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $cd15ee075658be2b$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $cd15ee075658be2b$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $cd15ee075658be2b$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $cd15ee075658be2b$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $cd15ee075658be2b$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $cd15ee075658be2b$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $cd15ee075658be2b$export$f546e18e46478c84);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER_PREFILLED", () => $cd15ee075658be2b$export$dff97dd5b11f16cf);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $cd15ee075658be2b$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $cd15ee075658be2b$export$145eb8935a34e85e);
$parcel$export(module.exports, "BOARD_CREATE", () => $cd15ee075658be2b$export$1daadfb71bec9061);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $cd15ee075658be2b$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $cd15ee075658be2b$export$ab926dced0f69c1e);
$parcel$export(module.exports, "UC_ATLASSIAN_HOME_CREATE_ISSUE", () => $cd15ee075658be2b$export$d3df6a0ce4e0bc8b);
$parcel$export(module.exports, "JIRA_ISSUE_TABLE_TRIGGER", () => $cd15ee075658be2b$export$99b5cdc74c6071b4);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $cd15ee075658be2b$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $cd15ee075658be2b$export$7a8328e1f8bd992b);
/* eslint-disable jira/filename-case */ const $cd15ee075658be2b$export$a05673a22505d5ee = 'forge-open-issue-create';
const $cd15ee075658be2b$export$c78d329777576aa0 = 'global-create-button';
const $cd15ee075658be2b$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $cd15ee075658be2b$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $cd15ee075658be2b$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $cd15ee075658be2b$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $cd15ee075658be2b$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $cd15ee075658be2b$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $cd15ee075658be2b$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $cd15ee075658be2b$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $cd15ee075658be2b$export$9bc326812a93707 = 'jsw-security-create-issue';
const $cd15ee075658be2b$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $cd15ee075658be2b$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $cd15ee075658be2b$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $cd15ee075658be2b$export$3ce1e5f0e10cb8ea = 'jsm-ops-xflow-onboarding-create';
const $cd15ee075658be2b$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $cd15ee075658be2b$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $cd15ee075658be2b$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $cd15ee075658be2b$export$235b856f54db8916 = 'jwm-board-create-issue';
const $cd15ee075658be2b$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $cd15ee075658be2b$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $cd15ee075658be2b$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $cd15ee075658be2b$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $cd15ee075658be2b$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $cd15ee075658be2b$export$aa348159181703a0 = 'software-create-issue-dialog';
const $cd15ee075658be2b$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $cd15ee075658be2b$export$718822a309bffada = 'create-linked-issue-command-palette';
const $cd15ee075658be2b$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $cd15ee075658be2b$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $cd15ee075658be2b$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $cd15ee075658be2b$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $cd15ee075658be2b$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $cd15ee075658be2b$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $cd15ee075658be2b$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $cd15ee075658be2b$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $cd15ee075658be2b$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $cd15ee075658be2b$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $cd15ee075658be2b$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $cd15ee075658be2b$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $cd15ee075658be2b$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $cd15ee075658be2b$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $cd15ee075658be2b$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $cd15ee075658be2b$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $cd15ee075658be2b$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $cd15ee075658be2b$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $cd15ee075658be2b$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $cd15ee075658be2b$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $cd15ee075658be2b$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $cd15ee075658be2b$export$dff97dd5b11f16cf = 'issue-create-embed-trigger-prefilled';
const $cd15ee075658be2b$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $cd15ee075658be2b$export$145eb8935a34e85e = 'jwm-inline-create';
const $cd15ee075658be2b$export$1daadfb71bec9061 = 'board-create';
const $cd15ee075658be2b$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $cd15ee075658be2b$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $cd15ee075658be2b$export$220cd7b39e0b57a = 'jira-issue-comment';
const $cd15ee075658be2b$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $cd15ee075658be2b$export$d3df6a0ce4e0bc8b = 'uc-atlassian-home-create-issue';
const $cd15ee075658be2b$export$99b5cdc74c6071b4 = 'jira-issue-table-trigger';
const $cd15ee075658be2b$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $cd15ee075658be2b$export$7a8328e1f8bd992b = [
    $cd15ee075658be2b$export$7e9cfd1f59e60910,
    $cd15ee075658be2b$export$708499dcd016e5e9,
    $cd15ee075658be2b$export$e1c8789144c4c810,
    $cd15ee075658be2b$export$c5afabb7a17e802
];

});

parcelRegister("kTMHb", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SUBMIT_BEHAVIOUR", () => $1081e3ae83892313$export$d7147f8e1d7be0e2);
/* eslint-disable jira/filename-case */ const $1081e3ae83892313$export$d7147f8e1d7be0e2 = {
    CREATE_ISSUE: 'createIssue',
    SAVE_EDITS_WITHOUT_ISSUE_CREATION: 'saveEditsWithoutIssueCreation'
};

});

parcelRegister("k2847", function(module, exports) {
$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $340b537aa60cae02$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $340b537aa60cae02$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $340b537aa60cae02$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $340b537aa60cae02$export$720579602bb055a2);
$parcel$export(module.exports, "shouldTriggerModernisedIssueCreate", () => $340b537aa60cae02$export$68a6f9b6b3dd1f1e);
$parcel$export(module.exports, "shouldTriggerModernisedIssueCreateEmbed", () => $340b537aa60cae02$export$51a09725004a8662);
$parcel$export(module.exports, "shouldForceExpandedIssueCreateModal", () => $340b537aa60cae02$export$5a45eebd3613eefc);
/* eslint-disable jira/filename-case */ 
var $VoOhq = parcelRequire("VoOhq");

var $2700E = parcelRequire("2700E");

var $eJ8Fl = parcelRequire("eJ8Fl");

var $jaJSD = parcelRequire("jaJSD");

var $6GOOT = parcelRequire("6GOOT");

var $1OTgk = parcelRequire("1OTgk");
const $340b537aa60cae02$export$550b19803bc962ec = (isSubsequentLoad, isModernisedTrigger = false)=>{
    (0, $jaJSD.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $6GOOT.globalIssueCreateModalLoadSubsequent) : (0, $6GOOT.globalIssueCreateModalLoad);
    if (isSubsequentLoad) {
        if (!isModernisedTrigger) (0, $VoOhq.default)('global-issue.create-modal-subsequent');
    } else if (!isModernisedTrigger) (0, $VoOhq.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $eJ8Fl.startGlobalIssueCreateTTIWithAdjustments)();
};
const $340b537aa60cae02$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $340b537aa60cae02$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $340b537aa60cae02$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};
const $340b537aa60cae02$export$11ffbb568e7def20 = [
    (0, $1OTgk.GENERIC_KEYBOARD_SHORTCUT),
    (0, $1OTgk.GENERIC_GLOBAL_CREATE_BUTTON),
    (0, $1OTgk.ISSUE_VIEW_CREATE_LINKED_ISSUE),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_SUBTASK),
    (0, $1OTgk.CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW),
    (0, $1OTgk.JIRA_ISSUE_TABLE_TRIGGER),
    (0, $1OTgk.JWM_INLINE_CREATE),
    (0, $1OTgk.BOARD_CREATE),
    (0, $1OTgk.JSW_ADAPTED_GLOBAL_ISSUE_CREATE),
    (0, $1OTgk.JSW_ROADMAP_CREATE_ISSUE),
    (0, $1OTgk.JSW_CREATE_EPIC_ISSUE),
    (0, $1OTgk.CREATE_SUBTASK_NIN_TRIGGER),
    (0, $1OTgk.UC_ATLASSIAN_HOME_CREATE_ISSUE)
];
/**
 * Trigger points that should open the modernised modal in expanded mode (no mini toggle).
 * Subset of TRIGGER_POINTS_USING_MODERNISED_MODAL (issue-view flows only).
 */ const $340b537aa60cae02$var$TRIGGER_POINTS_FORCE_EXPANDED_IN_MODERNISED = [
    (0, $1OTgk.ISSUE_VIEW_CREATE_LINKED_ISSUE),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_SUBTASK),
    (0, $1OTgk.ISSUE_CREATE_EMBEDDABLE_TRIGGER),
    (0, $1OTgk.ISSUE_CREATE_EMBEDDABLE_TRIGGER_PREFILLED)
];
const $340b537aa60cae02$export$68a6f9b6b3dd1f1e = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && $340b537aa60cae02$export$11ffbb568e7def20.includes(triggerPointKey);
};
const $340b537aa60cae02$export$51a09725004a8662 = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && (0, $2700E.expVal)('implement_modern_gic_for_embed_routes', 'isEnabled', false) && (triggerPointKey === (0, $1OTgk.ISSUE_CREATE_EMBEDDABLE_TRIGGER) || triggerPointKey === (0, $1OTgk.ISSUE_CREATE_EMBEDDABLE_TRIGGER_PREFILLED));
};
const $340b537aa60cae02$export$5a45eebd3613eefc = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && $340b537aa60cae02$var$TRIGGER_POINTS_FORCE_EXPANDED_IN_MODERNISED.includes(triggerPointKey);
};

});
parcelRegister("eJ8Fl", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $ce28ce5101a62053$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $ce28ce5101a62053$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $ce28ce5101a62053$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $ce28ce5101a62053$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $ce28ce5101a62053$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $ce28ce5101a62053$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $ce28ce5101a62053$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $ce28ce5101a62053$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @jira/issue-create__use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @jira/issue-create__use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $jvGCa = parcelRequire("jvGCa");
const $ce28ce5101a62053$export$9f3d6f17e1da7874 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $ce28ce5101a62053$export$457c9fb71ad5b3a9 = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.start();
};
const $ce28ce5101a62053$export$ef664dac649a716c = ()=>$ce28ce5101a62053$export$9f3d6f17e1da7874.mark('gic-tti');
const $ce28ce5101a62053$export$30ca4c461fab486c = (customData)=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $ce28ce5101a62053$export$27f2445288b528c = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.cancel();
};
const $ce28ce5101a62053$export$7a2709fc1e33401a = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $ce28ce5101a62053$export$cf3893335c93e33b = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $ce28ce5101a62053$export$d86f4868694f2aa7 = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});

parcelRegister("6GOOT", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $99ad8571c112a80a$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $99ad8571c112a80a$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $99ad8571c112a80a$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $99ad8571c112a80a$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $99ad8571c112a80a$export$c1592e4d8d98963e);
/* eslint-disable jira/filename-case */ 
var $jvGCa = parcelRequire("jvGCa");
const $99ad8571c112a80a$export$5a01a7fa84b239c8 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $99ad8571c112a80a$export$c50ad3c31b6fcfc6 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $99ad8571c112a80a$export$4b2382574525bb0f = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $99ad8571c112a80a$export$7839bdaa2f6a2385 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $99ad8571c112a80a$export$c1592e4d8d98963e = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});



parcelRegister("dC2mi", function(module, exports) {
$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $a9d6728219737a6c$export$fc0840474cb1fce9);

var $3yzOx = parcelRequire("3yzOx");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");


var $4dhaE = parcelRequire("4dhaE");

var $78ZxQ = parcelRequire("78ZxQ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a9d6728219737a6c$var$NavigationCreateIssueButtonLazy = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("bUjzT")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/NavigationCreateIssueButtonWrapperNudge.tsx"
});
const $a9d6728219737a6c$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $78ZxQ.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $4dhaE.OnboardingNudgeErrorBoundary), {
        id: (0, $99cb2e6a234d7a1f$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $99cb2e6a234d7a1f$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $a8EUd.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement($a9d6728219737a6c$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $99cb2e6a234d7a1f$export$aba87e019f5ccb8d)
    }, children)));
};
$a9d6728219737a6c$export$fc0840474cb1fce9.displayName = "NavigationCreateIssueButtonWrapperNudgeAsync";

});
/* eslint-disable jira/filename-case */ // Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $99cb2e6a234d7a1f$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $99cb2e6a234d7a1f$export$e3884212029f7bef = 'should-show-welcome-modal';
const $99cb2e6a234d7a1f$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $99cb2e6a234d7a1f$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $99cb2e6a234d7a1f$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $99cb2e6a234d7a1f$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $99cb2e6a234d7a1f$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $99cb2e6a234d7a1f$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $99cb2e6a234d7a1f$export$6e69f8dc03075ef8 = 'team-type';
const $99cb2e6a234d7a1f$export$c06666264cd35603 = 'team-type-shorthand';
const $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $99cb2e6a234d7a1f$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $99cb2e6a234d7a1f$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $99cb2e6a234d7a1f$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $99cb2e6a234d7a1f$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $99cb2e6a234d7a1f$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $99cb2e6a234d7a1f$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $99cb2e6a234d7a1f$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $99cb2e6a234d7a1f$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $99cb2e6a234d7a1f$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $99cb2e6a234d7a1f$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $99cb2e6a234d7a1f$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $99cb2e6a234d7a1f$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99cb2e6a234d7a1f$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $99cb2e6a234d7a1f$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $99cb2e6a234d7a1f$export$468488291ccd988 = 'timelineAddItemNudge';
const $99cb2e6a234d7a1f$export$7a33548109ac931d = 'createFormNudge';
const $99cb2e6a234d7a1f$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $99cb2e6a234d7a1f$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $99cb2e6a234d7a1f$export$594d3436316492be = 'summaryViewNudge';
const $99cb2e6a234d7a1f$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $99cb2e6a234d7a1f$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99cb2e6a234d7a1f$export$699265ec8ad9a740 = 'Software Development';
const $99cb2e6a234d7a1f$export$e07d1fa2da8ed874 = 'Customer Service';
const $99cb2e6a234d7a1f$export$76dcec3f438d9e56 = 'IT Support';
const $99cb2e6a234d7a1f$export$9a574c301f67ba30 = 'Human Resources';
const $99cb2e6a234d7a1f$export$363ec144a94029c8 = 'Finance';
const $99cb2e6a234d7a1f$export$df0fb32d68ae1e78 = 'Legal';
const $99cb2e6a234d7a1f$export$d9c0e3e59442fb4 = 'Marketing';
const $99cb2e6a234d7a1f$export$27dbc7d7ce66e6e3 = 'Operations';
const $99cb2e6a234d7a1f$export$a5dce388adf922bd = 'Sales';
const $99cb2e6a234d7a1f$export$e1473b31a257caff = 'Data Science';
const $99cb2e6a234d7a1f$export$85657457db93c2c2 = 'Product Management';
const $99cb2e6a234d7a1f$export$c0c2d1dfaeba89dd = 'Project Management';
const $99cb2e6a234d7a1f$export$2e6a7ad3ab9c82a3 = 'Design';
const $99cb2e6a234d7a1f$export$7b60378c3b4372e9 = 'Other or Personal';
const $99cb2e6a234d7a1f$export$572242e58bd07594 = 'CS';
const $99cb2e6a234d7a1f$export$d7de553940261eba = 'ITS';
const $99cb2e6a234d7a1f$export$4c29d0d04c15e55d = 'HR';
const $99cb2e6a234d7a1f$export$3950f7f841bf94b6 = 'FNC';
const $99cb2e6a234d7a1f$export$881249b988b6030f = 'LGL';
const $99cb2e6a234d7a1f$export$e4824f74b9879164 = 'MKT';
const $99cb2e6a234d7a1f$export$4f3cb0844009af52 = 'OPS';
const $99cb2e6a234d7a1f$export$1a65d50c4a641bb4 = 'SAL';
const $99cb2e6a234d7a1f$export$9ee64e8fbd8b03a2 = 'DS';
const $99cb2e6a234d7a1f$export$b8b1ac856ba1434b = 'DEV';
const $99cb2e6a234d7a1f$export$4f54a09a24fd1d74 = 'PDM';
const $99cb2e6a234d7a1f$export$79685802e8ff1098 = 'PJM';
const $99cb2e6a234d7a1f$export$e5c438b7501b5a24 = 'DES';
const $99cb2e6a234d7a1f$export$cbc0e551d91a692d = 'OTR';

parcelRegister("4dhaE", function(module, exports) {
$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $c9f3e130b4fb2f28$export$3915a8814b99f0b);
// eslint-disable-next-line jira/filename-case

var $3yzOx = parcelRequire("3yzOx");

var $3GXRL = parcelRequire("3GXRL");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $c9f3e130b4fb2f28$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $3GXRL.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $5ZtCQ.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};
$c9f3e130b4fb2f28$export$3915a8814b99f0b.displayName = "OnboardingNudgeErrorBoundary";

});
parcelRegister("3GXRL", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $e8fc8984665e0283$export$9171acf2e93b7d4d);
// eslint-disable-next-line jira/filename-case

var $3yzOx = parcelRequire("3yzOx");

var $h8QGu = parcelRequire("h8QGu");

var $iuYkJ = parcelRequire("iuYkJ");
const $e8fc8984665e0283$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $iuYkJ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $h8QGu.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};
$e8fc8984665e0283$export$9171acf2e93b7d4d.displayName = "ErrorBoundaryWithChunkErrorLogging";

});
parcelRegister("iuYkJ", function(module, exports) {
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $638333d69388a906$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $638333d69388a906$export$807be5f3f1ea996);
/* eslint-disable jira/filename-case */ 
var $3yzOx = parcelRequire("3yzOx");

var $8dImz = parcelRequire("8dImz");
const $638333d69388a906$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $8dImz.isLoaderError)(error)
    });
const $638333d69388a906$export$807be5f3f1ea996 = (attributes = {})=>(0, $3yzOx.useCallback)((error)=>({
            ...attributes,
            ...$638333d69388a906$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



parcelRegister("78ZxQ", function(module, exports) {
$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $b12a5e09957dfa55$export$b687eb4905cdc15a);

var $11VMX = parcelRequire("11VMX");
const $b12a5e09957dfa55$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $11VMX.useHasOpened)();
    return hasOpened;
};

});
parcelRegister("11VMX", function(module, exports) {
$parcel$export(module.exports, "useHasOpened", () => $cef4dc00e5865d98$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $5vUJG = parcelRequire("5vUJG");
const $cef4dc00e5865d98$var$actions = {
    setHasOpened: $5vUJG.setHasOpened
};
const $cef4dc00e5865d98$var$initialState = {
    hasOpened: false
};
const $cef4dc00e5865d98$var$Store = (0, $5QDqc.createStore)({
    initialState: $cef4dc00e5865d98$var$initialState,
    actions: $cef4dc00e5865d98$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $cef4dc00e5865d98$export$cbaabcded53b5c1f = (0, $3h1FP.createHook)($cef4dc00e5865d98$var$Store);

});
parcelRegister("5vUJG", function(module, exports) {
$parcel$export(module.exports, "setHasOpened", () => $2af725793541a0e6$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2af725793541a0e6$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $2af725793541a0e6$export$2e2bcd8739ae039 = $2af725793541a0e6$export$c4743c64a7c42294;

});



parcelRegister("bUjzT", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4cUSg").then(()=>parcelRequire('59Kf9'));

});


// This id is required to ensure pollinator tests work between Nav3 and Nav4 and also in feature tests
const $aec4a9b10933d5e3$export$bac9f330cf4670e8 = 'atlassian-navigation--create-button';
const $aec4a9b10933d5e3$export$c65f84387a2a60c = 'atlassian-navigation--create-split-button';
const $aec4a9b10933d5e3$export$d28a4ed98505cc58 = 'atlassian-navigation.ui.universal-create.universal-create-wrapper';
const $aec4a9b10933d5e3$export$91e69945d7373dba = 'universalCreate';

parcelRegister("6NPUA", function(module, exports) {
$parcel$export(module.exports, "useCreateIssueItem", () => $9dfd5822153144d4$export$7878b4db79a52b24);

var $3yzOx = parcelRequire("3yzOx");

var $B4kk2 = parcelRequire("B4kk2");

var $4K6DP = parcelRequire("4K6DP");

var $8ikZc = parcelRequire("8ikZc");

var $jNFSU = parcelRequire("jNFSU");

var $ihOVt = parcelRequire("ihOVt");

var $i860n = parcelRequire("i860n");

var $cvA2R = parcelRequire("cvA2R");

var $k6ufm = parcelRequire("k6ufm");

var $kFDmj = parcelRequire("kFDmj");

var $1OTgk = parcelRequire("1OTgk");

var $9Oo0T = parcelRequire("9Oo0T");

var $7Odw0 = parcelRequire("7Odw0");

var $jA99X = parcelRequire("jA99X");


var $gMI76 = parcelRequire("gMI76");

var $7RI9J = parcelRequire("7RI9J");
var $93ner = parcelRequire("93ner");

var $6ZLJT = parcelRequire("6ZLJT");

var $6UbAk = parcelRequire("6UbAk");

var $bMCBV = parcelRequire("bMCBV");

var $faNwm = parcelRequire("faNwm");
const $9dfd5822153144d4$var$createIssue = (0, $7RI9J.defineMessage)({
    defaultMessage: "Work item",
    id: "atlassian-navigation.universal-create.create-button-aria-label"
});
const $9dfd5822153144d4$var$useConditionalGicOptInResource = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('render_modern_global_issue_create_modal_experience'), ()=>(0, $k6ufm.useResource)((0, $6UbAk.gicOptInStatusResources)), ()=>({
        data: null,
        update: (0, (/*@__PURE__*/$parcel$interopDefault($B4kk2)))
    }));
const $9dfd5822153144d4$export$fc4d210bb6a1528a = ()=>{
    (0, $4K6DP.di)(window);
    const JSW_TMP_BACKLOG_BOARD_REGEXP = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return JSW_TMP_BACKLOG_BOARD_REGEXP.test(window.location.pathname);
};
function $9dfd5822153144d4$export$7878b4db79a52b24(options) {
    const { onCreateClick: onCreateClick = (0, $jA99X.default), experienceTracker: experienceTracker = (0, $faNwm.GlobalIssueCreateFromUniversalCreateExperience) } = options ?? {};
    const { formatMessage: formatMessage } = (0, $93ner.default)();
    const isClientReady = (0, $bMCBV.useIsClientReady)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $9Oo0T.useTriggerIssueCreateModal)();
    (0, $kFDmj.useInitializePersistentIssueCreateModalView)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $gMI76.useIsInitialLoadLegacyIssueCreate)();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $3yzOx.useRef)(false);
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $7Odw0.isSupportedUserAgent)();
    // copied from src/packages/navigation-apps/atlassian-navigation/src/ui/create/main.tsx#useLayoutEffect hook
    // TODO: delete this code for clean up issue-create-stop-using-gicoptinstatusresources
    const { data: data, update: update } = $9dfd5822153144d4$var$useConditionalGicOptInResource();
    (0, $3yzOx.useLayoutEffect)(()=>{
        if (!(0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) return;
        if (!isClientReady) // Return nothing during SSR
        return;
        if (isAnonymous && !gicOptInStateOverridden.current) {
            update(()=>({
                    gicOptInStatus: {
                        isEnabled: true
                    }
                }));
            gicOptInStateOverridden.current = true;
        }
    }, [
        isAnonymous,
        update,
        isClientReady
    ]);
    currentIssueCreateVisibility = data && data?.gicOptInStatus;
    const onClick = (0, $3yzOx.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if (currentIssueCreateVisibility?.isEnabled) {
            (0, $jNFSU.default)('global-create.work-item-click', e);
            experienceTracker.abort({
                force: true
            });
            experienceTracker.start();
            experienceTracker.addMetadata({
                inputDelay: Math.round(performance.now() - e.timeStamp)
            });
            const nextState = {
                disableCreationSuccessFlag: (0, $i860n.fg)('show_top_nav_gic_success_flag') ? false : $9dfd5822153144d4$export$fc4d210bb6a1528a(),
                triggerPointKey: (0, $1OTgk.GENERIC_GLOBAL_CREATE_BUTTON),
                ...isMobileExperienceEnabled ? {
                    displayMinimizableButtons: false,
                    displayCreateAnotherIssueToggle: false,
                    triggerPointKey: (0, $1OTgk.MOBILE_GLOBAL_CREATE_BUTTON)
                } : {}
            };
            openIssueCreateModal(nextState);
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $7812e963ef8030d6$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
    }, [
        actions,
        currentIssueCreateVisibility,
        experienceTracker,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal
    ]);
    return {
        ati: (0, $ihOVt.Ati).parse('ati:cloud:jira:issue:create'),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8ikZc))),
        children: formatMessage($9dfd5822153144d4$var$createIssue),
        onClick: isClientReady ? onClick : undefined
    };
}

});
parcelRegister("8ikZc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c0c4ad146353612d795bc46242b9b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60a04891e754a221$var$_react = $60a04891e754a221$var$_interopRequireDefault((parcelRequire("3yzOx")));

var $60a04891e754a221$var$_iconNew = $60a04891e754a221$var$_interopRequireDefault((parcelRequire("52mjj")));
function $60a04891e754a221$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-item
 * Usage guidance:
 * Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60a04891e754a221$var$WorkItemIcon = (props)=>/*#__PURE__*/ $60a04891e754a221$var$_react.default.createElement($60a04891e754a221$var$_iconNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$60a04891e754a221$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $60a04891e754a221$var$_default = module.exports.default = $60a04891e754a221$var$WorkItemIcon;

});

parcelRegister("jNFSU", function(module, exports) {
$parcel$export(module.exports, "default", () => $49eb1c81f24d86a9$export$2e2bcd8739ae039);

var $jKpg5 = parcelRequire("jKpg5");

var $e6ag7 = parcelRequire("e6ag7");
/**
 * *Warning* Currently this only supports the events with the following types
 * ```ts
 * 'click' | 'dblclick' | 'mousedown' | 'mouseenter' | 'mouseover'
 * ```
 */ function $49eb1c81f24d86a9$var$traceUFOInteraction(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = (0, $jKpg5.default)(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    return (0, $e6ag7.default)(name, interactionType, event.timeStamp);
}
var $49eb1c81f24d86a9$export$2e2bcd8739ae039 = $49eb1c81f24d86a9$var$traceUFOInteraction;

});
parcelRegister("jKpg5", function(module, exports) {
$parcel$export(module.exports, "default", () => $700d435c87916e52$export$2e2bcd8739ae039);
function $700d435c87916e52$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
var $700d435c87916e52$export$2e2bcd8739ae039 = $700d435c87916e52$var$mapToInteractionType;

});


parcelRegister("kFDmj", function(module, exports) {
$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $530e5ba73be91b3b$export$9086117e14a55509);

var $58tmX = parcelRequire("58tmX");

var $3yzOx = parcelRequire("3yzOx");

var $9Oo0T = parcelRequire("9Oo0T");

var $7Odw0 = parcelRequire("7Odw0");

var $f99M0 = parcelRequire("f99M0");

var $2b39L = parcelRequire("2b39L");

var $l2ZRY = parcelRequire("l2ZRY");
const $530e5ba73be91b3b$export$9086117e14a55509 = ()=>{
    const $ = (0, $58tmX.c)(15);
    const [t0, t1] = (0, $9Oo0T.useTriggerIssueCreateModal)();
    const { shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight } = t0;
    const { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView } = t1;
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const hasUserSeenMiniModal = (0, $3yzOx.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $l2ZRY.usePersistentIssueCreateModalViewResource)();
    let t2;
    if ($[0] !== resource?.view || $[1] !== setPersistentModalView) {
        t2 = ()=>{
            setPersistentModalView(resource?.view || "modal");
        };
        $[0] = resource?.view;
        $[1] = setPersistentModalView;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[3] = t3;
    } else t3 = $[3];
    (0, $3yzOx.useEffect)(t2, t3);
    let t4;
    if ($[4] !== isJSM || $[5] !== resource?.isDiscoPushComplete || $[6] !== setShouldPushMiniModalDiscoverability) {
        t4 = ()=>{
            if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
            else setShouldPushMiniModalDiscoverability(!isJSM && !(0, $7Odw0.isSupportedUserAgent)());
        };
        $[4] = isJSM;
        $[5] = resource?.isDiscoPushComplete;
        $[6] = setShouldPushMiniModalDiscoverability;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = resource?.isDiscoPushComplete;
    let t6;
    if ($[8] !== isJSM || $[9] !== setShouldPushMiniModalDiscoverability || $[10] !== t5) {
        t6 = [
            t5,
            setShouldPushMiniModalDiscoverability,
            isJSM
        ];
        $[8] = isJSM;
        $[9] = setShouldPushMiniModalDiscoverability;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    (0, $3yzOx.useEffect)(t4, t6);
    let t7;
    let t8;
    if ($[12] !== shouldShowMiniModalSpotlight) {
        t7 = ()=>{
            if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
        };
        t8 = [
            shouldShowMiniModalSpotlight
        ];
        $[12] = shouldShowMiniModalSpotlight;
        $[13] = t7;
        $[14] = t8;
    } else {
        t7 = $[13];
        t8 = $[14];
    }
    (0, $3yzOx.useEffect)(t7, t8);
    return null;
};

});
parcelRegister("l2ZRY", function(module, exports) {
$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $2c64d8938b349ba0$export$20dbed3226e737bc);

var $3yzOx = parcelRequire("3yzOx");

var $k6ufm = parcelRequire("k6ufm");

var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");


var $gjifS = parcelRequire("gjifS");
const $2c64d8938b349ba0$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $k6ufm.useResource)((0, $gjifS.persistentIssueCreateModalViewResource));
    const updateView = (0, $3yzOx.useCallback)(async (view)=>{
        try {
            await (0, $fNXFu.userPreferenceAPI).set((0, $197033e503119526$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $3yzOx.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $fNXFu.userPreferenceAPI).set((0, $197033e503119526$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});
const $197033e503119526$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $197033e503119526$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';



parcelRegister("jA99X", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1c1502547c5c730$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");

var $6rVwb = parcelRequire("6rVwb");

var $j2SU8 = parcelRequire("j2SU8");
const $f1c1502547c5c730$var$onCreateClick = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $j2SU8.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $6rVwb.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api?.showCreateDialog({});
        (0, $j2SU8.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};
var $f1c1502547c5c730$export$2e2bcd8739ae039 = $f1c1502547c5c730$var$onCreateClick;

});
parcelRegister("j2SU8", function(module, exports) {
$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $da1a81f3dc0c28fb$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $da1a81f3dc0c28fb$export$b5c5d408bb7fd104);

var $pnnt0 = parcelRequire("pnnt0");

var $2L6OC = parcelRequire("2L6OC");
const $da1a81f3dc0c28fb$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $2L6OC.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $2L6OC.legacyIssueCreateTransitionInteraction).start();
        (0, $2L6OC.legacyIssueCreateCombinedInteraction).start();
    }
};
const $da1a81f3dc0c28fb$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $pnnt0.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $2L6OC.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $2L6OC.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $2L6OC.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("2L6OC", function(module, exports) {
$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $e00ed344dccb1894$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $e00ed344dccb1894$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $e00ed344dccb1894$export$52353a8848646ccd);

var $jvGCa = parcelRequire("jvGCa");
const $e00ed344dccb1894$export$2bc24132dfd54487 = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $e00ed344dccb1894$export$ba0054dee3105c90 = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $e00ed344dccb1894$export$52353a8848646ccd = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $7812e963ef8030d6$export$d983e94cf86f65d = 'global-create-button';
const $7812e963ef8030d6$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("gMI76", function(module, exports) {
$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $8c6214622bff3e47$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $8c6214622bff3e47$var$initialState = {
    isInitialLoad: true
};
const $8c6214622bff3e47$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $8c6214622bff3e47$var$store = (0, $5QDqc.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $8c6214622bff3e47$var$initialState,
    actions: $8c6214622bff3e47$export$e324594224ef24da
});
const $8c6214622bff3e47$export$8a73e89ffc4b9342 = (0, $3h1FP.createHook)($8c6214622bff3e47$var$store);

});

parcelRegister("faNwm", function(module, exports) {
$parcel$export(module.exports, "GlobalIssueCreateFromUniversalCreateExperience", () => $6d447e2719a9570c$export$4ace9e843d9f669d);
$parcel$export(module.exports, "UniversalCreateButtonLoadExperience", () => $6d447e2719a9570c$export$86b6e5ad9a2eec50);
$parcel$export(module.exports, "UniversalCreateButtonInteractiveExperience", () => $6d447e2719a9570c$export$a608a0f480dc39e);

var $jkqqC = parcelRequire("jkqqC");

var $ipvkO = parcelRequire("ipvkO");

var $iUbRz = parcelRequire("iUbRz");
const $6d447e2719a9570c$export$4ace9e843d9f669d = new (0, $jkqqC.UFOExperience)('global-issue-create-from-universal-create', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    until: (0, $iUbRz.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $6d447e2719a9570c$export$86b6e5ad9a2eec50 = new (0, $jkqqC.UFOExperience)('universal-create-button-load', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
});
const $6d447e2719a9570c$export$a608a0f480dc39e = new (0, $jkqqC.UFOExperience)('universal-create-button-interactive', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("c0zmz", function(module, exports) {
$parcel$export(module.exports, "useCreateWithPlannerItem", () => $162dfd5a71937179$export$7ed642fef00ec80a);

var $3yzOx = parcelRequire("3yzOx");

var $b47ZF = parcelRequire("b47ZF");

var $2EFuW = parcelRequire("2EFuW");

var $defJG = parcelRequire("defJG");

var $ihOVt = parcelRequire("ihOVt");

var $aUdYV = parcelRequire("aUdYV");

var $7RI9J = parcelRequire("7RI9J");
var $93ner = parcelRequire("93ner");
const $162dfd5a71937179$var$planWithJira = (0, $7RI9J.defineMessage)({
    id: "jira-ai.plan-with-jira.label",
    defaultMessage: "Create with Planner"
});
const $162dfd5a71937179$var$eapLozenge = (0, $7RI9J.defineMessage)({
    id: "jira-ai.plan-with-jira.eap-lozenge",
    defaultMessage: "EAP"
});
function $162dfd5a71937179$export$7ed642fef00ec80a() {
    const { formatMessage: formatMessage } = (0, $93ner.default)();
    return {
        ati: (0, $ihOVt.Ati).parse('ati:cloud:jira:rovo'),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $defJG.Inline), {
            space: "space.100"
        }, formatMessage($162dfd5a71937179$var$planWithJira), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $2EFuW.default), {
            appearance: "new"
        }, formatMessage($162dfd5a71937179$var$eapLozenge))),
        testId: 'jira-uc--create-with-planner-menu-item',
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($b47ZF))),
        Wrapper: (0, $aUdYV.AiPlannerIframeModalMenuItemWrapper)
    };
}

});
parcelRegister("aUdYV", function(module, exports) {
$parcel$export(module.exports, "AiPlannerIframeModalMenuItemWrapper", () => $4da05e78fd5bf876$export$ceea918193769425);

var $3yzOx = parcelRequire("3yzOx");

var $ikm5U = parcelRequire("ikm5U");

var $8jh8S = parcelRequire("8jh8S");

var $6Phv4 = parcelRequire("6Phv4");

var $alN1m = parcelRequire("alN1m");

var $a5pM6 = parcelRequire("a5pM6");
const $4da05e78fd5bf876$var$EMPTY_ENTRY_POINT_PROPS = {};
const $4da05e78fd5bf876$export$ceea918193769425 = ({ children: children })=>{
    const shared = (0, $6Phv4.useAiPlannerIframe)();
    const modalProps = (0, $a5pM6.useAiPlannerIframeModalProps)();
    const loadExperience = (0, $alN1m.useAiPlannerIframeLoadExperience)({
        kind: 'create',
        surface: 'modal'
    });
    const handleEntryPointError = (0, $3yzOx.useCallback)(({ error: error })=>{
        loadExperience.start();
        loadExperience.fail('entry-point', error, {
            skipErrorAnalytics: true
        });
    }, [
        loadExperience
    ]);
    const handleEntryPointClose = (0, $3yzOx.useCallback)(()=>{
        shared?.releaseActiveClaim();
    }, [
        shared
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3yzOx))).createElement((0, $ikm5U.ModalTrigger), {
        entryPoint: (0, $8jh8S.aiPlannerIframeModalEntryPoint),
        entryPointProps: {
            ...$4da05e78fd5bf876$var$EMPTY_ENTRY_POINT_PROPS,
            onClose: handleEntryPointClose
        },
        modalProps: modalProps,
        onError: handleEntryPointError
    }, (triggerProps)=>children({
            triggerProps: triggerProps
        }));
};
$4da05e78fd5bf876$export$ceea918193769425.displayName = "AiPlannerIframeModalMenuItemWrapper";

});
parcelRegister("8jh8S", function(module, exports) {
$parcel$export(module.exports, "aiPlannerIframeModalEntryPoint", () => $937d8c7dab912b32$export$461cb36ce2316d57);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $937d8c7dab912b32$export$461cb36ce2316d57 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("72Tpx")), {
        moduleId: "72943a54",
        moduleName: "AiPlannerIframeModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("72Tpx", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("70zr0").then(()=>parcelRequire('ctCPY'));

});


parcelRegister("alN1m", function(module, exports) {
$parcel$export(module.exports, "AI_PLANNER_IFRAME_ANALYTICS_SOURCE", () => $4263460d3065f503$export$16f21923aaa52318);
$parcel$export(module.exports, "AI_PLANNER_IFRAME_EXPERIENCE_TIMEOUT_MS", () => $4263460d3065f503$export$183b364a95153282);
$parcel$export(module.exports, "useAiPlannerIframeLoadExperience", () => $4263460d3065f503$export$5667147906a78128);

var $3yzOx = parcelRequire("3yzOx");

var $2cOe8 = parcelRequire("2cOe8");

var $ipvkO = parcelRequire("ipvkO");

var $hFtK7 = parcelRequire("hFtK7");

var $868gB = parcelRequire("868gB");

var $cUnrZ = parcelRequire("cUnrZ");

var $dtDO2 = parcelRequire("dtDO2");

var $lTQTl = parcelRequire("lTQTl");
const $4263460d3065f503$var$PACKAGE_NAME = 'jiraAiPlanningAiPlannerIframeModal';
const $4263460d3065f503$var$TEAM_NAME = 'dev-ai-planner';
const $4263460d3065f503$export$16f21923aaa52318 = 'ai-planner';
const $4263460d3065f503$export$183b364a95153282 = 15000;
const $4263460d3065f503$var$EXPERIENCE_BY_KIND = {
    create: 'ai-planner-create-iframe-load',
    plan: 'ai-planner-plan-iframe-load'
};
const $4263460d3065f503$var$iframeLoadLatency = {
    create: new (0, $2cOe8.ConcurrentExperience)($4263460d3065f503$var$EXPERIENCE_BY_KIND.create, {
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
    }),
    plan: new (0, $2cOe8.ConcurrentExperience)($4263460d3065f503$var$EXPERIENCE_BY_KIND.plan, {
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
    })
};
const $4263460d3065f503$var$createIframeLoadError = (reason)=>new Error(`AI Planner iframe load failed: ${reason}`);
const $4263460d3065f503$export$5667147906a78128 = ({ kind: kind, surface: surface })=>{
    const experience = $4263460d3065f503$var$EXPERIENCE_BY_KIND[kind];
    const experienceId = `${surface}-${kind}`;
    const attributes = (0, $3yzOx.useMemo)(()=>({
            iframeKind: kind,
            surface: surface
        }), [
        kind,
        surface
    ]);
    const startExperience = (0, $dtDO2.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: $4263460d3065f503$export$16f21923aaa52318,
        timeout: $4263460d3065f503$export$183b364a95153282
    });
    const markSucceeded = (0, $lTQTl.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const markFailed = (0, $cUnrZ.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const markAborted = (0, $868gB.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const attemptSettledRef = (0, $3yzOx.useRef)(false);
    const latencyAttemptRef = (0, $3yzOx.useRef)(0);
    const latencyInstanceIdRef = (0, $3yzOx.useRef)(null);
    const endLatency = (0, $3yzOx.useCallback)((outcome)=>{
        const instanceId = latencyInstanceIdRef.current;
        if (instanceId == null) return;
        latencyInstanceIdRef.current = null;
        const instance = $4263460d3065f503$var$iframeLoadLatency[kind].getInstance(instanceId);
        (outcome === 'success' ? instance.success() : instance.abort()).catch(()=>undefined);
    }, [
        kind
    ]);
    const start = (0, $3yzOx.useCallback)(()=>{
        if (latencyInstanceIdRef.current != null) endLatency('abort');
        attemptSettledRef.current = false;
        const instanceId = `${experienceId}-${latencyAttemptRef.current + 1}`;
        latencyAttemptRef.current += 1;
        latencyInstanceIdRef.current = instanceId;
        startExperience();
        $4263460d3065f503$var$iframeLoadLatency[kind].getInstance(instanceId).start().catch(()=>undefined);
    }, [
        endLatency,
        experienceId,
        kind,
        startExperience
    ]);
    const succeed = (0, $3yzOx.useCallback)((loadAttributes = {})=>{
        if (attemptSettledRef.current) return;
        attemptSettledRef.current = true;
        markSucceeded(loadAttributes);
        endLatency('success');
    }, [
        endLatency,
        markSucceeded
    ]);
    const fail = (0, $3yzOx.useCallback)((reason, error = $4263460d3065f503$var$createIframeLoadError(reason), { skipErrorAnalytics: skipErrorAnalytics = false, attributes: loadAttributes = {} } = {})=>{
        if (attemptSettledRef.current) return;
        attemptSettledRef.current = true;
        markFailed(`ai-planner-iframe.${surface}`, error, {
            reason: reason,
            ...loadAttributes
        });
        endLatency('abort');
        if (skipErrorAnalytics) return;
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'iframeLoad',
                packageName: $4263460d3065f503$var$PACKAGE_NAME,
                teamName: $4263460d3065f503$var$TEAM_NAME
            },
            attributes: {
                ...attributes,
                ...loadAttributes,
                reason: reason
            },
            error: error,
            sendToPrivacyUnsafeSplunk: false
        });
    }, [
        attributes,
        endLatency,
        markFailed,
        surface
    ]);
    const abort = (0, $3yzOx.useCallback)((reason)=>{
        if (attemptSettledRef.current) return;
        attemptSettledRef.current = true;
        markAborted(reason);
        endLatency('abort');
    }, [
        endLatency,
        markAborted
    ]);
    return (0, $3yzOx.useMemo)(()=>({
            experience: experience,
            experienceId: experienceId,
            start: start,
            succeed: succeed,
            fail: fail,
            abort: abort
        }), [
        abort,
        experience,
        experienceId,
        fail,
        start,
        succeed
    ]);
};

});
parcelRegister("2cOe8", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $548d8167ff565de9$export$ac1cddfee07ba6ac);

var $dqaa1 = parcelRequire("dqaa1");

var $jkqqC = parcelRequire("jkqqC");
class $548d8167ff565de9$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $jkqqC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dqaa1.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});

parcelRegister("868gB", function(module, exports) {
$parcel$export(module.exports, "useExperienceAbort", () => $875ac4dcc884f25e$export$cc92b7ce453f4403);
/* eslint-disable jira/filename-case */ 
var $3yzOx = parcelRequire("3yzOx");

var $a5nxD = parcelRequire("a5nxD");

var $6bEm8 = parcelRequire("6bEm8");

var $UlW5d = parcelRequire("UlW5d");
const $875ac4dcc884f25e$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const self = (0, $3yzOx.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $3yzOx.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        let shardAndRegionAttributes = {};
        shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        const holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes
            }
        });
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        self
    ]);
};

});

parcelRegister("cUnrZ", function(module, exports) {
$parcel$export(module.exports, "useExperienceFail", () => $85e9bbc4c2fc8179$export$606da7704d8eaf06);
/* eslint-disable jira/filename-case */ 
var $3yzOx = parcelRequire("3yzOx");

var $a5nxD = parcelRequire("a5nxD");

var $lCetP = parcelRequire("lCetP");

var $8dImz = parcelRequire("8dImz");

var $6bEm8 = parcelRequire("6bEm8");

var $UlW5d = parcelRequire("UlW5d");
const $85e9bbc4c2fc8179$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const self = (0, $3yzOx.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $3yzOx.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $8dImz.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $lCetP.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        const holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes,
                location: location
            }
        });
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        self
    ]);
};

});

parcelRegister("lTQTl", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $c52f7ca5d7a37e94$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $c52f7ca5d7a37e94$export$4962f3898bd5c829);
/* eslint-disable jira/filename-case */ 
var $3yzOx = parcelRequire("3yzOx");

var $a5nxD = parcelRequire("a5nxD");

var $6bEm8 = parcelRequire("6bEm8");

var $4Onaa = parcelRequire("4Onaa");

var $UlW5d = parcelRequire("UlW5d");
const $c52f7ca5d7a37e94$var$STABLE_EMPTY_OBJECT = {};
const $c52f7ca5d7a37e94$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $c52f7ca5d7a37e94$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $UlW5d.useExperienceContext)();
    const route = (0, $4Onaa.useCurrentRoute)();
    const self = (0, $3yzOx.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $3yzOx.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $6bEm8.default)('ajs-shard'),
            region: (0, $6bEm8.default)('ajs-region')
        };
        const holdoutAttributes = {
            customHoldout: (0, $a5nxD.getIsInJiraHoldoutData)().holdout
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                ...holdoutAttributes
            }
        });
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        self
    ]);
};
const $c52f7ca5d7a37e94$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $c52f7ca5d7a37e94$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $c52f7ca5d7a37e94$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $3yzOx.useEffect)(()=>{
        onExperienceSuccess();
    // oxlint-disable-next-line react/exhaustive-effect-dependencies
    }, [
        attributes,
        onExperienceSuccess
    ]);
    // oxlint-disable-next-line react/void-use-memo
    (0, $3yzOx.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};
$c52f7ca5d7a37e94$export$4962f3898bd5c829.displayName = "ExperienceSuccess";

});


parcelRegister("a5pM6", function(module, exports) {
$parcel$export(module.exports, "AI_PLANNER_IFRAME_MODAL_TEST_ID", () => $53fee58a66f619c2$export$55449fcb95741234);
$parcel$export(module.exports, "AI_PLANNER_IFRAME_MODAL_PRESENTATION_ATTRIBUTE", () => $53fee58a66f619c2$export$d4ef780c798e40e8);
$parcel$export(module.exports, "AI_PLANNER_IFRAME_MODAL_RESIZE_TRANSITION_ATTRIBUTE", () => $53fee58a66f619c2$export$b61ac926bfbe045);
$parcel$export(module.exports, "useAiPlannerIframeModalProps", () => $53fee58a66f619c2$export$50a31e202c4da784);

var $3yzOx = parcelRequire("3yzOx");
const $53fee58a66f619c2$export$55449fcb95741234 = 'ai-planner-iframe-modal-dialog';
const $53fee58a66f619c2$export$d4ef780c798e40e8 = 'data-ai-planner-iframe-modal-presentation';
const $53fee58a66f619c2$export$b61ac926bfbe045 = 'data-ai-planner-iframe-modal-resize-transition';
const $53fee58a66f619c2$var$SIZING_STYLE_ELEMENT_ID = 'ai-planner-iframe-modal-sizing';
/**
 * Sizes ModalDialog's positioner from the presentation attribute owned by the
 * modal content. The positioner is an ancestor of the modal's own subtree, so
 * it can only be reached with a global rule. This is a workaround until a
 * maximized ADS modal is available to products.
 *
 * The compact presentation is tuned for Planner home. Both dimensions remain
 * bounded by the same viewport gutter as the expanded presentation.
 */ const $53fee58a66f619c2$var$modalSizingGlobalStyles = `
	.atlaskit-portal [data-testid="${$53fee58a66f619c2$export$55449fcb95741234}--positioner"] {
		--ai-planner-iframe-modal-width: calc(100vw - ${"var(--ds-space-400, 32px)"});
		--ai-planner-iframe-modal-height: calc(100vh - ${"var(--ds-space-400, 32px)"});
		inset: 0 !important;
		margin: auto !important;
		width: var(--ai-planner-iframe-modal-width);
		max-width: var(--ai-planner-iframe-modal-width);
		height: var(--ai-planner-iframe-modal-height);
		max-height: var(--ai-planner-iframe-modal-height);
	}

	.atlaskit-portal [data-testid="${$53fee58a66f619c2$export$55449fcb95741234}--positioner"][${$53fee58a66f619c2$export$d4ef780c798e40e8}][${$53fee58a66f619c2$export$b61ac926bfbe045}] {
		transition-property: transform, width, max-width, height, max-height;
		/* ADS sets the duration inline. Preserve its transform timing while making only resizing slower. */
		transition-duration:
			${"var(--ds-duration-medium, 200ms)"},
			${"var(--ds-duration-xlong, 400ms)"},
			${"var(--ds-duration-xlong, 400ms)"},
			${"var(--ds-duration-xlong, 400ms)"},
			${"var(--ds-duration-xlong, 400ms)"} !important;
	}

	.atlaskit-portal [data-testid="${$53fee58a66f619c2$export$55449fcb95741234}--positioner"][${$53fee58a66f619c2$export$d4ef780c798e40e8}="compact"] {
		--ai-planner-iframe-modal-width: min(908px, calc(100vw - ${"var(--ds-space-400, 32px)"}));
		--ai-planner-iframe-modal-height: min(740px, calc(100vh - ${"var(--ds-space-400, 32px)"}));
	}

	@media (prefers-reduced-motion: reduce) {
		.atlaskit-portal [data-testid="${$53fee58a66f619c2$export$55449fcb95741234}--positioner"][${$53fee58a66f619c2$export$d4ef780c798e40e8}][${$53fee58a66f619c2$export$b61ac926bfbe045}] {
			transition-property: none;
		}
	}
`;
const $53fee58a66f619c2$export$50a31e202c4da784 = ()=>{
    (0, $3yzOx.useEffect)(()=>{
        if (typeof globalThis.document === 'undefined') return;
        if (globalThis.document.getElementById($53fee58a66f619c2$var$SIZING_STYLE_ELEMENT_ID) != null) return;
        const style = globalThis.document.createElement('style');
        style.id = $53fee58a66f619c2$var$SIZING_STYLE_ELEMENT_ID;
        style.textContent = $53fee58a66f619c2$var$modalSizingGlobalStyles;
        globalThis.document.head.appendChild(style);
    }, []);
    return {
        width: '100%',
        height: '100%',
        testId: $53fee58a66f619c2$export$55449fcb95741234
    };
};

});



parcelRegister("3e4X9", function(module, exports) {
$parcel$export(module.exports, "useShouldShowDefaultCreateButton", () => $44acce0b64e020fc$export$d3a943ffcd556bb8);

var $i860n = parcelRequire("i860n");

var $7jBdz = parcelRequire("7jBdz");

var $kZFXL = parcelRequire("kZFXL");

var $f99M0 = parcelRequire("f99M0");

var $2b39L = parcelRequire("2b39L");
const $44acce0b64e020fc$export$d3a943ffcd556bb8 = ()=>{
    const { data: projectContextData, key: projectContextResourceKey } = (0, $2b39L.useProjectContext)();
    const projectType = projectContextData?.projectType;
    const hasSoftwareAccess = (0, $kZFXL.useHasActiveSoftwareAccess)();
    const aiPlannerEnabled = (0, $7jBdz.useAiPlannerUniversalCreateEnabled)();
    const isBusinessProjectContext = projectContextResourceKey === 'BUS';
    // Valid software project if we are in a software project, or project type is unresolved and context is not business.
    const isValidSoftwareProject = projectType === (0, $f99M0.SOFTWARE_PROJECT) || hasSoftwareAccess && projectType === undefined && // This fixes a bug where business projects had undefined project type
    // We need to rely on resource key instead of project type
    // Instead of fixing outright, gating behind aiPlannerEnabled for now
    !(aiPlannerEnabled && isBusinessProjectContext);
    return !isValidSoftwareProject || !aiPlannerEnabled || !(0, $i860n.fg)('navx_onboarding_universal_create_in_jira');
};

});
parcelRegister("kZFXL", function(module, exports) {
$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $892bf31c9afab76a$export$895f9b38ce00671e);
/* eslint-disable jira/filename-case */ 
var $ccEzE = parcelRequire("ccEzE");

var $1KydW = parcelRequire("1KydW");
const $892bf31c9afab76a$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $ccEzE.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $1KydW.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});


parcelRegister("cMz6U", function(module, exports) {
$parcel$export(module.exports, "useUniversalCreateAnalytics", () => $7f7f9d08eb4ad487$export$eebe354ebe67c94c);

var $3yzOx = parcelRequire("3yzOx");

var $fTB7r = parcelRequire("fTB7r");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $7f7f9d08eb4ad487$export$eebe354ebe67c94c = ()=>{
    const { isVisible: isVisible } = (0, $fTB7r.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $3yzOx.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // oxlint-disable-next-line typescript/consistent-type-assertions
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'universal-create-trigger-button', {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible
    ]);
};

});

parcelRegister("fHaVI", function(module, exports) {
$parcel$export(module.exports, "useUniversalCreateLoadExperience", () => $b56c5dec60d86e43$export$647dc96a7cee15d6);
$parcel$export(module.exports, "useUniversalCreateButtonInteractiveExperienceStart", () => $b56c5dec60d86e43$export$87e04082b26a8e65);
$parcel$export(module.exports, "useUniversalCreateButtonInteractiveExperienceComplete", () => $b56c5dec60d86e43$export$f50595e730404308);

var $3yzOx = parcelRequire("3yzOx");

var $faNwm = parcelRequire("faNwm");
const $b56c5dec60d86e43$var$INTERACTIVE_TIMEOUT_MS = 3000; // 3 seconds
// Shared ref to track if interactive experience has completed (success or failure)
const $b56c5dec60d86e43$var$interactiveExperienceCompletedRef = {
    current: false
};
const $b56c5dec60d86e43$export$647dc96a7cee15d6 = ()=>{
    // Measure time from component mount to button painted on screen
    (0, $3yzOx.useEffect)(()=>{
        (0, $faNwm.UniversalCreateButtonLoadExperience).start();
        // Wait for next paint, then mark as success (measures time until button is visible)
        requestAnimationFrame(()=>{
            (0, $faNwm.UniversalCreateButtonLoadExperience).success();
        });
    }, []);
};
const $b56c5dec60d86e43$export$87e04082b26a8e65 = ()=>{
    // Start tracking interactive experience on component mount
    (0, $3yzOx.useEffect)(()=>{
        (0, $faNwm.UniversalCreateButtonInteractiveExperience).start();
        // Mark as failure if items don't load within timeout
        const timeoutId = setTimeout(()=>{
            if (!$b56c5dec60d86e43$var$interactiveExperienceCompletedRef.current) {
                (0, $faNwm.UniversalCreateButtonInteractiveExperience).failure();
                $b56c5dec60d86e43$var$interactiveExperienceCompletedRef.current = true;
            }
        }, $b56c5dec60d86e43$var$INTERACTIVE_TIMEOUT_MS);
        // Cleanup timeout on unmount
        return ()=>clearTimeout(timeoutId);
    }, []);
};
const $b56c5dec60d86e43$export$f50595e730404308 = ()=>{
    // Mark experience as completed and prevent failure() from being called by the timeout
    (0, $3yzOx.useEffect)(()=>{
        $b56c5dec60d86e43$var$interactiveExperienceCompletedRef.current = true;
        (0, $faNwm.UniversalCreateButtonInteractiveExperience).success();
    }, []);
};

});



$parcel$global.rlb("27fFF")
//# sourceMappingURL=UniversalCreate.95d2f059.js.map
